//Importaciones necesaria para poder utilizar react
import { makeStyles } from '@material-ui/core/styles';
import MenuSemilleros, { MOSTRAR_INFORME_SEMILLERO_TUTORES } from './Hijos/MenuSemilleros'
import TareasTerminadas from '../general/TareasTerminadas';
import emma_w from '../../global/imagenes/emma_w.png';
import emma_s from '../../global/imagenes/emma_s1.png';
import * as Funciones from '../../global/js/funciones';
import TituloAccion from "../general/TituloAccion";
import { Grid, Link, Paper, Button, Typography, Card, CardHeader, CardContent, Avatar, Grow, Slide, createMuiTheme, Tooltip } from '@material-ui/core'
import SemilleroCardSolicitud from './Hijos/SemilleroCardSolicitud';
import SemillerosSolicitudes from './SemillerosSolicitudes';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import SemilleroTables from './Hijos/SemilleroTables'
import revisar from '../../global/imagenes/revisar.png';
import noti3 from '../../global/imagenes/noti3.png';
import tap from '../../global/imagenes/tap.png';
import AccionesRapidas from '../general/AccionesRapidas'
import SemillerosListSemi from './Hijos/SemillerosListSemi'
import SemilleroActualizar from './Hijos/SemilleroActualizar'
import SwitchDisponibilidadSemillero from './Hijos/SwitchDisponibilidadSemillero'
import ListarDatos from '../general/ListarDatos';
import MenuBookIcon from '@material-ui/icons/MenuBook';
import IconButton from '@material-ui/core/IconButton';
import NotificationImportantIcon from '@material-ui/icons/NotificationImportant';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import AppBarModal from '../general/AppBarModal'
import { coloresEmma } from '../../global/js/funciones';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
//Constantes del Helper
import * as Helper from './Hijos/Helper';
import assigment from '../../global/imagenes/assigment.png';
import LinearProgress from '@material-ui/core/LinearProgress';
import React, { Fragment, useState } from "react";
import DateFnsUtils from '@date-io/date-fns';
import { DateTimePicker, MuiPickersUtilsProvider, DatePicker, KeyboardDatePicker } from "@material-ui/pickers";
import TextField from '@material-ui/core/TextField';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import Checkbox from '@material-ui/core/Checkbox';
import StepLabel from '@material-ui/core/StepLabel';
import BuscarSelect from '../general/BuscarSelect';
import { obtenerValores, obtenerValoresFiltros, validarCorreo, obtenerPermisosValor, formulario, mostrarError, crear_form_data,obtenerMisDatos } from "../../global/js/funciones";
import { BtnCargar, BtnEliminar,BtnSeleccion,BtnVer } from "../general/BotonesAccion";
import SemilleroAddParti from './Hijos/SemilleroAddParti';
import EditIcon from '@material-ui/icons/Edit';
import { BtnForm } from '../general/BotonesAccion';
import InputBuscar from '../general/InputBuscar';
import BuscarPersona from '../general/BuscarPersona';
import FormHelperText from '@material-ui/core/FormHelperText';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Box from '@material-ui/core/Box';
import DoneIcon from '@material-ui/icons/Done';
import ClearIcon from '@material-ui/icons/Clear';
import PublishIcon from '@material-ui/icons/Publish';
import { useDispatch , useSelector} from 'react-redux';
import { actualizarMensaje, mostrarModulo } from '../../redux/actions/actGlobal';
import SemilleroMessage from './Hijos/SemilleroMessage';
import userSemillero from '../../global/imagenes/userSemillero.png'
import moreInformation from '../../global/imagenes/more-information.png'
import { red } from '@material-ui/core/colors';
import { ContactlessOutlined, Label } from '@material-ui/icons';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import moment from 'moment'
import VisibilityIcon from '@material-ui/icons/Visibility';
import NotificaIcon from '../../global/imagenes/noti4.png';
import InformeSemillerosTutores from './Hijos/InformeSemillerosTutores';
import { Document, Image, Page, PDFDownloadLink, Text, View,StyleSheet,Font } from '@react-pdf/renderer';
import file from '../../global/imagenes/file.png'
import sourcebold from './../../global/fonts/PTSerif-Bold.ttf'
import LogoCuc from '../../global/imagenes/logo_cuc3.png';
import firma_melissa from '../../global/imagenes/firma_melissa.png';
import logoproductotecnologicos from '../../global/imagenes/digital.png';
import logoproductosdivulgacion from '../../global/imagenes/innovation.png';
import logorecurso from '../../global/imagenes/project-management.png';
import logoapropiacion from '../../global/imagenes/nuevoconocimiento.png';
import logoestrategias from '../../global/imagenes/problem.png';
import logonuevoconocimiento from '../../global/imagenes/articles.png'; 
import PaticipantesListaSemi from './Hijos/ParticipantesListaSemi';
import InputFile from '../general/InputFile';
import {  Link as RouterLink } from 'react-router-dom';


const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    contenidoModulo: {
        [theme.breakpoints.up('sm')]: {
            paddingLeft: "90px !important"
        },
    },
    formControl: {
        margin: "0",
      },
    selectEmpty: {
        marginTop: theme.spacing(2),
      },
    colorEmmma: {
        color: coloresEmma.secondarycolor,
        transition: 'all 0.3s',
        '&:hover': {
          color: "#fff",
          backgroundColor: coloresEmma.secondarycolor,
          transform: "scale(1.3)",
        }
    },
    color:{
        transition: 'all 0.4s',
        borderRadius: "20px",
        '&:hover': {
            transform: "scale(1.01)",
            boxShadow: "0px 6px 15px rgba(0,0,0,0.2)", 
            backgroundColor: "#fff5f5",      
        },
    },
    center:{
        textAlign: 'center'
    },
    colorEdit: {
        color: "#0074C5",
        transition: "all 0.3s",
        '&:hover': {
          color: "#fff",
          backgroundColor: "#0074C5",
          transform: "scale(1.3)",
        },
    },
      colorDelete: {
        color: "#d11a2a",
        transition: "all 0.3s",
        '&:hover': {
          color: "#fff",
          backgroundColor: "#d11a2a",
          transform: "scale(1.3)",
        },
      },
      colorCheck: {
        color: "#2ECC71",
        transition: "all 0.3s",
        '&:hover': {
          color: "#fff",
          backgroundColor: "#2ECC71",
          transform: "scale(1.2)",
        },
      },
      modalMinWith: {
            [theme.breakpoints.up('sm')]: {
                minWidth:'500px'
            },
        },
        dialogCustomizedWidth: {
            'max-width': '800px'
          },
    escalar: {
        transition: "all 0.3s",
        border: '1px solid #e0e0e0',
        [theme.breakpoints.up('sm')]: {
            '&:hover': {
                transform: "scale(1.05)",
                border: `1px solid ${coloresEmma.secondarycolor}`,
            },

        },
    },
    girar360: {
        transition: "all 0.3s",
        [theme.breakpoints.up('sm')]: {
            '&:hover': {
                transform: "rotate(1turn)",
            },

        },
    }
}));
Font.register({ family: 'PTSerifBold', src: sourcebold });
const styles = StyleSheet.create({
    body: {
        border: '1.1px solid #DFDDDD',
        width: '100%',
        height: '100%',
        padding: 'auto 45px auto 45px'
       
    },
    imagen: {
        width: '100%',
        display: 'flex',
        padding: '0 0 20px 0',
        justifyContent: 'center',
        alignItems: 'center',
       
    },
    titular:{
        fontSize: '12px',
        textAlign: 'center',
        marginTop: '30px',
        fontFamily: 'PTSerifBold',
        
    },
    negrita:{
        fontFamily: 'PTSerifBold',
        lineHeight: 1.3,
        textAlign: 'justify',
    },
    parrafo:{
        fontSize: '12px',
        margin: '50px 0 0 0',
        textAlign: 'justify',
        lineHeight: 1.3,
    },
    parrafo1:{
        fontSize: '12px',
        margin: '70px 0 0 0',
        textAlign: 'justify',
    },
    imagenfirma: {
        paddingLeft:'10px',
        width: '100px',
        height:'135px',
        display: 'flex',
        margin: '35px 0 -10px -5px'
   
    },
    piefirma:{
        fontFamily: 'PTSerifBold',
        fontSize: '13px',
        margin: '15px 0 0 0'
    },
    piefirma1:{
        fontSize: '13px',
        textAlign: 'justify',
        margin: '10px 0 0 0'
    },
    informacion:{
        textAlign: 'justify',
        fontSize: '11px',
        color: 'lightcoral',
        margin: '130px 0 6px 0',
    },linea:{
        margin: '-15px 0 0 0',
    }
  });

const Semilleros = (props) => {

    const usuario = useSelector(state => state.redGlobal.usuario);
    const [seleccion, setSeleccion] = React.useState('miproceso');
    const [mensaje, setMensaje] = React.useState(null);
    const [detalle, setDetalle] = React.useState(true)
    const [procesos, setProcesos] = React.useState([])
    const [notificaciones, setNotificaciones] = React.useState([]);
    const [semiActual, setSemiActual] = React.useState({});
    const [openModalInfo, setOpenModalInfo] = React.useState(false);
    const [openModalInfoParticipante, setOpenModalInfoParticipante] = React.useState(false);
    const classes = useStyles()
    const [cargandoProcesos, setCargandoProcesos] = React.useState(true);
    const [mdlIntegrantes, setmdlIntegrantes] = React.useState(false);
    const [liderAutomatico, setLiderAutomatico] = React.useState([]);
    const [instructivo, setInstructivo] = React.useState([]);
    const dispatchI = useDispatch();
    const [permisoGestionarSemilleros, setPermisoGestionarSemilleros] = React.useState(false);
    const [cordinador, setCordinador] = React.useState('');

    React.useEffect(() => {
        if (!MOSTRAR_INFORME_SEMILLERO_TUTORES && seleccion === 'Informe') {
            setSeleccion('miproceso');
        }
    }, [seleccion]);

    React.useEffect(() => {
        if(usuario.perfil.codigo !== 'Per_Nor' && (usuario.perfil.codigo=='Per_Doc'||usuario.perfil.codigo=='Per_Adm')){
            setPermisoGestionarSemilleros(true);
            dispatchI(mostrarModulo({ ruta: '/semilleros_profesor', nombre: 'Semilleros Tutores' }))
            obtenerAlerta()
            obtenerUsuario()
            obtenerNombreJefes()
        }else{
                const obtenerProcesos = async () => {
                    const data = await obtenerSemillerosSolicitudesLider()
                    if ((!data || data.length === 0) && usuario.perfil.codigo === 'Per_Nor') {
                        setMensaje('permiso')
                    } else {
                        setPermisoGestionarSemilleros(true);
                    }
                }
                obtenerProcesos();
        }
    }, []);

    const obtenerSemillerosSolicitudesLider = async () =>{
        return new Promise(resolve => {
            Funciones.consulta(`api/v1.0/investigacion/semillerosListLideres`, null, null, (error, estado, resp) => {
                resolve(estado === 200 && !error ? resp : null);
            })
        })
    }
    const obtenerNombreJefes = async () => {
        let nombrejefe = await Funciones.obtenerValoresFiltros([{ 'llave': 'codigo', 'valor': 'firma_coordinador' }]);
        setCordinador(nombrejefe[0].valora)
      }

    const obtenerUsuario= async()=>{
       let data = await obtenerMisDatos()
       let instructivo_docente = await obtenerValoresFiltros([{ 'llave': 'codigo', 'valor': 'Sem_Inst' }]);
       setLiderAutomatico(data)
       setInstructivo(instructivo_docente)
    }
      const obtenerAlerta= async()=>{
        setCargandoProcesos(true)
        let dato_noti = await ObtenerNotificaciones()
        let helpnoti
        let da=[]
        let notiguardar=[]

        const accionesSolicitudes = (data) => {
            const onClickAbrir = async () => {

                setSeleccion('miproceso')
                setDetalle(false)
                setSemiActual(data.semillero)
                setmdlIntegrantes(true)
                }

            return (
            <>
            <BtnVer  callback={() =>{onClickAbrir(data)} }texto='Ver' />
            </>
            )

        }

        if (Array.isArray(dato_noti)) {
            dato_noti.map((data) => {
                const usuario = data?.participante || data?.usuario_registro || {};
                const semillero = data?.semillero || {};

                const {
                primer_apellido = '',
                primer_nombre = '',
                segundo_apellido = '',
                } = usuario;

                const { nombre = '' } = semillero;

                helpnoti = {
                icono: NotificaIcon,
                titulo: '¡ Solicitud Participacion a Semillero !',
                mensaje: `El estudiante ${primer_nombre} ${primer_apellido} ${segundo_apellido} hizo una solicitud al semillero ${nombre}.`,
                tipo: 'mensaje',
                acciones: () => accionesSolicitudes(data),
                };

                notiguardar.push(helpnoti);
            });
            }

                setNotificaciones(notiguardar);
                setCargandoProcesos(false);
      }

    const vista = () => {

        switch (seleccion) {
          case 'miproceso':
            return (
                <div>
                    {detalle == true ?
                    <PintarSolicitudes
                    procesos = {procesos}
                    setProcesos = {setProcesos}

                    seleccion = {seleccion}
                    setSeleccion = {setSeleccion}

                    detalle = {detalle}
                    setDetalle = {setDetalle}

                    semiActual={semiActual}
                    setSemiActual={setSemiActual}

                    vistaEstudiante={props.vistaEstudiante}
                    />  : <PintarSolicitudSeleccionada
                    semiActual={semiActual}
                    setSemiActual={setSemiActual}
                    cordinador={cordinador}
                    detalle = {detalle}
                    setDetalle = {setDetalle}
                    mdlIntegrantes={mdlIntegrantes}
                    setmdlIntegrantes={setmdlIntegrantes}
                    openModalInfo={openModalInfo}
                    setOpenModalInfo={setOpenModalInfo}
                    vistaEstudiante={props.vistaEstudiante}
                    openModalInfoParticipante={openModalInfoParticipante}
                    setOpenModalInfoParticipante={setOpenModalInfoParticipante}

                    />}
                </div>
            )
          case 'nuevo':
            return (
                <SemillerosSolicitudes
                liderAutomatico={liderAutomatico}
                setLiderAutomatico={setLiderAutomatico}

                />
            )
          case 'historial':
            return (
                <div>
                    <PintarHistorial
                        procesos = {procesos}
                        setProcesos = {setProcesos}

                        seleccion = {seleccion}
                        setSeleccion = {setSeleccion}

                        detalle = {detalle}
                        setDetalle = {setDetalle}

                        semiActual={semiActual}
                        setSemiActual={setSemiActual}
                    />
                </div>
            )
            case 'Informe':
            if (!MOSTRAR_INFORME_SEMILLERO_TUTORES) {
              return null;
            }
            return (
                <InformeSemillerosTutores
                />
            )
          default:
            break;
        }
    }

    return (
        <div>
            {mensaje ? (
            <div>
            <RouterLink to="/semilleros">
                <ArrowBackIcon style={{ fontSize: '35px', color: '#900807', marginTop: '5px' }} />
            </RouterLink>
            <TareasTerminadas mensaje='No tienes permiso para este módulo' marginTop='7%' imagen={emma_s} widthImg="7%" />
            </div>
        ) : (
            props.vistaEstudiante != true ? (
            <div>
            <MenuSemilleros
            notificaciones={notificaciones}
            sele={seleccion}
            cargandoProcesos={cargandoProcesos}
            mdlIntegrantes={mdlIntegrantes}
            instructivo_docente={instructivo[0] ? instructivo[0].archivo : ''}
            seleccionar={
                (seleccion)  =>{
                if(seleccion!='notificacion'){

                setSeleccion(seleccion)
                }else {
                    obtenerAlerta()
                }
            }}
            />
        </div>

            ) : '')}
            {
                (permisoGestionarSemilleros === true) ? (
                    <div className={classes.contenidoModulo}>
                        {vista()}
                    </div>
                ) : ''
            }
        </div>
    )
}

const ObtenerNotificaciones = async () => {
    return new Promise(resolve => {
        Funciones.consulta(`api/v1.0/investigacion/notificaciones?estado_actual__codigo=Semi_par_env`, null, null, (error, estado, resp) => {
          resolve(estado === 200 && !error ? resp : null);
        })
    })
}

const PintarSolicitudes = (props) => {

    const isInitialMount = React.useRef(true);
    const [cargando, setCargando] = React.useState(true);


    React.useEffect( () => {
        //Obtengo los prceosos activos de la persona activa.
        if(isInitialMount.current){
            isInitialMount.current = false
            const obtenerProcesos = async () => {
                let data
                if(props.vistaEstudiante != true){
                    data = await obtenerSemillerosSolicitudes();
                }else{
                    data = await obtenerSemillerosSolicitudesLider();
                }

                props.setProcesos(data)
                setCargando(false)
            }
            obtenerProcesos()
        }
    })
    //Obtener semilleros solicitudes
    const obtenerSemillerosSolicitudes = async () => {
        return new Promise(resolve => {
            Funciones.consulta(`api/v1.0/investigacion/semillerosList`, null, null, (error, estado, resp) => {
              resolve(estado === 200 && !error ? resp : null);
            })
        })
    }

    const obtenerSemillerosSolicitudesLider = async () =>{
        return new Promise(resolve => {
            Funciones.consulta(`api/v1.0/investigacion/semillerosListLideres`, null, null, (error, estado, resp) => {
              resolve(estado === 200 && !error ? resp : null);
            })
        })
    }

    if (cargando) {
        return <TareasTerminadas imagen={emma_s} mensaje={'Cargando..'} widthImg='7%' marginTop='7%' />;
    }

    if (!props.procesos || props.procesos.length == 0) {
            if(props.vistaEstudiante != true){
                return (
                    <div className="pointer" onClick={() => props.setSeleccion("nuevo")}>
                      <TareasTerminadas
                        mensaje="No tienes solicitudes activas, clic aquí para crear un Semillero"
                        marginTop="7%"
                        imagen={emma_s}
                        widthImg="7%"
                      />
                    </div>
                  );
            }else{
                return (
                    <div>
                      <TareasTerminadas
                        mensaje="No eres lider de ningún Semillero"
                        marginTop="7%"
                        imagen={emma_s}
                        widthImg="7%"
                      />
                    </div>
                  );
            }
        }

    const handleClick = (semi) => {
        props.setDetalle(false)
        props.setSemiActual(semi)
    };

    return (
        <div>
            {cargando == true ? <TareasTerminadas imagen={emma_s} mensaje={'Cargando..'} widthImg='7%' marginTop='7%' />
            : <div style={{ padding: '2% 2% 0% 2%' }}>
                <>
                <Grid container direction={'row'} spacing={1}>
                    <TituloAccion principal="" alterno="¡ Lista de Semilleros !" />
                    {props.procesos.map((semi, i) => {
                    return (
                        <Grid item xs={12} sm={6} md={4} lg={3} key={i}>
                        <Paper elevation={1} onClick={() => handleClick(semi)} className="pointer">
                            <SemilleroCardSolicitud
                            id={semi.id}
                            tipo={semi}
                            fecha={semi.fecha_registro}
                            descripcion={`Este es el semillero ${semi.nombre}
                            se encuentra en estado ${semi.solicitud.estado_actual.nombre}. Clic aquí para obtener mas información.`}
                            estado={semi.solicitud.estado_actual}
                            //handleClickDelete={handleClickDelete}
                            />
                        </Paper>
                        </Grid>
                    );
                    })}
                </Grid>
                </>
			</div>}
        </div>
    )

}

const PintarSolicitudSeleccionada = (props) =>{
    const isInitialMount = React.useRef(true);
    const [pos, setPos] = React.useState('Información del Semillero')
    const [openModalGestion, setOpenModalGestion] = React.useState(false)
    const [openModalIntegrantes, setOpenModalIntegrantes] = React.useState(false)
    const [lider, setLider] = React.useState([])
    const [semilleronuevo, setSemilleronuevo] = React.useState([]);
    const [profesorLider, setProfesorLider] = React.useState('');
    const usuario = useSelector(state => state.redGlobal.usuario);
    //Estado open para abrir y cerrar el modal.
    const [open, setOpen] = React.useState(false);
    const [cargando, setCargando] = React.useState(true);
    const classes = useStyles()

    React.useEffect(() => {
        if(isInitialMount.current){
            isInitialMount.current = false
            obtenerLider()
            setCargando(false)
         if(props.mdlIntegrantes==true){
            setOpenModalIntegrantes(true)
        }

      }
    })

    const obtenerLider= async()=>{
        let data = await obtenerliderSemillero()
        data.lideres.map((l)=>{
            if(l.rol.codigo=='Semi_rol3'){
            setProfesorLider(l.usuario_registro)
            } 
        })
        setLider(data)
     }
    const obtenerliderSemillero = async () => {
        return new Promise(resolve => {
            Funciones.consulta(`api/v1.0/investigacion/listalideres/${props.semiActual.id}`, null, null, (error, estado, resp) => {
              resolve(estado === 200 && !error ? resp : null);
            })
        })
    }
    
    const handleClick = () => {
        props.setDetalle(true)
        props.setSemiActual({})
        setPos('Información del Semillero')
    };

    const openModalInfo = () =>{
        props.setOpenModalInfo(true)
    }

    const openModalInfoWithParticipantes = () =>{
        props.setOpenModalInfo(true)
        setPos('Solicitudes')
    }

    const handleClickOpenModalGestion = () =>{
        setOpenModalGestion(true)
    }

    const handleClickOpenModalIntegrantes = () =>{
        setOpenModalIntegrantes(true)
    }
    //Funciones para que abra y cierre el modal del formulario.
    const handleClickOpen = () => {
        setOpen(true);
    };
    const obtenerMes = (mes) => {
        const meses = {
          '1': 'Enero',
          '2': 'Febrero',
          '3': 'Marzo',
          '4': 'Abril',
          '5': 'Mayo',
          '6': 'Junio',
          '7': 'Julio',
          '8': 'Agosto',
          '9': 'Septiembre',
          '10': 'Octubre',
          '11': 'Noviembre',
          '12': 'Diciembre'
        }
        return (meses[mes])
      }
    const generarPDF= () => {
        let fecha_actual = moment()
        let hoy = `${fecha_actual.format('D')} de ${obtenerMes(fecha_actual.format('M'))} de ${fecha_actual.format('YYYY')}`
        let data = props.semiActual
        let datalider=lider.lideres
        let firma = props.cordinador
        let grupo = ''
        let semillero=data.nombre
        let nombre=data.usuario_registro.primer_nombre + ' ' + data.usuario_registro.primer_apellido+ ' ' + data.usuario_registro.segundo_apellido
        let estado=data.solicitud.estado_actual.nombre.toUpperCase()
        let part=''
        data.semillero_grupos_investigacion.map((g)=>{
            if(g.estado==1){
                grupo= grupo +' '+ g.nombreGrupo + ','
            }

        })
        if(datalider){
            datalider.map((p)=>{
                  part = part + ` ${p.nombre} - ${p.rol.nombre.toUpperCase()} (Desde: ${moment(p.fecha_registro).format('DD/MM/YYYY')}),`
            })
        }


        return (
          <Document>
            <Page size="A4">
              <View style={styles.body}>
                <View style={styles.imagen}>
                  <Image src={LogoCuc} alt="images" />
                </View>
                <Text style={styles.titular}>A QUIEN INTERESE</Text>
                <Text style={styles.parrafo}>
                 El suscrito Coordinador Semilleros De Investigación e Innovación de la Corporación Universidad de la Costa, certifica que el Grupo de Semillero de investigación <Text style={styles.negrita}>{semillero} </Text> 
                  adscrito al Grupo de Investigación<Text style={styles.negrita}>{grupo}</Text> actualmente se encuentra en estado<Text style={styles.negrita}> {estado} </Text>y los Lideres son: <Text style={styles.negrita}>{part}</Text> 
                 {"\n\n"}Se expide el presente certificado en Barranquilla, Colombia el {hoy}
                </Text>
                <Text style={styles.parrafo1}></Text>
                <Text style={styles.parrafo}>Atentamente, </Text>

                <View style={styles.imagenfirma} >
                  <Image src={firma_melissa} alt="images" />
                </View>
                <Text style={styles.linea}>_____________________</Text>
                <Text style={styles.piefirma}>{firma}  </Text>
                <Text style={styles.piefirma1}> Coordinación de semilleros de investigación e innovación </Text>
                <Text style={styles.piefirma1}> Vicerrectoría de Ciencia, Tecnología e Innovación </Text>
                <View style={styles.informacion}>
                <Text>
                  Calle 58 N° 55-66 – Teléfonos: (5) 336 2200 – 3441974 – Fax: 3442670 – A.A. 50366 – www.cuc.edu.co
                </Text>
                </View>
            </View>
            </Page>
          </Document>
        )
      }
    const semilleroNuevoParticipantes=async ()=>{

        let f = await Funciones.generarFiltros([{ 'llave': 'solicitud_ant', 'valor': props.semiActual.solicitud.id }]);
        return new Promise(resolve => {
            Funciones.consulta(`api/v1.0/investigacion/ObtenerSemillero3?${f}`, null, null, (error, estado, resp) => {
                setSemilleronuevo(resp)
            })
        })
      }


    return (
        <div className='' >
            
            <Button  onClick={() => handleClick()} style={{ padding: "0px 3px 0px 3px", marginTop: '1%' }} color="secondary" > <ArrowBackIcon className={classes.girar360}/> <Typography variant="body2" style={{ color: '#9e9e9e' }} component="p" align='justify'> </Typography> </Button>
            {cargando == true ? <TareasTerminadas imagen={emma_w} mensaje={'Cargando..'} widthImg='7%' marginTop='7%' />
             :
            <div style={{ padding: '0% 2% 0% 2%' }} >
                <Grid container direction={'row'} spacing={1} >
                    <Grid item xs={12} sm={12} md={6} >
                        <TituloAccion principal='' alterno='¡ Información Básica !' />
                        <Paper elevation={0} square className="scroll">
                            <SemilleroTables semi={props.semiActual} />
                        </Paper>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                        <TituloAccion principal='' alterno='¿ Que deseas hacer ?' />
                        <Grid container direction={'row'} spacing={2} style={{ width: "100%" }}>
                            
                            <Grid item xs={12} sm={12} md={12} >
                                {/**/}
                                <Paper className={classes.escalar} elevation={3} onClick={() => openModalInfo()}>
                                    <AccionesRapidas imagen={revisar} titulo='¡ Más Información !' sub_titulo='Bien' des_sub_titulo=', Aquí puedes ver toda la información actual.' />
                                </Paper>
                            </Grid>
                            
                            {props.semiActual.solicitud.estado_actual.codigo=='Semi_activo'? <Grid item xs={12} sm={12} md={12} >
                                {/**/}
                                <Paper className={classes.escalar} elevation={3} onClick={() => handleClickOpenModalGestion()}>
                                    <AccionesRapidas imagen={moreInformation} titulo='¡ Gestion de Produccion del Semillero !' sub_titulo='Bien' des_sub_titulo=', Aquí puedes encontrar la sección de gestión para el Semillero' />
                                </Paper>
                            </Grid>: null}
                            {props.semiActual.solicitud.estado_actual.codigo=='Semi_pause'?<Grid item xs={12} sm={12} md={12} >
                                {/**/}
                                <Paper className={classes.escalar} elevation={3} onClick={() => handleClickOpen()}>
                                    <AccionesRapidas imagen={noti3} titulo='¡ Actualiza Semillero !' sub_titulo='Bien' des_sub_titulo=', Aquí puedes actualizar la Información del Semillero' />
                                </Paper>
                            </Grid>: null}
                            
                            <Grid item xs={12} sm={12} md={12} >
                                
                                <Paper className={classes.escalar} elevation={3} onClick={() => handleClickOpenModalIntegrantes()}>
                                    <AccionesRapidas imagen={userSemillero} titulo='¡ Gestion de Integrantes del Semillero !' sub_titulo='Bien' des_sub_titulo=', Aquí puedes encontrar la sección de gestión de Integrantes para el Semillero' />
                                </Paper>
                            </Grid>

                            {props.semiActual.solicitud.estado_actual.codigo=='Semi_activo'?
                            <Grid item xs={12} sm={12} md={12} >
                            <PDFDownloadLink style={{ textDecoration: 'none' }} document={ generarPDF()} fileName={`CerificadoSemillero.pdf`}>
                                {
                                  () => (
                                    
                                    <Paper className={classes.escalar} elevation={3} style={{ border: '1px solid #e0e0e0'}}  >
                                    <AccionesRapidas imagen={file} titulo='¡ Descargar Certificado !' sub_titulo='Bien' des_sub_titulo=', Aquí puedes Descargar tu certificado de participacion en pdf.' />
                                    </Paper>
                                    
                                    )
                                } 
                            </PDFDownloadLink>
                            </Grid>
                            :''}
                        </Grid>
                    </Grid>
                </Grid>
            </div>}

            {props.openModalInfo == true ? <SemillerosListSemi
                openModalInfo={props.openModalInfo}
                setOpenModalInfo={props.setOpenModalInfo}

                semiActual={props.semiActual}

                pos={pos}
                setPos={setPos}

                profesor={true}

                vistaEstudiante={props.vistaEstudiante}
                gestor={false}
            /> : ''}

            {open == true ? <SemilleroActualizar
                handleClickOpen={handleClickOpen}

                open={open}
                setOpen={setOpen}

                semiActual={props.semiActual}
                semilleronuevo={semilleroNuevoParticipantes}
                openModalInfoParticipante={props.openModalInfoParticipante}
                setOpenModalInfoParticipante={props.setOpenModalInfoParticipante}

            /> : ''}
             {props.openModalInfoParticipante == true ? <PaticipantesListaSemi
                openModalInfoParticipante={props.openModalInfoParticipante}
                setOpenModalInfoParticipante={props.setOpenModalInfoParticipante}
                detalle={props.detalle}
                setDetalle = {props.setDetalle}
                semiActual={props.semiActual}
                setSemiActual={props.setSemiActual}
                pos={pos}
                setPos={setPos}
                profesor={true}
                vistaEstudiante={props.vistaEstudiante}
                gestor={false}
                semilleronuevo={semilleronuevo}
            />  : ''}

            {openModalGestion == true ? <SemilleroGestion
                openModalGestion={openModalGestion}
                setOpenModalGestion={setOpenModalGestion}
                semiActual={props.semiActual}
                obtenerliderSemillero={obtenerliderSemillero}
            /> : ''}

            {openModalIntegrantes == true || props.mdlIntegrantes == true ? <SemilleroGestionIntegrantes
                openModalIntegrantes={openModalIntegrantes}
                setOpenModalIntegrantes={setOpenModalIntegrantes}
                mdlIntegrantes={props.mdlIntegrantes} 
                setmdlIntegrantes={props.setmdlIntegrantes}

                semiActual={props.semiActual}
            /> : ''}
        </div>
    )
}

const PintarHistorial = (props) => {

    const isInitialMount = React.useRef(true);
    const [cargando, setCargando] = React.useState(true);
    const classes = useStyles()
    const [openModalInfo, setOpenModalInfo] = React.useState(false);
    const [pos, setPos] = React.useState('Información del Semillero')
    const [semiActual, setSemiActual] = React.useState('Información del Semillero')
    React.useEffect( () => {
        //Obtengo los prceosos activos de la persona activa.
        if(isInitialMount.current){
            isInitialMount.current = false
            const obtenerProcesos = async () => {
                let data = await obtenerSemillerosSolicitudes();

                props.setProcesos(data)
                setCargando(false)
            }
            obtenerProcesos()
        }
    })
    //Obtener semilleros solicitudes
    const obtenerSemillerosSolicitudes = async () => {
        return new Promise(resolve => {
            Funciones.consulta(`api/v1.0/investigacion/ObtenerSemillero2?user_reg=1`, null, null, (error, estado, resp) => {
              resolve(estado === 200 && !error ? resp : null);
            })
        })
    }

    if (props.procesos.length == 0) {
        return (
          <div className="pointer" onClick={() => props.setSeleccion("nuevo")}>
            <TareasTerminadas
              mensaje="Historial vacio"
              marginTop="7%"
              imagen={emma_s}
              widthImg="7%"
            />
          </div>
        );
    }

    const acciones = (data) => {

        const openModal = () =>{
            setOpenModalInfo(true)
            setSemiActual(data);
        }

        const detalle = (
            <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                <SwitchDisponibilidadSemillero semillero={data} onCambio={actualizarDisponibilidadLocal} />
                <IconButton aria-label="done" className={classes.colorEmmma} onClick={openModal}>
                    <MenuBookIcon/>
                </IconButton>
            </div>
        );
        return detalle;
    };

    const actualizarDisponibilidadLocal = (idSemillero, valor) => {
        props.setProcesos((prev) => Array.isArray(prev)
            ? prev.map((s) => s.id === idSemillero ? { ...s, disponibilidad: valor } : s)
            : prev);
    };

    return (
        <div>
            {cargando == true ? <TareasTerminadas imagen={emma_s} mensaje={'Cargando..'} widthImg='7%' marginTop='7%' />
            : <div>
                    <ListarDatos
                    id="tbl_listar_semilleros"
                    avatar={({ nombre }) => nombre.charAt(0)}
                    datos={props.procesos}
                    opciones={true}
                    buscar={true}
                    acciones={(row) => acciones(row)}
                    titulo={"Lista de Semilleros de Investigación"}
                    fila_principal={({ nombre, id }) => `${id} - ${nombre}`}
                    filas={[
                    {
                        'mostrar': ({ id }) => `${id}`,
                        'id': 'id', 'enLista': false
                    },
                    {
                        'mostrar': ({ nombre }) => `${nombre}`,
                        'id': 'nombre', 'enLista': false
                    },
                    {
                        'mostrar': ({solicitud}) => `${solicitud.estado_actual.nombre}`,
                        'id': 'estado_actual', 'enLista': true
                    },
                    {
                        'mostrar': ({disponibilidad}) => disponibilidad === '0' ? 'No disponible para nuevos estudiantes' : 'Disponible para nuevos estudiantes',
                        'id': 'Disponibilidad', 'enLista': true
                    },
                    { 'id': 'descripcion', 'enLista': false },
                    ]}
                />
                {openModalInfo == true ? <SemillerosListSemi
                        openModalInfo={openModalInfo}
                        setOpenModalInfo={setOpenModalInfo}

                        semiActual={semiActual}

                        pos={pos}
                        setPos={setPos}

                        profesor={false}
                /> : ''}
            </div>
            }
        </div>
    )

}

const SemilleroGestion = (props) => {
    const isInitialMount = React.useRef(true);
    const [tipoSolicitud, setTipoSolicitud] = React.useState([]);
    const [cargando, setCargando] = React.useState(true)
    const [modalForm, setModalForm] = React.useState(false)
    const [seleccion, setSeleccion] = React.useState('tipo')
    const [tipoSolicitudActual, setTipoSolicitudActual] = React.useState('')
    const classes = useStyles()
    const [steps, setSteps] = React.useState(['Información del General', 'Autores'])


    //Variables para Eventos
    const [anio, setAnio] = React.useState(new Date());
    const [fechaInicioEvento, setFechaInicioEvento] = React.useState(new Date());
    const [fechaFinEvento, setFechaFinEvento] = React.useState(new Date());
    const [departamentos, setDepartamentos] = React.useState([]);
    const [departamento, setDepartamento] = React.useState('');
    const [ciudades, setCiudades] = React.useState([])
    const [ciudad, setCiudad] = React.useState('')
    const [nombreDelEvento, setNombreDelEvento] = React.useState('');
    const [adj_evento, setAdj_evento] = React.useState('')
    const [adj_evento_final, setAdj_evento_final] = React.useState('')
    const [adj_certificado, setAdj_certificado] = React.useState([]);
    const [adj_certificado_final, setAdj_certificado_final] = React.useState([]);
    
    const [nombreDelAmbito, setNombreDelAmbito] = React.useState('')
    const [nombreAmbitos, setNombreAmbitos] = React.useState([])//Array de ambitos

    const [nombreModalidadPar, setNombreModalidadPar] = React.useState('')
    const [nombreModalidadPars, setNombreModalidadPars] = React.useState([])//Array de modalidad de particiapacion

    const [cargandoEvento, setCargandoEvento] = React.useState(false)
    //Variables para Proyectos
    const [fechaInicio, setFechaInicio] = React.useState(new Date());
    const [fechaFin, setFechaFin] = React.useState(new Date());
    const [nombreProyecto, setNombreProyecto] = React.useState('')
    const [descripcionProyecto, setDescripcionProyecto] = React.useState('')
    const [asignaturaProyecto, setAsignaturaProyecto] = React.useState('')
    const [nombreprofesorProyecto, setNombreprofesorProyecto] = React.useState('')
    const [profesorProyecto, setProfesorProyecto] = React.useState([])// Array de Profesores

    //Variables Prod. Bibliografica
    const [nombreProductoBiblio, setNombreProductoBiblio] = React.useState('')
    const [tipoProductoBiblio, setTipoProductoBiblio] = React.useState('')
    const [anioBiblio, setAnioBiblio] = React.useState(new Date())
    const [revistaEditorialBiblio, setRevistaEditorialBiblio] = React.useState('')
    const [cuartilBiblio, setCuartilBiblio] = React.useState('')
    const [lugarPublicacionBiblio, setLugarPublicacionBiblio] = React.useState('')
    const [medioDivulgacionBiblio, setMedioDivulgacionBiblio] = React.useState('')

    //Variables Prod. Tec y Tecno
    const [nombreProductoTec, setNombreProductoTec] = React.useState('')
    const [tipoProductoTec, setTipoProductoTec] = React.useState('')
    const [nitTec, setNitTec] = React.useState('')
    const [numeroRegistroTec, setNumeroRegistroTec] = React.useState('')
    const [nombreTitular, setNombreTitular] = React.useState('')
    const [anioTec, setAnioTec] = React.useState(new Date())
    const [paisTec, setPaisTec] = React.useState('')
    const dispatch = useDispatch();
    //Autores y particiapntes
    const [numeroIdParEvent, setNumeroIdParEvent] = React.useState([])
    const [arrai, setArrai] = React.useState([])

    //Stepper
    //Estado para cambiar de step en el SemillerosStepper
    const [activeStep, setActiveStep] = React.useState(0);

    //Cargando Semillero Gestion
    const [cargandoFormGestion, setCargandoFormGestion] = React.useState(true)
    const [permisosDeLaSolicitud, setPermisosDeLaSolicitud] = React.useState([])

    /*Estados necesarios para produccion bibliografica*/
        const [cargandoGestionBibliografica, setCargandoGestionBibliografica] = React.useState(true)
        //Cargando tipos de produccion bibliografica
        const [cargandoProduBibliografico, setCargandoProduBibliografico] = React.useState(true)
        //ActiveStep para produccion bibliografica
        const [activeStepBiblio, setActiveStepBiblio] = React.useState(0);
        //Estado para saber el tipo de produccion bibliografica
        const [tipoProduccionBiblio, setTipoProduccionBiblio] = React.useState([])
        //Campos del tipo Articulo de produccion bibliografica
        // const [indexacionSelected, setIndexacionSelected] = React.useState("")
        // const [tipoArticuloSelected, setTipoArticuloSelected] = React.useState("")
        // const [tipoArticuloOtro, setTipoArticuloOtro] = React.useState("")
        const [tituloArticulo, setTituloArticulo] = React.useState("")
        const [PaginaInicial, setPaginaInicial] = React.useState("")
        const [PaginaFinal, setPaginaFinal] = React.useState("")
        const [numeropaginas, setNumeropaginas] = React.useState("")
        const [issn, setIssn] = React.useState("")
        const [nombreRevista, setNombreRevista] = React.useState("")
        const [anioPublicacion, setAnioPublicacion] = React.useState(new Date())
        // const [numPagTotales, setNumPagTotales] = React.useState("")
        const [volumenRevista, setVolumenRevista] = React.useState("")
        // const [numeroRevista, setNumeroRevista] = React.useState("")
        // const [paisPublicacion, setPaisPublicacion] = React.useState("")
        const [idioma, setIdioma] = React.useState("")
        const [enlace, setEnlace] = React.useState("")
        const [doi, setDoi] = React.useState("")
        const [mediodivulgacion, setMediodivulgacion] = React.useState("")
        const [idiomasTipoArticulo, setIdiomasTipoArticulo] = React.useState([])
        const [idiomaTipoArticuloSelected, setIdiomaTipoArticuloSelected] = React.useState("")
        const [CiudadesTipoArticulo, setCiudadesTipoArticulo] = React.useState([])
        const [CiudadesTipoArticuloSelected, setCiudadesTipoArticuloSelected] = React.useState("")
        //Campos del tipo Libro de produccion bibliografica
        // const [tipoLibroSelected, setTipoLibroSelected] = React.useState("")
        const [tipoLibroOtro, setTipoLibroOtro] = React.useState("")
        const [tituloLibro, setTituloLibro] = React.useState("")
        const [isbnLibro, setIsbnLibro] = React.useState("")
        const [editorialLibro, setEditorialLibro] = React.useState("")
        const [anioPublicacionLibro, setAnioPublicacionLibro] = React.useState(new Date())
        const [paisesTipoArticulo, setPaisesTipoArticulo] = React.useState([])
        const [mediopublicacionlibro, setMedioPublicacionLibro] = React.useState("")
        const [paisPublicacionLibro, setPaisPublicacionLibro] = React.useState("")
        const [idiomaLibro, setIdiomaLibro] = React.useState("")
        const [volumenLibro, setVolumenLibro] = React.useState("")
        const [numeroEdicionLibro, setNumeroEdicionLibro] = React.useState("")
        const [idiomasLibro, setIdiomasLibro] = React.useState([])
        const [idiomaLibroSelected, setIdiomaLibroSelected] = React.useState("")
        const [adj_certificado2, setAdj_certificado2] = React.useState('')
        const [adj_certificado_final2, setAdj_certificado_final2] = React.useState('')
        const [adj_certificado3, setAdj_certificado3] = React.useState('')
        const [adj_certificado_final3, setAdj_certificado_final3] = React.useState('')
        const [adj_certificado4, setAdj_certificado4] = React.useState('')
        const [adj_certificado_final4, setAdj_certificado_final4] = React.useState('')
        const [adj_certificado5, setAdj_certificado5] = React.useState('')
        const [adj_certificado_final5, setAdj_certificado_final5] = React.useState('')
        //Capos del tipo Capitulo de Libro de produccion bibliografica
        const [tipoLibroSelectedCap, setTipoLibroSelectedCap] = React.useState("")
        const [tipoLibroOtroCap, setTipoLibroOtroCap] = React.useState("")
        const [tituloCapLibro, setTituloCapLibro] = React.useState("")
        const [tituloLibroCap, setTituloLibroCap] = React.useState("")
        const [isbnLibroCap, setIsbnLibroCap] = React.useState("")
        const [editorialLibroCap, setEditorialLibroCap] = React.useState("")
        const [anioPublicacionLibroCap, setAnioPublicacionLibroCap] = React.useState(new Date())
        const [paisPublicacionLibroCap, setPaisPublicacionLibroCap] = React.useState("")
        const [idiomaLibroCap, setIdiomaLibroCap] = React.useState("")
        const [volumenLibroCap, setVolumenLibroCap] = React.useState("")
        const [numeroEdicionLibroCap, setNumeroEdicionLibroCap] = React.useState("")
        const [paisTipoCapLibroSelected, setPaisTipoCapLibroSelected] = React.useState("")
        const [idiomasCapituloLibro, setIdiomasCapituloLibro] = React.useState([])
        const [idiomaCapituloLibroSelected, setIdiomaCapituloLibroSelected] = React.useState("")

        //Campos de Obra a producto de producción bibliografica
        const [nombreObra, setNombreObra] = React.useState([])
        const [disciplina, setDisciplina] = React.useState([])
        const [disciplinaSelected, setDisciplinaSelected] = React.useState(""); 
        const [tituloObraproducto, setTituloObraproducto] = React.useState([])
        const [tecnica, setTecnica] = React.useState([])
        const [nombreespacio, setNombreEspacio] = React.useState([])
        const [tipoespacio, setTipoEspacio] = React.useState([])
        const [tipoespacioSelected,settipoespacioSelected]= React.useState("");
        const [aniocreacionespacio, setAniocreacionEspacio] = React.useState(new Date())
        const [fechapresentacion, setFechaPresentacion] = React.useState(new Date())
        const [distincion, setDistincion] = React.useState([])
        const [distincionSelected,setdistincionSelected] = React.useState("")
        const [entidadconvocante, setEntidadConvocante] = React.useState([])
        const [mecanismoseleccion, setMecanismoSeleccion] = React.useState([])
        const [mecanismoSelected, setmecanismoSelected] = React.useState("")
        const [acuerdoLicencia, setAcuerdoLicencia] = React.useState("")
        const [institucionlicencia, setInstitucionLicencia] = React.useState([])
        const [fechaotrogamiento, setFechaOtorgamiento] = React.useState(new Date())
        const [numeroregistro, setNumeroRegistro] = React.useState([])
        const [contratocomercializacion,setContratoComercializacion] = React.useState("")
        
        //Campos del tipo Patente de producion bibliografica
        const [tipoPatente, setTipoPatente] = React.useState([])
        const [tipoPatenteSelected, setTipoPatenteSelected] = React.useState("")
        const [viaSolicitud, setviaSolicitud]= React.useState([])
        const [viaSolicitudSelected,setviaSolicitudSelected]= React.useState("")
        const [anioObtencionPatente, setAnioObtencionPatente] = React.useState(new Date())
        const [numeroRegistroPatente, setNumeroRegistroPatente] = React.useState("")
        const [tituloPatente, setTituloPatente] = React.useState("")
        const [numeroPatente, setNumeroPatente] = React.useState("")
        const [nombreSolicitante,setnombreSolicitante]= React.useState("")
        const [paisObtencionPatente, setPaisObtencionPatente] = React.useState("")
        const [gacetaIndustrialPatente, setGaceteIndustrialPatente] = React.useState("")
        const [institucionPatente, setInstitucionPatente] = React.useState("")
        const [tipoPatenteOtro, setTipoPatenteOtro] = React.useState("")
        const [paisPatenteSelected, setPaisPatenteSelected] = React.useState("")
        /*Estados necesarios para produccion Tenica*/
        //Estado para saber el tipo de producto
        const [tipoProduccionTecnica, setTipoProduccionTecnica] = React.useState([])
        const [tipoProduccionDivulgacion, setTipoProduccionDivulgacion] = React.useState([])
        const [tipoProduccionSocial, setTipoProduccionSocial] = React.useState([])
        const [tipoProduccionRecursos, setTipoProduccionRecursos] = React.useState([])
        const [tipoProduccionEstrategias, setTipoProduccionEstrategias] = React.useState([])
        const [cargandoProduTec, setCargandoProduTec] = React.useState(true)
        const [tipoProductoTecSelected, setTipoProductoTecSelected] = React.useState([])
        const [tipoProductoDivSelected, setTipoProductoDivSelected] = React.useState([])
        const [tipoProductoSolSelected, setTipoProductoSolSelected] = React.useState([])
        const [tipoProductoRecSelected, setTipoProductoRecSelected] = React.useState([])
        const [tipoProductoEstSelected, setTipoProductoEstSelected] = React.useState([])
        const [inputs, setInputs] = React.useState([])
        const [inputsSelects, setInputsSelects] = React.useState([])
        //Fechas para los formularios de tecnico
        const [fechaCreacionDiseñoIndus, setFechaCreacionDiseñoIndus] = React.useState(new Date())
        const [fechaDesarrolloSoftware, setFechaDesarrolloSoftware] = React.useState(new Date())
        const [fechaObtencionRegistroSoftware, setFechaObtencionRegistroSoftware] = React.useState(new Date())
        const [fechaCreacionPrototipo, setFechaCreacionPrototipo] = React.useState(new Date())
        const [fechaCreacionSignoDistintivo, setFechaCreacionSignoDistintivo] = React.useState(new Date())
        const [fechaRegistroBaseTecno, setFechaRegistroBaseTecno] = React.useState(new Date())
        const [fechaInnovacionProceServi, setFechaInnovacionProceServi] = React.useState(new Date())
        const [fechaInnovacionGestionEmp, setFechaInnovacionGestionEmp] = React.useState(new Date())
        const [fechaPresentacionObraProducto, setFechaPresentacionObraProducto] = React.useState(new Date())
        const [fechaCreacionObraProducto, setFechaCreacionObraProducto] = React.useState(new Date())
        const [fechaInicioEventoArtistico, setFechaInicioEventoArtistico] = React.useState(new Date())
        const [fechaFinalEventoArtistico, setFechaFinalEventoArtistico] = React.useState(new Date())
        const [fechaInicioTalleresCreacion, setFechaInicioTalleresCreacion] = React.useState(new Date())
        const [fechaFinalTalleresCreacion, setFechaFinalTalleresCreacion] = React.useState(new Date())
        //Fecha para el registro de diseño prototipo tiene
        const [fechaRegistroDiseñoPrototipoTiene, setFechaRegistroDiseñoPrototipoTiene] = React.useState(new Date())
        //Selecteds para los formularios de tecnico
        const [productoTieneSelected, setProductoTieneSelected] = React.useState("")
        const [tipoPrototipoSelected, setTipoPrototipoSelected] = React.useState("")
        const [tipoSoftwareSelected, setTipoSoftwareSelected] = React.useState("")
        const [tipoSignoDistintivoSelected, setTipoSignoDistintivoSelected] = React.useState("")
        const [tipoEmpresaSelected, setTipoEmpresaSelected] = React.useState("")
        const [tipoProgramaSelected, setTipoProgramaSelected] = React.useState("")
        const [tipoDepartamentoSelected, setTipoDepartamentoSelected] = React.useState("")
        const [tiposDepartamentos, setTiposDepartamentos] = React.useState([])
        const [tipoInnovacionSelected, setTipoInnovacionSelected] = React.useState("")
        const [tipoEspacioEventoSelected, setTipoEspacioEventoSelected] = React.useState("")
        const [tipoDisciplinaAmbitoSelected, setTipoDisciplinaAmbitoSelected] = React.useState("")
        const [tipoAmbitoSelected, setTipoAmbitoSelected]= React.useState("")
        const [tipoRolSelected, setTipoRolSelected]= React.useState("")
        const [tipoEventoSelected, setTipoEventoSelected]= React.useState("")
        //Cuando seleccionen otro en los formularios de tecnico en los selects
        const [otroTipoPrototipoSelected, setOtroTipoPrototipoSelected] = React.useState("")
        const [otroTipoSoftwareSelected, setOtroTipoSoftwareSelected] = React.useState("")
        //Selects de produccion tecnica
        const [productoTiene, setProductoTiene] = React.useState([])
        const [tiposDePrototipos, setTiposDePrototipos] = React.useState([])
        const [tiposDeSoftware, setTiposDeSoftware] = React.useState([])
        const [tiposSignoDistintivos, setTiposSignoDistintivos] = React.useState([])
        const [tiposEmpresas, setTiposEmpresas] = React.useState([])
        const [tiposProgramas, setTiposProgramas] = React.useState([])
        const [tiposInnovaciones, setTiposInnovaciones] = React.useState([])
        const [tiposEspacioEvento, setTiposEspacioEvento] = React.useState([])
        const [tiposDisciplinaAmbito, setTiposDisciplinaAmbito] = React.useState([])
        const [tiposAmbitos, setTiposAmbitos] = React.useState([])
        const [tiposRoles, setTiposRoles] = React.useState([])
        const [tiposEventos, setTiposEventos] = React.useState([])
        const [paisesTecTecno, setPaisesTecTecno] = React.useState([])
        const [paisSelectedTecTecno, setPaisSelectedTecTecno] = React.useState("")
        const [ciudadesTecTecno, setCiudadesTecTecno] = React.useState([])
        const [disponibilidadSelectedTecTecno, setDisponibilidadSelectedTecTecno] = React.useState("")
        const [disponibilidadesTecTecno, setDisponibilidadesTecTecno] = React.useState([])
        const [idiomaTecTecno, setIdiomaTecTecno] = React.useState([])
        const [idiomaSelectedTecTecno, setIdiomaSelectedTecTecno] = React.useState("")
        const [ciudadesSelectedTecTecno, setCiudadesSelectedTecTecno] = React.useState("")
        // formulario divulgacion 
        const [tipoContenidoSelected, setTipoContenidoSelected] = React.useState("")
        const [tipoContenido, setTipoContenido] = React.useState([])
        const [tipoDesarrollo, setTipoDesarrollo] = React.useState([])
        const [tipoDesarrolloSelected, setTipoDesarrolloSelected] = React.useState("")
        const [medioVerificacion, setMedioVerificacion] = React.useState([])
        const [medioVerificacionSelected, setMedioVerificacionSelected] = React.useState("")
        const [tipoClase, setTipoClase] = React.useState([])
        const [tipoClaseSelected, setTipoClaseSelected] = React.useState("")
        const [idiomaArticulo, setIdiomaArticulo] = React.useState([])
        const [idiomaArticuloSelected, setIdiomaArticuloSelected] = React.useState("")
        const [generoLiterario, setGeneroLiterario] = React.useState([])
        const [generoLiterarioSelected, setGeneroLiterarioSelected] = React.useState("")
        const [fecha, setFecha]= React.useState(new Date())
        const [fechaFinal, setFechaFinal]= React.useState(new Date())
        const [ciudadesDivulgacion, setCiudadesDivulgacion] = React.useState([])
        const [ciudadesSelectedDivulgacion, setCiudadesSelectedDivulgacion] = React.useState("")
        const [publicoObjetivo, setPublicoObjetivo] = React.useState([])
        const [publicoObjetivoSelected, setPublicoObjetivoSelected] = React.useState("")
        const [rutaCirculacion, setRutaCirculacion] = React.useState([])
        const [rutaCirculacionSelected, setRutaCirculacionSelected] = React.useState("")
        //formulario conocimiento Social
        const [licencia, setLicencia]= React.useState([])
        const [licenciaSelected,setlicenciaSelected]= React.useState("") 
        const [tipoEmpresa, setTipoEmpresa] = React.useState([])
        const [tipoEmpresasoSelected, setTipoEmpresasoSelected] =React.useState("")
        //FORMULARIO RECURSO
        const [tipoProyecto, setTipoProyecto] = React.useState([])
        const [tipoProyectoSelected, setTipoProyectoSelected]= React.useState("") 
        const [orientacion, setOrientacion] = React.useState([])
        const [orientacionSelected, setOrientacionSelected] = React.useState("") 

        //Formulario estrtegias
         const [indiquecual,setIndiquecual] = React.useState("")
        //Empresas de base cultural
        const [fechaRegistroEmpresaCultural, setFechaRegistroEmpresaCultural] = React.useState(new Date())
        const [otroTipoEspacioEvento, setOtroTipoEspacioEvento] = React.useState("")
        //Estados para rol y participacion de algunos formularios para los autores o participantes
        const [rolActive, setRolActive] = React.useState(false)
        const [modalidadParticipacionActive, setModalidadParticipacionActive] = React.useState(false)
        //Data final

        //Centros
        const [centroInvestigacion, setCentroInvestigacion] = React.useState([]);
        const [centrosInvestigacion, setCentrosInvestigacion] = React.useState([]);
        
    let data = {}

    //Errores
    const [errores, setErrores] = React.useState([]);

    React.useEffect( () => {
        //Obtengo los prceosos activos de la persona activa.
        if(isInitialMount.current){
            isInitialMount.current = false
            const obtenerProcesos = async () => {
                obtenerTiposDeSolicitudes()
            }
            obtenerProcesos()
        }
    })


    const obtenerTiposDeSolicitudes = async () => {
        try{
          const data = await Funciones.obtenerValores(Helper.NUEVO_GESTION_TIPOS_INVESTIGACION)

          setTipoSolicitud(data)
          setCargando(false)

        }catch(err){

        }
    }

    const handleClickChangeToForm = async (item) =>{
        setCargandoFormGestion(true)
        setCargando(true)
        let permisos = await obtenerPermisosValor(item.id);
        setPermisosDeLaSolicitud(permisos)

        if(permisos[0].secundario.codigo == "Inves_par_participante"){
            setSteps(['Información del General', 'Información del Participante'])
        }else{
            setSteps(['Información del General', 'Coautores'])
        }

        setTipoSolicitudActual(item.codigo)
        if(item.codigo == "Soli_inves_social"){
            setSeleccion('social')
            setCargando(false)
        }else if(item.codigo == "Semi_inves_generacion"){
            setSeleccion('bibliografica')
            setCargando(false)
        }else if(item.codigo == "Semi_inves_tecnologico"){
            setSeleccion('tecnica')
            setCargando(false)
        }else if(item.codigo == "Semi_inves_divulgacion"){
            setSeleccion('proyectos')
            setCargando(false)
        }else if(item.codigo == "Semi_estrategiasCuc"){
            setSeleccion('estrategias')
            setCargando(false)
        }else if(item.codigo == "Semi_ForRecurso"){
            setSeleccion('recursos')
            setCargando(false)
        }

    }

    const handleClickChangeToFormBibliografia = (item) =>{
        if (item.codigo === "Inves_tipo_obra") {
        setSteps(['Información General']);
         }else{setSteps(['Información General', 'Coautores'])}
        setSeleccion('gestionBibliografica')
        setCargandoProduBibliografico(true)
        setTipoProduccionBiblio(item)
    }

    const handleClickChangeToFormTec = (item) =>{
        setSteps(['Información del General', 'Autores'])
        setSeleccion('gestionTecnica')
        setTipoProduccionTecnica(item)
        setTipoProductoTecSelected(item);
    }

    const handleClickChangeFormDivulgacion   = (item) => {
        setSteps(['Información del General', 'Autores'])
        setSeleccion('gestionProyectos')
        setTipoProduccionDivulgacion(item)
        setTipoProductoDivSelected(item);
    }

    const handleClickChangeFormSocial = (item) =>{
        setSteps(['Información del General', 'Autores'])
        setSeleccion('gestionSocial')
        setTipoProduccionSocial(item)
        setTipoProductoSolSelected(item);

    }

    const handleClickChangeFormRecursos = (item) =>{
        setSteps(['Información del General', 'Autores'])
        setSeleccion('gestionRecursos')
        setTipoProduccionRecursos(item)
        setTipoProductoRecSelected(item);

    }
    const handleClickChangeFormEstrategias = (item) =>{
        setSteps(['Información del General', 'Autores'])
        setSeleccion('gestionEstrategias')
        setTipoProduccionEstrategias(item)
        setTipoProductoEstSelected(item);

    }
    //Sistema de errores

    const getError = (llave, errores) => {
        let existe = errores.find(e => e.llave === llave);
        return existe ? existe.mensaje : '';
    }

    const validateInputs = (campos = []) => {
        return new Promise((resolve) => {
        let errores = [];
        let date_now = new Date()

        function isObjEmpty(obj) {

            if(typeof obj === 'object'){
                for (var prop in obj) {
                    if (obj.hasOwnProperty(prop)) return false;
                  }

                  return true;
            }else if(typeof obj === 'string'){
                return true
            }else{
                return false;
            }

        }

        campos.map(({ value, name, err, value2 }) => {

            if (!err.obj && err.empty && (typeof value !== "string" || value.trim() === "")) errores.push({ llave: name, 'mensaje': `Este campo es obligatorio` });
            if (!err.obj && err.empty === false && (Array.isArray(value) ? value.length === 0 : !value)) errores.push({ llave: name, 'mensaje': `Este campo es obligatorio` })
            //Validacion exclusiva para buscar Select.
            if (err.empty && isObjEmpty(value) && err.obj){
                errores.push({ llave: name, 'mensaje': `Este campo es obligatorio` })
            }

            // Validación para el año de publicación
            if (value instanceof Date && isNaN(value.getTime())) {
                errores.push({ llave: name, 'mensaje': `Este campo es obligatorio` })
            }
        });

        resolve(errores);
        });
    }
    const validateInputsTecnico = (campos = []) => {
        return new Promise((resolve) => {
        let errores = [];

        function isObjEmpty(obj) {

            if(typeof obj === 'object'){
                for (var prop in obj) {
                    if (obj.hasOwnProperty(prop)) return false;
                  }

                  return true;
            }else if(typeof obj === 'string'){
                return true
            }else{
                return false;
            }

        }

        campos.map(({ value, name, err }) => {

            if (!err.obj && err.empty && value.replace(/\s+/g, '') == "") {
                errores.push({ llave: name, 'mensaje': `Este campo es obligatorio` })
            }
            if (err.empty && isObjEmpty(value) && err.obj){
                errores.push({ llave: name, 'mensaje': `Este campo es obligatorio` })
            }
            /*if (err.numeric && isNaN(value)) errores.push({ llave: name, 'mensaje': `Este campo debe ser un numero` });
            if (err.email && !validarCorreo(value)) errores.push({ llave: name, 'mensaje': `Correo invalido` });
            if (err.before_today && value >= date_now) errores.push({ llave: name, 'mensaje': `Fecha futura invalida` });
            if (err.after_today && value <= date_now) errores.push({ llave: name, 'mensaje': `Fecha pasada invalida` });
            if (err.finish_date && value <= value2) errores.push({ llave: name, 'mensaje': `Fecha invalida` });
            if (err.range && (value < 1 || value > value2)) errores.push({ llave: name, 'mensaje': `El valor está fuera del rango permitido` });
            if (err.not_null && value == null) errores.push({ llave:name, 'mensaje': `Este campo es obligatorio` });
            if (err.not_decimal && value % 1 != 0) errores.push({ llave: name, 'mensaje': `El valor no puede ser decimal` });*/
        });

        resolve(errores);
        });
    }
    //Evento para cambiar de step
    const handleNext = async () => {
        if(seleccion == 'gestion'){
            if(tipoSolicitudActual == "Soli_inves_evento"){
                if(activeStep == 0){

                    function isObjEmpty(obj) {

                        if(typeof obj === 'object'){
                            for (var prop in obj) {
                                if (obj.hasOwnProperty(prop)) return false;
                              }

                              return true;
                        }else if(typeof obj === 'string'){
                            return true
                        }else{
                            return false;
                        }

                    }

                    let array = await validateInputs([
                        { value: nombreDelEvento, name: 'nombreDelEvento', err: { empty: true, obj: false } },
                        { value: departamento, name: 'departamento', err: { empty: true, obj: true } },
                        { value: ciudad, name: 'ciudad', err: { empty: true, obj: true } },
                        { value: nombreDelAmbito, name: 'nombreDelAmbito', err: { empty: true, obj: true } },
                    ])
                    setErrores(array)
                    let fecha_inicio = moment(fechaInicioEvento).format('YYYY-MM-DD');
                    let fecha_fin = moment(fechaFinEvento).format('YYYY-MM-DD');
                    let aniio = moment(anio).format('YYYY')
                    let fecha_inicio_1 = moment(fechaInicioEvento).format('YYYY');
                    let fecha_fin_1 = moment(fechaFinEvento).format('YYYY');

                    if(aniio != fecha_inicio_1 || aniio != fecha_fin_1){
                        let tipo = "info"
                        let titulo = "El año no coincide con la fecha de inicio o fin."
                        dispatch(
                            actualizarMensaje({ titulo, tipo, mostrar: true, tiempo: 6000 })
                          );
                    }else if(fecha_inicio > fecha_fin){
                        let tipo = "info"
                        let titulo = "La Fecha Inicio es mayor que la Fecha Fin"
                        dispatch(
                            actualizarMensaje({ titulo, tipo, mostrar: true, tiempo: 6000 })
                          );
                    }else if(array.length > 0){

                    }else if(!adj_evento){
                        dispatch(
                            actualizarMensaje({ titulo: 'Debe adjuntar el soporte', tipo: "info", mostrar: true, tiempo: 5000 })
                        );
                    }else{
                        let adj_evento1 = document.getElementById('adj_evento').files[0];
                        if (adj_evento1) setAdj_evento_final(adj_evento1);

                        data = {
                            nombre:nombreDelEvento,
                            anio:anio,
                            departamento:departamento,
                            ciudad: ciudad,
                            ambito:nombreDelAmbito,
                            fecha_de_inicio: fecha_inicio,
                            fecha_de_fin: fecha_fin,
                            tipo: tipoSolicitudActual
                        }

                        setActiveStep((prevActiveStep) => prevActiveStep + 1);
                    }
                }
            }else if(tipoSolicitudActual == "Semi_inves_divulgacion"){
                if(activeStep == 0){

                    let array = await validateInputs([
                        { value: nombreProyecto, name: 'nombreProyecto', err: { empty: true, obj: false } },
                        { value: descripcionProyecto, name: 'descripcionProyecto', err: { empty: true, obj: false } },
                        { value: asignaturaProyecto, name: 'asignaturaProyecto', err: { empty: true, obj: false } },
                        // { value: nombreprofesorProyecto, name: 'nombreprofesorProyecto', err: { empty: true, obj: false } },
                    ])

                    setErrores(array)
                    let fecha_inicio = moment(fechaInicio).format('YYYY-MM-DD');
                    let fecha_fin = moment(fechaFin).format('YYYY-MM-DD');
                    if(fecha_inicio > fecha_fin){
                        let tipo = "info"
                        let titulo = "La Fecha Inicio es mayor que Fecha Fin"
                        dispatch(
                            actualizarMensaje({ titulo, tipo, mostrar: true, tiempo: 6000 })
                          );
                    }else if(array.length > 0){

                    }else{

                        data = {
                            nombreProyecto:nombreProyecto,
                            descripcionProyecto:descripcionProyecto,
                            asignaturaProyecto:asignaturaProyecto,
                            profesor:nombreprofesorProyecto,
                            fechaInicio: fecha_inicio,
                            fechaFin: fecha_fin
                        }

                        setActiveStep((prevActiveStep) => prevActiveStep + 1);
                    }

                }
            }else if(tipoSolicitudActual == "Semi_inves_generacion"){

            }else if(tipoSolicitudActual == "Semi_inves_tecnologico"){

            }else{

            }

        }else if(seleccion == "gestionBibliografica"){
            if(tipoProduccionBiblio.codigo == 'Inves_tipo_biblio_articulo'){
                if(activeStepBiblio == 0){
                    let array = await validateInputs([
                        { value: tituloArticulo, name: 'tituloArticulo', err: { empty: true, obj: false } },
                        { value: PaginaInicial, name: 'PaginaInicial', err: { empty: true, obj: false } },
                        { value: PaginaFinal, name: 'PaginaFinal', err: { empty: true, obj: false } },
                        { value: issn, name: 'issn', err: { empty: true, obj: false } },
                        { value: nombreRevista, name: 'nombreRevista', err: { empty: true, obj: false } },
                        { value: volumenRevista, name: 'volumenRevista', err: { empty: true, obj: false } },
                        { value: CiudadesTipoArticuloSelected, name: 'CiudadesTipoArticuloSelected', err: { empty: true, obj: true } },
                        { value: idiomaTipoArticuloSelected, name: 'idiomaTipoArticuloSelected', err: { empty: true, obj: true } },
                        { value: enlace, name: 'enlace', err: { empty: true, obj: false } },
                        { value: doi, name: 'doi', err: { empty: true, obj: false } },
                        { value: mediodivulgacion, name: 'mediodivulgacion', err: { empty: true, obj: false } },
                    ])
                    console.log(array);
                    setErrores(array)

                    if(array.length > 0){

                    }else{
                     setActiveStepBiblio((prevActiveStep) => prevActiveStep + 1);
                    }}
                
                }else if(tipoProduccionBiblio.codigo == 'Inves_tipo_biblio_libro'){
                if(activeStepBiblio == 0){

                    let array = await validateInputs([
                        { value: tituloLibro, name: 'tituloLibro', err: { empty: true, obj: false } },
                        { value: mediopublicacionlibro, name: 'mediopublicacionlibro', err: { empty: true, obj: false } }, 
                        { value: mediodivulgacion, name: 'mediodivulgacion', err: { empty: true, obj: false } },
                        { value: isbnLibro, name: 'isbnLibro', err: { empty: true, obj: false } },
                        { value: editorialLibro, name: 'editorialLibro', err: { empty: true, obj: false } },
                        { value: adj_certificado2, name: 'adj_certificado2', err: { empty: true, obj: false } },
                        { value: adj_certificado3, name: 'adj_certificado3', err: { empty: true, obj: false } },
                    ])
                    setErrores(array)

                    if(array.length > 0){
                    

                   } else if (!adj_certificado2) {
                        dispatch(
                            actualizarMensaje({
                                titulo: 'Debe adjuntar el certificado 2',
                                tipo: "info",
                                mostrar: true,
                                tiempo: 5000
                            })
                        );
                    } else if (!adj_certificado3) {
                        dispatch(
                            actualizarMensaje({
                                titulo: 'Debe adjuntar el certificado 3',
                                tipo: "info",
                                mostrar: true,
                                tiempo: 5000
                            })
                        );
                    } else {
                        let adj_certificado2_file = document.getElementById('adj_certificado2').files[0];
                        if (adj_certificado2_file) setAdj_certificado_final2(adj_certificado2_file);

                        let adj_certificado3_file = document.getElementById('adj_certificado3').files[0];
                        if (adj_certificado3_file) setAdj_certificado_final3(adj_certificado3_file);

                        setActiveStepBiblio((prevActiveStep) => prevActiveStep + 1);
                    }
                    
                }
            }else if(tipoProduccionBiblio.codigo == 'Inves_tipo_biblio_capituloLib'){
                if(activeStepBiblio == 0){

                    let array = await validateInputs([
                        { value: tituloCapLibro, name: 'tituloCapLibro', err: { empty: true, obj: false } },
                        { value: tituloLibroCap, name: 'tituloLibroCap', err: { empty: true, obj: false } },
                        { value: PaginaInicial, name: 'PaginaInicial', err: { empty: true, obj: false } },
                        { value: paisTipoCapLibroSelected, name: 'paisTipoCapLibroSelected', err: { empty: true, obj: true } },
                        { value: PaginaFinal, name: 'PaginaFinal', err: { empty: true, obj: false } },
                        { value: numeropaginas, name: 'numeropaginas', err: { empty: true, obj: false } },
                        { value: isbnLibroCap, name: 'isbnLibroCap', err: { empty: true, obj: false } },
                        { value: mediodivulgacion, name: 'mediodivulgacion', err: { empty: true, obj: false } },
                        { value: adj_certificado2, name: 'adj_certificado2', err: { empty: true, obj: false } },
                        { value: adj_certificado3, name: 'adj_certificado3', err: { empty: true, obj: false } },
                    ])
                    setErrores(array)

                    if(array.length > 0){
                    

                   } else if (!adj_certificado2) {
                        dispatch(
                            actualizarMensaje({
                                titulo: 'Debe adjuntar el certificado 2',
                                tipo: "info",
                                mostrar: true,
                                tiempo: 5000
                            })
                        );
                    } else if (!adj_certificado3) {
                        dispatch(
                            actualizarMensaje({
                                titulo: 'Debe adjuntar el certificado 3',
                                tipo: "info",
                                mostrar: true,
                                tiempo: 5000
                            })
                        );
                    } else {
                        let adj_certificado2_file = document.getElementById('adj_certificado2').files[0];
                        if (adj_certificado2_file) setAdj_certificado_final2(adj_certificado2_file);

                        let adj_certificado3_file = document.getElementById('adj_certificado3').files[0];
                        if (adj_certificado3_file) setAdj_certificado_final3(adj_certificado3_file);

                        setActiveStepBiblio((prevActiveStep) => prevActiveStep + 1);
                    }
                    
                }
            }else if (tipoProduccionBiblio.codigo == 'Inves_tipo_obra'){
                let inputs = [
                { value: nombreObra, name: 'nombreObra', err: { empty: true, obj: false } },
                { value: disciplinaSelected, name: 'disciplinaSelected', err: { empty: true, obj: true } },
                { value: tituloObraproducto, name: 'tituloObraproducto', err: { empty: true, obj: false } },
                { value: tecnica, name: 'tecnica', err: { empty: true, obj: false } },
                { value: anioPublicacion ? new Date(anioPublicacion).getFullYear().toString() : "", name: 'anioPublicacion', err: { empty: true, obj: false } },                        
                { value: nombreespacio, name: 'nombreespacio', err: { empty: true, obj: false } },
                { value: tipoespacioSelected, name: 'tipoespacioSelected', err: { empty: true, obj: true } },
                { value: fechapresentacion ? new Date(fechapresentacion).getFullYear().toString() : "", name: 'fechapresentacion', err: { empty: true, obj: false } },
                { value: aniocreacionespacio ? new Date(aniocreacionespacio).getFullYear().toString() : "", name: 'aniocreacionespacio', err: { empty: true, obj: false } },
                { value: distincionSelected, name: 'distincionSelected', err: { empty: true, obj: true } },
                { value: entidadconvocante, name: 'entidadconvocante', err: { empty: true, obj: false } },
                { value: tipoAmbitoSelected, name: 'tipoAmbitoSelected', err: { empty: true, obj: true } },
                { value: mecanismoSelected, name: 'mecanismoSelected', err: { empty: true, obj: true } },
                { value: acuerdoLicencia, name: 'acuerdoLicencia', err: { empty: true, obj: false } }, 
                ];

                // Si acuerdoLicencia es "si"
                if (acuerdoLicencia === "si") {
                    inputs.push(
                        { value: institucionlicencia, name: 'institucionlicencia', err: { empty: true, obj: false } },
                        { value: fechaotrogamiento ? new Date(fechaotrogamiento).getFullYear().toString() : "", name: 'fechaotrogamiento', err: { empty: true, obj: false } },
                        { value: numeroregistro, name: 'numeroregistro', err: { empty: true, obj: false } },
                        { value: contratocomercializacion, name: 'contratocomercializacion', err: { empty: true, obj: false } }
                    );
                }
                let array = await validateInputs(inputs);

                console.log(array);
                setErrores(array);

                if (array.length === 0) {
                       handleSendToApi();
                }
            

            }else if(tipoProduccionBiblio.codigo == 'Inves_tipo_biblio_patente'){
                if(activeStepBiblio == 0){
                let arrai = await validateInputs([
                    { value: tituloPatente, name: 'tituloPatente', err: { empty: true, obj: false } },
                    { value: numeroPatente, name: 'numeroPatente', err: { empty: true, obj: false } },
                    { value: nombreSolicitante, name:'nombreSolicitante', err:{ empty: true, obj:false}},
                    { value: tipoPatenteSelected, name: 'tipoPatenteSelected', err: { empty: true, obj: true } },
                    { value: viaSolicitudSelected, name: 'viaSolicitudSelected', err:{empty: true, obj:true}},
                    { value: institucionPatente, name: 'institucionPatente', err: { empty: true, obj: false } },
                    { value: adj_certificado2, name: 'adj_certificado2', err: { empty: true, obj: false } },
                    { value: acuerdoLicencia, name: 'acuerdoLicencia', err: { empty: true, obj: false } }, 
                    { value: adj_certificado3, name: 'adj_certificado3', err: { empty: true, obj: false } },
                    { value: adj_certificado4, name: 'adj_certificado4', err: { empty: true, obj: false } },
                ]);
                setErrores(arrai);
                if(arrai.length > 0){
                } else if (!adj_certificado2) {
                    dispatch(actualizarMensaje({
                        titulo: 'Debe adjuntar el certificado 2',
                        tipo: "info",
                        mostrar: true,
                        tiempo: 5000
                    }));
                } else if (!adj_certificado3) {
                    dispatch(actualizarMensaje({
                        titulo: 'Debe adjuntar el certificado 3',
                        tipo: "info",
                        mostrar: true,
                        tiempo: 5000
                    }));
                } else if (!adj_certificado4) {
                    dispatch(actualizarMensaje({
                        titulo: 'Debe adjuntar el certificado 4',
                        tipo: "info",
                        mostrar: true,
                        tiempo: 5000
                    }));
                } else {
                    let adj_certificado2_file = document.getElementById('adj_certificado2').files[0];
                    if (adj_certificado2_file) setAdj_certificado_final2(adj_certificado2_file);

                    let adj_certificado3_file = document.getElementById('adj_certificado3').files[0];
                    if (adj_certificado3_file) setAdj_certificado_final3(adj_certificado3_file);

                    let adj_certificado4_file = document.getElementById('adj_certificado4').files[0];
                    if (adj_certificado4_file) setAdj_certificado_final4(adj_certificado4_file);

                    setActiveStepBiblio((prevActiveStep) => prevActiveStep + 1);
                }
            }
        }
    }else if(seleccion == "gestionTecnica"){
                if(tipoProductoTecSelected.codigo == "Inves_tipo_tec_pro_diseñoIndustrial"){

                    if(activeStepBiblio == 0){
                        let array = []
                        let errorSelects = []
                        let sw = true
                        for (const item of inputs) {
                            let error = []

                            if(item.codigo.includes('fecha')){
                                if(item.codigo == "fechaCreacion"){
                                    let fecha_actual = moment(new Date()).format('YYYY-MM');
                                    let fecha = moment(fechaCreacionDiseñoIndus).format('YYYY-MM');
                                    if(fecha_actual < fecha){
                                        let tipo = "info"
                                        let titulo = "Elija una fecha de Creacion valida"
                                        sw = false
                                        dispatch(
                                            actualizarMensaje({ titulo, tipo, mostrar: true, tiempo: 6000 })
                                        );
                                    }
                                }
                            }if(item.codigo.includes('ciudad')){
                            }else{
                                if(item.codigo != "fechaCreacion"){
                                    error = await validateInputsTecnico([
                                        { value: item.value, name: item.codigo, err: { empty: true, obj: false } },
                                    ])
                                }
                            }
                            if(error.length != 0){
                                array.push(error[0])
                            }

                        }

                        errorSelects = await validateInputsTecnico([
                            { value: productoTieneSelected, name: 'productoTiene', err: { empty: true, obj: true } },
                            { value: ciudadesSelectedTecTecno, name: 'ciudadesSelectedTecTecno', err: { empty: true, obj: true } },

                        ])

                        if(errorSelects.length != 0){
                            array.push(errorSelects[0])
                        }else {
                            if(productoTieneSelected.codigo != "ningunoDiseñoPrototipoTiene"){
                                for (const item of inputsSelects) {
                                    let error = []

                                    if(item.codigo.includes('fecha')){
                                        if(item.codigo == "fechaRegistroDiseñoPrototipoTiene"){
                                            let fecha_actual = moment(new Date()).format('YYYY-MM');
                                            let fecha = moment(fechaRegistroDiseñoPrototipoTiene).format('YYYY-MM');
                                            if(fecha_actual < fecha){
                                                let tipo = "info"
                                                let titulo = "Elija una Fecha de Obtención del Registro valida"
                                                sw = false
                                                dispatch(
                                                    actualizarMensaje({ titulo, tipo, mostrar: true, tiempo: 6000 })
                                                );
                                            }
                                        }
                                    }else{
                                        error = await validateInputsTecnico([
                                            { value: item.value, name: item.codigo, err: { empty: true, obj: false } },
                                        ])
                                    }
                                    if(error.length != 0){
                                        array.push(error[0])
                                    }
                                }
                            }
                        }

                        setErrores(array)
                        if(array.length == 0 && sw == true){
                            setActiveStepBiblio((prevActiveStep) => prevActiveStep + 1);
                        }

                    }

                }else if(tipoProductoTecSelected.codigo == "Inves_tipo_tec_pro_software"){
                    if(activeStepBiblio == 0){
                        let array = []
                        let errorSelects = []
                        let sw = true
                        for (const item of inputs) {
                            let error = []

                            if(item.codigo.includes('fecha')){
                                if(item.codigo == "fechaDesarrolloSoftware"){
                                    let fecha_actual = moment(new Date()).format('YYYY-MM-DD');
                                    let fecha = moment(fechaDesarrolloSoftware).format('YYYY-MM-DD');
                                    if(fecha_actual < fecha){
                                        let tipo = "info"
                                        let titulo = "Elija una Fecha de Desarrollo valida"
                                        sw = false
                                        dispatch(
                                            actualizarMensaje({ titulo, tipo, mostrar: true, tiempo: 6000 })
                                        );
                                    }
                                }
                            } else if(item.codigo.includes('pais') || item.codigo.includes('disponibilidad')) {
                            }else{
                                if(item.codigo != "fechaDesarrolloSoftware" && item.codigo != "fechaObtencionRegistroSoftware"){
                                    error = await validateInputsTecnico([
                                        { value: item.value, name: item.codigo, err: { empty: true, obj: false } },

                                    ])
                                }
                            }
                            if(error.length != 0){
                                array.push(error[0])
                            }

                        }

                        errorSelects = await validateInputsTecnico([
                            { value: paisSelectedTecTecno, name: 'paisSelectedTecTecno', err: { empty: true, obj: true } },
                            { value: disponibilidadSelectedTecTecno, name: 'disponibilidadSelectedTecTecno', err: { empty: true, obj: true } },
                            { value: adj_certificado2, name: 'adj_certificado2', err: { empty: true, obj: false } },
                            { value: adj_certificado3, name: 'adj_certificado3', err: { empty: true, obj: false } },
                        ])

                        if(errorSelects.length != 0){
                            for(let i = 0; i < errorSelects.length; i++){
                                array.push(errorSelects[i])
                            }
                        }

                        setErrores(array)
                        if(array.length == 0 && sw == true){
                            setActiveStepBiblio((prevActiveStep) => prevActiveStep + 1);
                        }
                    }
                }else if(tipoProductoTecSelected.codigo == "Inves_tipo_tec_pro_prototipo"){
                    if(activeStepBiblio == 0){
                        let array = []
                        let errorSelects = []
                        let sw = true
                        for (const item of inputs) {
                            let error = []

                            if(item.codigo.includes('fecha')){
                                if(item.codigo == "fechaCreacionPrototipo"){
                                    let fecha_actual = moment(new Date()).format('YYYY-MM-DD');
                                    let fecha = moment(fechaCreacionPrototipo).format('YYYY-MM-DD');
                                    if(fecha_actual < fecha){
                                        let tipo = "info"
                                        let titulo = "Elija una Fecha de Creación Prototipo valida"
                                        sw = false
                                        dispatch(
                                            actualizarMensaje({ titulo, tipo, mostrar: true, tiempo: 6000 })
                                        );
                                    }
                                }
                            } else if(item.codigo.includes('ciudad') || item.codigo.includes('disponibilidad')) {
                            }else{
                                if(item.codigo != "fechaCreacionPrototipo"){
                                    error = await validateInputsTecnico([
                                        { value: item.value, name: item.codigo, err: { empty: true, obj: false } },
                                    ])
                                }
                            }
                            if(error.length != 0){
                                array.push(error[0])
                            }

                        }

                        errorSelects = await validateInputsTecnico([
                            { value: productoTieneSelected, name: 'productoTiene', err: { empty: true, obj: true } },
                            { value: tipoPrototipoSelected, name: 'tipoPrototipoSelected', err: { empty: true, obj: true } },
                            { value: ciudadesSelectedTecTecno, name: 'ciudadesSelectedTecTecno', err: { empty: true, obj: true } },
                            { value: disponibilidadSelectedTecTecno, name: 'disponibilidadSelectedTecTecno', err: { empty: true, obj: true } },
                        ])

                        if(errorSelects.length != 0){
                            for(let i = 0; i < errorSelects.length; i++){
                                array.push(errorSelects[i])
                            }
                        }else {
                            if(productoTieneSelected.codigo != "ningunoDiseñoPrototipoTiene"){
                                for (const item of inputsSelects) {
                                    let error = []

                                    if(item.codigo.includes('fecha')){
                                        if(item.codigo == "fechaRegistroDiseñoPrototipoTiene"){
                                            let fecha_actual = moment(new Date()).format('YYYY-MM-DD');
                                            let fecha = moment(fechaRegistroDiseñoPrototipoTiene).format('YYYY-MM-DD');
                                            if(fecha_actual < fecha){
                                                let tipo = "info"
                                                let titulo = "Elija una Fecha de Obtención del Registro valida"
                                                sw = false
                                                dispatch(
                                                    actualizarMensaje({ titulo, tipo, mostrar: true, tiempo: 6000 })
                                                );
                                            }
                                        }
                                    }else{
                                        error = await validateInputsTecnico([
                                            { value: item.value, name: item.codigo, err: { empty: true, obj: false } },
                                        ])
                                    }
                                    if(error.length != 0){
                                        array.push(error[0])
                                    }
                                }
                            }
                        }

                        setErrores(array)
                        if(array.length == 0 && sw == true){
                            setActiveStepBiblio((prevActiveStep) => prevActiveStep + 1);
                        }
                    }
                }else if(tipoProductoTecSelected.codigo == "Inves_tipo_tec_pro_signo_distintivo"){
                    if(activeStepBiblio == 0){
                        let array = []
                        let errorSelects = []
                        let sw = true
                        for (const item of inputs) {
                            let error = []

                            if(item.codigo.includes('fecha')){
                                if(item.codigo == "fechaCreacionSignoDistintivo"){
                                    let fecha_actual = moment(new Date()).format('YYYY-MM-DD');
                                    let fecha = moment(fechaCreacionSignoDistintivo).format('YYYY-MM-DD');
                                    if(fecha_actual < fecha){
                                        let tipo = "info"
                                        let titulo = "Elija una Fecha de Creación Signo Distintivo valida"
                                        sw = false
                                        dispatch(
                                            actualizarMensaje({ titulo, tipo, mostrar: true, tiempo: 6000 })
                                        );
                                    }
                                }
                            }if(item.codigo.includes('tipo')){
                            }else{
                                if(item.codigo != "fechaCreacionSignoDistintivo"){
                                    error = await validateInputsTecnico([
                                        { value: item.value, name: item.codigo, err: { empty: true, obj: false } },
                                    ])
                                }
                            }
                            if(error.length != 0){
                                array.push(error[0])
                            }

                        }

                        errorSelects = await validateInputsTecnico([
                            { value: adj_certificado2, name: 'adj_certificado2', err: { empty: true, obj: false } },
                            { value: tipoSignoDistintivoSelected, name: 'tipoSignoDistintivoSelected', err: { empty: true, obj: true } },
                        ])

                        if(errorSelects.length != 0){
                            for(let i = 0; i < errorSelects.length; i++){
                                array.push(errorSelects[i])
                            }
                        }

                        setErrores(array)
                        if(array.length == 0 && sw == true){
                            setActiveStepBiblio((prevActiveStep) => prevActiveStep + 1);
                        }
                    }
                }if(tipoProductoTecSelected.codigo == "Inves_tipo_tec_pro_empCreaCul"){
                    if(activeStepBiblio == 0){
                        let array = []
                        let errorSelects = []
                        let sw = true
                        for (const item of inputs) {
                            let error = []

                            if(item.codigo.includes('fecha')){
                                if(item.codigo == "fechaRegistroEmpresaCultural"){
                                    let fecha_actual = moment(new Date()).format('YYYY-MM-DD');
                                    let fecha = moment(fechaRegistroEmpresaCultural).format('YYYY-MM-DD');
                                    if(fecha_actual < fecha){
                                        let tipo = "info"
                                        let titulo = "Elija una Fecha de Registro valida"
                                        sw = false
                                        dispatch(
                                            actualizarMensaje({ titulo, tipo, mostrar: true, tiempo: 6000 })
                                        );
                                    }
                                }
                            }else{
                                error = await validateInputsTecnico([
                                    { value: item.value, name: item.codigo, err: { empty: true, obj: false } },
                                ])
                            }
                            if(error.length != 0){
                                array.push(error[0])
                            }

                        }

                        errorSelects = await validateInputsTecnico([
                            { value: tipoDisciplinaAmbitoSelected, name: 'tipoDisciplinaAmbitoSelected', err: { empty: true, obj: true } },
                            { value: acuerdoLicencia, name: 'acuerdoLicencia', err: { empty: true, obj: false } },
                            { value: adj_certificado2, name: 'adj_certificado2', err: { empty: true, obj: false } },
                            { value: adj_certificado3, name: 'adj_certificado3', err: { empty: true, obj: false } }



                        ])

                        if(errorSelects.length != 0){
                            for(let i = 0; i < errorSelects.length; i++){
                                array.push(errorSelects[i])
                            }
                        }

                        setErrores(array)
                        if(array.length == 0 && sw == true){
                            setActiveStepBiblio((prevActiveStep) => prevActiveStep + 1);
                        }
                    }
                }else if(tipoProductoTecSelected.codigo == "Inves_tipo_tec_pro_empBaseTec"){
                    if(activeStepBiblio == 0){
                        let array = []
                        let errorSelects = []
                        let sw = true
                        for (const item of inputs) {
                            let error = []

                            if(item.codigo.includes('fecha')){
                                if(item.codigo == "fechaRegistroBaseTecno"){
                                    let fecha_actual = moment(new Date()).format('YYYY-MM-DD');
                                    let fecha = moment(fechaRegistroBaseTecno).format('YYYY-MM-DD');
                                    if(fecha_actual < fecha){
                                        let tipo = "info"
                                        let titulo = "Elija una Fecha de Registro Base Tecnológica valida"
                                        sw = false
                                        dispatch(
                                            actualizarMensaje({ titulo, tipo, mostrar: true, tiempo: 6000 })
                                        );
                                    }
                                }
                            }else{
                                error = await validateInputsTecnico([
                                    { value: item.value, name: item.codigo, err: { empty: true, obj: false } },
                                ])
                            }
                            if(error.length != 0){
                                array.push(error[0])
                            }

                        }

                        errorSelects = await validateInputsTecnico([
                            { value: tipoEmpresaSelected, name: 'tipoEmpresaSelected', err: { empty: true, obj: true } },
                            { value: adj_certificado2, name: 'adj_certificado2', err: { empty: true, obj: false } },
                            { value: acuerdoLicencia, name: 'acuerdoLicencia', err: { empty: true, obj: false } },
                        ])

                        if(errorSelects.length != 0){
                            for(let i = 0; i < errorSelects.length; i++){
                                array.push(errorSelects[i])
                            }
                        }

                        setErrores(array)
                        if(array.length == 0 && sw == true){
                            setActiveStepBiblio((prevActiveStep) => prevActiveStep + 1);
                        }
                    }
                }else if(tipoProductoTecSelected.codigo == "Inves_tipo_tec_pro_innProProSer"){
                    if(activeStepBiblio == 0){
                        let array = []
                        let errorSelects = []
                        let sw = true
                        for (const item of inputs) {
                            let error = []

                            if(item.codigo.includes('fecha')){
                                if(item.codigo == "fechaInnovacionProceServi"){
                                    let fecha_actual = moment(new Date()).format('YYYY-MM-DD');
                                    let fecha = moment(fechaInnovacionProceServi).format('YYYY-MM-DD');
                                    if(fecha_actual < fecha){
                                        let tipo = "info"
                                        let titulo = "Elija una Fecha de la Innovación Procedimientos y Servicios valida"
                                        sw = false
                                        dispatch(
                                            actualizarMensaje({ titulo, tipo, mostrar: true, tiempo: 6000 })
                                        );
                                    }
                                }
                            }else if(item.codigo.includes('ciudad') || item.codigo.includes('disponibilidad')){
                            }else{
                                if(item.codigo != "fechaInnovacionProceServi"){
                                    error = await validateInputsTecnico([
                                        { value: item.value, name: item.codigo, err: { empty: true, obj: false } },
                                    ])
                                }
                            }
                            if(error.length != 0){
                                array.push(error[0])
                            }

                        }

                        errorSelects = await validateInputsTecnico([
                            { value: productoTieneSelected, name: 'productoTiene', err: { empty: true, obj: true } },
                            { value: ciudadesSelectedTecTecno, name: 'ciudadesSelectedTecTecno', err: { empty: true, obj: true } },
                            { value: disponibilidadSelectedTecTecno, name: 'disponibilidadSelectedTecTecno', err: { empty: true, obj: true } },
                            { value: adj_certificado2, name: 'adj_certificado2', err: { empty: true, obj: false } },
                        ])

                        if(errorSelects.length != 0){
                            for(let i = 0; i < errorSelects.length; i++){
                                array.push(errorSelects[i])
                            }
                        }else {
                            if(productoTieneSelected.codigo != "ningunoDiseñoPrototipoTiene"){
                                for (const item of inputsSelects) {
                                    let error = []

                                    if(item.codigo.includes('fecha')){
                                        if(item.codigo == "fechaRegistroDiseñoPrototipoTiene"){
                                            let fecha_actual = moment(new Date()).format('YYYY-MM-DD');
                                            let fecha = moment(fechaRegistroDiseñoPrototipoTiene).format('YYYY-MM-DD');
                                            if(fecha_actual < fecha){
                                                let tipo = "info"
                                                let titulo = "Elija una Fecha de Obtención del Registro valida"
                                                sw = false
                                                dispatch(
                                                    actualizarMensaje({ titulo, tipo, mostrar: true, tiempo: 6000 })
                                                );
                                            }
                                        }
                                    }else{
                                        error = await validateInputsTecnico([
                                            { value: item.value, name: item.codigo, err: { empty: true, obj: false } },
                                        ])
                                    }
                                    if(error.length != 0){
                                        array.push(error[0])
                                    }
                                }
                            }
                        }

                        setErrores(array)
                        if(array.length == 0 && sw == true){
                            setActiveStepBiblio((prevActiveStep) => prevActiveStep + 1);
                        }
                    }
                }else if(tipoProductoTecSelected.codigo == "Inves_tipo_tec_pro_innGenGesEmp"){
                    if(activeStepBiblio == 0){
                        let array = []
                        let errorSelects = []
                        let sw = true
                        for (const item of inputs) {
                            let error = []

                            if(item.codigo.includes('fecha')){
                                if(item.codigo == "fechaInnovacionGestionEmp"){
                                    let fecha_actual = moment(new Date()).format('YYYY-MM-DD');
                                    let fecha = moment(fechaInnovacionGestionEmp).format('YYYY-MM-DD');
                                    if(fecha_actual < fecha){
                                        let tipo = "info"
                                        let titulo = "Elija una Fecha de la Innovación Gestión Emp. valida"
                                        sw = false
                                        dispatch(
                                            actualizarMensaje({ titulo, tipo, mostrar: true, tiempo: 6000 })
                                        );
                                    }
                                }
                            }if(item.codigo.includes('ciudad') || item.codigo.includes('idioma') || item.codigo.includes('disponibilidad')){ 
                            }else{
                                if(item.codigo != "fechaInnovacionGestionEmp"){
                                    error = await validateInputsTecnico([
                                        { value: item.value, name: item.codigo, err: { empty: true, obj: false } },
                                    ])
                                }
                            }
                            if(error.length != 0){
                                array.push(error[0])
                            }

                        }

                        errorSelects = await validateInputsTecnico([
                            { value: productoTieneSelected, name: 'productoTiene', err: { empty: true, obj: true } },
                            { value: tipoInnovacionSelected, name: 'tipoInnovacionSelected', err: { empty: true, obj: true } },
                            { value: ciudadesSelectedTecTecno, name: 'ciudadesSelectedTecTecno', err: { empty: true, obj: true } },
                            { value: disponibilidadSelectedTecTecno, name: 'disponibilidadSelectedTecTecno', err: { empty: true, obj: true } },
                            { value: acuerdoLicencia, name: 'acuerdoLicencia', err: { empty: true, obj: false } },
                            { value: idiomaSelectedTecTecno, name: 'idiomaSelectedTecTecno', err: { empty: true, obj: true } },
                            { value: adj_certificado2, name: 'adj_certificado2', err: { empty: true, obj: false } },
                            { value: adj_certificado3, name: 'adj_certificado3', err: { empty: true, obj: false } },
                            { value: adj_certificado4, name: 'adj_certificado4', err: { empty: true, obj: false } },
                            { value: adj_certificado5, name: 'adj_certificado5', err: { empty: true, obj: false } }

                        ])

                        if(errorSelects.length != 0){
                            for(let i = 0; i < errorSelects.length; i++){
                                array.push(errorSelects[i])
                            }
                        }else {
                            if(productoTieneSelected.codigo != "ningunoDiseñoPrototipoTiene"){
                                for (const item of inputsSelects) {
                                    let error = []

                                    if(item.codigo.includes('fecha')){
                                        if(item.codigo == "fechaRegistroDiseñoPrototipoTiene"){
                                            let fecha_actual = moment(new Date()).format('YYYY-MM-DD');
                                            let fecha = moment(fechaRegistroDiseñoPrototipoTiene).format('YYYY-MM-DD');
                                            if(fecha_actual < fecha){
                                                let tipo = "info"
                                                let titulo = "Elija una Fecha de Obtención del Registro valida"
                                                sw = false
                                                dispatch(
                                                    actualizarMensaje({ titulo, tipo, mostrar: true, tiempo: 6000 })
                                                );
                                            }
                                        }
                                    }else{
                                        error = await validateInputsTecnico([
                                            { value: item.value, name: item.codigo, err: { empty: true, obj: false } },
                                        ])
                                    }
                                    if(error.length != 0){
                                        array.push(error[0])
                                    }
                                }
                            }
                        }

                        setErrores(array)
                        if(array.length == 0 && sw == true){
                            setActiveStepBiblio((prevActiveStep) => prevActiveStep + 1);
                        }
                    }
                }
            if(tipoProductoTecSelected.codigo == "Inves_tipo_tec_pro_obrPro"){
                    if(activeStepBiblio == 0){
                        let array = []
                        let errorSelects=[]
                        let sw = true
                        for (const item of inputs) {
                            let error = []

                            if(item.codigo.includes('fecha')){
                                if(item.codigo == "fechaPresentacionObraProducto"){
                                    let fecha_actual = moment(new Date()).format('YYYY-MM-DD');
                                    let fecha = moment(fechaPresentacionObraProducto).format('YYYY-MM-DD');
                                    if(fecha_actual < fecha){
                                        let tipo = "info"
                                        let titulo = "Elija una Fecha de Presentación Obra o Producto valida"
                                        sw = false
                                        dispatch(
                                            actualizarMensaje({ titulo, tipo, mostrar: true, tiempo: 6000 })
                                        );
                                    }
                                }else if(item.codigo == "fechaCreacionObraProducto"){
                                    let fecha_actual = moment(new Date()).format('YYYY-MM-DD');
                                    let fecha = moment(fechaCreacionObraProducto).format('YYYY-MM-DD');
                                    if(fecha_actual < fecha){
                                        let tipo = "info"
                                        let titulo = "Elija una Fecha de Creación Obra o Producto valida"
                                        sw = false
                                        dispatch(
                                            actualizarMensaje({ titulo, tipo, mostrar: true, tiempo: 6000 })
                                        );
                                    }
                                }
                            }if(item.codigo.includes('pais')){
                            }else{
                                if(item.codigo != "fechaCreacionObraProducto" && item.codigo != "fechaPresentacionObraProducto"){
                                    error = await validateInputsTecnico([
                                        { value: item.value, name: item.codigo, err: { empty: true, obj: false } },
                                    ])
                                }
                            }
                            if(error.length != 0){
                                array.push(error[0])
                            }

                        }

                        errorSelects = await validateInputsTecnico([
                            { value: tipoAmbitoSelected, name: 'tipoAmbitoSelected', err: { empty: true, obj: true } },
                            { value: tipoDisciplinaAmbitoSelected, name: 'tipoDisciplinaAmbitoSelected', err: { empty: true, obj: true } },
                            { value: tipoEspacioEventoSelected, name: 'tipoEspacioEventoSelected', err: { empty: true, obj: true } },
                            { value: paisSelectedTecTecno, name: 'paisSelectedTecTecno', err: { empty: true, obj: true } },
                        ])


                        if(errorSelects.length != 0){
                            for(let i = 0; i < errorSelects.length; i++){
                                array.push(errorSelects[i])
                            }
                        }else{
                            if(tipoEspacioEventoSelected.codigo == "Inves_tipo_espaEven_otro"){
                                let error = []
                                error = await validateInputsTecnico([
                                    { value: otroTipoEspacioEvento, name: 'otroTipoEspacioEvento', err: { empty: true, obj: false } },
                                ])
                                if(error.length != 0){
                                    array.push(error[0])
                                }
                            }
                        }

                        setErrores(array)
                        if(array.length == 0 && sw == true){
                            setActiveStepBiblio((prevActiveStep) => prevActiveStep + 1);
                        }
                    }
                }if(tipoProductoTecSelected.codigo == "Inves_tipo_tec_pro_eveArt"){
                    if(activeStepBiblio == 0){
                        let array = []
                        let errorSelects = []
                        let sw = true
                        for (const item of inputs) {
                            let error = []

                            if(item.codigo.includes('fecha')){
                                if(item.codigo == "fechaInicioEventoArtistico"){
                                    let fecha_inicio = moment(fechaInicioEventoArtistico).format('YYYY-MM');
                                    let fecha_final = moment(fechaFinalEventoArtistico).format('YYYY-MM');
                                    if(fecha_inicio > fecha_final){
                                        let tipo = "info"
                                        let titulo = "La fecha de inicio no puede ser mayor que la fecha final"
                                        sw = false
                                        dispatch(
                                            actualizarMensaje({ titulo, tipo, mostrar: true, tiempo: 6000 })
                                        );
                                    }
                                }
                            }if(item.codigo.includes('pais')){
                            }else{
                                if(item.codigo != "fechaInicioEventoArtistico" && item.codigo != "fechaFinalEventoArtistico"){
                                    error = await validateInputsTecnico([
                                        { value: item.value, name: item.codigo, err: { empty: true, obj: false } },
                                    ])
                                }
                            }
                            if(error.length != 0){
                                array.push(error[0])
                            }

                        }

                        errorSelects = await validateInputsTecnico([
                            { value: productoTieneSelected, name: 'productoTiene', err: { empty: true, obj: true } },
                            { value: paisSelectedTecTecno, name: 'paisSelectedTecTecno', err: { empty: true, obj: true } },
                        ])

                        if(errorSelects.length != 0){
                            for(let i = 0; i < errorSelects.length; i++){
                                array.push(errorSelects[i])
                            }
                        }

                        setErrores(array)
                        if(array.length == 0 && sw == true){
                            setActiveStepBiblio((prevActiveStep) => prevActiveStep + 1);
                        }
                    }
                }if(tipoProductoTecSelected.codigo == "Inves_tipo_tec_pro_talCre"){
                    if(activeStepBiblio == 0){
                        let array = []
                        let errorSelects = []
                        let sw = true
                        for (const item of inputs) {
                            let error = []

                            if(item.codigo.includes('fecha')){
                                if(item.codigo == "fechaInicioTalleresCreacion"){
                                    let fecha_inicio = moment(fechaInicioTalleresCreacion).format('YYYY-MM-DD');
                                    let fecha_final = moment(fechaFinalTalleresCreacion).format('YYYY-MM-DD');
                                    if(fecha_inicio > fecha_final){
                                        let tipo = "info"
                                        let titulo = "La fecha de inicio no puede ser mayor que la fecha final"
                                        sw = false
                                        dispatch(
                                            actualizarMensaje({ titulo, tipo, mostrar: true, tiempo: 6000 })
                                        );
                                    }
                                }
                            }if(item.codigo.includes('ciudad')){
                            }else{
                                if(item.codigo != "fechaInicioTalleresCreacion" && item.codigo != "fechaFinalTalleresCreacion"){
                                    error = await validateInputsTecnico([
                                        { value: item.value, name: item.codigo, err: { empty: true, obj: false } },
                                    ])
                                }
                            }
                            if(error.length != 0){
                                array.push(error[0])
                            }

                        }

                        errorSelects = await validateInputsTecnico([
                            { value: tipoAmbitoSelected, name: 'tipoAmbitoSelected', err: { empty: true, obj: true } },
                            { value: tipoEventoSelected, name: 'tipoEventoSelected', err: { empty: true, obj: true } },
                            { value: ciudadesSelectedTecTecno, name: 'ciudadesSelectedTecTecno', err: { empty: true, obj: true } },
                            { value: adj_certificado2, name: 'adj_certificado2', err: { empty: true, obj: false } },
                            { value: adj_certificado3, name: 'adj_certificado3', err: { empty: true, obj: false } },
                            { value: adj_certificado4, name: 'adj_certificado4', err: { empty: true, obj: false } },
                        ])

                        if(errorSelects.length != 0){
                            for(let i = 0; i < errorSelects.length; i++){
                                array.push(errorSelects[i])
                            }
                        }

                        setErrores(array)
                        if(array.length == 0 && sw == true){
                            setActiveStepBiblio((prevActiveStep) => prevActiveStep + 1);
                        }
                    }
                }
        }else if(seleccion === 'gestionProyectos'){
            if(activeStepBiblio == 0){
                let array = []
                let errorSelects = []
                let sw = true

                 for (const item of inputs) {
                    let error = await validateInputsTecnico([
                        { value: item.value, name: item.codigo, err: { empty: true, obj: false } },
                    ])
                    if(error.length !== 0){
                        array.push(error[0])
                    }
                }
                let fields = []
                    if(tipoProductoDivSelected.codigo === "producciones_contenido_digital"|| tipoProductoDivSelected.codigo=="produ_estra_contsytrasmedia"){
                        fields = [
                            { value: adj_certificado2, name: 'adj_certificado2', err: { empty: true, obj: false } },
                            { value: generoLiterarioSelected, name: 'generoLiterarioSelected', err: { empty: true, obj: true } },
                            { value: ciudadesSelectedDivulgacion, name: 'ciudadesSelectedDivulgacion', err: { empty: true, obj: true } },
                            { value: publicoObjetivoSelected, name: 'publicoObjetivoSelected', err: { empty: true, obj: true } },
                            { value: rutaCirculacionSelected, name: 'rutaCirculacionSelected', err: { empty: true, obj: true } },
                        ]
                    }
                    if(tipoProductoDivSelected.codigo === "desarrollos_web"){
                        fields = [
                            { value: adj_certificado2, name: 'adj_certificado2', err: { empty: true, obj: false } },
                            { value: generoLiterarioSelected, name: 'generoLiterarioSelected', err: { empty: true, obj: true } },
                            { value: ciudadesSelectedDivulgacion, name: 'ciudadesSelectedDivulgacion', err: { empty: true, obj: true } },
                            { value: publicoObjetivoSelected, name: 'publicoObjetivoSelected', err: { empty: true, obj: true } },
                            { value: rutaCirculacionSelected, name: 'rutaCirculacionSelected', err: { empty: true, obj: true } },
                            { value: tipoDesarrolloSelected, name: 'tipoDesarrolloSelected', err: { empty: true, obj: true } },
                            { value: medioVerificacionSelected, name: 'medioVerificacionSelected', err: { empty: true, obj: true }},
                            { value: adj_certificado3, name: 'adj_certificado3', err: { empty: true, obj: false } }
                        ]
                    }
                    if(tipoProductoDivSelected.codigo === "otro_articulo_publicado"){
                        fields = [
                            { value: tipoClaseSelected, name: 'tipoClaseSelected', err: { empty: true, obj: true } },
                            { value: idiomaArticuloSelected, name: 'idiomaArticuloSelected', err: { empty: true, obj: true } },
                        ]
                    }
                    if (tipoProductoDivSelected.codigo ==="talleres_creacion"){
                        fields = [
                            { value: adj_certificado2, name: 'adj_certificado2', err: { empty: true, obj: false } },
                            { value: tipoClaseSelected, name: 'tipoClaseSelected', err: { empty: true, obj: true } },
                            { value: idiomaArticuloSelected, name: 'idiomaArticuloSelected', err: { empty: true, obj: true } },
                            { value: tipoContenidoSelected, name: 'tipoContenidoSelected', err: { empty: true, obj: true } },
                            { value: tipoDesarrolloSelected, name: 'tipoDesarrolloSelected', err: { empty: true, obj: true } },
                        
                        ]
                    }
                    if (tipoProductoDivSelected.codigo ==="eventos_artisticos"){
                        fields = [
                            { value: adj_certificado2, name: 'adj_certificado2', err: { empty: true, obj: false } },
                        ]
                    }
                    if (tipoProductoDivSelected.codigo === "evento_cientifico"){
                        fields=[
                            { value: adj_certificado2, name: 'adj_certificado2', err: { empty: true, obj: false } },
                            { value: idiomaArticuloSelected, name: 'idiomaArticuloSelected', err: { empty: true, obj: true } },
                            { value: tipoContenidoSelected, name: 'tipoContenidoSelected', err: { empty: true, obj: true } },
                            { value: tipoClaseSelected, name: 'tipoClaseSelected', err: { empty: true, obj: true } },
                            { value: acuerdoLicencia, name: 'acuerdoLicencia', err: {empty:true, obj: false}},
                            { value: ciudadesSelectedDivulgacion, name: 'ciudadesSelectedDivulgacion', err: { empty: true, obj: true } },

                        ]
                    }
                    if (tipoProductoDivSelected.codigo === "consultaria_cientifica_tecnologia"){
                        fields=[
                            { value: tipoClaseSelected, name: 'tipoClaseSelected', err: { empty: true, obj: true } },
                            { value: idiomaArticuloSelected, name: 'idiomaArticuloSelected', err: { empty: true, obj: true } },
                            { value: ciudadesSelectedDivulgacion, name: 'ciudadesSelectedDivulgacion', err: { empty: true, obj: true } },
                            { value: tipoContenidoSelected, name: 'tipoContenidoSelected', err: { empty: true, obj: true } },
                            { value: adj_certificado2, name: 'adj_certificado2', err: { empty: true, obj: false } },
                            { value: adj_certificado3, name: 'adj_certificado3', err: { empty: true, obj: false } },
                        ]
                    }
                    if(tipoProductoDivSelected.codigo === "informe_tecnico"){
                        fields=[
                            { value: idiomaArticuloSelected, name: 'idiomaArticuloSelected', err: { empty: true, obj: true } },
                            { value: ciudadesSelectedDivulgacion, name: 'ciudadesSelectedDivulgacion', err: { empty: true, obj: true } },
                            { value: tipoContenidoSelected, name: 'tipoContenidoSelected', err: { empty: true, obj: true } },
                            { value: adj_certificado2, name: 'adj_certificado2', err: { empty: true, obj: false } },

                        ]
                    }
                    if(tipoProductoDivSelected.codigo === "manuales_guiasespecializadas"){
                        fields=[
                            { value: ciudadesSelectedDivulgacion, name: 'ciudadesSelectedDivulgacion', err: {empty: true, obj: true}},
                            { value: acuerdoLicencia, name: 'acuerdoLicencia', err: {empty:true, obj: false}},
                            { value: idiomaArticuloSelected, name: 'idiomaArticuloSelected', err: { empty: true, obj: true } },
                            { value: adj_certificado2, name: 'adj_certificado2', err: { empty: true, obj: false } },

                        ]
                    }
                    for (const field of fields) {
                    let error = await validateInputsTecnico([field]);
                    if (error.length !== 0) {
                        array.push(error[0]);
                    }
                    }

                if(errorSelects.length != 0){
                    for(let i = 0; i < errorSelects.length; i++){
                        array.push(errorSelects[i])
                    }
                }
                setErrores(array)
                if(array.length == 0 && sw == true){
                    setActiveStepBiblio((prevActiveStep) => prevActiveStep + 1);
                }
            }
            }
            else if(seleccion === 'gestionSocial'){
            if(activeStepBiblio == 0){
                let array = []
                let errorSelects = []
                let sw = true

                 for (const item of inputs) {
                    let error = await validateInputsTecnico([
                        { value: item.value, name: item.codigo, err: { empty: true, obj: false } },
                    ])
                    if(error.length !== 0){
                        array.push(error[0])
                    }
                }
                let fields = []
                    if(tipoProductoSolSelected.codigo === "apropiaciacion_social_conocimiento" || tipoProductoSolSelected.codigo === "trabajo_conjunto"){
                        fields = [
                            { value: adj_certificado2, name: 'adj_certificado2', err: { empty: true, obj: false } },
                            { value: licenciaSelected, name: 'licenciaSelected', err: { empty: true, obj: true } },

                        ]
                    }
                    if(tipoProductoSolSelected.codigo === "fortalecimiento_cadenas_productivas"  || tipoProductoSolSelected.codigo === "generacion_insumos"){
                        fields = [
                            { value: adj_certificado2, name: 'adj_certificado2', err: { empty: true, obj: false } },
                            { value: licenciaSelected, name: 'licenciaSelected', err: { empty: true, obj: true } },
                            { value: tipoEmpresasoSelected, name: 'tipoEmpresasoSelected', err: { empty: true, obj: true } },

                        ]
                    }  
                    for (const field of fields) {
                    let error = await validateInputsTecnico([field])
                    if(error.length !== 0){
                        array.push(error[0])
                        }
                    }
        
                if(errorSelects.length != 0){
                    for(let i = 0; i < errorSelects.length; i++){
                        array.push(errorSelects[i])
                    }
                }
                setErrores(array)
                if(array.length == 0 && sw == true){
                    setActiveStepBiblio((prevActiveStep) => prevActiveStep + 1);
                }
            }
            } else if(seleccion === 'gestionRecursos'){
                if(activeStepBiblio == 0){
                let array = []
                let errorSelects = []
                let sw = true

                 for (const item of inputs) {
                    let error = await validateInputsTecnico([
                        { value: item.value, name: item.codigo, err: { empty: true, obj: false } },
                    ])
                    if(error.length !== 0){
                        array.push(error[0])
                    }
                }
                let fields = []
                    if(tipoProductoRecSelected.codigo === "produ_recurso_proyecto" || tipoProductoRecSelected.codigo === "produ_trabajos_dirigidos" ){
                        fields = [
                            { value: tipoProyectoSelected, name: 'tipoProyectoSelected', err: { empty: true, obj: true } },
                            { value: orientacionSelected, name: 'orientacionSelected', err: {empty: true, obj: true }},
                            { value: tipoEmpresaSelected, name: 'tipoEmpresaSelected', err: {empty: true, obj: true }},
                        ]
                    }  
                    for (const field of fields) {
                    let error = await validateInputsTecnico([field])
                    if(error.length !== 0){
                        array.push(error[0])
                        }
                    }
        
                if(errorSelects.length != 0){
                    for(let i = 0; i < errorSelects.length; i++){
                        array.push(errorSelects[i])
                    }
                }
                setErrores(array)
                if(array.length == 0 && sw == true){
                    setActiveStepBiblio((prevActiveStep) => prevActiveStep + 1);
                }
                    }
            }else if(seleccion === 'gestionEstrategias'){
                if(activeStepBiblio == 0){
                let array = []
                let errorSelects = []
                let sw = true

                 for (const item of inputs) {
                    let error = await validateInputsTecnico([
                        { value: item.value, name: item.codigo, err: { empty: true, obj: false } },
                    ])
                if(error.length !== 0){
                        array.push(error[0])
                    }
                 }
                    let fields = []
                    if(tipoProductoEstSelected.codigo === "proyectos_aula" ){
                        fields = [
                            { value: tipoProyectoSelected, name: 'tipoProyectoSelected', err: { empty: true, obj: true } },
                            { value: adj_certificado2, name: 'adj_certificado2', err: { empty: true, obj: false } },
                            { value: acuerdoLicencia, name: 'acuerdoLicencia', err: { empty: true, obj: false } }, 
                        ]
                    if (acuerdoLicencia === "si") {
                            fields.push(
                                { value: indiquecual, name: 'indiquecual', err: { empty: true, obj: false } },
                        );
                    }
                    }
                    if(tipoProductoEstSelected.codigo === "retos_cuc" ){
                        fields = [
                        { value: adj_certificado2, name: 'adj_certificado2', err: { empty: true, obj: false } },
                        ]
                        }
                    if (tipoProductoEstSelected.codigo ==="buenas_practicas")
                        {
                        fields = [
                            { value: adj_certificado2, name: 'adj_certificado2', err: { empty: true, obj: false } },
                            { value: acuerdoLicencia, name: 'acuerdoLicencia', err: { empty: true, obj: false } }, 
                        ]
                    if (acuerdoLicencia === "si") {
                            fields.push(
                                { value: indiquecual, name: 'indiquecual', err: { empty: true, obj: false } },
                        );
                    }
                    }
                     if(tipoProductoEstSelected.codigo === "pasantias_investigacion" ){
                        fields = [
                            { value: adj_certificado2, name: 'adj_certificado2', err: { empty: true, obj: false } },
                            { value: acuerdoLicencia, name: 'acuerdoLicencia', err: { empty: true, obj: false } },
                            { value: indiquecual, name: 'indiquecual', err: { empty: true, obj: false } },

                        ]
    
                    }
                    if (tipoProductoEstSelected.codigo === "prueba_ciclo"){
                     fields = [
                            { value: adj_certificado2, name: 'adj_certificado2', err: { empty: true, obj: false } },

                        ]
    
                    }
                    for (const field of fields) {
                    let error = await validateInputsTecnico([field])
                    if(error.length !== 0){
                    array.push(error[0])
                    }
                    }
        
                    if(errorSelects.length != 0){
                    for(let i = 0; i < errorSelects.length; i++){
                    array.push(errorSelects[i])
                    }
                    }
                    setErrores(array)
                    if(array.length == 0 && sw == true){
                    setActiveStepBiblio((prevActiveStep) => prevActiveStep + 1);
                    }
                }
                }
        }

const appendCentrosInvestigacion = (formData) => {
  centroInvestigacion.forEach((id) => {
    formData.append("centros_investigacion", id);
  });
};

        
 const handleSendToApi = async () => {
        const url = "api/v1.0/investigacion/produccionSemillero";

        const callback = (error, estado, resp) => {
        let titulo = "Ha ocurrido un error, contacte con el administrador.";
        let tipo = "error";
        if (!error && estado === 201) {
            tipo = "success";
            titulo = resp.titulo;
        }
        dispatch(actualizarMensaje({ titulo, tipo, mostrar: true, tiempo: 6000 }));
        if (estado === 201) {
            handleOnClose();
        } else {
            setCargandoGestionBibliografica(false);
        }
        };

        const validarParticipantes = () => {
        if (numeroIdParEvent.length === 0) {
            dispatch(actualizarMensaje({
                titulo: "Inserte por lo menos 1 Participante",
                tipo: "info",
                mostrar: true,
                tiempo: 6000
            }));
            return false;
        }
        return true;
        };

        const autores = numeroIdParEvent.map(a => a.id);
        const autoresRol = numeroIdParEvent.map(a => ({
            id: a.id,
            nombre: a.nombre,
            rol: a.rolDeParticipante?.nombre || ""
        }));
        const semillero = props.semiActual.id;
        const tipo_Producto = tipoSolicitudActual;
        const subtipo_producto = tipoProduccionBiblio.id;

        let formattedAnioPublicacion = anioPublicacion;
                if (anioPublicacion instanceof Date) {
                const year = anioPublicacion.getFullYear();
                const month = String(anioPublicacion.getMonth() + 1).padStart(2, '0');
                formattedAnioPublicacion = `${year}-${month}`;
                }

        function formatDateToISO(date) {
            if (!(date instanceof Date)) return "";
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
            }
        function formatYearMonth(date) {
            if (!(date instanceof Date)) return date || "";
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            return `${year}-${month}`;
        }
        function formatDateToYear(date) {
            if (!(date instanceof Date)) return "";
            const year = date.getFullYear();
            return `${year}`;
        }

        if (seleccion === 'gestionBibliografica' && tipoSolicitudActual === "Semi_inves_generacion") {
        let data = new FormData();
        switch (tipoProduccionBiblio.codigo) {
            case "Inves_tipo_biblio_articulo":
                if (!validarParticipantes()) return;

                appendCentrosInvestigacion(data);

                const dataArticulo = {
                    semillero,
                    tipo_Producto,
                    subtipo_producto,
                    Título_articulo:tituloArticulo,
                    Página_inicial:PaginaInicial,
                    Página_final:PaginaFinal,
                    Issn:issn,
                    Nombre_revista: nombreRevista,
                    Volumen_revista:volumenRevista,
                    Ciudad: CiudadesTipoArticuloSelected.nombre,
                    Idioma: idiomaTipoArticuloSelected.nombre,
                    Sitio_Web:enlace,
                    Doi:doi,
                    Año_mes_publicación: formattedAnioPublicacion,
                    Medio_Divulgación:mediodivulgacion,
                    Autores:autores,
                };

                Object.entries(dataArticulo).forEach(([key, value]) => {
                    const finalValue = typeof value === "object" ? JSON.stringify(value) : value;
                    data.append(key, finalValue);
                });
                break;

            case "Inves_tipo_biblio_libro":
                if (!validarParticipantes()) return;

                data.append("Certificado_credito_obra", adj_certificado_final2);
                data.append("Certificacido_aval", adj_certificado_final3);

                appendCentrosInvestigacion(data);

                const dataLibro = {
                    semillero,
                    tipo_Producto,
                    subtipo_producto,
                    Titulo_libro: tituloLibro,
                    Año_mes_publicación: formattedAnioPublicacion,
                    Isbn_libro: isbnLibro,
                    Lugar_publicacion: paisTipoCapLibroSelected.nombre,
                    Medio_divulgación: mediodivulgacion,
                    Medio_publicación_del_libro: mediopublicacionlibro,
                    Editorial_libro: editorialLibro,
                    Autores:autores,
                };

                Object.entries(dataLibro).forEach(([key, value]) => {
                    const finalValue = typeof value === "object" ? JSON.stringify(value) : value;
                    data.append(key, finalValue);
                });
                break;

            case "Inves_tipo_biblio_capituloLib":
                if (!validarParticipantes()) return;
                data.append("Certificado_credito_obra", adj_certificado_final2);
                data.append("Certificado_Institución_que_avala", adj_certificado_final3);

                appendCentrosInvestigacion(data);

                const dataCapitulo = {
                    semillero,
                    tipo_Producto,
                    subtipo_producto,
                    Titulo_capitulo: tituloCapLibro,
                    Página_inicial:PaginaInicial,
                    Página_final:PaginaFinal,
                    Número_páginas:numeropaginas,
                    Año_mes_publicación: formattedAnioPublicacion,
                    Titulo_libro:tituloLibroCap,
                    Isbn_libro:isbnLibroCap,
                    Medio_divulgación:mediodivulgacion,
                    Lugar_publicación: paisTipoCapLibroSelected.nombre,
                    Autores:autores,
                };

                Object.entries(dataCapitulo).forEach(([key, value]) => {
                    const finalValue = typeof value === "object" ? JSON.stringify(value) : value;
                    data.append(key, finalValue);
                });
                break;

            case "Inves_tipo_obra":
                  let formattedFechaPresentacionObra = formatDateToISO(fechapresentacion);
                  let formattedaniocreacionespacioObra = formatDateToYear(aniocreacionespacio);
                  let formateddfechaotrogamiento = formatDateToISO(fechaotrogamiento);

                appendCentrosInvestigacion(data);

                const dataObra = {
                    semillero,
                    tipo_Producto,
                    subtipo_producto,
                    Nombre_de_la_obra: nombreObra,
                    Disciplina_o_ámbito: disciplinaSelected.nombre,
                    Titulo_del_proyecto_o_investigación:tituloObraproducto,
                    Tecnica_o_formato:tecnica,
                    Fecha_creación: formattedAnioPublicacion,
                    Nombre_espacio_o_evento:nombreespacio,
                    Tipo_espacio_o_evento: tipoespacioSelected.nombre,
                    Fecha_presentación:formattedFechaPresentacionObra,
                    Año_creación_espacio_evento:formattedaniocreacionespacioObra,
                    Distinción_obtenida: distincionSelected.nombre,
                    Entidad_convocante:entidadconvocante,
                    Ámbito: tipoAmbitoSelected.nombre,
                    Mecanismo_selección: mecanismoSelected.nombre,
                    Registro_acuerdo_licencia:acuerdoLicencia,
                };

                if (acuerdoLicencia === 'si') {
                if (institucionlicencia) {dataObra.Institucion_licencia = institucionlicencia;}
                if (formateddfechaotrogamiento) { dataObra.Fecha_otorgamiento = formateddfechaotrogamiento;}
                if (CiudadesTipoArticuloSelected) {dataObra.Ciudad = CiudadesTipoArticuloSelected.nombre;}
                if (numeroregistro) {dataObra.Numero_registro = numeroregistro;}
                if (contratocomercializacion) {dataObra.Contrato_comercializacion = contratocomercializacion;}}

                Object.entries(dataObra).forEach(([key, value]) => {
                    const finalValue = typeof value === "object" ? JSON.stringify(value) : value;
                    data.append(key, finalValue);
                });
                break;

            case "Inves_tipo_biblio_patente":
                let formattedFechaPresentacion = formatDateToISO(fechapresentacion);
                let formattedFechaObtencion = formatDateToISO(fechaotrogamiento);
                let formattedAnioObtencionPatente = formatDateToISO(anioObtencionPatente);
                if (!validarParticipantes()) return;
                data.append("Gaceta_industrial", adj_certificado_final2);
                data.append("Certificado_patente", adj_certificado_final3);
                data.append("Examen_fondo", adj_certificado_final4);
                appendCentrosInvestigacion(data);

                const dataPatente = {
                    semillero,
                    tipo_Producto,
                    subtipo_producto,
                    Titulo_patente: tituloPatente,
                    Número_patente: numeroPatente,
                    Nombre_solicitante_patente: nombreSolicitante,
                    Tipo_patente: tipoPatenteSelected.nombre,
                    Vía_solicitud: viaSolicitudSelected.nombre,
                    Fecha_presentación: formattedAnioObtencionPatente,
                    Fecha_examen: formattedFechaPresentacion,
                    Fecha_obtención: formattedFechaObtencion,
                    Institucion_patente:institucionPatente,
                    Contrato_explotación_o_licenciamiento: acuerdoLicencia,
                    Autores:autores,
                };

                Object.entries(dataPatente).forEach(([key, value]) => {
                    const finalValue = typeof value === "object" ? JSON.stringify(value) : value;
                    data.append(key, finalValue);
                });
                break;

            default:
                dispatch(actualizarMensaje({
                    titulo: "Tipo de producción bibliográfica no reconocido",
                    tipo: "error",
                    mostrar: true,
                    tiempo: 6000
                }));
                return;
        }
        await Funciones.formulario(url, data, 'POST', callback);
        return;
        }
   
        if (seleccion === 'gestionTecnica' && tipoSolicitudActual === "Semi_inves_tecnologico") {
    if (!validarParticipantes()) return;

    let data = new FormData();

        switch (tipoProduccionTecnica.codigo) {
            case "Inves_tipo_tec_pro_diseñoIndustrial":
                let formateddfechaCreacionDiseñoIndu = formatYearMonth(fechaCreacionDiseñoIndus);

                appendCentrosInvestigacion(data);

            const dataDiseno = {
                semillero,
                tipo_Producto,
                El_producto_Tiene: productoTieneSelected.nombre,
                subtipo_producto: tipoProductoTecSelected.id,
                Ciudad: ciudadesSelectedTecTecno.nombre,
                Fecha:formateddfechaCreacionDiseñoIndu,
                Autores:autores,
            };

            inputs.forEach(input => {
                if (
                    input.codigo !== "ciudadRegistroDiseñoPrototipoTiene" &&
                    input.codigo !== "fechaCreacion"
                ) {
                    dataDiseno[input.codigo] = input.value;
                }
            });

            Object.entries(dataDiseno).forEach(([key, value]) => {
                const finalValue = typeof value === "object" ? JSON.stringify(value) : value;
                data.append(key, finalValue);
            });
            break;

        case "Inves_tipo_tec_pro_software":
            let formateddfechaDesarrollo = formatYearMonth(fechaDesarrolloSoftware);

                data.append("soporte_institucion_financiadora", adj_certificado_final2);
                data.append("Avance_final", adj_certificado_final3);

                appendCentrosInvestigacion(data);

            const dataSoftware = {
                semillero,
                tipo_Producto,
                Producto_tiene: productoTieneSelected.nombre,
                subtipo_producto: tipoProductoTecSelected.id,
                Pais: paisSelectedTecTecno.nombre,
                Disponibiidad: disponibilidadSelectedTecTecno.nombre,
                Fecha:formateddfechaDesarrollo,
                Autores:autores,
            };

            inputs.forEach(input => {
                if (
                    input.codigo !== "fechaDesarrolloSoftware" &&
                    input.codigo !== "paisSoftware" &&
                    input.codigo !== "disponibilidadsoftware" &&
                    input.codigo !== "adj_certificado2" &&
                    input.codigo !== "adj_certificado3"
                ) {
                    dataSoftware[input.codigo] = input.value;
                }
            });

            Object.entries(dataSoftware).forEach(([key, value]) => {
                const finalValue = typeof value === "object" ? JSON.stringify(value) : value;
                data.append(key, finalValue);
            });
            break;

            case "Inves_tipo_tec_pro_eveArt":
                let formateddcircuito = formatYearMonth(fechaInicioEventoArtistico);

                appendCentrosInvestigacion(data);

                const dataEvento = {
                    semillero,
                    tipo_Producto,
                    Producto_tiene: productoTieneSelected.nombre,
                    subtipo_producto: tipoProductoTecSelected.id,
                    Pais: paisSelectedTecTecno.nombre,
                    Fecha: formateddcircuito,
                    Autores: autores,
                };

                inputs.forEach(input => {
                    if (
                        input.codigo !== "fechaInicioEventoArtistico" &&
                        input.codigo !== "paisSelectedTecTecno"
                    ) {
                        dataEvento[input.codigo] = input.value;
                    }
                });

                Object.entries(dataEvento).forEach(([key, value]) => {
                    const finalValue = typeof value === "object" ? JSON.stringify(value) : value;
                    data.append(key, finalValue);
                });
                break;

            case "Inves_tipo_tec_pro_prototipo":
                let formatedPrototipo = formatYearMonth(fechaCreacionPrototipo);

                appendCentrosInvestigacion(data);

            const dataPrototipo = {
                semillero,
                tipo_Producto,
                Producto_tiene: productoTieneSelected.nombre,
                subtipo_producto: tipoProductoTecSelected.id,
                Fecha_creacion_prototipo:formatedPrototipo,
                Ciudad: ciudadesSelectedTecTecno.nombre,
                Disponibilidad: disponibilidadSelectedTecTecno.nombre,
                Autores:autores,
            };

            inputs.forEach(input => {
                if (
                    input.codigo !== "disponibilidadsoftware" &&
                    input.codigo !== "fechaCreacionPrototipo" &&
                    input.codigo !== "ciudadRegistroDiseñoPrototipoTiene"
                ) {
                    dataPrototipo[input.codigo] = input.value;
                }
            });

            Object.entries(dataPrototipo).forEach(([key, value]) => {
                const finalValue = typeof value === "object" ? JSON.stringify(value) : value;
                data.append(key, finalValue);
            });
            break;

        case "Inves_tipo_tec_pro_signo_distintivo":
            let formatedsignoDistintivo = formatYearMonth(fechaCreacionSignoDistintivo);

                data.append("Registro_superintendencia", adj_certificado_final2);

                appendCentrosInvestigacion(data);

            const dataSigno = {
                semillero,
                tipo_Producto,
                subtipo_producto: tipoProductoTecSelected.id,
                Fecha_creacion:formatedsignoDistintivo,
                Tipo_Signo_distintivo: tipoSignoDistintivoSelected.nombre,
                Autores:autores,
            };

            inputs.forEach(input => {
                if (
                    input.codigo !== "tiposSignoDistintivos" &&
                    input.codigo !== "fechaCreacionSignoDistintivo"
                ) {
                    dataSigno[input.codigo] = input.value;
                }
            });

            Object.entries(dataSigno).forEach(([key, value]) => {
                const finalValue = typeof value === "object" ? JSON.stringify(value) : value;
                data.append(key, finalValue);
            });
            break;

        case "Inves_tipo_tec_pro_empBaseTec":
            let formateddfechaRegistroBaseTecno = formatDateToISO(fechaRegistroBaseTecno);

                data.append("Certificación_Institucional", adj_certificado_final2);

                appendCentrosInvestigacion(data);

            const dataEmpBase = {
                semillero,
                tipo_Producto,
                subtipo_producto: tipoProductoTecSelected.id,
                Tipo_Empresa: tipoEmpresaSelected.nombre,
                Fecha_Registro:formateddfechaRegistroBaseTecno,
                Tiene_productos_en_mercado: acuerdoLicencia,
                Autores:autores,
            };

            inputs.forEach(input => {
                if (
                    input.codigo !== "fechaRegistroBaseTecno" &&
                    input.codigo !== "tipoEmpresaSelected"
                ) {
                    dataEmpBase[input.codigo] = input.value;
                }
            });

            Object.entries(dataEmpBase).forEach(([key, value]) => {
                const finalValue = typeof value === "object" ? JSON.stringify(value) : value;
                data.append(key, finalValue);
            });
            break;

        case "Inves_tipo_tec_pro_empCreaCul":
            let formatedfechaRegistroEmpresaCultural = formatDateToISO(fechaRegistroEmpresaCultural);

                data.append("Certificacion_Institucional", adj_certificado_final2);
                data.append("Certificado_camara_comercio", adj_certificado_final3);

                appendCentrosInvestigacion(data);

            const dataEmpCultural = {
                semillero,
                tipo_Producto,
                subtipo_producto: tipoProductoTecSelected.id,
                Tiene_productos_en_mercado: acuerdoLicencia,
                Disciplina_Ambito: tipoDisciplinaAmbitoSelected.nombre,
                Fecha_de_registro_ante_la_camara_de_comercio:formatedfechaRegistroEmpresaCultural,
                Autores:autores,
            };

            inputs.forEach(input => {
                if (
                    input.codigo !== "fechaRegistroEmpresaCultural" &&
                    input.codigo !== "tipoDisciplinaAmbitoSelected"
                ) {
                    dataEmpCultural[input.codigo] = input.value;
                }
            });

            Object.entries(dataEmpCultural).forEach(([key, value]) => {
                const finalValue = typeof value === "object" ? JSON.stringify(value) : value;
                data.append(key, finalValue);
            });
            break;

        case "Inves_tipo_tec_pro_innProProSer":
            let formatedfechaInnovacionProceServi = formatYearMonth(fechaInnovacionProceServi);

                data.append("Certificado_implementación", adj_certificado_final2);

                appendCentrosInvestigacion(data);

            const dataInnPro = {
                semillero,
                tipo_Producto,
                subtipo_producto: tipoProductoTecSelected.id,
                Producto_tiene: productoTieneSelected.nombre,
                Ciudad: ciudadesSelectedTecTecno.nombre,
                Fecha:formatedfechaInnovacionProceServi,
                Disponibilidad: disponibilidadSelectedTecTecno.nombre,
                Autores:autores,
            };

            inputs.forEach(input => {
                if (
                    input.codigo !== "fechaInnovacionProceServi" &&
                    input.codigo !== "disponibilidadsoftware" &&
                    input.codigo !== "ciudadRegistroDiseñoPrototipoTiene"
                ) {
                    dataInnPro[input.codigo] = input.value;
                }
            });

            Object.entries(dataInnPro).forEach(([key, value]) => {
                const finalValue = typeof value === "object" ? JSON.stringify(value) : value;
                data.append(key, finalValue);
            });
            break;

        case "Inves_tipo_tec_pro_innGenGesEmp":
            let formatedfechaInnovacionGestionEmp = formatYearMonth(fechaInnovacionGestionEmp);

                data.append("certificado_implementacion", adj_certificado_final2);
                data.append("certificado_producto", adj_certificado_final3);
                data.append("certificado_tamaño", adj_certificado_final4);
                data.append("registro_tributario", adj_certificado_final5);

                appendCentrosInvestigacion(data);

            const dataInnGen = {
                semillero,
                tipo_Producto,
                subtipo_producto: tipoProductoTecSelected.id,
                Producto_Tiene: productoTieneSelected.nombre,
                Tipo_Innovacion: tipoInnovacionSelected.nombre,
                Fecha:formatedfechaInnovacionGestionEmp,
                Ciudad: ciudadesSelectedTecTecno.nombre,
                Disponibilidad: disponibilidadSelectedTecTecno.nombre,
                idioma: idiomaSelectedTecTecno.nombre,
                Tamaño_empresa:acuerdoLicencia,
                Autores:autores,
            };

            inputs.forEach(input => {
                if (
                    input.codigo !== "fechaInnovacionGestionEmp" &&
                    input.codigo !== "disponibilidadsoftware" &&
                    input.codigo !== "idioma" &&
                    input.codigo !== "ciudadRegistroDiseñoPrototipoTiene"
                ) {
                    dataInnGen[input.codigo] = input.value;
                }
            });

            Object.entries(dataInnGen).forEach(([key, value]) => {
                const finalValue = typeof value === "object" ? JSON.stringify(value) : value;
                data.append(key, finalValue);
            });
            break;

        case "Inves_tipo_tec_pro_talCre":
         let formatedfechaInicioTalleresCreacion = formatYearMonth(fechaInicioTalleresCreacion);

                data.append("Certificacion_agencia_nacional", adj_certificado_final2);
                data.append("Certificacion_Institucional", adj_certificado_final3);
                data.append("Certificado_participación", adj_certificado_final4);

                appendCentrosInvestigacion(data);

            const dataTaller = {
                semillero,
                tipo_Producto,
                subtipo_producto: tipoProductoTecSelected.id,
                Tipo: tipoEventoSelected.nombre,
                Fecha:formatedfechaInicioTalleresCreacion,
                Ciudad: ciudadesSelectedTecTecno.nombre,
                Ámbito: tipoAmbitoSelected.nombre,
                 Autores:autores,
            };

            inputs.forEach(input => {
                if (
                    input.codigo !== "fechaInicioTalleresCreacion" &&
                    input.codigo !== "ciudadRegistroDiseñoPrototipoTiene"
                ) {
                    dataTaller[input.codigo] = input.value;
                }
            });

            Object.entries(dataTaller).forEach(([key, value]) => {
                const finalValue = typeof value === "object" ? JSON.stringify(value) : value;
                data.append(key, finalValue);
            });
            break;

        default:
            dispatch(actualizarMensaje({
                titulo: "Tipo de producción técnica no reconocido",
                tipo: "error",
                mostrar: true,
                tiempo: 6000
            }));
            return;
    }

    await Funciones.formulario(url, data, 'POST', callback);
    return;
        }

       if (seleccion === 'gestionProyectos' && tipoSolicitudActual === "Semi_inves_divulgacion") {
            if (!validarParticipantes()) return;

            let data = new FormData();

        data.append("semillero", semillero);
        data.append("tipo_Producto", tipo_Producto);
        data.append("subtipo_producto", tipoProductoDivSelected.id);
        appendCentrosInvestigacion(data);

            inputs.forEach(input => {
                data.append(input.codigo, input.value);
            });

            switch (tipoProductoDivSelected.codigo) {
                
                case "producciones_contenido_digital":

                    const formattedFecha1 = formatYearMonth(fecha);
                    data.append("Certificado_alianza", adj_certificado_final2);
                    data.append("Genero_literario", generoLiterarioSelected.nombre);
                    data.append("Ciudad", ciudadesSelectedDivulgacion.nombre);
                    data.append("Fecha", formattedFecha1)
                    data.append("Publico_Objetivo", publicoObjetivoSelected.nombre);
                    data.append("Ruta_circulacion", rutaCirculacionSelected.nombre);
                    data.append("Tipo", tipoContenidoSelected.nombre);
                    data.append("Autores", JSON.stringify(autores));
                    break;

                case "produ_estra_contsytrasmedia":
                    const formattedFecha2 = formatYearMonth(fecha);
                    data.append("Certificado_alianza", adj_certificado_final2);
                    data.append("Genero_literario", generoLiterarioSelected.nombre);
                    data.append("Ciudad", ciudadesSelectedDivulgacion.nombre);
                    data.append("Fecha", formattedFecha2)
                    data.append("Publico_Objetivo", publicoObjetivoSelected.nombre);
                    data.append("Ruta_circulacion", rutaCirculacionSelected.nombre);
                    data.append("Autores", JSON.stringify(autores));
                    break;

                case "desarrollos_web":
                    const formattedFechadesarrollo = formatYearMonth(fecha);

                    data.append("Certificado_alianza", adj_certificado_final2);
                    data.append("Genero_literario", generoLiterarioSelected.nombre);
                    data.append("Ciudad", ciudadesSelectedDivulgacion.nombre);
                    data.append("Fecha", formattedFechadesarrollo)
                    data.append("Publico_objetivo", publicoObjetivoSelected.nombre);
                    data.append("Ruta_circulación", rutaCirculacionSelected.nombre);
                    data.append("Tipo_desarrollo", tipoDesarrolloSelected.nombre);
                    data.append("Medio_verificación", medioVerificacionSelected.nombre);
                    data.append("Certificado_Wireframe", adj_certificado_final3);
                    data.append("Autores", JSON.stringify(autores));
                    break;

                case "otro_articulo_publicado":
                    const formattedFechaotro = formatYearMonth(fecha);

                    data.append("Tipo_clase", tipoClaseSelected.nombre);
                    data.append("Idioma", idiomaArticuloSelected.nombre);
                    data.append("Fecha", formattedFechaotro);
                    data.append("Autores", JSON.stringify(autores));
                    break;

                case "talleres_creacion":
                    const formattedFechaTalleres = formatDateToISO(fecha);
                    const formattedFechaFinalTalleres = formatDateToISO(fechaFinal);
                    data.append("Certificado_paticipación", adj_certificado_final2);
                    data.append("Tipo_evento", tipoClaseSelected.nombre);
                    data.append("Ambito", idiomaArticuloSelected.nombre);
                    data.append("Distinción", tipoContenidoSelected.nombre);
                    data.append("Mecanismo", tipoDesarrolloSelected.nombre);
                    data.append("Fecha_Inicial", formattedFechaTalleres);
                    data.append("Fecha_final", formattedFechaFinalTalleres);
                    data.append("Autores", JSON.stringify(autoresRol));
                    break;

                case "eventos_artisticos":
                    const formattedFechaEventoAr = formatDateToISO(fecha);
                    const formattedFechaFinalEventoAr = formatDateToISO(fechaFinal);
                    data.append("Certificado_participación", adj_certificado_final2);
                    data.append("fecha_Inicial", formattedFechaEventoAr);
                    data.append("Fecha_Final", formattedFechaFinalEventoAr);
                    data.append("Autores", JSON.stringify(autoresRol));
                    break;

                case "evento_cientifico":
                    const formattedFechaEvento = formatDateToISO(fecha);
                    const formattedFechaFinalEvento = formatDateToISO(fechaFinal);

                    data.append("Certificado_investigador", adj_certificado_final2);
                    data.append("Fecha_inicial", formattedFechaEvento);          
                    data.append("Fecha_final", formattedFechaFinalEvento);
                    data.append("Tipo_evento", tipoClaseSelected.nombre);
                    data.append("Ambito", idiomaArticuloSelected.nombre);
                    data.append("Producto_realizado", tipoContenidoSelected.nombre);
                    data.append("Evento_CUC", acuerdoLicencia);
                    data.append("Ciudad", ciudadesSelectedDivulgacion.nombre);
                    data.append("Autores", JSON.stringify(autoresRol));
                    break;


                case "consultaria_cientifica_tecnologia":
                    const formattedFecha = formatYearMonth(fecha);
                    const formattedFechaFinal = formatYearMonth(fechaFinal);

                    data.append("Contrato", adj_certificado_final2);
                    data.append("Certificacion_objeto", adj_certificado_final3);
                    data.append("Fecha_incial", formattedFecha);
                    data.append("Fecha_final", formattedFechaFinal);
                    data.append("Tipo_clase", tipoClaseSelected.nombre);
                    data.append("Disponibilidad", tipoContenidoSelected.nombre);
                    data.append("Idioma", idiomaArticuloSelected.nombre);
                    data.append("Ciudad", ciudadesSelectedDivulgacion.nombre);
                    data.append("Autores", JSON.stringify(autores));
                    break;

                case "informe_tecnico":
                    const formattedFechaInf = formatYearMonth(fecha);

                    data.append("Idioma", idiomaArticuloSelected.nombre);
                    data.append("Ciudad", ciudadesSelectedDivulgacion.nombre);
                    data.append("Fecha_presentación", formattedFechaInf);
                    data.append("Disponibilidad", tipoContenidoSelected.nombre);
                    data.append("Certificado_entidad_estatal", adj_certificado_final2);
                    data.append("Autores", JSON.stringify(autores));
                    break;

                case "manuales_guiasespecializadas":
                    const formattedFechaGuia = formatYearMonth(fecha);
                    data.append("Lugar_publicacion", ciudadesSelectedDivulgacion.nombre);
                    data.append("Medio_divulgacion", acuerdoLicencia);
                    data.append("fecha", formattedFechaGuia);
                    data.append("Medio_publicacion_de_editorial", idiomaArticuloSelected.nombre);
                    data.append("Certificacion_representante_legal", adj_certificado_final2);
                    data.append("Autores", JSON.stringify(autores));
                    break;

                default:
                    dispatch(actualizarMensaje({
                        titulo: "Tipo de producción de proyecto no reconocido",
                        tipo: "error",
                        mostrar: true,
                        tiempo: 6000
                    }));
                    return;
            }

            await Funciones.formulario(url, data, 'POST', callback);
            return;
        }

       if (seleccion === 'gestionSocial' && tipoSolicitudActual === "Soli_inves_social") {
            if (!validarParticipantes()) return;

           let data = new FormData();

        data.append("semillero", semillero);
        data.append("tipo_Producto", tipo_Producto);
        data.append("subtipo_producto", tipoProductoSolSelected.id);
        appendCentrosInvestigacion(data);

            inputs.forEach(input => {
                data.append(input.codigo, input.value);
            });

            if (tipoProductoSolSelected.codigo === "apropiaciacion_social_conocimiento" || tipoProductoSolSelected.codigo === "trabajo_conjunto") {
                const formattedFechaInicio = formatYearMonth(fecha);
                data.append("Licencia", licenciaSelected.nombre);
                data.append("fecha", formattedFechaInicio);
                data.append("Certificación_comunidad", adj_certificado_final2);
                data.append("Autores", JSON.stringify(autores));
            } else if (tipoProductoSolSelected.codigo === "fortalecimiento_cadenas_productivas") {
                const formattedFechaInicio2 = formatYearMonth(fecha);
                data.append("Licencia", licenciaSelected.nombre);
                data.append("Fecha", formattedFechaInicio2);
                data.append("Certificado_agremiación", adj_certificado_final2);
                data.append("Tipo_empresa", tipoEmpresasoSelected.nombre);
                data.append("Autores", JSON.stringify(autores));
            } else if (tipoProductoSolSelected.codigo === "generacion_insumos") {
                const formattedFechaInicio1 = formatYearMonth(fecha);
                data.append("Licencia", licenciaSelected.nombre);
                data.append("Fecha", formattedFechaInicio1);
                data.append("Certificación_entidad", adj_certificado_final2);
                data.append("Nivel_documento", tipoEmpresasoSelected.nombre);
                data.append("Autores", JSON.stringify(autores));
            } else {
                dispatch(actualizarMensaje({
                    titulo: "Tipo de producción de proyecto no reconocido",
                    tipo: "error",
                    mostrar: true,
                    tiempo: 6000
                }));
                return;
            }
            await Funciones.formulario(url, data, 'POST', callback);
            return;
        }


        if (seleccion === 'gestionEstrategias' && tipoSolicitudActual === "Semi_estrategiasCuc") {
        if (!validarParticipantes()) return;

        let formData = new FormData();
        formData.append('semillero', semillero);
        formData.append('tipo_Producto', tipo_Producto);
        formData.append('subtipo_producto', tipoProductoEstSelected.id);
        appendCentrosInvestigacion(formData);

        for (const item of inputs) {
            formData.append(item.codigo, item.value);
        }

        if (tipoProductoEstSelected.codigo === "proyectos_aula") {
            formData.append('Tipo_proyecto', tipoProyectoSelected.nombre);
            formData.append('Evidencia_proyecto', adj_certificado_final2); 
            formData.append('Paticipacion_evento_institucional', acuerdoLicencia);
            formData.append('Programa_académico', tipoProgramaSelected.nombre);
            formData.append('Nombre_departamento', tipoDepartamentoSelected.nombre);
            formData.append('Autores', JSON.stringify(autores));

            if (acuerdoLicencia === 'si' && indiquecual) {
                formData.append('Indique_cual', indiquecual);
            }
        }

        if (tipoProductoEstSelected.codigo === "retos_cuc") {
            const formattedFechaInicio8 = formatYearMonth(fecha);
            formData.append('Evidencia_proyecto', adj_certificado_final2);
            formData.append('Nombre_departamento', tipoDepartamentoSelected.nombre);
            formData.append('Programa_académico', tipoProgramaSelected.nombre);
            formData.append('Fecha_certificación', formattedFechaInicio8);
            formData.append('Autores', JSON.stringify(autores));
        }

        if (tipoProductoEstSelected.codigo === "buenas_practicas") {
            formData.append('Certificacion_CED', adj_certificado_final2);
            formData.append('Nombre_departamento', tipoDepartamentoSelected.nombre);
            formData.append('Programa_académico', tipoProgramaSelected.nombre);
            formData.append('Obtuvo_Premiacion', acuerdoLicencia);
            formData.append('autores', JSON.stringify(autores));

            if (acuerdoLicencia === 'si' && indiquecual) {
                formData.append('Premiacion', indiquecual);
            }
        }

        if (tipoProductoEstSelected.codigo === "pasantias_investigacion") {
            const formattedFechaInicio1 = formatYearMonth(fecha);
            const formattedFechaFinal = formatYearMonth(fechaFinal);
            formData.append('Certificacion_Programa', adj_certificado_final2);
            formData.append('Tipo_movilidad', indiquecual);
            formData.append('Fecha_inicio', formattedFechaInicio1);
            formData.append('Fecha_final', formattedFechaFinal);
            formData.append('Ambito_movilidad', acuerdoLicencia);
            formData.append('Autores', JSON.stringify(autores));
        }

        if (tipoProductoEstSelected.codigo === "prueba_ciclo") {
            const formattedFechaInicio9 = formatYearMonth(fecha);
            formData.append('Certificacion_programa', adj_certificado_final2);
            formData.append('Fecha', formattedFechaInicio9);
            formData.append('Autores', JSON.stringify(autores));
        }

        await Funciones.formulario(url, formData, 'POST', callback);
    }

    if (seleccion === 'gestionRecursos') {
        let formData = new FormData();
        formData.append('semillero', semillero);
        formData.append('tipo_Producto', tipo_Producto);
        formData.append('subtipo_producto', tipoProductoRecSelected.id);
        appendCentrosInvestigacion(formData);

        for (const item of inputs) {
            formData.append(item.codigo, item.value);
        }

        if (tipoProductoRecSelected.codigo === "produ_trabajos_dirigidos") {
            const formattedFechaInicio10 = formatYearMonth(fecha);
            const formattedFechaInicio11 = formatYearMonth(fechaFinal);
            formData.append('Tipo_Producto:', tipoProyectoSelected.nombre);
            formData.append('Tipo_Orientación', orientacionSelected.nombre);
            formData.append('Valoración_tesis', tipoEmpresaSelected.nombre);
            formData.append('Programa_académico', tipoProgramaSelected.nombre);
            formData.append('Fecha_Inicio', formattedFechaInicio10);
            formData.append('Fecha_Final', formattedFechaInicio11);
            formData.append('Autores', JSON.stringify(autores));
        }

        if (tipoProductoRecSelected.codigo === "produ_recurso_proyecto") {
            const formattedFechaInicio12 = formatYearMonth(fecha);
            const formattedFechaInicio13 = formatYearMonth(fechaFinal);
            formData.append('El_proyecto_es', tipoProyectoSelected.nombre);
            formData.append('Tipo_proyecto', orientacionSelected.nombre);
            formData.append('Fecha_Inicio', formattedFechaInicio12);
            formData.append('Fecha_Final', formattedFechaInicio13);
            formData.append('Fuente_financiación', tipoEmpresaSelected.nombre);
        }

        await Funciones.formulario(url, formData, 'POST', callback);
    }
};

    //Funcion para hacer un reset en el Step
    const handleReset = () => {
        setActiveStep(0);
    };

    //Funcion para hacer un reset en el Step de Bibliografia
    const handleResetTipoBiblio = () => {
        setActiveStepBiblio(0);
    };

    //Funcion para hacer un back en el Step
    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    //Funcion para hacer un back en el Step de Bibliografia
    const handleBackTipoBiblio = () => {
        setActiveStepBiblio((prevActiveStep) => prevActiveStep - 1);
    };

    React.useEffect(() => {
    obtenerCentros();
    }, []);

    const obtenerCentros = async () => {
    try {
        const data = await Funciones.obtenerValores(Helper.SEMI_CENTROS_INVES);
        setCentrosInvestigacion(data); 
    } catch (err) {
        console.log(err);
    } finally {
        setCargando(false);
    }
    };

    const handleOnchangeCentro = (event) => {
    const value = event.target.value;
    setCentroInvestigacion(value); 

    if (errores.length > 0) {
        setErrores(
        errores.filter((er) => er.llave !== "centroInvestigacion")
        );
    }
    };


    const handleOnClose = () =>{
        //Reseteo Eventos
        setAnio(new Date())
        setFechaInicioEvento(new Date())
        setFechaFinEvento(new Date())
        setDepartamentos([])
        setDepartamento('')
        setCiudades([])
        setCiudad('')
        setNombreDelEvento('')
        setNombreDelAmbito('')
        setNombreModalidadPar('')
        setAdj_evento('')
        setCentrosInvestigacion([]);

        //Reseteo Eventos
        setFechaInicio(new Date())
        setFechaFin(new Date())
        setNombreProyecto('')
        setDescripcionProyecto('')
        setAsignaturaProyecto('')
        setNombreprofesorProyecto('')
        //Variables Prod. Tec y Tecno
        setNombreProductoTec('')
        setTipoProductoTec('')
        setNitTec('')
        setNumeroRegistroTec('')
        setNombreTitular('')
        setAnioTec(new Date())
        setPaisTec('')
        setSeleccion('tipo')

        setErrores([])
        setActiveStep(0);
        setActiveStepBiblio(0);
        props.setOpenModalGestion(false)
    }

    //Seccion de Produccion bibliografica funciones

    const vista = () => {
  const hasCentroSeleccionado =
    Array.isArray(centroInvestigacion) && centroInvestigacion.length > 0;

  const cardBaseStyle = {
    height: "100%",
    borderRadius: "14px",
    border: "1px solid #E5E7EB",
    boxShadow: "0 4px 12px rgba(15, 23, 42, 0.08)",
    transition: "all .2s ease",
    cursor: hasCentroSeleccionado ? "pointer" : "not-allowed",
    opacity: hasCentroSeleccionado ? 1 : 0.7,
    backgroundColor: "#FFFFFF",
  };

  switch (seleccion) {
    case "tipo":
      return cargando === true ? (
        <div>
          <TareasTerminadas
            imagen={emma_w}
            mensaje={"Cargando.."}
            widthImg="7%"
            marginTop="7%"
          />
          <LinearProgress />
        </div>
      ) : (
        <Grid
          container
          justify={"center"}
          style={{
            padding: "12px",
            backgroundColor: "#F8FAFC",
          }}
        >
          <Grid item xs={12} style={{ marginBottom: "12px" }}>
            <Paper
              elevation={0}
              style={{
                borderRadius: "12px",
                backgroundColor: "#FFF5F5",
                border: "1px solid #F5C2C7",
                borderLeft: "5px solid var(--primary-color)",
                padding: "14px",
              }}
            >
              <Grid container spacing={1} alignItems="flex-start">
                <Grid item>
                  <NotificationImportantIcon
                    style={{ color: "var(--primary-color)", fontSize: 20 }}
                  />
                </Grid>
                <Grid item xs>
                  <Typography
                    variant="subtitle2"
                    style={{ fontWeight: 600, color: "#7F1D1D" }}
                  >
                    Nota
                  </Typography>

                  <Typography
                    variant="body2"
                    style={{
                      color: "#5F2120",
                      marginTop: "4px",
                      lineHeight: 1.45,
                    }}
                  >
                    Si desea tener información sobre las tipologías de productos y
                    su definición según el modelo de medición de MinCiencias, lo
                    invitamos a consultar el siguiente sitio web:
                  </Typography>

                  <a
                    href="https://sway.cloud.microsoft/fFmh09rFkAs51aix?ref=Link"
                    target="_blank"
                    rel="noreferrer"
                    style={{
                      display: "inline-block",
                      marginTop: "6px",
                      color: "var(--primary-color)",
                      fontWeight: 500,
                      textDecoration: "none",
                      wordBreak: "break-all",
                    }}
                  >
                    Ver sitio web
                  </a>
                </Grid>
              </Grid>
            </Paper>
          </Grid>

          <Grid item xs={12} style={{ marginBottom: "14px" }}>
            <Paper
              elevation={0}
              style={{
                borderRadius: "12px",
                border: "1px solid #E5E7EB",
                backgroundColor: "#FFFFFF",
                padding: "16px",
              }}
            >
              <Typography
                variant="subtitle2"
                style={{
                  marginBottom: "6px",
                  color: "#111827",
                  fontWeight: 600,
                }}
              >
                Paso 1. Selecciona el centro de investigación
              </Typography>

              <Typography
                variant="body2"
                style={{
                  marginBottom: "12px",
                  color: "#6B7280",
                }}
              >
                Debes elegir el centro de investigación antes de continuar.
              </Typography>

              <Grid item xs={12}>
                <InputLabel htmlFor="centro-investigacion-select">
                  Centros de Investigación
                </InputLabel>

                <FormControl
                  className={classes.formControl}
                  fullWidth
                  error={getError("centroInvestigacion", errores).length > 0}
                >
                  <Select
                    multiple
                    value={centroInvestigacion}
                    onChange={handleOnchangeCentro}
                    renderValue={(selected) => {
                      if (!selected || selected.length === 0) {
                        return `${centrosInvestigacion.length} Centros disponibles`;
                      }
                      return `${selected.length} centro${
                        selected.length > 1 ? "s" : ""
                      } seleccionado${selected.length > 1 ? "s" : ""}`;
                    }}
                  >
                    {(centrosInvestigacion || []).map((centro) => (
                      <MenuItem key={centro.id} value={centro.id}>
                        <Checkbox
                          checked={centroInvestigacion.includes(centro.id)}
                        />
                        {centro.nombre}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <FormHelperText>
                  {getError("centroInvestigacion", errores)}
                </FormHelperText>
              </Grid>
            </Paper>
          </Grid>

          <Grid item xs={12} style={{ marginBottom: "6px" }}>
            <Typography
              variant="subtitle2"
              style={{
                fontWeight: 600,
                color: "#111827",
                paddingLeft: "2px",
              }}
            >
              Paso 2. Elige el tipo de producto
            </Typography>
          </Grid>

          {tipoSolicitud.map((item, index) => {
            const disabled = !hasCentroSeleccionado;

            return (
              <Grid
                key={index}
                item
                xs={12}
                sm={6}
                md={4}
                style={{ padding: "8px" }}
              >
                <Card
                  elevation={0}
                  style={cardBaseStyle}
                  onClick={() => {
                    if (!disabled) handleClickChangeToForm(item);
                  }}
                >
                  <CardContent
                    style={{
                      padding: "14px",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      textAlign: "center",
                      minHeight: "220px",
                    }}
                  >
                    <div
                      style={{
                        height: "64px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginBottom: "10px",
                      }}
                    >
                      <img
                        src={`${Funciones.api}${item.archivo}`}
                        alt="Imagen Tipo"
                        style={{
                          width: "58px",
                          height: "58px",
                          objectFit: "contain",
                        }}
                      />
                    </div>

                    <Typography
                      variant="body1"
                      style={{
                        fontWeight: 600,
                        color: "#111827",
                        marginBottom: "8px",
                        fontSize: "0.92rem",
                        lineHeight: 1.25,
                        minHeight: "42px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {item.valorc}
                    </Typography>

                    <Typography
                      variant="body2"
                      style={{
                        color: "#6B7280",
                        lineHeight: 1.35,
                        marginBottom: "12px",
                        fontSize: "0.8rem",
                        flexGrow: 1,
                        display: "-webkit-box",
                        WebkitLineClamp: 3,
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                      }}
                    >
                      {item.valorb}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            );
          })}
        </Grid>
     
            )
          case 'gestion':
            return (
                <ModalStepperForm
                    //Stepper
                    hola={activeStep}
                    activeStepBiblio={activeStepBiblio}
                    handleReset={handleReset}
                    steps={steps}
                    tipoSolicitudActual={tipoSolicitudActual}
                    setTipoSolicitudActual={setTipoSolicitudActual}

                    //Variables eventos
                    anio={anio}
                    setAnio={setAnio}

                    fechaInicioEvento={fechaInicioEvento}
                    setFechaInicioEvento={setFechaInicioEvento}

                    fechaFinEvento={fechaFinEvento}
                    setFechaFinEvento={setFechaFinEvento}

                    departamentos={departamentos}
                    setDepartamentos={setDepartamentos}

                    departamento={departamento}
                    setDepartamento={setDepartamento}

                    ciudades={ciudades}
                    setCiudades={setCiudades}

                    ciudad={ciudad}
                    setCiudad={setCiudad}

                    nombreDelEvento={nombreDelEvento}
                    setNombreDelEvento={setNombreDelEvento}

                    nombreDelAmbito={nombreDelAmbito}
                    setNombreDelAmbito={setNombreDelAmbito}

                    nombreAmbitos={nombreAmbitos}
                    setNombreAmbitos={setNombreAmbitos}

                    nombreModalidadPar={nombreModalidadPar}
                    setNombreModalidadPar={setNombreModalidadPar}

                    nombreModalidadPars={nombreModalidadPars}
                    setNombreModalidadPars={setNombreModalidadPars}

                    cargandoEvento={cargandoEvento}
                    setCargandoEvento={setCargandoEvento}

                    adj_evento={adj_evento}
                    setAdj_evento={setAdj_evento}

                    adj_certificado_final={adj_certificado_final}
                    setAdj_certificado_final={setAdj_certificado_final}

                    adj_certificado={adj_certificado}
                    setAdj_certificado={setAdj_certificado}

                    adj_certificado_final2={adj_certificado_final2}
                    setAdj_certificado2={setAdj_certificado2}


                    adj_certificado3={adj_certificado3}
                    setAdj_certificado3={setAdj_certificado3}

                    adj_certificado4={adj_certificado4}
                    setAdj_certificado4={setAdj_certificado4}

                    adj_certificado5={adj_certificado5}
                    setAdj_certificado5={setAdj_certificado5}

                    adj_certificado_final3={adj_certificado_final3}
                    setAdj_certificado_final3={setAdj_certificado_final3}

                    //Variables Proyectos
                    fechaInicio={fechaInicio}
                    setFechaInicio={setFechaInicio}

                    fechaFin={fechaFin}
                    setFechaFin={setFechaFin}

                    nombreProyecto={nombreProyecto}
                    setNombreProyecto={setNombreProyecto}

                    nombreprofesorProyecto={nombreprofesorProyecto}
                    setNombreprofesorProyecto={setNombreprofesorProyecto}

                    profesorProyecto={profesorProyecto}
                    setProfesorProyecto={setProfesorProyecto}

                    obtenerliderSemillero={props.obtenerliderSemillero}

                    descripcionProyecto={descripcionProyecto}
                    setDescripcionProyecto={setDescripcionProyecto}

                    asignaturaProyecto={asignaturaProyecto}
                    setAsignaturaProyecto={setAsignaturaProyecto}


                    //Variables Prod. Bibliografica
                    nombreProductoBiblio={nombreProductoBiblio}
                    setNombreProductoBiblio={setNombreProductoBiblio}

                    tipoProductoBiblio={tipoProductoBiblio}
                    setTipoProductoBiblio={setTipoProductoBiblio}

                    anioBiblio={anioBiblio}
                    setAnioBiblio={setAnioBiblio}

                    revistaEditorialBiblio={revistaEditorialBiblio}
                    setRevistaEditorialBiblio={setRevistaEditorialBiblio}

                    cuartilBiblio={cuartilBiblio}
                    setCuartilBiblio={setCuartilBiblio}

                    lugarPublicacionBiblio={lugarPublicacionBiblio}
                    setLugarPublicacionBiblio={setLugarPublicacionBiblio}

                    medioDivulgacionBiblio={medioDivulgacionBiblio}
                    setMedioDivulgacionBiblio={setMedioDivulgacionBiblio}

                    //Variables Prod. Tec y Tecno
                    nombreProductoTec={nombreProductoTec}
                    setNombreProductoTec={setNombreProductoTec}

                    tipoProductoTec={tipoProductoTec}
                    setTipoProductoTec={setTipoProductoTec}

                    nitTec={nitTec}
                    setNitTec={setNitTec}

                    numeroRegistroTec={numeroRegistroTec}
                    setNumeroRegistroTec={setNumeroRegistroTec}

                    nombreTitular={nombreTitular}
                    setNombreTitular={setNombreTitular}

                    anioTec={anioTec}
                    setAnioTec={setAnioTec}

                    paisTec={paisTec}
                    setPaisTec={setPaisTec}

                    //Variables Autores y particiapntes
                    numeroIdParEvent={numeroIdParEvent}
                    setNumeroIdParEvent={setNumeroIdParEvent}
                    arrai={arrai}
                    setArrai={setArrai}

                    //Cargando
                    cargando={cargandoFormGestion}
                    setCargando={setCargandoFormGestion}

                    //Permisos de la solicitud
                    permisosDeLaSolicitud={permisosDeLaSolicitud}
                    setPermisosDeLaSolicitud={setPermisosDeLaSolicitud}

                    //Errores
                    getError={getError}
                    errores={errores}
                    setErrores={setErrores}

                    //rol y modalidad
                    rolActive={rolActive}
                    setRolActive={setRolActive}

                    modalidadParticipacionActive={modalidadParticipacionActive}
                    setModalidadParticipacionActive={setModalidadParticipacionActive}
                />
            )
        case 'bibliografica':
            return(
                <ModalProduccionBibliografica
                //Stepper
                hola={activeStep}
                activeStepBiblio={activeStepBiblio} 
                setActiveStepBiblio={setActiveStepBiblio}
                handleReset={handleReset}
                steps={steps}
                tipoSolicitudActual={tipoSolicitudActual}
                setTipoSolicitudActual={setTipoSolicitudActual}

                //Cargando
                cargandoProduBibliografico={cargandoProduBibliografico}
                setCargandoProduBibliografico={setCargandoProduBibliografico}

                //Funcion para cambiar la vista
                handleClickChangeToFormBibliografia={handleClickChangeToFormBibliografia}
                />
            )
        case 'tecnica':
            return(
                <ModalProduccionTecnica
                //Stepper
                hola={activeStep}
                handleReset={handleReset}
                steps={steps}
                tipoSolicitudActual={tipoSolicitudActual}
                setTipoSolicitudActual={setTipoSolicitudActual}

                //Funcion para cambiar la vista
                handleClickChangeToFormTec={handleClickChangeToFormTec}
                cargandoProduTec={cargandoProduTec}
                setCargandoProduTec={setCargandoProduTec}
                />
            )
        case 'gestionTecnica':
            return(
                <ModalProduccionTecnicaForms
                //Stepper
                hola={activeStepBiblio}
                handleReset={handleResetTipoBiblio}
                steps={steps}

                cargandoProduTec={cargandoProduTec}
                setCargandoProduTec={setCargandoProduTec}

                //Tipo de produccion
                tipoProduccionTecnica={tipoProduccionTecnica}
                setTipoProduccionTecnica={setTipoProduccionTecnica}
                //Tipo de Solicitud Actual
                tipoSolicitudActual={tipoSolicitudActual}
                setTipoSolicitudActual={setTipoSolicitudActual}

                tipoProductoTecSelected={tipoProductoTecSelected}
                setTipoProductoTecSelected={setTipoProductoTecSelected}

                inputs={inputs}
                setInputs={setInputs}

                // Tipo de Solicitud Actual
                // tipoSolicitudActual={tipoSolicitudActual}
                // setTipoSolicitudActual={setTipoSolicitudActual}
                //Variables Autores y particiapntes
                numeroIdParEvent={numeroIdParEvent}
                setNumeroIdParEvent={setNumeroIdParEvent}
                arrai={arrai}
                setArrai={setArrai}

                //Permisos de la solicitud
                permisosDeLaSolicitud={permisosDeLaSolicitud}
                setPermisosDeLaSolicitud={setPermisosDeLaSolicitud}

                cargandoGestionBibliografica={cargandoGestionBibliografica}
                setCargandoGestionBibliografica={setCargandoGestionBibliografica}

                //fechas para los formularios
                fechaCreacionDiseñoIndus={fechaCreacionDiseñoIndus}
                setFechaCreacionDiseñoIndus={setFechaCreacionDiseñoIndus}

                fechaDesarrolloSoftware={fechaDesarrolloSoftware}
                setFechaDesarrolloSoftware={setFechaDesarrolloSoftware}

                fechaObtencionRegistroSoftware={fechaObtencionRegistroSoftware}
                setFechaObtencionRegistroSoftware={setFechaObtencionRegistroSoftware}

                fechaCreacionPrototipo={fechaCreacionPrototipo}
                setFechaCreacionPrototipo={setFechaCreacionPrototipo}

                fechaCreacionSignoDistintivo={fechaCreacionSignoDistintivo}
                setFechaCreacionSignoDistintivo={setFechaCreacionSignoDistintivo}

                fechaRegistroBaseTecno={fechaRegistroBaseTecno}
                setFechaRegistroBaseTecno={setFechaRegistroBaseTecno}

                fechaInnovacionProceServi={fechaInnovacionProceServi}
                setFechaInnovacionProceServi={setFechaInnovacionProceServi}

                fechaInnovacionGestionEmp={fechaInnovacionGestionEmp}
                setFechaInnovacionGestionEmp={setFechaInnovacionGestionEmp}

                fechaPresentacionObraProducto={fechaPresentacionObraProducto}
                setFechaPresentacionObraProducto={setFechaPresentacionObraProducto}

                fechaCreacionObraProducto={fechaCreacionObraProducto}
                setFechaCreacionObraProducto={setFechaCreacionObraProducto}

                fechaInicioEventoArtistico={fechaInicioEventoArtistico}
                setFechaInicioEventoArtistico={setFechaInicioEventoArtistico}

                fechaFinalEventoArtistico={fechaFinalEventoArtistico}
                setFechaFinalEventoArtistico={setFechaFinalEventoArtistico}

                fechaInicioTalleresCreacion={fechaInicioTalleresCreacion}
                setFechaInicioTalleresCreacion={setFechaInicioTalleresCreacion}

                fechaFinalTalleresCreacion={fechaFinalTalleresCreacion}
                setFechaFinalTalleresCreacion={setFechaFinalTalleresCreacion}

                productoTieneSelected={productoTieneSelected}
                setProductoTieneSelected={setProductoTieneSelected}

                inputsSelects={inputsSelects}
                setInputsSelects={setInputsSelects}

                fechaRegistroDiseñoPrototipoTiene={fechaRegistroDiseñoPrototipoTiene}
                setFechaRegistroDiseñoPrototipoTiene={setFechaRegistroDiseñoPrototipoTiene}

                tipoPrototipoSelected={tipoPrototipoSelected}
                setTipoPrototipoSelected={setTipoPrototipoSelected}

                otroTipoPrototipoSelected={otroTipoPrototipoSelected}
                setOtroTipoPrototipoSelected={setOtroTipoPrototipoSelected}

                tipoSoftwareSelected={tipoSoftwareSelected}
                setTipoSoftwareSelected={setTipoSoftwareSelected}

                otroTipoSoftwareSelected={otroTipoSoftwareSelected}
                setOtroTipoSoftwareSelected={setOtroTipoSoftwareSelected}

                tipoSignoDistintivoSelected={tipoSignoDistintivoSelected}
                setTipoSignoDistintivoSelected={setTipoSignoDistintivoSelected}

                tipoEmpresaSelected={tipoEmpresaSelected}
                setTipoEmpresaSelected={setTipoEmpresaSelected}

                tipoProgramaSelected={tipoProgramaSelected}
                setTipoProgramaSelected={setTipoProgramaSelected}

                setTipoDepartamentoSelected={setTipoDepartamentoSelected}
                tipoDepartamentoSelected={tipoDepartamentoSelected}

                tipoInnovacionSelected={tipoInnovacionSelected}
                setTipoInnovacionSelected={setTipoInnovacionSelected}

                tipoEspacioEventoSelected={tipoEspacioEventoSelected}
                setTipoEspacioEventoSelected={setTipoEspacioEventoSelected}

                tipoDisciplinaAmbitoSelected={tipoDisciplinaAmbitoSelected}
                setTipoDisciplinaAmbitoSelected={setTipoDisciplinaAmbitoSelected}

                tipoAmbitoSelected={tipoAmbitoSelected}
                setTipoAmbitoSelected={setTipoAmbitoSelected}

                tipoRolSelected={tipoRolSelected}
                setTipoRolSelected={setTipoRolSelected}

                tipoEventoSelected={tipoEventoSelected}
                setTipoEventoSelected={setTipoEventoSelected}

                productoTiene={productoTiene}
                setProductoTiene={setProductoTiene}

                tiposDePrototipos={tiposDePrototipos}
                setTiposDePrototipos={setTiposDePrototipos}

                tiposDeSoftware={tiposDeSoftware}
                setTiposDeSoftware={setTiposDeSoftware}

                tiposSignoDistintivos={tiposSignoDistintivos}
                setTiposSignoDistintivos={setTiposSignoDistintivos}

                tiposEmpresas={tiposEmpresas}
                setTiposEmpresas={setTiposEmpresas}

                tiposProgramas={tiposProgramas}
                setTiposProgramas={setTiposProgramas}

                tiposDepartamentos={tiposDepartamentos}
                setTiposDepartamentos={setTiposDepartamentos}

                tiposInnovaciones={tiposInnovaciones}
                setTiposInnovaciones={setTiposInnovaciones}

                tiposEspacioEvento={tiposEspacioEvento}
                setTiposEspacioEvento={setTiposEspacioEvento}

                tiposDisciplinaAmbito={tiposDisciplinaAmbito}
                setTiposDisciplinaAmbito={setTiposDisciplinaAmbito}

                tiposAmbitos={tiposAmbitos}
                setTiposAmbitos={setTiposAmbitos}

                tiposRoles={tiposRoles}
                setTiposRoles={setTiposRoles}

                tiposEventos={tiposEventos}
                setTiposEventos={setTiposEventos}

                paisesTecTecno={paisesTecTecno}
                setPaisesTecTecno={setPaisesTecTecno}

                paisSelectedTecTecno={paisSelectedTecTecno}
                setPaisSelectedTecTecno={setPaisSelectedTecTecno}
                ciudadesTecTecno={ciudadesTecTecno}
                setCiudadesTecTecno={setCiudadesTecTecno}   
                ciudadesSelectedTecTecno={ciudadesSelectedTecTecno}
                setCiudadesSelectedTecTecno={setCiudadesSelectedTecTecno}

                disponibilidadesTecTecno={disponibilidadesTecTecno}
                setDisponibilidadesTecTecno={setDisponibilidadesTecTecno}

                idiomaTecTecno={idiomaTecTecno}
                setIdiomaTecTecno={setIdiomaTecTecno}
                idiomaSelectedTecTecno={idiomaSelectedTecTecno}
                setIdiomaSelectedTecTecno={setIdiomaSelectedTecTecno}

                acuerdoLicencia={acuerdoLicencia}
                setAcuerdoLicencia={setAcuerdoLicencia}

                disponibilidadSelectedTecTecno={disponibilidadSelectedTecTecno}
                setDisponibilidadSelectedTecTecno={setDisponibilidadSelectedTecTecno}

                adj_certificado2={adj_certificado2}
                setAdj_certificado2={setAdj_certificado2}

                adj_certificado_final2={adj_certificado_final2}
                setAdj_certificado_final2={setAdj_certificado_final2}

                adj_certificado3={adj_certificado3}
                setAdj_certificado3={setAdj_certificado3}

                adj_certificado_final3={adj_certificado_final3}
                setAdj_certificado_final3={setAdj_certificado_final3}

                adj_certificado4={adj_certificado4}
                setAdj_certificado4={setAdj_certificado4}

                adj_certificado_final4={adj_certificado_final4}
                setAdj_certificado_final4={setAdj_certificado_final4}

                adj_certificado5={adj_certificado5}
                setAdj_certificado5={setAdj_certificado5}

                adj_certificado_final5={adj_certificado_final5}
                setAdj_certificado_final5={setAdj_certificado_final5}
                //Errores
                getError={getError}
                errores={errores}
                setErrores={setErrores}

                //rol y modalidad
                rolActive={rolActive}
                setRolActive={setRolActive}

                modalidadParticipacionActive={modalidadParticipacionActive}
                setModalidadParticipacionActive={setModalidadParticipacionActive}

                fechaRegistroEmpresaCultural={fechaRegistroEmpresaCultural}
                setFechaRegistroEmpresaCultural={setFechaRegistroEmpresaCultural}

                otroTipoEspacioEvento={otroTipoEspacioEvento}
                setOtroTipoEspacioEvento={setOtroTipoEspacioEvento}
                />
            )
        case 'proyectos':
            return(
                <ModalDivulgacionCientifica

                hola={activeStep}
                handleReset={handleReset}
                steps={steps}
                tipoSolicitudActual={tipoSolicitudActual}
                setTipoSolicitudActual={setTipoSolicitudActual}

                //Funcion para cambiar la vista
                handleClickChangeFormDivulgacion={handleClickChangeFormDivulgacion}
                cargandoProduTec={cargandoProduTec}
                setCargandoProduTec={setCargandoProduTec}

                
                />)
        case 'gestionProyectos':
            return(
                <ModalProduccionDivulgacionForms
                //Stepper
                hola={activeStepBiblio}
                handleReset={handleResetTipoBiblio}
                steps={steps}

                cargandoProduTec={cargandoProduTec}
                setCargandoProduTec={setCargandoProduTec}

                //Tipo de produccion
                tipoProduccionDivulgacion={tipoProduccionDivulgacion}
                setTipoProduccionDivulgacion={setTipoProduccionDivulgacion}
                //Tipo de Solicitud Actual
                tipoSolicitudActual={tipoSolicitudActual}
                setTipoSolicitudActual={setTipoSolicitudActual}

                tipoProductoDivSelected={tipoProductoDivSelected}
                setTipoProductoDivSelected={setTipoProductoDivSelected}

                inputs={inputs}
                setInputs={setInputs}
                inputsSelects={inputsSelects}
                setInputsSelects={setInputsSelects}

                numeroIdParEvent={numeroIdParEvent}
                setNumeroIdParEvent={setNumeroIdParEvent}
                arrai={arrai}
                setArrai={setArrai}

                //Permisos de la solicitud
                permisosDeLaSolicitud={permisosDeLaSolicitud}
                setPermisosDeLaSolicitud={setPermisosDeLaSolicitud}

                cargandoGestionBibliografica={cargandoGestionBibliografica}
                setCargandoGestionBibliografica={setCargandoGestionBibliografica}

                //formularios

                tipoContenidoSelected={tipoContenidoSelected}
                setTipoContenidoSelected={setTipoContenidoSelected}
                tipoContenido={tipoContenido}
                setTipoContenido={setTipoContenido}

                tipoDesarrollo={tipoDesarrollo}
                setTipoDesarrollo={setTipoDesarrollo}
                tipoDesarrolloSelected={tipoDesarrolloSelected}
                setTipoDesarrolloSelected={setTipoDesarrolloSelected}

                tipoClase={tipoClase}
                setTipoClase={setTipoClase}
                tipoClaseSelected={tipoClaseSelected}
                setTipoClaseSelected={setTipoClaseSelected}

                idiomaArticulo={idiomaArticulo}
                setIdiomaArticulo={setIdiomaArticulo}
                idiomaArticuloSelected={idiomaArticuloSelected}
                setIdiomaArticuloSelected={setIdiomaArticuloSelected}

                medioVerificacion={medioVerificacion}
                setMedioVerificacion={setMedioVerificacion}
                medioVerificacionSelected={medioVerificacionSelected}
                setMedioVerificacionSelected={setMedioVerificacionSelected}

                generoLiterarioSelected={generoLiterarioSelected}
                setGeneroLiterarioSelected={setGeneroLiterarioSelected}
                generoLiterario={generoLiterario}
                setGeneroLiterario={setGeneroLiterario}

                fecha={fecha}
                setFecha={setFecha}

                fechaFinal={fechaFinal}
                setFechaFinal={setFechaFinal}

                ciudadesDivulgacion={ciudadesDivulgacion}
                setCiudadesDivulgacion={setCiudadesDivulgacion}
                ciudadesSelectedDivulgacion={ciudadesSelectedDivulgacion}
                setCiudadesSelectedDivulgacion={setCiudadesSelectedDivulgacion}

                publicoObjetivoSelected={publicoObjetivoSelected}
                setPublicoObjetivoSelected={setPublicoObjetivoSelected}
                publicoObjetivo={publicoObjetivo}
                setPublicoObjetivo={setPublicoObjetivo}

                rutaCirculacion={rutaCirculacion}
                setRutaCirculacion={setRutaCirculacion}
                rutaCirculacionSelected={rutaCirculacionSelected}
                setRutaCirculacionSelected={setRutaCirculacionSelected}

                acuerdoLicencia={acuerdoLicencia}
                setAcuerdoLicencia={setAcuerdoLicencia}

                adj_certificado2={adj_certificado2}
                setAdj_certificado2={setAdj_certificado2}
                adj_certificado_final2={adj_certificado_final2}
                setAdj_certificado_final2={setAdj_certificado_final2}

                adj_certificado3={adj_certificado3}
                setAdj_certificado3={setAdj_certificado3}
                adj_certificado_final3={adj_certificado_final3}
                setAdj_certificado_final3={setAdj_certificado_final3}

                tiposRoles={tiposRoles}
                setTiposRoles={setTiposRoles}

                //Errores
                getError={getError}
                errores={errores}
                setErrores={setErrores}

                //rol y modalidad
                rolActive={rolActive}
                setRolActive={setRolActive}

                modalidadParticipacionActive={modalidadParticipacionActive}
                setModalidadParticipacionActive={setModalidadParticipacionActive}

                fechaRegistroEmpresaCultural={fechaRegistroEmpresaCultural}
                setFechaRegistroEmpresaCultural={setFechaRegistroEmpresaCultural}

                otroTipoEspacioEvento={otroTipoEspacioEvento}
                setOtroTipoEspacioEvento={setOtroTipoEspacioEvento}
                />
            )
        case 'social':
            return(
                <ModalApropiacionSocialConocimiento

                hola={activeStep}
                handleReset={handleReset}
                steps={steps}
                tipoSolicitudActual={tipoSolicitudActual}
                setTipoSolicitudActual={setTipoSolicitudActual}

                //Funcion para cambiar la vista
                handleClickChangeFormSocial={handleClickChangeFormSocial}
                cargandoProduTec={cargandoProduTec}
                setCargandoProduTec={setCargandoProduTec}

                
                />)
        case 'gestionSocial':
            return(
                <ModalProduccionSocialForms
                //Stepper
                hola={activeStepBiblio}
                handleReset={handleResetTipoBiblio}
                steps={steps}

                cargandoProduTec={cargandoProduTec}
                setCargandoProduTec={setCargandoProduTec}

                //Tipo de produccion
                tipoProduccionSocial={tipoProduccionSocial}
                setTipoProduccionSocial={setTipoProduccionSocial}
                //Tipo de Solicitud Actual
                tipoSolicitudActual={tipoSolicitudActual}
                setTipoSolicitudActual={setTipoSolicitudActual}

                tipoProductoSolSelected={tipoProductoSolSelected}
                setTipoProductoSolSelected={setTipoProductoSolSelected}

                inputs={inputs}
                setInputs={setInputs}
                inputsSelects={inputsSelects}
                setInputsSelects={setInputsSelects}

                numeroIdParEvent={numeroIdParEvent}
                setNumeroIdParEvent={setNumeroIdParEvent}
                arrai={arrai}
                setArrai={setArrai}

                //Permisos de la solicitud
                permisosDeLaSolicitud={permisosDeLaSolicitud}
                setPermisosDeLaSolicitud={setPermisosDeLaSolicitud}

                cargandoGestionBibliografica={cargandoGestionBibliografica}
                setCargandoGestionBibliografica={setCargandoGestionBibliografica}

                //formularios
                licencia={licencia}
                setLicencia={setLicencia}
                licenciaSelected={licenciaSelected}
                setlicenciaSelected={setlicenciaSelected}

                tipoEmpresa={tipoEmpresa}
                setTipoEmpresa={setTipoEmpresa}
                tipoEmpresasoSelected={tipoEmpresasoSelected}
                setTipoEmpresasoSelected={setTipoEmpresasoSelected}

                fecha={fecha}
                setFecha={setFecha}

                adj_certificado2={adj_certificado2}
                setAdj_certificado2={setAdj_certificado2}
                adj_certificado_final2={adj_certificado_final2}
                setAdj_certificado_final2={setAdj_certificado_final2}

                adj_certificado3={adj_certificado3}
                setAdj_certificado3={setAdj_certificado3}
                adj_certificado_final3={adj_certificado_final3}
                setAdj_certificado_final3={setAdj_certificado_final3}

                tiposRoles={tiposRoles}
                setTiposRoles={setTiposRoles}

                //Errores
                getError={getError}
                errores={errores}
                setErrores={setErrores}

                //rol y modalidad
                rolActive={rolActive}
                setRolActive={setRolActive}

                modalidadParticipacionActive={modalidadParticipacionActive}
                setModalidadParticipacionActive={setModalidadParticipacionActive}

                fechaRegistroEmpresaCultural={fechaRegistroEmpresaCultural}
                setFechaRegistroEmpresaCultural={setFechaRegistroEmpresaCultural}

                otroTipoEspacioEvento={otroTipoEspacioEvento}
                setOtroTipoEspacioEvento={setOtroTipoEspacioEvento}
                />
            )
         case 'recursos':
            return(
                <ModalrecursoHumanoCTeI

                hola={activeStep}
                handleReset={handleReset}
                steps={steps}
                tipoSolicitudActual={tipoSolicitudActual}
                setTipoSolicitudActual={setTipoSolicitudActual}

                //Funcion para cambiar la vista
                handleClickChangeFormRecursos={handleClickChangeFormRecursos}
                cargandoProduTec={cargandoProduTec}
                setCargandoProduTec={setCargandoProduTec}

                
                />)
        case 'gestionRecursos':
            return(
                <ModalProduccionRecursoForms
                //Stepper
                hola={activeStepBiblio}
                handleReset={handleResetTipoBiblio}
                steps={steps}

                cargandoProduTec={cargandoProduTec}
                setCargandoProduTec={setCargandoProduTec}

                //Tipo de produccion
                tipoProduccionRecursos={tipoProduccionRecursos}
                setTipoProduccionRecursos={setTipoProduccionRecursos}
                //Tipo de Solicitud Actual
                tipoSolicitudActual={tipoSolicitudActual}
                setTipoSolicitudActual={setTipoSolicitudActual}

                tipoProductoRecSelected={tipoProductoRecSelected}
                setTipoProductoRecSelected={setTipoProductoRecSelected}

                inputs={inputs}
                setInputs={setInputs}
                inputsSelects={inputsSelects}
                setInputsSelects={setInputsSelects}

                numeroIdParEvent={numeroIdParEvent}
                setNumeroIdParEvent={setNumeroIdParEvent}
                arrai={arrai}
                setArrai={setArrai}

                //Permisos de la solicitud
                permisosDeLaSolicitud={permisosDeLaSolicitud}
                setPermisosDeLaSolicitud={setPermisosDeLaSolicitud}

                cargandoGestionBibliografica={cargandoGestionBibliografica}
                setCargandoGestionBibliografica={setCargandoGestionBibliografica}

                //formularios
                tipoProyecto={tipoProyecto}
                setTipoProyecto={setTipoProyecto}
                tipoProyectoSelected={tipoProyectoSelected}
                setTipoProyectoSelected={setTipoProyectoSelected}

                orientacion={orientacion}
                setOrientacion={setOrientacion}
                orientacionSelected={orientacionSelected}
                setOrientacionSelected={setOrientacionSelected}

                tiposEmpresas={tiposEmpresas}
                setTiposEmpresas={setTiposEmpresas}
                tipoEmpresaSelected={tipoEmpresaSelected}
                setTipoEmpresaSelected={setTipoEmpresaSelected}
                
                tiposProgramas={tiposProgramas}
                setTiposProgramas={setTiposProgramas}
                tipoProgramaSelected={tipoProgramaSelected}
                setTipoProgramaSelected={setTipoProgramaSelected}

                tiposDepartamentos={tiposDepartamentos}
                setTiposDepartamentos={setTiposDepartamentos}
                tipoDepartamentoSelected={tipoDepartamentoSelected}
                setTipoDepartamentoSelected={setTipoDepartamentoSelected}

                fecha={fecha}
                setFecha={setFecha}

                fechaFinal={fechaFinal}
                setFechaFinal={setFechaFinal}

                adj_certificado2={adj_certificado2}
                setAdj_certificado2={setAdj_certificado2}
                adj_certificado_final2={adj_certificado_final2}
                setAdj_certificado_final2={setAdj_certificado_final2}

                adj_certificado3={adj_certificado3}
                setAdj_certificado3={setAdj_certificado3}
                adj_certificado_final3={adj_certificado_final3}
                setAdj_certificado_final3={setAdj_certificado_final3}

                tiposRoles={tiposRoles}
                setTiposRoles={setTiposRoles}

                //Errores
                getError={getError}
                errores={errores}
                setErrores={setErrores}

                //rol y modalidad
                rolActive={rolActive}
                setRolActive={setRolActive}

                modalidadParticipacionActive={modalidadParticipacionActive}
                setModalidadParticipacionActive={setModalidadParticipacionActive}

                fechaRegistroEmpresaCultural={fechaRegistroEmpresaCultural}
                setFechaRegistroEmpresaCultural={setFechaRegistroEmpresaCultural}

                otroTipoEspacioEvento={otroTipoEspacioEvento}
                setOtroTipoEspacioEvento={setOtroTipoEspacioEvento}
                />
            )
        case 'estrategias':
            return(
                <ModalEstrategias

                hola={activeStep}
                handleReset={handleReset}
                steps={steps}
                tipoSolicitudActual={tipoSolicitudActual}
                setTipoSolicitudActual={setTipoSolicitudActual}

                //Funcion para cambiar la vista
                handleClickChangeFormEstrategias={handleClickChangeFormEstrategias}
                cargandoProduTec={cargandoProduTec}
                setCargandoProduTec={setCargandoProduTec}

                
                />)
        case 'gestionEstrategias':
            return(
                <ModalProduccionEstrategiaForms
                //Stepper
                hola={activeStepBiblio}
                handleReset={handleResetTipoBiblio}
                steps={steps}

                cargandoProduTec={cargandoProduTec}
                setCargandoProduTec={setCargandoProduTec}

                //Tipo de produccion
                tipoProduccionEstrategias={tipoProduccionEstrategias}
                setTipoProduccionEstrategias={setTipoProduccionEstrategias}
                //Tipo de Solicitud Actual
                tipoSolicitudActual={tipoSolicitudActual}
                setTipoSolicitudActual={setTipoSolicitudActual}

                tipoProductoEstSelected={tipoProductoEstSelected}
                setTipoProductoEstSelected={setTipoProductoEstSelected}

                acuerdoLicencia={acuerdoLicencia}
                setAcuerdoLicencia={setAcuerdoLicencia}

                indiquecual={indiquecual}
                setIndiquecual={setIndiquecual}
                tipoProgramaSelected={tipoProgramaSelected}
                setTipoProgramaSelected={setTipoProgramaSelected}
                tiposProgramas={tiposProgramas}
                setTiposProgramas={setTiposProgramas}
                tiposDepartamentos={tiposDepartamentos}
                setTiposDepartamentos={setTiposDepartamentos}
                setTipoDepartamentoSelected={setTipoDepartamentoSelected}
                tipoDepartamentoSelected={tipoDepartamentoSelected}

                inputs={inputs}
                setInputs={setInputs}
                inputsSelects={inputsSelects}
                setInputsSelects={setInputsSelects}

                numeroIdParEvent={numeroIdParEvent}
                setNumeroIdParEvent={setNumeroIdParEvent}
                arrai={arrai}
                setArrai={setArrai}

                //Permisos de la solicitud
                permisosDeLaSolicitud={permisosDeLaSolicitud}
                setPermisosDeLaSolicitud={setPermisosDeLaSolicitud}

                cargandoGestionBibliografica={cargandoGestionBibliografica}
                setCargandoGestionBibliografica={setCargandoGestionBibliografica}

                //formularios
                tipoProyecto={tipoProyecto}
                setTipoProyecto={setTipoProyecto}
                tipoProyectoSelected={tipoProyectoSelected}
                setTipoProyectoSelected={setTipoProyectoSelected}

                tipoEmpresa={tipoEmpresa}
                setTipoEmpresa={setTipoEmpresa}
                tipoEmpresasoSelected={tipoEmpresasoSelected}
                setTipoEmpresasoSelected={setTipoEmpresasoSelected}

                fecha={fecha}
                setFecha={setFecha}
                fechaFinal={fechaFinal}
                setFechaFinal={setFechaFinal}

                adj_certificado2={adj_certificado2}
                setAdj_certificado2={setAdj_certificado2}
                adj_certificado_final2={adj_certificado_final2}
                setAdj_certificado_final2={setAdj_certificado_final2}

                adj_certificado3={adj_certificado3}
                setAdj_certificado3={setAdj_certificado3}
                adj_certificado_final3={adj_certificado_final3}
                setAdj_certificado_final3={setAdj_certificado_final3}

                tiposRoles={tiposRoles}
                setTiposRoles={setTiposRoles}

                //Errores
                getError={getError}
                errores={errores}
                setErrores={setErrores}

                //rol y modalidad
                rolActive={rolActive}
                setRolActive={setRolActive}

                modalidadParticipacionActive={modalidadParticipacionActive}
                setModalidadParticipacionActive={setModalidadParticipacionActive}

                fechaRegistroEmpresaCultural={fechaRegistroEmpresaCultural}
                setFechaRegistroEmpresaCultural={setFechaRegistroEmpresaCultural}

                otroTipoEspacioEvento={otroTipoEspacioEvento}
                setOtroTipoEspacioEvento={setOtroTipoEspacioEvento}
                />
            )
        case 'gestionBibliografica':
            return(
                <ModalProduccionBibliograficaForms
                    hola={activeStepBiblio}
                    activeStepBiblio={activeStepBiblio}
                    handleReset={handleResetTipoBiblio}
                    steps={steps}
                    cargandoGestionBibliografica={cargandoGestionBibliografica}
                    setCargandoGestionBibliografica={setCargandoGestionBibliografica}
                    //Tipo de produccion
                    tipoProduccionBiblio={tipoProduccionBiblio}
                    setTipoProduccionBiblio={setTipoProduccionBiblio}
                    //Tipo de Solicitud Actual
                    tipoSolicitudActual={tipoSolicitudActual}
                    setTipoSolicitudActual={setTipoSolicitudActual}
                    //Variables Autores y particiapntes
                    numeroIdParEvent={numeroIdParEvent}
                    setNumeroIdParEvent={setNumeroIdParEvent}
                    arrai={arrai}
                    setArrai={setArrai}
                    //Permisos de la solicitud
                    permisosDeLaSolicitud={permisosDeLaSolicitud}
                    setPermisosDeLaSolicitud={setPermisosDeLaSolicitud}
                    //Campos de tipo articulo de produccion bibliografica
                    idiomasTipoArticulo={idiomasTipoArticulo}
                    setIdiomasTipoArticulo={setIdiomasTipoArticulo}

                    idiomaTipoArticuloSelected={idiomaTipoArticuloSelected}
                    setIdiomaTipoArticuloSelected={setIdiomaTipoArticuloSelected}
                    
                    CiudadesTipoArticulo={CiudadesTipoArticulo}
                    setCiudadesTipoArticulo={setCiudadesTipoArticulo}

                    CiudadesTipoArticuloSelected={CiudadesTipoArticuloSelected}
                    setCiudadesTipoArticuloSelected={setCiudadesTipoArticuloSelected}

                    tituloArticulo={tituloArticulo}
                    setTituloArticulo={setTituloArticulo}
                    
                    PaginaInicial={PaginaInicial}
                    setPaginaInicial={setPaginaInicial}

                    PaginaFinal={PaginaFinal}
                    setPaginaFinal={setPaginaFinal}

                    numeropaginas={numeropaginas}
                    setNumeropaginas={setNumeropaginas}

                    issn={issn}
                    setIssn={setIssn}

                    nombreRevista={nombreRevista}
                    setNombreRevista={setNombreRevista}

                    anioPublicacion={anioPublicacion}
                    setAnioPublicacion={setAnioPublicacion}

                    volumenRevista={volumenRevista}
                    setVolumenRevista={setVolumenRevista}

                    idioma={idioma}
                    setIdioma={setIdioma}

                    enlace={enlace}
                    setEnlace={setEnlace}

                    doi={doi}
                    setDoi={setDoi}

                    mediodivulgacion={mediodivulgacion}
                    setMediodivulgacion={setMediodivulgacion}

                    //Campos de tipo libro de produccion bibliografica

                    idiomasLibro={idiomasLibro}
                    setIdiomasLibro={setIdiomasLibro}

                    idiomaLibroSelected={idiomaLibroSelected}
                    setIdiomaLibroSelected={setIdiomaLibroSelected}

                    tipoLibroOtro={tipoLibroOtro}
                    setTipoLibroOtro={setTipoLibroOtro}

                    tituloLibro={tituloLibro}
                    setTituloLibro={setTituloLibro}

                    isbnLibro={isbnLibro}
                    setIsbnLibro={setIsbnLibro}

                    mediopublicacionlibro={mediopublicacionlibro}
                    setMedioPublicacionLibro={setMedioPublicacionLibro}

                    editorialLibro={editorialLibro}
                    setEditorialLibro={setEditorialLibro}

                    anioPublicacionLibro={anioPublicacionLibro}
                    setAnioPublicacionLibro={setAnioPublicacionLibro}

                    paisesTipoArticulo={paisesTipoArticulo}
                    setPaisesTipoArticulo={setPaisesTipoArticulo}

                    paisPublicacionLibro={paisPublicacionLibro}
                    setPaisPublicacionLibro={setPaisPublicacionLibro}

                    setPaisTipoCapLibroSelected={setPaisTipoCapLibroSelected}
                    paisTipoCapLibroSelected={paisTipoCapLibroSelected}

                    idiomaLibro={idiomaLibro}
                    setIdiomaLibro={setIdiomaLibro}

                    volumenLibro={volumenLibro}
                    setVolumenLibro={setVolumenLibro}

                    numeroEdicionLibro={numeroEdicionLibro}
                    setNumeroEdicionLibro={setNumeroEdicionLibro}

                    adj_certificado2={adj_certificado2}
                    setAdj_certificado2={setAdj_certificado2}

                    adj_certificado_final2={adj_certificado_final2} 
                    setAdj_certificado_final2={setAdj_certificado_final2}
                    
                    adj_certificado3={adj_certificado3}
                    setAdj_certificado3={setAdj_certificado3}

                    adj_certificado_final3={adj_certificado_final3}
                    setAdj_certificado_final3={setAdj_certificado_final3}

                    adj_certificado4={adj_certificado4}
                    setAdj_certificado4={setAdj_certificado4}

                    adj_certificado_final4={adj_certificado_final4}
                    setAdj_certificado_final4={setAdj_certificado_final4}

                    adj_certificado5={adj_certificado5}
                    setAdj_certificado5={setAdj_certificado5}

                    adj_certificado_final5={adj_certificado_final5}
                    setAdj_certificado_final5={setAdj_certificado_final5}
                    

                    //Campos de tipo Capitulo de Libro de produccion bibliografica
                    idiomasCapituloLibro={idiomasCapituloLibro}
                    setIdiomasCapituloLibro={setIdiomasCapituloLibro}

                    idiomaCapituloLibroSelected={idiomaCapituloLibroSelected}
                    setIdiomaCapituloLibroSelected={setIdiomaCapituloLibroSelected}

                    tipoLibroSelectedCap={tipoLibroSelectedCap}
                    setTipoLibroSelectedCap={setTipoLibroSelectedCap}

                    tipoLibroOtroCap={tipoLibroOtroCap}
                    setTipoLibroOtroCap={setTipoLibroOtroCap}

                    tituloCapLibro={tituloCapLibro}
                    setTituloCapLibro={setTituloCapLibro}

                    tituloLibroCap={tituloLibroCap}
                    setTituloLibroCap={setTituloLibroCap}

                    isbnLibroCap={isbnLibroCap}
                    setIsbnLibroCap={setIsbnLibroCap}

                    editorialLibroCap={editorialLibroCap}
                    setEditorialLibroCap={setEditorialLibroCap}

                    anioPublicacionLibroCap={anioPublicacionLibroCap}
                    setAnioPublicacionLibroCap={setAnioPublicacionLibroCap}

                    paisPublicacionLibroCap={paisPublicacionLibroCap}
                    setPaisPublicacionLibroCap={setPaisPublicacionLibroCap}

                    idiomaLibroCap={idiomaLibroCap}
                    setIdiomaLibroCap={setIdiomaLibroCap}

                    volumenLibroCap={volumenLibroCap}
                    setVolumenLibroCap={setVolumenLibroCap}

                    numeroEdicionLibroCap={numeroEdicionLibroCap}
                    setNumeroEdicionLibroCap={setNumeroEdicionLibroCap}

                    //Campos del tipo de Obra de produccion bibliografica

                    nombreObra={nombreObra}
                    setNombreObra={setNombreObra}

                    disciplina={disciplina}
                    setDisciplina={setDisciplina}

                    disciplinaSelected={disciplinaSelected}
                    setDisciplinaSelected = {setDisciplinaSelected}

                    tituloObraproducto={tituloObraproducto}
                    setTituloObraproducto={setTituloObraproducto}

                    tecnica={tecnica}
                    setTecnica={setTecnica}

                    nombreespacio={nombreespacio}
                    setNombreEspacio={setNombreEspacio}

                    tipoespacio={tipoespacio}
                    setTipoEspacio={setTipoEspacio}

                    tipoespacioSelected= {tipoespacioSelected}
                    settipoespacioSelected={settipoespacioSelected}

                    fechapresentacion={fechapresentacion}
                    setFechaPresentacion={setFechaPresentacion}

                    aniocreacionespacio={aniocreacionespacio}
                    setAniocreacionEspacio={setAniocreacionEspacio}

                    distincion={distincion}
                    setDistincion={setDistincion}

                    distincionSelected={distincionSelected}
                    setdistincionSelected ={setdistincionSelected}

                    entidadconvocante={entidadconvocante}
                    setEntidadConvocante={setEntidadConvocante}
                    
                    tipoAmbitoSelected={tipoAmbitoSelected}
                    setTipoAmbitoSelected={setTipoAmbitoSelected}
                    
                    tiposAmbitos={tiposAmbitos}
                    setTiposAmbitos={setTiposAmbitos}
                   

                    mecanismoseleccion={mecanismoseleccion}
                    setMecanismoSeleccion={setMecanismoSeleccion}

                    mecanismoSelected={mecanismoSelected}
                    setmecanismoSelected={setmecanismoSelected}

                    acuerdoLicencia={acuerdoLicencia}
                    setAcuerdoLicencia={setAcuerdoLicencia}

                    institucionlicencia={institucionlicencia}
                    setInstitucionLicencia={setInstitucionLicencia}

                    fechaotrogamiento={fechaotrogamiento}
                    setFechaOtorgamiento={setFechaOtorgamiento}

                    numeroregistro={numeroregistro}
                    setNumeroRegistro={setNumeroRegistro}

                    contratocomercializacion={contratocomercializacion}
                    setContratoComercializacion={setContratoComercializacion}


                    //Campos del tipo Patente de producion bibliografica
                    tipoPatente={tipoPatente}
                    setTipoPatente={setTipoPatente}

                    viaSolicitud={viaSolicitud}
                    setviaSolicitud={setviaSolicitud}

                    anioObtencionPatente={anioObtencionPatente}
                    setAnioObtencionPatente={setAnioObtencionPatente}

                    numeroRegistroPatente={numeroRegistroPatente}
                    setNumeroRegistroPatente={setNumeroRegistroPatente}

                    tituloPatente={tituloPatente}
                    setTituloPatente={setTituloPatente}

                    numeroPatente={numeroPatente}
                    setNumeroPatente={setNumeroPatente}

                    nombreSolicitante={nombreSolicitante}
                    setnombreSolicitante={setnombreSolicitante}

                    paisObtencionPatente={paisObtencionPatente}
                    setPaisObtencionPatente={setPaisObtencionPatente}

                    gacetaIndustrialPatente={gacetaIndustrialPatente}
                    setGaceteIndustrialPatente={setGaceteIndustrialPatente}

                    institucionPatente={institucionPatente}
                    setInstitucionPatente={setInstitucionPatente}

                    tipoPatenteSelected={tipoPatenteSelected}
                    setTipoPatenteSelected={setTipoPatenteSelected}

                    viaSolicitudSelected ={viaSolicitudSelected}
                    setviaSolicitudSelected={setviaSolicitudSelected}

                    tipoPatenteOtro={tipoPatenteOtro}
                    setTipoPatenteOtro={setTipoPatenteOtro}

                    //Errores
                    getError={getError}
                    errores={errores}
                    setErrores={setErrores}

                    //rol y modalidad
                    rolActive={rolActive}
                    setRolActive={setRolActive}

                    modalidadParticipacionActive={modalidadParticipacionActive}
                    setModalidadParticipacionActive={setModalidadParticipacionActive}
                />
            )
          default:
            break;
        }
    }

    function handleBackToTipos(){
        //Reseteo Eventos
        setAnio(new Date())
        setFechaInicioEvento(new Date())
        setFechaFinEvento(new Date())
        setDepartamentos([])
        setDepartamento('')
        setCiudades([])
        setCiudad('')
        setNombreDelEvento('')
        setNombreDelAmbito('')
        setNombreModalidadPar('')

        //Reseteo Eventos
        setFechaInicio(new Date())
        setFechaFin(new Date())
        setNombreProyecto('')

        //Reseteo Prod. Bibliografica
        setNombreProductoBiblio('')
        setTipoProductoBiblio('')
        setAnioBiblio(new Date())
        setRevistaEditorialBiblio('')
        setCuartilBiblio('')
        setLugarPublicacionBiblio('')
        setMedioDivulgacionBiblio('')

        //Variables Prod. Tec y Tecno
        setNombreProductoTec('')
        setTipoProductoTec('')
        setNitTec('')
        setNumeroRegistroTec('')
        setNombreTitular('')
        setAnioTec(new Date())
        setPaisTec('')
        setSeleccion('tipo')

        setErrores([])
        setActiveStep(0);
    }

    const actionsBackButton = () => {
        if(seleccion == 'gestion'){
            setSeleccion('tipo')
            setDepartamentos([])
            setDepartamento('')
            setCiudades([])
            setCiudad('')
            setNombreDelEvento('')
            setNombreDelAmbito('')
            setNombreAmbitos([])
            setNombreModalidadPar('')
            setNombreModalidadPars([])
            setNombreProyecto('')
            setNombreprofesorProyecto('')
            setProfesorProyecto([])
            setAdj_evento('')
            setAdj_evento_final('')
        }else if(seleccion == 'bibliografica'){
            setCargandoProduBibliografico(true)
            setSeleccion('tipo')
        }else if(seleccion == 'gestionBibliografica'){
            setCargandoGestionBibliografica(true)
            setSeleccion('bibliografica')
        }else if(seleccion == 'tecnica'){
            setCargandoProduTec(true)
            setSeleccion('tipo')
         }else if(seleccion == 'proyectos'){
            setCargandoProduTec(true)
            setSeleccion('tipo')
        }else if(seleccion == 'gestionTecnica'){
            setCargandoProduTec(true)
            setInputs([])
            setSeleccion('tecnica')
        }else if(seleccion == 'gestionProyectos'){
            setCargandoProduTec(true)
            setInputs([])
            setSeleccion('proyectos')
        }else if(seleccion == 'social'){
            setCargandoProduTec(true)
            setSeleccion('tipo')
        }else if (seleccion == 'gestionSocial'){
            setCargandoProduTec(true)
            setInputs([])
            setSeleccion('social')
        }else if(seleccion == 'recursos'){
            setCargandoProduTec(true)
            setSeleccion('tipo')
        }else if (seleccion == 'gestionRecursos'){
            setCargandoProduTec(true)
            setInputs([])
            setSeleccion('recursos')
        }else if(seleccion == 'estrategias'){
            setCargandoProduTec(true)
            setSeleccion('tipo')
        }else if (seleccion == 'gestionEstrategias'){
            setCargandoProduTec(true)
            setInputs([])
            setSeleccion('estrategias')
        }
    }

    const botones = () => {

        if(seleccion == 'tipo'){
            return(
                <div></div>
            )
        }else if(seleccion == 'gestion'){
            return(
                <div>
                    <Button disabled={cargando == true || cargandoEvento == true} onClick={() => actionsBackButton()} >
                        Volver a Inicio
                    </Button>
                    <Button disabled={activeStep === 0 || cargando == true || cargandoEvento == true} onClick={handleBack} >
                        Atras
                    </Button>
                    {activeStep === steps.length - 1 ? <Button disabled={cargandoEvento == true} variant="contained" color="primary" style={{color: "#fff"}} onClick={handleSendToApi}>Enviar</Button> : <Button disabled={cargandoEvento == true} variant="contained" color="primary" style={{color: '#fff'}} onClick={handleNext}>Siguiente</Button>}
                </div>
            )
        }else if(seleccion == 'proyectos'){
             return(
                <div>
                    <Button onClick={() => actionsBackButton()} >
                        Volver a Inicio
                    </Button>
                </div>
            )
        }else if(seleccion == 'gestionProyectos'){
            return(
                <div>
                    <Button onClick={() => actionsBackButton()} >
                        Volver a Productos
                    </Button>
                    <Button disabled={activeStepBiblio === 0} onClick={handleBackTipoBiblio} >
                        Atras
                    </Button>
                    {activeStepBiblio === steps.length - 1 ? <Button variant="contained" color="primary" style={{color: "#fff"}} onClick={()=>{handleSendToApi()}}>Enviar</Button> : <Button variant="contained" color="primary" style={{color: '#fff'}} onClick={handleNext}>Siguiente</Button>}
                </div>
            )
        }
        else if(seleccion == 'bibliografica'){
            return(
                <div>
                    <Button onClick={() => actionsBackButton()} >
                        Volver a Inicio
                    </Button>
                </div>
            )
        }else if(seleccion == 'gestionBibliografica'){
            return(
                <div>
                    <Button onClick={() => actionsBackButton()} >
                        Volver a Productos
                    </Button>
                    <Button disabled={activeStepBiblio === 0} onClick={handleBackTipoBiblio} >
                        Atras
                    </Button>
                    {activeStepBiblio === steps.length - 1 ? <Button variant="contained" color="primary" style={{color: "#fff"}} onClick={async () => {if (tipoProduccionBiblio.codigo === "Inves_tipo_obra") {const isValid = await handleNext(); if (isValid) {handleSendToApi(); }} else {handleSendToApi(); }}}>Enviar</Button> : <Button variant="contained" color="primary" style={{color: '#fff'}} onClick={handleNext}>Siguiente</Button>}
                </div>
            )
        }else if(seleccion == 'tecnica'){
            return(
                <div>
                    <Button onClick={() => actionsBackButton()} >
                        Volver a Inicio
                    </Button>
                </div>
            )
        }else if(seleccion == 'gestionTecnica'){
            return(
                <div>
                    <Button onClick={() => actionsBackButton()} >
                        Volver a Productos
                    </Button>
                    <Button disabled={activeStepBiblio === 0} onClick={handleBackTipoBiblio} >
                        Atras
                    </Button>
                    {activeStepBiblio === steps.length - 1 ? <Button variant="contained" color="primary" style={{color: "#fff"}} onClick={()=>{handleSendToApi()}}>Enviar</Button> : <Button variant="contained" color="primary" style={{color: '#fff'}} onClick={handleNext}>Siguiente</Button>}
                </div>
            )
        }else if(seleccion == 'social'){
            return(
                <div>
                    <Button onClick={() => actionsBackButton()} >
                        Volver a Inicio
                    </Button>
                </div>
            )
        }else if(seleccion == 'gestionSocial'){
            return(
                <div>
                    <Button onClick={() => actionsBackButton()} >
                        Volver a Productos
                    </Button>
                    <Button disabled={activeStepBiblio === 0} onClick={handleBackTipoBiblio} >
                        Atras
                    </Button>
                    {activeStepBiblio === steps.length - 1 ? <Button variant="contained" color="primary" style={{color: "#fff"}} onClick={()=>{handleSendToApi()}}>Enviar</Button> : <Button variant="contained" color="primary" style={{color: '#fff'}} onClick={handleNext}>Siguiente</Button>}
                </div>
            )
        }else if(seleccion == 'recursos'){
            return(
                <div>
                    <Button onClick={() => actionsBackButton()} >
                        Volver a Inicio
                    </Button>
                </div>
            )
        }else if(seleccion == 'gestionRecursos'){
            return(
                <div>
                    <Button onClick={() => actionsBackButton()} >
                        Volver a Productos
                    </Button>
                    <Button disabled={activeStepBiblio === 0} onClick={handleBackTipoBiblio} >
                        Atras
                    </Button>
                    {activeStepBiblio === steps.length - 1 ? <Button variant="contained" color="primary" style={{color: "#fff"}} onClick={()=>{handleSendToApi()}}>Enviar</Button> : <Button variant="contained" color="primary" style={{color: '#fff'}} onClick={handleNext}>Siguiente</Button>}
                </div>
            )
        }else if(seleccion == 'estrategias'){
            return(
                <div>
                    <Button onClick={() => actionsBackButton()} >
                        Volver a Inicio
                    </Button>
                </div>
            )
        }else if(seleccion == 'gestionEstrategias'){
            return(
                <div>
                    <Button onClick={() => actionsBackButton()} >
                        Volver a Productos
                    </Button>
                    <Button disabled={activeStepBiblio === 0} onClick={handleBackTipoBiblio} >
                        Atras
                    </Button>
                    {activeStepBiblio === steps.length - 1 ? <Button variant="contained" color="primary" style={{color: "#fff"}} onClick={()=>{handleSendToApi()}}>Enviar</Button> : <Button variant="contained" color="primary" style={{color: '#fff'}} onClick={handleNext}>Siguiente</Button>}
                </div>
            )
        }
        else{
            return(
                <div>
                </div>
            )
        }

    }

    const titulos = () =>{
        if(seleccion == "bibliografica" || seleccion == "tecnica"|| seleccion == "proyectos" || seleccion == "social" || seleccion == "recursos" || seleccion == "estrategias"){
            return 'Elija el Tipo de Producto'
        }else if(seleccion == "tipo" || seleccion == "gestion"){
            return 'Elija lo que desea realizar'
        }else if(seleccion == "gestionBibliografica" || seleccion == "gestionTecnica"|| seleccion == "gestionProyectos" || seleccion == "gestionSocial" || seleccion == "gestionRecursos" || seleccion == "gestionEstrategias"){
            return 'Diligencie el Formulario'
        }
    }

    return (
        <div >

            <Dialog TransitionComponent={Slide} open={props.openModalGestion} onClose={()=>{handleOnClose()}} aria-labelledby="form-dialog-title"  maxWidth="lg">

                <AppBarModal
                titulo={ titulos() }
                mostrarModal={()=>{handleOnClose()}}
                titulo_accion="" 
                accion="" />
                {/* Contenido del modal del formulario de */}
                <DialogContent className={classes.modalMinWith}>
                    {cargandoEvento == true ? <TareasTerminadas imagen={emma_s} mensaje={'Cargando..'} widthImg='7%' marginTop='7%' /> : vista()}
                </DialogContent>

                <DialogActions>
                    {/* className={classes.backButton}*/}
                    <div>
                        {botones()}
                    </div>

                </DialogActions>

            </Dialog>
        </div>
    )
}

//Este se ejecuta cuando setSeleccion es igual a tecnica
const ModalProduccionTecnica = (props) => {
    const isInitialMount = React.useRef(true);
    const [tiposProductos, setTiposProductos] = React.useState([]);
    const classes = useStyles()
    React.useEffect( () => {
        //Obtengo los prceosos activos de la persona activa.
        if(isInitialMount.current){
            isInitialMount.current = false
            const obtenerProcesos = async () => {
                obtenerTiposDeProductos()

            }
            obtenerProcesos()
        }
    })

    const obtenerTiposDeProductos = async () => {
        try{
            let data = await Funciones.obtenerValores(Helper.TIPOS_DE_PROD_TEC_INVES)

            setTiposProductos(data)
            props.setCargandoProduTec(false)
        }catch(err){
          console.log(err)
        }
    }
    // PRODUCTOS tecnologicos e innovacion
    return(
        props.cargandoProduTec == true ? <div> <TareasTerminadas imagen={emma_w} mensaje={'Cargando..'} widthImg='7%' marginTop='7%' /> <LinearProgress /></div> :

        <Grid container direction={'row'} justify={'center'}>
            {tiposProductos.map((item, index) => {
                return(
                <Grid key={index} item xs={12} sm={6} md={4} lg={4}style={{ padding: '2% 2% 0% 2%', maxWidth: '20%' }}  onClick={() => { props.handleClickChangeToFormTec(item) }}>
                    <Paper className={classes.color} elevation={8} square>
                        <Card className={classes.color} style={{ maxWidth: "100%", minHeight: '100px', cursor: 'pointer' }} elevation={1}>
                        <CardHeader
                            title={
                            <Typography
                            variant="body2"
                            align="center"
                            style={{fontWeight: "bold", minHeight: "60px", maxHeight: "60px",display: "flex",alignItems: "center",justifyContent: "center",textAlign: "center"}}>
                            {item.valorc}
                            </Typography>
                        }
                        />                   
                        <CardContent >
                            <Grid container direction={'row'} justify={'center'}>
                                <Grid item xs={12} sm={12} md={12} style={{ textAlign: 'center', height: "80px" }}>
                                    <img src={logoproductotecnologicos} style={{ width: '80px', maxWidth: '100px', minWidth: '80px', height: "80px" }} alt='Imagen Tipo' />
                                </Grid>
                            </Grid>
                        </CardContent>
                        </Card>
                    </Paper>
                </Grid>
                )
            })}
        </Grid>
    )

}

const ModalDivulgacionCientifica = (props) => {
   const isInitialMount = React.useRef(true);
    const [tiposProductos, setTiposProductos] = React.useState([]);
    const classes = useStyles()
    React.useEffect( () => {
        //Obtengo los prceosos activos de la persona activa.
        if(isInitialMount.current){
            isInitialMount.current = false
            const obtenerProcesos = async () => {
                obtenerTiposDeProductos()

            }
            obtenerProcesos()
        }
    })

    const obtenerTiposDeProductos = async () => {
        try{
            let data = await Funciones.obtenerValores(Helper.TIPOS_DE_PROD_DIVULGACION)

            setTiposProductos(data)
            props.setCargandoProduTec(false)
        }catch(err){
          console.log(err)
        }
    }

    // PRODUCTOS Divulgación
    return(
        props.cargandoProduTec == true ? <div> <TareasTerminadas imagen={emma_w} mensaje={'Cargando..'} widthImg='7%' marginTop='7%' /> <LinearProgress /></div> :

        <Grid container direction={'row'} justify={'center'}>
            {tiposProductos.map((item, index) => {
                return(
                <Grid key={index} item xs={12} sm={6} md={4} lg={4}style={{ padding: '2% 2% 0% 2%', maxWidth: '20%' }}  onClick={() => { props.handleClickChangeFormDivulgacion(item) }}>
                    <Paper className={classes.color} elevation={8} square>
                        <Card className={classes.color} style={{ maxWidth: "100%", minHeight: '100px', cursor: 'pointer' }} elevation={1}>
                        <CardHeader
                            title={
                            <Typography
                            variant="body2"
                            align="center"
                            style={{fontWeight: "bold", minHeight: "60px", maxHeight: "60px",display: "flex",alignItems: "center",justifyContent: "center",textAlign: "center"}}>
                            {item.valorc}
                            </Typography>
                        }
                        />                   
                        <CardContent >
                            <Grid container direction={'row'} justify={'center'}>
                                <Grid item xs={12} sm={12} md={12} style={{ textAlign: 'center', height: "80px" }}>
                                    <img src={logoproductosdivulgacion} style={{ width: '80px', maxWidth: '100px', minWidth: '80px', height: "80px" }} alt='Imagen Tipo' />
                                </Grid>
                            </Grid>
                        </CardContent>
                        </Card>
                    </Paper>
                </Grid>
                )
            })}
        </Grid>
    )

}
const ModalrecursoHumanoCTeI = (props) => {
   const isInitialMount = React.useRef(true);
    const [tiposProductos, setTiposProductos] = React.useState([]);
    const classes = useStyles()
    React.useEffect( () => {
        //Obtengo los prceosos activos de la persona activa.
        if(isInitialMount.current){
            isInitialMount.current = false
            const obtenerProcesos = async () => {
                obtenerTiposDeProductos()
            }
            obtenerProcesos()
        }
    })
    const obtenerTiposDeProductos = async () => {
        try{
            let data = await Funciones.obtenerValores(Helper.TIPOS_DE_PROD_RECURSO)

            setTiposProductos(data)
            props.setCargandoProduTec(false)
        }catch(err){
          console.log(err)
        }
    }

    // PRODUCTOS Recurso Humano
    return(
        props.cargandoProduTec == true ? <div> <TareasTerminadas imagen={emma_w} mensaje={'Cargando..'} widthImg='7%' marginTop='7%' /> <LinearProgress /></div> :

        <Grid container direction={'row'} justify={'center'} alignItems={"stretch"}>
            {tiposProductos.map((item, index) => {
                return(
                <Grid key={index} item xs={12} sm={6} md={4} lg={6} style={{ padding: '2% 2% 0% 2%' }}onClick={() => { props.handleClickChangeFormRecursos(item) }}>
                    <Paper className={classes.color} elevation={8} square>
                        <Card className={classes.color} style={{ maxWidth: "100%", minHeight: "100px", cursor: "pointer", display: "flex", flexDirection: "column", justifyContent: "space-between", height: "100%", }} elevation={1}>
                        <CardHeader
                            title={
                            <Typography
                            variant="body2"
                            align="center"
                            style={{fontWeight: "bold", minHeight: "60px", whiteSpace: "normal", wordWrap: "break-word", display: "flex",alignItems: "center",justifyContent: "center",textAlign: "center"}}>
                            {item.valorc}
                            </Typography>
                        }
                        />                   
                        <CardContent >
                            <Grid container direction={'row'} justify={'center'}>
                                <Grid item xs={12} sm={12} md={12} style={{ textAlign: 'center', height: "80px" }}>
                                    <img src={logorecurso} style={{ width: '100px', maxWidth: '100px', minWidth: '80px', height: "80px" }} alt='Imagen Tipo' />
                                </Grid>
                            </Grid>
                        </CardContent>
                        </Card>
                    </Paper>
                </Grid>
                )
            })}
        </Grid>
    )
}
const ModalEstrategias = (props) => {
   const isInitialMount = React.useRef(true);
    const [tiposProductos, setTiposProductos] = React.useState([]);
    const classes = useStyles()
    React.useEffect( () => {
        //Obtengo los prceosos activos de la persona activa.
        if(isInitialMount.current){
            isInitialMount.current = false
            const obtenerProcesos = async () => {
                obtenerTiposDeProductos()
            }
            obtenerProcesos()
        }
    })
    const obtenerTiposDeProductos = async () => {
        try{
            let data = await Funciones.obtenerValores(Helper.TIPOS_DE_PROD_ESTRATEGIAS)

            setTiposProductos(data)
            props.setCargandoProduTec(false)
        }catch(err){
          console.log(err)
        }
    }

    // PRODUCTOS ESTRATEGIAS CUC
    return(
        props.cargandoProduTec == true ? <div> <TareasTerminadas imagen={emma_w} mensaje={'Cargando..'} widthImg='7%' marginTop='7%' /> <LinearProgress /></div> :

        <Grid container direction={'row'} justify={'center'} alignItems={"stretch"}>
            {tiposProductos.map((item, index) => {
                return(
                <Grid key={index} item xs={12} sm={6} md={4} lg={2} style={{ padding: '2% 2% 0% 2%' }}onClick={() => { props.handleClickChangeFormEstrategias(item) }}>
                    <Paper className={classes.color} elevation={8} square>
                        <Card className={classes.color} style={{ maxWidth: "100%", minHeight: "100px", cursor: "pointer", display: "flex", flexDirection: "column", justifyContent: "space-between", height: "100%", }} elevation={1}>
                        <CardHeader
                            title={
                            <Typography
                            variant="body2"
                            align="center"
                            style={{fontWeight: "bold", minHeight: "60px", display: "flex",alignItems: "center",justifyContent: "center",textAlign: "center"}}>
                            {item.valorc}
                            </Typography>
                        }
                        />                   
                        <CardContent >
                            <Grid container direction={'row'} justify={'center'}>
                                <Grid item xs={12} sm={12} md={12} style={{ textAlign: 'center', height: "80px" }}>
                                    <img src={logoestrategias} style={{ width: '100px', maxWidth: '100px', minWidth: '80px', height: "80px" }} alt='Imagen Tipo' />
                                </Grid>
                            </Grid>
                        </CardContent>
                        </Card>
                    </Paper>
                </Grid>
                )
            })}
        </Grid>
    )
}
const ModalApropiacionSocialConocimiento = (props) => {
   const isInitialMount = React.useRef(true);
    const [tiposProductos, setTiposProductos] = React.useState([]);
    const classes = useStyles()
    React.useEffect( () => {
        //Obtengo los prceosos activos de la persona activa.
        if(isInitialMount.current){
            isInitialMount.current = false
            const obtenerProcesos = async () => {
                obtenerTiposDeProductos()

            }
            obtenerProcesos()
        }
    })

    const obtenerTiposDeProductos = async () => {
        try{
            let data = await Funciones.obtenerValores(Helper.TIPOS_DE_PROD_SOCIAL_CONOCIMIENTO)

            setTiposProductos(data)
            props.setCargandoProduTec(false)
        }catch(err){
          console.log(err)
        }
    }

    // PRODUCTOS Social Conocimientos
    return(
        props.cargandoProduTec == true ? <div> <TareasTerminadas imagen={emma_w} mensaje={'Cargando..'} widthImg='7%' marginTop='7%' /> <LinearProgress /></div> :

        <Grid container direction={'row'} justify={'center'} alignItems={"stretch"}>
            {tiposProductos.map((item, index) => {
                return(
                <Grid key={index} item xs={12} sm={6} md={4} lg={3} style={{ padding: '2% 2% 0% 2%' }}onClick={() => { props.handleClickChangeFormSocial(item) }}>
                    <Paper className={classes.color} elevation={8} square>
                        <Card className={classes.color} style={{ maxWidth: "100%", minHeight: "250px", cursor: "pointer", display: "flex", flexDirection: "column", justifyContent: "space-between" }} elevation={1}>
                        <CardHeader
                            title={
                            <Typography
                            variant="body2"
                            align="center"
                            style={{fontWeight: "bold", minHeight: "60px", whiteSpace: "normal", wordWrap: "break-word", display: "flex",alignItems: "center",justifyContent: "center",textAlign: "center"}}>
                            {item.valorc}
                            </Typography>
                        }
                        />                   
                        <CardContent >
                            <Grid container direction={'row'} justify={'center'}>
                                <Grid item xs={12} sm={12} md={12} style={{ textAlign: 'center', height: "80px" }}>
                                    <img src={logoapropiacion} style={{ width: '100px', maxWidth: '100px', minWidth: '80px', height: "80px" }} alt='Imagen Tipo' />
                                </Grid>
                            </Grid>
                        </CardContent>
                        </Card>
                    </Paper>
                </Grid>
                )
            })}
        </Grid>
    )

}

//Aqui estan los formularios de la parte de tipos de produccion 
const ModalProduccionTecnicaForms = (props) =>{

    const classes = useStyles()
    const isInitialMount = React.useRef(true);
    const [tipoDeProductoTec, setTipoProductoTec] = React.useState([]);
    React.useEffect( () => {
        //Obtengo los prceosos activos de la persona activa.
        if(isInitialMount.current){
            isInitialMount.current = false
            const obtenerProcesos = async () => {
                obtenerPRODUCTO()
                obtenerTiposRoles()
                obtenerPaises()
                obtenerciudades()
            }
            obtenerProcesos()
        }
    })

    const obtenerTiposRoles = async () =>{
        let permisos = await Funciones.obtenerValores(Helper.TIPO_ROL_INVESTIGACION)

        props.setTiposRoles(permisos)
    }

    const obtenerPaises= async () => {
        try{
            let data = await Funciones.obtenerValores(Helper.PAISES)
            props.setPaisesTecTecno(data)
            props.setCargandoProduTec(false)
        }catch(err){
          console.log(err)
        }
    }
    const obtenerciudades= async () => {
        try{
            let data = await Funciones.obtenerValores(Helper.CIUDADES)
            props.setCiudadesTecTecno(data)
            props.setCargandoProduTec(false)
        }catch(err){
          console.log(err)
        }
    }

    const obtenerPRODUCTO = async () =>{
        let permisos = await obtenerPermisosValor(props.tipoProduccionTecnica.id);
        permisos = permisos.map(({ secundario }) => ({
            value: secundario.id,
            label: secundario.nombre,
            codigo: secundario.codigo
        }));
        setTipoProductoTec(permisos)

    }

    return (
        <div className={classes.root}>
          <Stepper activeStep={props.hola} alternativeLabel>
            {props.steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
          <div>
          {/* Aqui es cuando el Stepper llega al final.*/}
            {props.hola === props.steps.length ? (
              <div>
                <Typography className={classes.instructions}>{props.hola}</Typography>
                <Button onClick={props.handleReset}>Reset</Button>
              </div>
            ) : (
              <div>
                <GetStepContentTec
                    //Control del Stepper
                    stepIndex = {props.hola}
                    activeStepBiblio={props.activeStepBiblio}
                    //Tipo de Solicitud Actual
                    tipoSolicitudActual={props.tipoSolicitudActual}
                    setTipoSolicitudActual={props.setTipoSolicitudActual}

                    cargando={props.cargandoProduTec}
                    setCargando={props.setCargandoProduTec}

                    tipoDeProductoTec={tipoDeProductoTec}
                    setTipoProductoTec={setTipoProductoTec}

                    tipoProductoTecSelected={props.tipoProductoTecSelected}
                    setTipoProductoTecSelected={props.setTipoProductoTecSelected}

                    inputs={props.inputs}
                    setInputs={props.setInputs}

                    //Tipo de Solicitud Actual
                    // tipoSolicitudActual={props.tipoSolicitudActual}
                    // setTipoSolicitudActual={props.setTipoSolicitudActual}
                    //Variables Autores y particiapntes
                    numeroIdParEvent={props.numeroIdParEvent}
                    setNumeroIdParEvent={props.setNumeroIdParEvent}
                    arrai={props.arrai}
                    setArrai={props.setArrai}

                    //Permisos de la solicitud
                    permisosDeLaSolicitud={props.permisosDeLaSolicitud}
                    setPermisosDeLaSolicitud={props.setPermisosDeLaSolicitud}

                    //fechas para los formularios
                    fechaCreacionDiseñoIndus={props.fechaCreacionDiseñoIndus}
                    setFechaCreacionDiseñoIndus={props.setFechaCreacionDiseñoIndus}

                    fechaDesarrolloSoftware={props.fechaDesarrolloSoftware}
                    setFechaDesarrolloSoftware={props.setFechaDesarrolloSoftware}

                    fechaObtencionRegistroSoftware={props.fechaObtencionRegistroSoftware}
                    setFechaObtencionRegistroSoftware={props.setFechaObtencionRegistroSoftware}

                    fechaCreacionPrototipo={props.fechaCreacionPrototipo}
                    setFechaCreacionPrototipo={props.setFechaCreacionPrototipo}

                    fechaCreacionSignoDistintivo={props.fechaCreacionSignoDistintivo}
                    setFechaCreacionSignoDistintivo={props.setFechaCreacionSignoDistintivo}

                    fechaRegistroBaseTecno={props.fechaRegistroBaseTecno}
                    setFechaRegistroBaseTecno={props.setFechaRegistroBaseTecno}

                    fechaInnovacionProceServi={props.fechaInnovacionProceServi}
                    setFechaInnovacionProceServi={props.setFechaInnovacionProceServi}

                    fechaInnovacionGestionEmp={props.fechaInnovacionGestionEmp}
                    setFechaInnovacionGestionEmp={props.setFechaInnovacionGestionEmp}

                    fechaPresentacionObraProducto={props.fechaPresentacionObraProducto}
                    setFechaPresentacionObraProducto={props.setFechaPresentacionObraProducto}

                    fechaCreacionObraProducto={props.fechaCreacionObraProducto}
                    setFechaCreacionObraProducto={props.setFechaCreacionObraProducto}

                    fechaInicioEventoArtistico={props.fechaInicioEventoArtistico}
                    setFechaInicioEventoArtistico={props.setFechaInicioEventoArtistico}

                    fechaFinalEventoArtistico={props.fechaFinalEventoArtistico}
                    setFechaFinalEventoArtistico={props.setFechaFinalEventoArtistico}

                    fechaInicioTalleresCreacion={props.fechaInicioTalleresCreacion}
                    setFechaInicioTalleresCreacion={props.setFechaInicioTalleresCreacion}

                    fechaFinalTalleresCreacion={props.fechaFinalTalleresCreacion}
                    setFechaFinalTalleresCreacion={props.setFechaFinalTalleresCreacion}

                    productoTieneSelected={props.productoTieneSelected}
                    setProductoTieneSelected={props.setProductoTieneSelected}

                    inputsSelects={props.inputsSelects}
                    setInputsSelects={props.setInputsSelects}

                    fechaRegistroDiseñoPrototipoTiene={props.fechaRegistroDiseñoPrototipoTiene}
                    setFechaRegistroDiseñoPrototipoTiene={props.setFechaRegistroDiseñoPrototipoTiene}

                    tipoPrototipoSelected={props.tipoPrototipoSelected}
                    setTipoPrototipoSelected={props.setTipoPrototipoSelected}

                    otroTipoPrototipoSelected={props.otroTipoPrototipoSelected}
                    setOtroTipoPrototipoSelected={props.setOtroTipoPrototipoSelected}

                    tipoSoftwareSelected={props.tipoSoftwareSelected}
                    setTipoSoftwareSelected={props.setTipoSoftwareSelected}

                    otroTipoSoftwareSelected={props.otroTipoSoftwareSelected}
                    setOtroTipoSoftwareSelected={props.setOtroTipoSoftwareSelected}

                    tipoSignoDistintivoSelected={props.tipoSignoDistintivoSelected}
                    setTipoSignoDistintivoSelected={props.setTipoSignoDistintivoSelected}

                    tipoEmpresaSelected={props.tipoEmpresaSelected}
                    setTipoEmpresaSelected={props.setTipoEmpresaSelected}

                    tipoProgramaSelected={props.tipoProgramaSelected}
                    setTipoProgramaSelected={props.setTipoProgramaSelected}

                    tipoDepartamentoSelected={props.tipoDepartamentoSelected}
                    setTipoDepartamentoSelected={props.setTipoDepartamentoSelected}

                    tipoInnovacionSelected={props.tipoInnovacionSelected}
                    setTipoInnovacionSelected={props.setTipoInnovacionSelected}

                    tipoEspacioEventoSelected={props.tipoEspacioEventoSelected}
                    setTipoEspacioEventoSelected={props.setTipoEspacioEventoSelected}

                    tipoDisciplinaAmbitoSelected={props.tipoDisciplinaAmbitoSelected}
                    setTipoDisciplinaAmbitoSelected={props.setTipoDisciplinaAmbitoSelected}

                    tipoAmbitoSelected={props.tipoAmbitoSelected}
                    setTipoAmbitoSelected={props.setTipoAmbitoSelected}

                    tipoRolSelected={props.tipoRolSelected}
                    setTipoRolSelected={props.setTipoRolSelected}

                    tipoEventoSelected={props.tipoEventoSelected}
                    setTipoEventoSelected={props.setTipoEventoSelected}


                    productoTiene={props.productoTiene}
                    setProductoTiene={props.setProductoTiene}

                    tiposDePrototipos={props.tiposDePrototipos}
                    setTiposDePrototipos={props.setTiposDePrototipos}

                    tiposDeSoftware={props.tiposDeSoftware}
                    setTiposDeSoftware={props.setTiposDeSoftware}

                    tiposSignoDistintivos={props.tiposSignoDistintivos}
                    setTiposSignoDistintivos={props.setTiposSignoDistintivos}

                    tiposEmpresas={props.tiposEmpresas}
                    setTiposEmpresas={props.setTiposEmpresas}

                    tiposProgramas={props.tiposProgramas}
                    setTiposProgramas={props.setTiposProgramas}

                    tiposDepartamentos={props.tiposDepartamentos}
                    setTiposDepartamentos={props.setTiposDepartamentos}

                    tiposInnovaciones={props.tiposInnovaciones}
                    setTiposInnovaciones={props.setTiposInnovaciones}

                    tiposEspacioEvento={props.tiposEspacioEvento}
                    setTiposEspacioEvento={props.setTiposEspacioEvento}

                    tiposDisciplinaAmbito={props.tiposDisciplinaAmbito}
                    setTiposDisciplinaAmbito={props.setTiposDisciplinaAmbito}

                    tiposAmbitos={props.tiposAmbitos}
                    setTiposAmbitos={props.setTiposAmbitos}

                    tiposRoles={props.tiposRoles}
                    setTiposRoles={props.setTiposRoles}

                    tiposEventos={props.tiposEventos}
                    setTiposEventos={props.setTiposEventos}

                    paisesTecTecno={props.paisesTecTecno}
                    setPaisesTecTecno={props.setPaisesTecTecno}

                    paisSelectedTecTecno={props.paisSelectedTecTecno}
                    setPaisSelectedTecTecno={props.setPaisSelectedTecTecno}
                    ciudadesTecTecno={props.ciudadesTecTecno}
                    setCiudadesTecTecno={props.setCiudadesTecTecno}
                    ciudadesSelectedTecTecno={props.ciudadesSelectedTecTecno}
                    setCiudadesSelectedTecTecno={props.setCiudadesSelectedTecTecno}

                    disponibilidadesTecTecno={props.disponibilidadesTecTecno}
                    setDisponibilidadesTecTecno={props.setDisponibilidadesTecTecno}
                    disponibilidadSelectedTecTecno={props.disponibilidadSelectedTecTecno}
                    setDisponibilidadSelectedTecTecno={props.setDisponibilidadSelectedTecTecno}

                    idiomaTecTecno={props.idiomaTecTecno}
                    setIdiomaTecTecno={props.setIdiomaTecTecno}
                    idiomaSelectedTecTecno={props.idiomaSelectedTecTecno}
                    setIdiomaSelectedTecTecno={props.setIdiomaSelectedTecTecno}

                    acuerdoLicencia={props.acuerdoLicencia}
                    setAcuerdoLicencia={props.setAcuerdoLicencia}

                    adj_certificado2={props.adj_certificado2}
                    setAdj_certificado2={props.setAdj_certificado2}

                    adj_certificado_final2={props.adj_certificado_final2}
                    setAdj_certificado_final2={props.setAdj_certificado_final2}

                    adj_certificado3={props.adj_certificado3}
                    setAdj_certificado3={props.setAdj_certificado3}

                    adj_certificado_final3={props.adj_certificado_final3}
                    setAdj_certificado_final3={props.setAdj_certificado_final3}

                    adj_certificado4={props.adj_certificado4}
                    setAdj_certificado4={props.setAdj_certificado4}

                    adj_certificado_final4={props.adj_certificado_final4}
                    setAdj_certificado_final4={props.setAdj_certificado_final4}

                    adj_certificado5={props.adj_certificado5}
                    setAdj_certificado5={props.setAdj_certificado5}

                    adj_certificado_final5={props.adj_certificado_final5}
                    setAdj_certificado_final5={props.setAdj_certificado_final5}
                    //Errores
                     getError={props.getError}
                     errores={props.errores}
                     setErrores={props.setErrores}

                      //rol y modalidad
                    rolActive={props.rolActive}
                    setRolActive={props.setRolActive}

                    modalidadParticipacionActive={props.modalidadParticipacionActive}
                    setModalidadParticipacionActive={props.setModalidadParticipacionActive}

                    fechaRegistroEmpresaCultural={props.fechaRegistroEmpresaCultural}
                    setFechaRegistroEmpresaCultural={props.setFechaRegistroEmpresaCultural}

                    otroTipoEspacioEvento={props.otroTipoEspacioEvento}
                    setOtroTipoEspacioEvento={props.setOtroTipoEspacioEvento}
                />
              </div>
            )}
          </div>
        </div>
    )
}
const ModalProduccionEstrategiaForms = (props) =>{

    const classes = useStyles()
    const isInitialMount = React.useRef(true);
    const [tipoDeProductoTec, setTipoProductoTec] = React.useState([]);
    React.useEffect( () => {
        //Obtengo los prceosos activos de la persona activa.
        if(isInitialMount.current){
            isInitialMount.current = false
            const obtenerProcesos = async () => {
                obtenerPRODUCTO()            }
            obtenerProcesos()
        }
    })

    const obtenerPRODUCTO = async () =>{
        let permisos = await obtenerPermisosValor(props.tipoProduccionEstrategias.id);
        permisos = permisos.map(({ secundario }) => ({
            value: secundario.id,
            label: secundario.nombre,
            codigo: secundario.codigo
        }));
        setTipoProductoTec(permisos)

    }

    return (
        <div className={classes.root}>
          <Stepper activeStep={props.hola} alternativeLabel>
            {props.steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
          <div>
          {/* Aqui es cuando el Stepper llega al final.*/}
            {props.hola === props.steps.length ? (
              <div>
                <Typography className={classes.instructions}>{props.hola}</Typography>
                <Button onClick={props.handleReset}>Reset</Button>
              </div>
            ) : (
              <div>
                <GetStepContentEst
                    //Control del Stepper
                    stepIndex = {props.hola}
                    activeStepBiblio={props.activeStepBiblio}
                    //Tipo de Solicitud Actual
                    tipoSolicitudActual={props.tipoSolicitudActual}
                    setTipoSolicitudActual={props.setTipoSolicitudActual}

                    cargando={props.cargandoProduTec}
                    setCargando={props.setCargandoProduTec}

                    tipoDeProductoTec={tipoDeProductoTec}
                    setTipoProductoTec={setTipoProductoTec}

                    tipoProductoEstSelected={props.tipoProductoEstSelected}
                    setTipoProductoEstSelected={props.setTipoProductoEstSelected}

                    inputs={props.inputs}
                    setInputs={props.setInputs}

                    numeroIdParEvent={props.numeroIdParEvent}
                    setNumeroIdParEvent={props.setNumeroIdParEvent}
                    arrai={props.arrai}
                    setArrai={props.setArrai}

                    //Permisos de la solicitud
                    permisosDeLaSolicitud={props.permisosDeLaSolicitud}
                    setPermisosDeLaSolicitud={props.setPermisosDeLaSolicitud}

                     getError={props.getError}
                     errores={props.errores}
                     setErrores={props.setErrores}

                      //rol y modalidad
                    rolActive={props.rolActive}
                    setRolActive={props.setRolActive}

                    modalidadParticipacionActive={props.modalidadParticipacionActive}
                    setModalidadParticipacionActive={props.setModalidadParticipacionActive}

                    fechaRegistroEmpresaCultural={props.fechaRegistroEmpresaCultural}
                    setFechaRegistroEmpresaCultural={props.setFechaRegistroEmpresaCultural}

                    otroTipoEspacioEvento={props.otroTipoEspacioEvento}
                    setOtroTipoEspacioEvento={props.setOtroTipoEspacioEvento}

                    //formularios

                    tipoProyecto={props.tipoProyecto}
                    setTipoProyecto={props.setTipoProyecto}
                    setTipoProyectoSelected={props.setTipoProyectoSelected}
                    tipoProyectoSelected={props.tipoProyectoSelected}

                    acuerdoLicencia={props.acuerdoLicencia}
                    setAcuerdoLicencia={props.setAcuerdoLicencia}

                    indiquecual={props.indiquecual}
                    setIndiquecual={props.setIndiquecual}

                    tipoProgramaSelected={props.tipoProgramaSelected}
                    setTipoProgramaSelected={props.setTipoProgramaSelected}
                    tiposProgramas={props.tiposProgramas}
                    setTiposProgramas={props.setTiposProgramas}
                    tipoDepartamentoSelected={props.tipoDepartamentoSelected}
                    setTipoDepartamentoSelected={props.setTipoDepartamentoSelected}
                    tiposDepartamentos={props.tiposDepartamentos}
                    setTiposDepartamentos={props.setTiposDepartamentos}


                    fecha={props.fecha}
                    setFecha={props.setFecha}
                    fechaFinal={props.fechaFinal}
                    setFechaFinal={props.setFechaFinal}

                    tipoEmpresa={props.tipoEmpresa}
                    setTipoEmpresa={props.setTipoEmpresa}
                    tipoEmpresasoSelected={props.tipoEmpresasoSelected}
                    setTipoEmpresasoSelected={props.setTipoEmpresasoSelected}
                             
                    adj_certificado2={props.adj_certificado2}
                    setAdj_certificado2={props.setAdj_certificado2}
                    adj_certificado_final2={props.adj_certificado_final2}
                    setAdj_certificado_final2={props.setAdj_certificado_final2}

                    adj_certificado3={props.adj_certificado3}
                    setAdj_certificado3={props.setAdj_certificado3}
                    adj_certificado_final3={props.adj_certificado_final3}
                    setAdj_certificado_final3={props.setAdj_certificado_final3}


                    tiposRoles={props.tiposRoles}
                    setTiposRoles={props.setTiposRoles}
                />
              </div>
            )}
          </div>
        </div>
    )
}

const GetStepContentEst = (props) => {
    switch (props.stepIndex) {
        case 0:
            return (
                <ModalEstForm1

                    cargando={props.cargando}
                    setCargando={props.setCargando}

                    tipoDeProductoTec={props.tipoDeProductoTec}
                    setTipoProductoTec={props.setTipoProductoTec}

                    tipoProductoEstSelected={props.tipoProductoEstSelected}
                    setTipoProductoEstSelected={props.setTipoProductoEstSelected}

                    inputs={props.inputs}
                    setInputs={props.setInputs}


                    //fechas para los formularios

                    tipoProyecto={props.tipoProyecto}
                    setTipoProyecto={props.setTipoProyecto}
                    setTipoProyectoSelected={props.setTipoProyectoSelected}
                    tipoProyectoSelected={props.tipoProyectoSelected}

                    acuerdoLicencia={props.acuerdoLicencia}
                    setAcuerdoLicencia={props.setAcuerdoLicencia}

                    indiquecual={props.indiquecual}
                    setIndiquecual={props.setIndiquecual}
                    tipoProgramaSelected={props.tipoProgramaSelected}
                    setTipoProgramaSelected={props.setTipoProgramaSelected}
                    tiposProgramas={props.tiposProgramas}
                    setTiposProgramas={props.setTiposProgramas}
                    tipoDepartamentoSelected={props.tipoDepartamentoSelected}
                    setTipoDepartamentoSelected={props.setTipoDepartamentoSelected}
                    tiposDepartamentos={props.tiposDepartamentos}
                    setTiposDepartamentos={props.setTiposDepartamentos}

                    fecha={props.fecha}
                    setFecha={props.setFecha}
                    fechaFinal={props.fechaFinal}
                    setFechaFinal={props.setFechaFinal}

                    tipoEmpresa={props.tipoEmpresa}
                    setTipoEmpresa={props.setTipoEmpresa}
                    tipoEmpresasoSelected={props.tipoEmpresasoSelected}
                    setTipoEmpresasoSelected={props.setTipoEmpresasoSelected}

                    adj_certificado2={props.adj_certificado2}
                    setAdj_certificado2={props.setAdj_certificado2}

                    adj_certificado_final2={props.adj_certificado_final2}
                    setAdj_certificado_final2={props.setAdj_certificado_final2}

                    adj_certificado3={props.adj_certificado3}
                    setAdj_certificado3={props.setAdj_certificado3}

                    adj_certificado_final3={props.adj_certificado_final3}
                    setAdj_certificado_final3={props.setAdj_certificado_final3}

                    adj_certificado4={props.adj_certificado4}
                    setAdj_certificado4={props.setAdj_certificado4}

                    adj_certificado_final4={props.adj_certificado_final4}
                    setAdj_certificado_final4={props.setAdj_certificado_final4}

                    adj_certificado5={props.adj_certificado5}
                    setAdj_certificado5={props.setAdj_certificado5}

                    adj_certificado_final5={props.adj_certificado_final5}
                    setAdj_certificado_final5={props.setAdj_certificado_final5}
                    //Errores
                     getError={props.getError}
                     errores={props.errores}
                     setErrores={props.setErrores}

                    //rol y modalidad
                    rolActive={props.rolActive}
                    setRolActive={props.setRolActive}

                    fechaRegistroEmpresaCultural={props.fechaRegistroEmpresaCultural}
                    setFechaRegistroEmpresaCultural={props.setFechaRegistroEmpresaCultural}

                    otroTipoEspacioEvento={props.otroTipoEspacioEvento}
                    setOtroTipoEspacioEvento={props.setOtroTipoEspacioEvento}
                />
            )
        case 1:
            return (
                <ModalFormGestionAutores
                    tipoSolicitudActual={props.tipoSolicitudActual}
                    setTipoSolicitudActual={props.setTipoSolicitudActual}
                    //Variables Autores y Particiapntes
                    numeroIdParEvent={props.numeroIdParEvent}
                    setNumeroIdParEvent={props.setNumeroIdParEvent}
                    arrai={props.arrai}
                    setArrai={props.setArrai}

                    //Permisos de la solicitud
                    permisosDeLaSolicitud={props.permisosDeLaSolicitud}
                    setPermisosDeLaSolicitud={props.setPermisosDeLaSolicitud}

                    cargando={props.cargando}
                    setCargando={props.setCargando}

                    //rol y modalidad
                    rolActive={props.rolActive}
                    setRolActive={props.setRolActive}

                    modalidadParticipacionActive={props.modalidadParticipacionActive}
                    setModalidadParticipacionActive={props.setModalidadParticipacionActive}

                    tiposRoles={props.tiposRoles}
                    setTiposRoles={props.setTiposRoles}
                />
            )
    }
}
const ModalEstForm1 = (props) => {
    const classes = useStyles()
    const fileInput = React.createRef();
    React.useEffect(() => {
        if (props.tipoProductoEstSelected && props.tipoProductoEstSelected.codigo) {
            props.setCargando(true);
            obtenerPRODUCTO(props.tipoProductoEstSelected);
            
        }
    }, [props.tipoProductoEstSelected]);
    const handleOnchange = async (e) =>{

        if(e.target.name == "tipoProyectoSelected"){
            props.setTipoProyectoSelected(e.target.value)
            if(props.errores.length > 0){
                props.setErrores(props.errores.filter(er => er.llave != "tipoProyectoSelected"));
            }
         }else if (e.target.name == "acuerdoLicencia"){
            props.setAcuerdoLicencia(e.target.value)
            if (props.errores.length > 0){
                props.setErrores(props.errores.filter(er => er.llave != "acuerdoLicencia"));
            }
        }else if (e.target.name == "tipoProgramaSelected"){
            props.setTipoProgramaSelected(e.target.value) 
            if (props.errores.length > 0){
                props.setErrores(props.errores.filter(er => er.llave != "tipoProgramaSelected"));
            }
        }else if (e.target.name == "tipoDepartamentoSelected"){
            props.setTipoDepartamentoSelected(e.target.value) 
            if (props.errores.length > 0){
                props.setErrores(props.errores.filter(er => er.llave != "tipoDepartamentoSelected"));
            }
        }else if (e.target.name == "indiquecual"){
            props.setIndiquecual(e.target.value)
            if (props.errores.length > 0){
                props.setErrores(props.errores.filter(er => er.llave != "indiquecual"));
            }
        }else if(e.target.name == "tipoEmpresasoSelected"){
            props.setTipoEmpresasoSelected(e.target.value)
            if(props.errores.length > 0){
                props.setErrores(props.errores.filter(er => er.llave != "tipoEmpresasoSelected"));
            }
       
        }else if (e.target.name === "adj_certificado2") {
                const file = e.target.files[0];
                if (file) {
                    props.setAdj_certificado2(file.name);          
                    props.setAdj_certificado_final2(file);         
                }
                if (props.errores.length > 0) {
                    props.setErrores(props.errores.filter(er => er.llave !== "adj_certificado2"));
                }
        }  
                let array = props.inputs.map((item) => {
                if (item.codigo == e.target.name) {
                    if (props.errores.length > 0) {
                        props.setErrores(props.errores.filter(er => er.llave !== e.target.name));
                        }
                    return {
                        ...item,
                        value: e.target.value
                    }
                }
                return item
            })
            props.setInputs(array)

            if (Array.isArray(props.inputsSelects)) {
            let arraySelects = props.inputsSelects.map((item) => {
                if (item.codigo == e.target.name) {
                    if (props.errores.length > 0) {
                    props.setErrores(props.errores.filter(er => er.llave !== e.target.name));
                    }
                    return {
                        ...item,
                        value: e.target.value
                    }
                }
                return item
            })
            props.setInputsSelects(arraySelects)
        }
    }


    const obtenerPRODUCTO = async (producto) =>{
        let permisos = await obtenerPermisosValor(producto.id);
        permisos = permisos.map(({ secundario }) => {
            return {
                id: secundario.id,
                label: secundario.nombre,
                codigo: secundario.codigo,
                error: props.errores,
                value: ''
            }
        });

        if(producto.codigo == "proyectos_aula"  ){
            await obtenerTipoProyecto()
            await obtenerprogramas()
            await obtenerDepartamentos()
        }

        if (producto.codigo === "retos_cuc" || producto.codigo === "buenas_practicas") {
            await obtenerprogramas();
            await obtenerDepartamentos()
            await obtenerDepartamentos()


        }


        props.setInputs(permisos)
        props.setCargando(false)
    }

     const obtenerTipoProyecto = async () =>{
        let permisos = await Funciones.obtenerValores(Helper.TIPO_PROYECTO_ESTRAEGIAS)
        props.setTipoProyecto(permisos)
    }
    const obtenerDepartamentos = async () =>{
        let permisos = await Funciones.obtenerValores(Helper.DEPARTAMENTOSACADEMICOS) 
        props.setTiposDepartamentos(permisos)
    }
    const obtenerprogramas = async () =>{
        let permisos = await Funciones.obtenerValores(Helper.PROGRAMAS)
        props.setTiposProgramas(permisos)
    }

    
    
    
    
    return (
        props.cargando == true ? <div> <TareasTerminadas imagen={emma_w} mensaje={'Cargando..'} widthImg='7%' marginTop='7%' /> <LinearProgress /></div> :
        <div>
            <Grid container spacing={3}>
                 {props.inputs.map((input, index) => (
                    <Grid item xs={12} key={index}>
                    <TextField
                        fullWidth
                        label={input.label}
                        name={input.codigo}
                        value={input.value || ""}
                        onChange={handleOnchange}
                        error={props.getError(input.codigo, props.errores).length > 0}
                        helperText={props.getError(input.codigo, props.errores)}
                    />
                    </Grid>
                ))}
                
                 {(props.tipoProductoEstSelected.codigo === "proyectos_aula" ) && (
                    <React.Fragment>                  
                    <Grid item xs={12}>
                            <InputLabel htmlFor="age-native-simple">Producto del proyecto de aula: </InputLabel>
                            <FormControl 
                                className={classes.formControl} 
                                fullWidth 
                                error={props.getError('tipoProyectoSelected', props.errores).length > 0}
                            >
                                <Select
                                    value={props.tipoProyectoSelected}
                                    displayEmpty
                                    fullWidth
                                    inputProps={{ 'aria-label': 'Without label' }}
                                    onChange={handleOnchange}
                                    name="tipoProyectoSelected"
                                >
                                    <MenuItem value="">
                                        <em style={{color: "rgba(0, 0, 0, 0.54)"}}>
                                            {`${props.tipoProyecto.length} Tipo proyecto a Elegir a Elegir`}
                                        </em>
                                    </MenuItem>
                                    {props.tipoProyecto.map((item, index) => (
                                        <MenuItem key={index} value={item}>
                                            {`${item.nombre}`}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <FormHelperText>{props.getError('tipoProyectoSelected', props.errores)}</FormHelperText>
                        </Grid>
                     <Grid item xs={12}>
                        <InputLabel htmlFor="age-native-simple">    Nombre del Departamento: </InputLabel>
                        <FormControl 
                            className={classes.formControl} 
                            fullWidth 
                            error={props.getError('tipoDepartamentoSelected', props.errores).length > 0}
                        >
                            <Select
                            value={props.tipoDepartamentoSelected}
                            displayEmpty
                            fullWidth
                            inputProps={{ 'aria-label': 'Without label' }}
                            onChange={handleOnchange}
                            name="tipoDepartamentoSelected"
                            >
                            <MenuItem value="">
                                <em style={{color: "rgba(0, 0, 0, 0.54)"}}>
                                {`${props.tiposDepartamentos.length} Departamento a Elegir`}
                                </em>
                            </MenuItem>
                            {props.tiposDepartamentos.map((item, index) => (
                                <MenuItem key={index} value={item}>
                                {item.nombre}
                                </MenuItem>
                            ))}
                            </Select>
                        </FormControl>
                        <FormHelperText>{props.getError('tipoDepartamentoSelected', props.errores)}</FormHelperText>
                        </Grid>

                     <Grid item xs={12}>
                        <InputLabel htmlFor="age-native-simple">    Programa: </InputLabel>
                        <FormControl 
                            className={classes.formControl} 
                            fullWidth 
                            error={props.getError('tipoProgramaSelected', props.errores).length > 0}
                        >
                            <Select
                            value={props.tipoProgramaSelected}
                            displayEmpty
                            fullWidth
                            inputProps={{ 'aria-label': 'Without label' }}
                            onChange={handleOnchange}
                            name="tipoProgramaSelected"
                            >
                            <MenuItem value="">
                                <em style={{color: "rgba(0, 0, 0, 0.54)"}}>
                                {`${props.tiposProgramas.length} Programa a Elegir`}
                                </em>
                            </MenuItem>
                            {props.tiposProgramas.map((item, index) => (
                                <MenuItem key={index} value={item}>
                                {item.nombre}
                                </MenuItem>
                            ))}
                            </Select>
                        </FormControl>
                        <FormHelperText>{props.getError('tipoProgramaSelected', props.errores)}</FormHelperText>
                        </Grid>

                     <Grid item xs={12} className="oculto">
                            <TextField
                                ref={fileInput}
                                required
                                type="file"
                                id="adj_certificado2"
                                name="adj_certificado2"
                                label="Adjuntar Identificación"
                                fullWidth
                                autoComplete="billing address-line1"
                                onChange={handleOnchange}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <InputFile 
                                id="adj_certificado2"
                                label="Evidencia del producto generado en el marco del proyecto de aula"
                                name="adj_certificado2"
                                value={props.adj_certificado2} 
                                required={props.adj_certificado2} 
                                error={props.getError("adj_certificado2", props.errores) > 0}
                                helperText={props.getError("adj_certificado2", props.errores)}
                            />
                        </Grid>
                        
                        <Grid item xs={12}>
                        <FormControl 
                            fullWidth 
                            error={props.getError('acuerdoLicencia', props.errores).length > 0}>
                            <InputLabel id="acuerdo-licencia-label">Participó en un evento institucional con el proyecto de aula?:</InputLabel>
                            <Select
                            labelId="acuerdo-licencia-label"
                            id="acuerdoLicencia"
                            value={props.acuerdoLicencia}
                            onChange={handleOnchange}
                            name="acuerdoLicencia"
                            >
                            <MenuItem value="si">Sí</MenuItem>
                            <MenuItem value="no">No</MenuItem>
                            </Select>
                            <FormHelperText>
                            {props.getError('acuerdoLicencia', props.errores)}
                            </FormHelperText>
                        </FormControl>
                        </Grid>


                        {props.acuerdoLicencia === "si" && (
                        <Grid item xs={12}>
                            <TextField
                            fullWidth
                            label="Indique Cúal"
                            id="indiquecual"
                            error={props.getError('indiquecual', props.errores).length > 0}
                            helperText={props.getError('indiquecual', props.errores)}
                            value={props.numeroregistro}
                            onChange={handleOnchange}
                            name="indiquecual"
                            />
                        </Grid>
                        )}
                        <Grid item xs={12}>
                        <Paper elevation={3} style={{ color: "#757575",borderRadius: "12px",boxShadow: "0px 2px 5px rgba(0,0,0,0.15)",backgroundColor: "#FFF2F2",borderBottom: "4px solid var(--primary-color)",padding: "8px"}}>                        
                            <Button variant="text" size="small" color="inherit" >
                            <NotificationImportantIcon style={{ height: 10 }} /> Nota
                            </Button>
                            <Typography variant="caption" component="P" gutterBottom className={classes.color}>
                               Recuerde también cargar la información en la tipología de eventos científicos
                            </Typography>
                        </Paper>
                    </Grid>
                    </React.Fragment>
                    )}
                {(props.tipoProductoEstSelected.codigo === "retos_cuc") && (
                    <React.Fragment>                  
                         <Grid item xs={12}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <Fragment>
                                    <DatePicker
                                        views={["year", "month"]}
                                        label="Fecha de Certificación:"
                                        value={props.fecha}
                                        fullWidth
                                        onChange={props.setFecha}
                                        format="yyyy/MM"
                                    />
                                </Fragment>
                            </MuiPickersUtilsProvider>
                        </Grid>
                      <Grid item xs={12}>
                        <InputLabel htmlFor="age-native-simple">    Nombre del Departamento: </InputLabel>
                        <FormControl 
                            className={classes.formControl} 
                            fullWidth 
                            error={props.getError('tipoDepartamentoSelected', props.errores).length > 0}
                        >
                            <Select
                            value={props.tipoDepartamentoSelected}
                            displayEmpty
                            fullWidth
                            inputProps={{ 'aria-label': 'Without label' }}
                            onChange={handleOnchange}
                            name="tipoDepartamentoSelected"
                            >
                            <MenuItem value="">
                                <em style={{color: "rgba(0, 0, 0, 0.54)"}}>
                                {`${props.tiposDepartamentos.length} Departamento a Elegir`}
                                </em>
                            </MenuItem>
                            {props.tiposDepartamentos.map((item, index) => (
                                <MenuItem key={index} value={item}>
                                {item.nombre}
                                </MenuItem>
                            ))}
                            </Select>
                        </FormControl>
                        <FormHelperText>{props.getError('tipoDepartamentoSelected', props.errores)}</FormHelperText>
                        </Grid>
                     <Grid item xs={12}>
                        <InputLabel htmlFor="age-native-simple">    Programa: </InputLabel>
                        <FormControl 
                            className={classes.formControl} 
                            fullWidth 
                            error={props.getError('tipoProgramaSelected', props.errores).length > 0}
                        >
                            <Select
                            value={props.tipoProgramaSelected}
                            displayEmpty
                            fullWidth
                            inputProps={{ 'aria-label': 'Without label' }}
                            onChange={handleOnchange}
                            name="tipoProgramaSelected"
                            >
                            <MenuItem value="">
                                <em style={{color: "rgba(0, 0, 0, 0.54)"}}>
                                {`${props.tiposProgramas.length} Programa a Elegir`}
                                </em>
                            </MenuItem>
                            {props.tiposProgramas.map((item, index) => (
                                <MenuItem key={index} value={item}>
                                {item.nombre}
                                </MenuItem>
                            ))}
                            </Select>
                        </FormControl>
                        <FormHelperText>{props.getError('tipoProgramaSelected', props.errores)}</FormHelperText>
                        </Grid>
                  
                     <Grid item xs={12} className="oculto">
                            <TextField
                                ref={fileInput}
                                required
                                type="file"
                                id="adj_certificado2"
                                name="adj_certificado2"
                                label="Adjuntar Identificación"
                                fullWidth
                                autoComplete="billing address-line1"
                                onChange={handleOnchange}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <InputFile 
                                id="adj_certificado2"
                                label="Certificación emitida por la entidad beneficiaria de la participación del estudiante en el reto"
                                name="adj_certificado2"
                                value={props.adj_certificado2} 
                                required={props.adj_certificado2} 
                                error={props.getError("adj_certificado2", props.errores) > 0}
                                helperText={props.getError("adj_certificado2", props.errores)}
                            />
                        </Grid>
                    </React.Fragment>
                    )}
                {(props.tipoProductoEstSelected.codigo === "buenas_practicas") && (
                    <React.Fragment>
                     <Grid item xs={12}>
                        <InputLabel htmlFor="age-native-simple">    Nombre del Departamento: </InputLabel>
                        <FormControl 
                            className={classes.formControl} 
                            fullWidth 
                            error={props.getError('tipoDepartamentoSelected', props.errores).length > 0}
                        >
                            <Select
                            value={props.tipoDepartamentoSelected}
                            displayEmpty
                            fullWidth
                            inputProps={{ 'aria-label': 'Without label' }}
                            onChange={handleOnchange}
                            name="tipoDepartamentoSelected"
                            >
                            <MenuItem value="">
                                <em style={{color: "rgba(0, 0, 0, 0.54)"}}>
                                {`${props.tiposDepartamentos.length} Departamento a Elegir`}
                                </em>
                            </MenuItem>
                            {props.tiposDepartamentos.map((item, index) => (
                                <MenuItem key={index} value={item}>
                                {item.nombre}
                                </MenuItem>
                            ))}
                            </Select>
                        </FormControl>
                        <FormHelperText>{props.getError('tipoDepartamentoSelected', props.errores)}</FormHelperText>
                        </Grid>
                     <Grid item xs={12}>
                        <InputLabel htmlFor="age-native-simple">    Programa: </InputLabel>
                        <FormControl 
                            className={classes.formControl} 
                            fullWidth 
                            error={props.getError('tipoProgramaSelected', props.errores).length > 0}
                        >
                            <Select
                            value={props.tipoProgramaSelected}
                            displayEmpty
                            fullWidth
                            inputProps={{ 'aria-label': 'Without label' }}
                            onChange={handleOnchange}
                            name="tipoProgramaSelected"
                            >
                            <MenuItem value="">
                                <em style={{color: "rgba(0, 0, 0, 0.54)"}}>
                                {`${props.tiposProgramas.length} Programa a Elegir`}
                                </em>
                            </MenuItem>
                            {props.tiposProgramas.map((item, index) => (
                                <MenuItem key={index} value={item}>
                                {item.nombre}
                                </MenuItem>
                            ))}
                            </Select>
                        </FormControl>
                        <FormHelperText>{props.getError('tipoProgramaSelected', props.errores)}</FormHelperText>
                        </Grid>
                     <Grid item xs={12}>
                        <FormControl 
                            fullWidth 
                            error={props.getError('acuerdoLicencia', props.errores).length > 0}>
                            <InputLabel id="acuerdo-licencia-label">¿Obtuvo Premiación?::</InputLabel>
                            <Select
                            labelId="acuerdo-licencia-label"
                            id="acuerdoLicencia"
                            value={props.acuerdoLicencia}
                            onChange={handleOnchange}
                            name="acuerdoLicencia"
                            >
                            <MenuItem value="si">Sí</MenuItem>
                            <MenuItem value="no">No</MenuItem>
                            </Select>
                            <FormHelperText>
                            {props.getError('acuerdoLicencia', props.errores)}
                            </FormHelperText>
                        </FormControl>
                        </Grid>

                        {props.acuerdoLicencia === "si" && (
                        <Grid item xs={12}>
                            <FormControl 
                            fullWidth 
                            error={props.getError('indiquecual', props.errores).length > 0}>
                            <InputLabel id="'indiquecua-label">Puesto Obtenido:</InputLabel>
                            <Select
                            labelId="'indiquecua-label"
                            id="indiquecual"
                            value={props.indiquecual}
                            onChange={handleOnchange}
                            name="indiquecual"
                            >
                            <MenuItem value="Primer puesto">Primer Puesto</MenuItem>
                            <MenuItem value="Segundo puesto">Segundo Puesto</MenuItem>
                            <MenuItem value="Tercer puesto">Tercer Puesto</MenuItem>
                            </Select>
                            <FormHelperText>
                            {props.getError('indiquecual', props.errores)}
                            </FormHelperText>
                        </FormControl>
                        </Grid>
                        )}
                     <Grid item xs={12} className="oculto">
                            <TextField
                                ref={fileInput}
                                required
                                type="file"
                                id="adj_certificado2"
                                name="adj_certificado2"
                                label="Adjuntar Identificación"
                                fullWidth
                                autoComplete="billing address-line1"
                                onChange={handleOnchange}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <InputFile 
                                id="adj_certificado2"
                                label="Certificación emitida por el CED"
                                name="adj_certificado2"
                                value={props.adj_certificado2} 
                                required={props.adj_certificado2} 
                                error={props.getError("adj_certificado2", props.errores) > 0}
                                helperText={props.getError("adj_certificado2", props.errores)}
                            />
                        </Grid>
                    </React.Fragment>
                    )}

                    {(props.tipoProductoEstSelected.codigo === "pasantias_investigacion") && (
                    <React.Fragment>
                     <Grid item xs={12}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <Fragment>
                                    <DatePicker
                                        views={["year", "month"]}
                                        label="Fecha de Inicio:"
                                        value={props.fecha}
                                        fullWidth
                                        onChange={props.setFecha}
                                        format="yyyy/MM"
                                    />
                                </Fragment>
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item xs={12}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <Fragment>
                                    <DatePicker
                                        views={["year", "month"]}
                                        label="Fecha de Finalización:"
                                        value={props.fechaFinal}
                                        fullWidth
                                        onChange={props.setFechaFinal}
                                        format="yyyy/MM"
                                    />
                                </Fragment>
                            </MuiPickersUtilsProvider>
                        </Grid> 

                        <Grid item xs={12}>
                            <FormControl 
                            fullWidth 
                            error={props.getError('indiquecual', props.errores).length > 0}>
                            <InputLabel id="'indiquecua-label">Tipo de movilidad:</InputLabel>
                            <Select
                            labelId="'indiquecua-label"
                            id="indiquecual"
                            value={props.indiquecual}
                            onChange={handleOnchange}
                            name="indiquecual"
                            >
                            <MenuItem value="Entrante">Entrante</MenuItem>
                            <MenuItem value="Saliente">Saliente</MenuItem>
                            </Select>
                            <FormHelperText>
                            {props.getError('indiquecual', props.errores)}
                            </FormHelperText>
                        </FormControl>
                        </Grid>
                         <Grid item xs={12}>
                        <FormControl 
                            fullWidth 
                            error={props.getError('acuerdoLicencia', props.errores).length > 0}>
                            <InputLabel id="acuerdo-licencia-label">Ambito de la movilidad</InputLabel>
                            <Select
                            labelId="acuerdo-licencia-label"
                            id="acuerdoLicencia"
                            value={props.acuerdoLicencia}
                            onChange={handleOnchange}
                            name="acuerdoLicencia"
                            >
                            <MenuItem value="Nacional">Nacional</MenuItem>
                            <MenuItem value="Internacional">Internacional</MenuItem>
                            </Select>
                            <FormHelperText>
                            {props.getError('acuerdoLicencia', props.errores)}
                            </FormHelperText>
                        </FormControl>
                        </Grid>

                     <Grid item xs={12} className="oculto">
                            <TextField
                                ref={fileInput}
                                required
                                type="file"
                                id="adj_certificado2"
                                name="adj_certificado2"
                                label="Adjuntar Identificación"
                                fullWidth
                                autoComplete="billing address-line1"
                                onChange={handleOnchange}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <InputFile 
                                id="adj_certificado2"
                                label="Certificación emitida por el CED"
                                name="adj_certificado2"
                                value={props.adj_certificado2} 
                                required={props.adj_certificado2} 
                                error={props.getError("adj_certificado2", props.errores) > 0}
                                helperText={props.getError("adj_certificado2", props.errores)}
                            />
                        </Grid>
                    </React.Fragment>
                    )}
                {(props.tipoProductoEstSelected.codigo === "prueba_ciclo") && (
                    <React.Fragment>
                     <Grid item xs={12}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <Fragment>
                                    <DatePicker
                                        views={["year", "month"]}
                                        label="Fecha:"
                                        value={props.fecha}
                                        fullWidth
                                        onChange={props.setFecha}
                                        format="yyyy/MM"
                                    />
                                </Fragment>
                            </MuiPickersUtilsProvider>
                        </Grid>
                        

                     <Grid item xs={12} className="oculto">
                            <TextField
                                ref={fileInput}
                                required
                                type="file"
                                id="adj_certificado2"
                                name="adj_certificado2"
                                label="Adjuntar Identificación"
                                fullWidth
                                autoComplete="billing address-line1"
                                onChange={handleOnchange}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <InputFile 
                                id="adj_certificado2"
                                label="Proyecto presentado en la prueba ciclo o rápido"
                                name="adj_certificado2"
                                value={props.adj_certificado2} 
                                required={props.adj_certificado2} 
                                error={props.getError("adj_certificado2", props.errores) > 0}
                                helperText={props.getError("adj_certificado2", props.errores)}
                            />
                        </Grid>
                    </React.Fragment>
                    )} 
                </Grid>
                </div>
            )
}
const ModalProduccionRecursoForms = (props) =>{

    const classes = useStyles()
    const isInitialMount = React.useRef(true);
    const [tipoDeProductoTec, setTipoProductoTec] = React.useState([]);
    React.useEffect( () => {
        //Obtengo los prceosos activos de la persona activa.
        if(isInitialMount.current){
            isInitialMount.current = false
            const obtenerProcesos = async () => {
                obtenerPRODUCTO()            }
            obtenerProcesos()
        }
    })

    const obtenerPRODUCTO = async () =>{
        let permisos = await obtenerPermisosValor(props.tipoProduccionRecursos.id);
        permisos = permisos.map(({ secundario }) => ({
            value: secundario.id,
            label: secundario.nombre,
            codigo: secundario.codigo
        }));
        setTipoProductoTec(permisos)

    }

    return (
        <div className={classes.root}>
          <Stepper activeStep={props.hola} alternativeLabel>
            {props.steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
          <div>
          {/* Aqui es cuando el Stepper llega al final.*/}
            {props.hola === props.steps.length ? (
              <div>
                <Typography className={classes.instructions}>{props.hola}</Typography>
                <Button onClick={props.handleReset}>Reset</Button>
              </div>
            ) : (
              <div>
                <GetStepContentRec
                    //Control del Stepper
                    stepIndex = {props.hola}
                    activeStepBiblio={props.activeStepBiblio}
                    //Tipo de Solicitud Actual
                    tipoSolicitudActual={props.tipoSolicitudActual}
                    setTipoSolicitudActual={props.setTipoSolicitudActual}

                    cargando={props.cargandoProduTec}
                    setCargando={props.setCargandoProduTec}

                    tipoDeProductoTec={tipoDeProductoTec}
                    setTipoProductoTec={setTipoProductoTec}

                    tipoProductoRecSelected={props.tipoProductoRecSelected}
                    setTipoProductoRecSelected={props.setTipoProductoRecSelected}

                    inputs={props.inputs}
                    setInputs={props.setInputs}

                    numeroIdParEvent={props.numeroIdParEvent}
                    setNumeroIdParEvent={props.setNumeroIdParEvent}
                    arrai={props.arrai}
                    setArrai={props.setArrai}

                    //Permisos de la solicitud
                    permisosDeLaSolicitud={props.permisosDeLaSolicitud}
                    setPermisosDeLaSolicitud={props.setPermisosDeLaSolicitud}

                     getError={props.getError}
                     errores={props.errores}
                     setErrores={props.setErrores}

                      //rol y modalidad
                    rolActive={props.rolActive}
                    setRolActive={props.setRolActive}

                    modalidadParticipacionActive={props.modalidadParticipacionActive}
                    setModalidadParticipacionActive={props.setModalidadParticipacionActive}

                    fechaRegistroEmpresaCultural={props.fechaRegistroEmpresaCultural}
                    setFechaRegistroEmpresaCultural={props.setFechaRegistroEmpresaCultural}

                    otroTipoEspacioEvento={props.otroTipoEspacioEvento}
                    setOtroTipoEspacioEvento={props.setOtroTipoEspacioEvento}

                    //formularios

                    tipoProyecto={props.tipoProyecto}
                    setTipoProyecto={props.setTipoProyecto}
                    setTipoProyectoSelected={props.setTipoProyectoSelected}
                    tipoProyectoSelected={props.tipoProyectoSelected}

                    fecha={props.fecha}
                    setFecha={props.setFecha}

                    fechaFinal={props.fechaFinal}
                    setFechaFinal={props.setFechaFinal}

                    orientacion={props.orientacion}
                    setOrientacion={props.setOrientacion}
                    orientacionSelected={props.orientacionSelected}
                    setOrientacionSelected={props.setOrientacionSelected}

                    tiposEmpresas={props.tiposEmpresas}
                    setTiposEmpresas={props.setTiposEmpresas}
                    tipoEmpresaSelected={props.tipoEmpresaSelected}
                    setTipoEmpresaSelected={props.setTipoEmpresaSelected}

                    tiposProgramas={props.tiposProgramas}
                    setTiposProgramas={props.setTiposProgramas}
                    tipoProgramaSelected={props.tipoProgramaSelected}
                    setTipoProgramaSelected={props.setTipoProgramaSelected}

                    tiposDepartamentos={props.tiposDepartamentos}
                    setTiposDepartamentos={props.setTiposDepartamentos}
                    tipoDepartamentoSelected={props.tipoDepartamentoSelected}
                    setTipoDepartamentoSelected={props.setTipoDepartamentoSelected}
                             
                    adj_certificado2={props.adj_certificado2}
                    setAdj_certificado2={props.setAdj_certificado2}
                    adj_certificado_final2={props.adj_certificado_final2}
                    setAdj_certificado_final2={props.setAdj_certificado_final2}

                    adj_certificado3={props.adj_certificado3}
                    setAdj_certificado3={props.setAdj_certificado3}
                    adj_certificado_final3={props.adj_certificado_final3}
                    setAdj_certificado_final3={props.setAdj_certificado_final3}


                    tiposRoles={props.tiposRoles}
                    setTiposRoles={props.setTiposRoles}
                />
              </div>
            )}
          </div>
        </div>
    )
}

const GetStepContentRec = (props) => {
    switch (props.stepIndex) {
        case 0:
            return (
                <ModalRecForm1

                    cargando={props.cargando}
                    setCargando={props.setCargando}

                    tipoDeProductoTec={props.tipoDeProductoTec}
                    setTipoProductoTec={props.setTipoProductoTec}

                    tipoProductoRecSelected={props.tipoProductoRecSelected}
                    setTipoProductoRecSelected={props.setTipoProductoRecSelected}

                    inputs={props.inputs}
                    setInputs={props.setInputs}


                    //fechas para los formularios

                    tipoProyecto={props.tipoProyecto}
                    setTipoProyecto={props.setTipoProyecto}
                    setTipoProyectoSelected={props.setTipoProyectoSelected}
                    tipoProyectoSelected={props.tipoProyectoSelected}

                    fecha={props.fecha}
                    setFecha={props.setFecha}

                    fechaFinal={props.fechaFinal}
                    setFechaFinal={props.setFechaFinal}

                    orientacion={props.orientacion}
                    setOrientacion={props.setOrientacion}
                    orientacionSelected={props.orientacionSelected}
                    setOrientacionSelected={props.setOrientacionSelected}

                    tiposEmpresas={props.tiposEmpresas}
                    setTiposEmpresas={props.setTiposEmpresas}
                    tipoEmpresaSelected={props.tipoEmpresaSelected}
                    setTipoEmpresaSelected={props.setTipoEmpresaSelected}

                    tiposProgramas={props.tiposProgramas}
                    setTiposProgramas={props.setTiposProgramas}
                    tipoProgramaSelected={props.tipoProgramaSelected}
                    setTipoProgramaSelected={props.setTipoProgramaSelected}

                    tiposDepartamentos={props.tiposDepartamentos}
                    setTiposDepartamentos={props.setTiposDepartamentos}
                    tipoDepartamentoSelected={props.tipoDepartamentoSelected}
                    setTipoDepartamentoSelected={props.setTipoDepartamentoSelected}

                    adj_certificado2={props.adj_certificado2}
                    setAdj_certificado2={props.setAdj_certificado2}

                    adj_certificado_final2={props.adj_certificado_final2}
                    setAdj_certificado_final2={props.setAdj_certificado_final2}

                    adj_certificado3={props.adj_certificado3}
                    setAdj_certificado3={props.setAdj_certificado3}

                    adj_certificado_final3={props.adj_certificado_final3}
                    setAdj_certificado_final3={props.setAdj_certificado_final3}

                    adj_certificado4={props.adj_certificado4}
                    setAdj_certificado4={props.setAdj_certificado4}

                    adj_certificado_final4={props.adj_certificado_final4}
                    setAdj_certificado_final4={props.setAdj_certificado_final4}

                    adj_certificado5={props.adj_certificado5}
                    setAdj_certificado5={props.setAdj_certificado5}

                    adj_certificado_final5={props.adj_certificado_final5}
                    setAdj_certificado_final5={props.setAdj_certificado_final5}
                    //Errores
                     getError={props.getError}
                     errores={props.errores}
                     setErrores={props.setErrores}

                    //rol y modalidad
                    rolActive={props.rolActive}
                    setRolActive={props.setRolActive}

                    fechaRegistroEmpresaCultural={props.fechaRegistroEmpresaCultural}
                    setFechaRegistroEmpresaCultural={props.setFechaRegistroEmpresaCultural}

                    otroTipoEspacioEvento={props.otroTipoEspacioEvento}
                    setOtroTipoEspacioEvento={props.setOtroTipoEspacioEvento}
                />
            )
        case 1:
            return (
                <ModalFormGestionAutores
                    tipoSolicitudActual={props.tipoSolicitudActual}
                    setTipoSolicitudActual={props.setTipoSolicitudActual}
                    //Variables Autores y Particiapntes
                    numeroIdParEvent={props.numeroIdParEvent}
                    setNumeroIdParEvent={props.setNumeroIdParEvent}
                    arrai={props.arrai}
                    setArrai={props.setArrai}

                    //Permisos de la solicitud
                    permisosDeLaSolicitud={props.permisosDeLaSolicitud}
                    setPermisosDeLaSolicitud={props.setPermisosDeLaSolicitud}

                    cargando={props.cargando}
                    setCargando={props.setCargando}

                    //rol y modalidad
                    rolActive={props.rolActive}
                    setRolActive={props.setRolActive}

                    modalidadParticipacionActive={props.modalidadParticipacionActive}
                    setModalidadParticipacionActive={props.setModalidadParticipacionActive}

                    tiposRoles={props.tiposRoles}
                    setTiposRoles={props.setTiposRoles}
                />
            )
    }
}
const ModalRecForm1 = (props) => {
    const classes = useStyles()
    const fileInput = React.createRef();
    React.useEffect(() => {
        if (props.tipoProductoRecSelected && props.tipoProductoRecSelected.codigo) {
            props.setCargando(true);
            obtenerPRODUCTO(props.tipoProductoRecSelected);
            
        }
    }, [props.tipoProductoRecSelected]);
    const handleOnchange = async (e) =>{

        if(e.target.name == "tipoProyectoSelected"){
            props.setTipoProyectoSelected(e.target.value)
            if(props.errores.length > 0){
                props.setErrores(props.errores.filter(er => er.llave != "tipoProyectoSelected"));
            }
        }else if (e.target.name == "orientacionSelected"){
            props.setOrientacionSelected(e.target.value)
            if (props.errores.length > 0){
            props.setErrores(props.errores.filter(er => er.llave != "orientacionSelected"));
            }
         }else if (e.target.name == "tipoEmpresaSelected"){
            props.setTipoEmpresaSelected(e.target.value) 
            if (props.errores.length > 0){
                props.setErrores(props.errores.filter(er => er.llave != "tipoEmpresaSelected"));
            }
        }else if (e.target.name == "tipoProgramaSelected"){
            props.setTipoProgramaSelected(e.target.value) 
            if (props.errores.length > 0){
                props.setErrores(props.errores.filter(er => er.llave != "tipoProgramaSelected"));
            }
        }else if (e.target.name === "adj_certificado2") {
                const file = e.target.files[0];
                if (file) {
                    props.setAdj_certificado2(file.name);          
                    props.setAdj_certificado_final2(file);         
                }
                if (props.errores.length > 0) {
                    props.setErrores(props.errores.filter(er => er.llave !== "adj_certificado2"));
                }
        }  
                let array = props.inputs.map((item) => {
                if (item.codigo == e.target.name) {
                    if (props.errores.length > 0) {
                        props.setErrores(props.errores.filter(er => er.llave !== e.target.name));
                        }
                    return {
                        ...item,
                        value: e.target.value
                    }
                }
                return item
            })
            props.setInputs(array)

            if (Array.isArray(props.inputsSelects)) {
            let arraySelects = props.inputsSelects.map((item) => {
                if (item.codigo == e.target.name) {
                    if (props.errores.length > 0) {
                    props.setErrores(props.errores.filter(er => er.llave !== e.target.name));
                    }
                    return {
                        ...item,
                        value: e.target.value
                    }
                }
                return item
            })
            props.setInputsSelects(arraySelects)
        }
    }


    const obtenerPRODUCTO = async (producto) =>{
        let permisos = await obtenerPermisosValor(producto.id);
        permisos = permisos.map(({ secundario }) => {
            return {
                id: secundario.id,
                label: secundario.nombre,
                codigo: secundario.codigo,
                error: props.errores,
                value: ''
            }
        });

        if(producto.codigo == "produ_trabajos_dirigidos"){
            await obtenerTipoProyecto()
            await obtenerOrientacion()
            await obtenerValoracionTesis()
            await obtenerprogramas()
        }

        if(producto.codigo =="produ_recurso_proyecto"){
             await obtenerTipoProyectoTrabajo()
             await obtenerProyectoes()
             await obtenerfinanciacion()
             
        
    }

        props.setInputs(permisos)
        props.setCargando(false)
    }

     const obtenerTipoProyecto = async () =>{
        let permisos = await Funciones.obtenerValores(Helper.TIPO_PROYECTO)
        props.setTipoProyecto(permisos)
    }
    const obtenerTipoProyectoTrabajo = async () =>{
        let permisos = await Funciones.obtenerValores(Helper.TIPO_PROYECTO_TRABAJO)
        props.setTipoProyecto(permisos)
    }
    const obtenerOrientacion = async () =>{
        let permisos = await Funciones.obtenerValores(Helper.ORIENTACION)
        props.setOrientacion(permisos)
    }
    const obtenerProyectoes = async () =>{
        let permisos = await Funciones.obtenerValores(Helper.PROYECTO_ES)
        props.setOrientacion(permisos)
    }
    const obtenerValoracionTesis = async () =>{
        let permisos = await Funciones.obtenerValores(Helper.VALORACION_TESIS)
        props.setTiposEmpresas(permisos)
    }
    const obtenerprogramas = async () =>{
        let permisos = await Funciones.obtenerValores(Helper.PROGRAMAS)
        props.setTiposProgramas(permisos)
    }
    const obtenerfinanciacion = async () =>{
        let permisos = await Funciones.obtenerValores(Helper.FINANCIACION)
        props.setTiposEmpresas(permisos)
    }
    
    return (
        props.cargando == true ? <div> <TareasTerminadas imagen={emma_w} mensaje={'Cargando..'} widthImg='7%' marginTop='7%' /> <LinearProgress /></div> :
        <div>
            <Grid container spacing={3}>
                 {props.inputs.map((input, index) => (
                    <Grid item xs={12} key={index}>
                    <TextField
                        fullWidth
                        label={input.label}
                        name={input.codigo}
                        value={input.value || ""}
                        onChange={handleOnchange}
                        error={props.getError(input.codigo, props.errores).length > 0}
                        helperText={props.getError(input.codigo, props.errores)}
                    />
                    </Grid>
                ))}
                
                 {(props.tipoProductoRecSelected.codigo === "produ_trabajos_dirigidos" ) && (
                    <React.Fragment>                  
                        <Grid item xs={12}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <Fragment>
                                    <DatePicker
                                        views={["year", "month"]}
                                        label="Fecha Inicio:"
                                        value={props.fecha}
                                        fullWidth
                                        onChange={props.setFecha}
                                        format="yyyy/MM"
                                    />
                                </Fragment>
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item xs={12}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <Fragment>
                                    <DatePicker
                                        views={["year", "month"]}
                                        label="Fecha Final:"
                                        value={props.fechaFinal}
                                        fullWidth
                                        onChange={props.setFechaFinal}
                                        format="yyyy/MM"
                                    />
                                </Fragment>
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item xs={12}>
                            <InputLabel htmlFor="age-native-simple">Tipo de producto: </InputLabel>
                            <FormControl 
                                className={classes.formControl} 
                                fullWidth 
                                error={props.getError('tipoProyectoSelected', props.errores).length > 0}
                            >
                                <Select
                                    value={props.tipoProyectoSelected}
                                    displayEmpty
                                    fullWidth
                                    inputProps={{ 'aria-label': 'Without label' }}
                                    onChange={handleOnchange}
                                    name="tipoProyectoSelected"
                                >
                                    <MenuItem value="">
                                        <em style={{color: "rgba(0, 0, 0, 0.54)"}}>
                                            {`${props.tipoProyecto.length} Tipo proyecto a Elegir a Elegir`}
                                        </em>
                                    </MenuItem>
                                    {props.tipoProyecto.map((item, index) => (
                                        <MenuItem key={index} value={item}>
                                            {`${item.nombre}`}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <FormHelperText>{props.getError('tipoProyectoSelected', props.errores)}</FormHelperText>
                        </Grid>

                        <Grid item xs={12}>
                            <InputLabel htmlFor="age-native-simple">Tipo de Orientación: </InputLabel>
                            <FormControl 
                                className={classes.formControl} 
                                fullWidth 
                                error={props.getError('orientacionSelected', props.errores).length > 0}
                            >
                                <Select
                                    value={props.orientacionSelected}
                                    displayEmpty
                                    fullWidth
                                    inputProps={{ 'aria-label': 'Without label' }}
                                    onChange={handleOnchange}
                                    name="orientacionSelected"
                                >
                                    <MenuItem value="">
                                        <em style={{color: "rgba(0, 0, 0, 0.54)"}}>
                                            {`${props.orientacion.length} Tipo Orientación a Elegir a Elegir`}
                                        </em>
                                    </MenuItem>
                                    {props.orientacion.map((item, index) => (
                                        <MenuItem key={index} value={item}>
                                            {`${item.nombre}`}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <FormHelperText>{props.getError('orientacionSelected', props.errores)}</FormHelperText>
                        </Grid>

                        <Grid item xs={12}>
                        <InputLabel htmlFor="age-native-simple">Valoración de la tesis: </InputLabel>
                        <FormControl 
                            className={classes.formControl} 
                            fullWidth 
                            error={props.getError('tipoEmpresaSelected', props.errores).length > 0}
                        >
                            <Select
                            value={props.tipoEmpresaSelected}
                            displayEmpty
                            fullWidth
                            inputProps={{ 'aria-label': 'Without label' }}
                            onChange={handleOnchange}
                            name="tipoEmpresaSelected"
                            >
                            <MenuItem value="">
                                <em style={{color: "rgba(0, 0, 0, 0.54)"}}>
                                {`${props.tiposEmpresas.length} Opciones a Elegir`}
                                </em>
                            </MenuItem>
                            {props.tiposEmpresas.map((item, index) => (
                                <MenuItem key={index} value={item}>
                                {item.nombre}
                                </MenuItem>
                            ))}
                            </Select>
                        </FormControl>
                        <FormHelperText>{props.getError('tipoEmpresaSelected', props.errores)}</FormHelperText>
                        </Grid>
                        
                        <Grid item xs={12}>
                        <InputLabel htmlFor="age-native-simple">    Programa: </InputLabel>
                        <FormControl 
                            className={classes.formControl} 
                            fullWidth 
                            error={props.getError('tipoProgramaSelected', props.errores).length > 0}
                        >
                            <Select
                            value={props.tipoProgramaSelected}
                            displayEmpty
                            fullWidth
                            inputProps={{ 'aria-label': 'Without label' }}
                            onChange={handleOnchange}
                            name="tipoProgramaSelected"
                            >
                            <MenuItem value="">
                                <em style={{color: "rgba(0, 0, 0, 0.54)"}}>
                                {`${props.tiposProgramas.length} Programa a Elegir`}
                                </em>
                            </MenuItem>
                            {props.tiposProgramas.map((item, index) => (
                                <MenuItem key={index} value={item}>
                                {item.nombre}
                                </MenuItem>
                            ))}
                            </Select>
                        </FormControl>
                        <FormHelperText>{props.getError('tipoProgramaSelected', props.errores)}</FormHelperText>
                        </Grid>



                    </React.Fragment>
                )}
                {(props.tipoProductoRecSelected.codigo === "produ_recurso_proyecto" ) && (
                    <React.Fragment>  
                        <Grid item xs={12}>
                            <InputLabel htmlFor="age-native-simple">Tipo de proyecto: </InputLabel>
                            <FormControl 
                                className={classes.formControl} 
                                fullWidth 
                                error={props.getError('orientacionSelected', props.errores).length > 0}
                            >
                                <Select
                                    value={props.orientacionSelected}
                                    displayEmpty
                                    fullWidth
                                    inputProps={{ 'aria-label': 'Without label' }}
                                    onChange={handleOnchange}
                                    name="orientacionSelected"
                                >
                                    <MenuItem value="">
                                        <em style={{color: "rgba(0, 0, 0, 0.54)"}}>
                                            {`${props.orientacion.length} Tipo proyecto a Elegir`}
                                        </em>
                                    </MenuItem>
                                    {props.orientacion.map((item, index) => (
                                        <MenuItem key={index} value={item}>
                                            {`${item.nombre}`}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <FormHelperText>{props.getError('orientacionSelected', props.errores)}</FormHelperText>
                        </Grid>  
                                     
                        <Grid item xs={12}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <Fragment>
                                    <DatePicker
                                        views={["year", "month"]}
                                        label="Fecha Inicio:"
                                        value={props.fecha}
                                        fullWidth
                                        onChange={props.setFecha}
                                        format="yyyy/MM"
                                    />
                                </Fragment>
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item xs={12}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <Fragment>
                                    <DatePicker
                                        views={["year", "month"]}
                                        label="Fecha Final:"
                                        value={props.fechaFinal}
                                        fullWidth
                                        onChange={props.setFechaFinal}
                                        format="yyyy/MM"
                                    />
                                </Fragment>
                            </MuiPickersUtilsProvider>
                        </Grid>

                        <Grid item xs={12}>
                            <InputLabel htmlFor="age-native-simple">El proyecto es: </InputLabel>
                            <FormControl 
                                className={classes.formControl} 
                                fullWidth 
                                error={props.getError('tipoProyectoSelected', props.errores).length > 0}
                            >
                                <Select
                                    value={props.tipoProyectoSelected}
                                    displayEmpty
                                    fullWidth
                                    inputProps={{ 'aria-label': 'Without label' }}
                                    onChange={handleOnchange}
                                    name="tipoProyectoSelected"
                                >
                                    <MenuItem value="">
                                        <em style={{color: "rgba(0, 0, 0, 0.54)"}}>
                                            {`${props.tipoProyecto.length} Opciones a Elegir `}
                                        </em>
                                    </MenuItem>
                                    {props.tipoProyecto.map((item, index) => (
                                        <MenuItem key={index} value={item}>
                                            {`${item.nombre}`}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <FormHelperText>{props.getError('tipoProyectoSelected', props.errores)}</FormHelperText>
                        </Grid> 

                        <Grid item xs={12}>
                        <InputLabel htmlFor="age-native-simple">Fuente de Financiacion: </InputLabel>
                        <FormControl 
                            className={classes.formControl} 
                            fullWidth 
                            error={props.getError('tipoEmpresaSelected', props.errores).length > 0}
                        >
                            <Select
                            value={props.tipoEmpresaSelected}
                            displayEmpty
                            fullWidth
                            inputProps={{ 'aria-label': 'Without label' }}
                            onChange={handleOnchange}
                            name="tipoEmpresaSelected"
                            >
                            <MenuItem value="">
                                <em style={{color: "rgba(0, 0, 0, 0.54)"}}>
                                {`${props.tiposEmpresas.length} Financiacion a Elegir`}
                                </em>
                            </MenuItem>
                            {props.tiposEmpresas.map((item, index) => (
                                <MenuItem key={index} value={item}>
                                {item.nombre}
                                </MenuItem>
                            ))}
                            </Select>
                        </FormControl>
                        <FormHelperText>{props.getError('tipoEmpresaSelected', props.errores)}</FormHelperText>
                        </Grid>


                    </React.Fragment>
                )}
                  
                </Grid>
        </div>
    )

}
const ModalProduccionSocialForms = (props) =>{

    const classes = useStyles()
    const isInitialMount = React.useRef(true);
    const [tipoDeProductoTec, setTipoProductoTec] = React.useState([]);
    React.useEffect( () => {
        //Obtengo los prceosos activos de la persona activa.
        if(isInitialMount.current){
            isInitialMount.current = false
            const obtenerProcesos = async () => {
                obtenerPRODUCTO()
                obtenerTiposRoles()
                obtenerPaises()
            }
            obtenerProcesos()
        }
    })

    const obtenerTiposRoles = async () =>{
        let permisos = await Funciones.obtenerValores(Helper.TIPO_ROL_INVESTIGACION)

        props.setTiposRoles(permisos)
    }

    const obtenerPaises= async () => {
        try{
            let data = await Funciones.obtenerValores(Helper.PAISES)
            props.setPaisesTecTecno(data)
            props.setCargandoProduTec(false)
        }catch(err){
          console.log(err)
        }
    }
    

    const obtenerPRODUCTO = async () =>{
        let permisos = await obtenerPermisosValor(props.tipoProduccionSocial.id);
        permisos = permisos.map(({ secundario }) => ({
            value: secundario.id,
            label: secundario.nombre,
            codigo: secundario.codigo
        }));
        setTipoProductoTec(permisos)

    }

    return (
        <div className={classes.root}>
          <Stepper activeStep={props.hola} alternativeLabel>
            {props.steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
          <div>
          {/* Aqui es cuando el Stepper llega al final.*/}
            {props.hola === props.steps.length ? (
              <div>
                <Typography className={classes.instructions}>{props.hola}</Typography>
                <Button onClick={props.handleReset}>Reset</Button>
              </div>
            ) : (
              <div>
                <GetStepContentSol
                    //Control del Stepper
                    stepIndex = {props.hola}
                    activeStepBiblio={props.activeStepBiblio}
                    //Tipo de Solicitud Actual
                    tipoSolicitudActual={props.tipoSolicitudActual}
                    setTipoSolicitudActual={props.setTipoSolicitudActual}

                    cargando={props.cargandoProduTec}
                    setCargando={props.setCargandoProduTec}

                    tipoDeProductoTec={tipoDeProductoTec}
                    setTipoProductoTec={setTipoProductoTec}

                    tipoProductoSolSelected={props.tipoProductoSolSelected}
                    setTipoProductoSolSelected={props.setTipoProductoSolSelected}

                    inputs={props.inputs}
                    setInputs={props.setInputs}

                    //Tipo de Solicitud Actual
                    // tipoSolicitudActual={props.tipoSolicitudActual}
                    // setTipoSolicitudActual={props.setTipoSolicitudActual}
                    //Variables Autores y particiapntes
                    numeroIdParEvent={props.numeroIdParEvent}
                    setNumeroIdParEvent={props.setNumeroIdParEvent}
                    arrai={props.arrai}
                    setArrai={props.setArrai}

                    //Permisos de la solicitud
                    permisosDeLaSolicitud={props.permisosDeLaSolicitud}
                    setPermisosDeLaSolicitud={props.setPermisosDeLaSolicitud}

                     getError={props.getError}
                     errores={props.errores}
                     setErrores={props.setErrores}

                      //rol y modalidad
                    rolActive={props.rolActive}
                    setRolActive={props.setRolActive}

                    modalidadParticipacionActive={props.modalidadParticipacionActive}
                    setModalidadParticipacionActive={props.setModalidadParticipacionActive}

                    fechaRegistroEmpresaCultural={props.fechaRegistroEmpresaCultural}
                    setFechaRegistroEmpresaCultural={props.setFechaRegistroEmpresaCultural}

                    otroTipoEspacioEvento={props.otroTipoEspacioEvento}
                    setOtroTipoEspacioEvento={props.setOtroTipoEspacioEvento}

                    //formularios

                    licencia={props.licencia}
                    setLicencia={props.setLicencia}
                    setlicenciaSelected={props.setlicenciaSelected}
                    licenciaSelected={props.licenciaSelected}

                    fecha={props.fecha}
                    setFecha={props.setFecha}

                    tipoEmpresa={props.tipoEmpresa}
                    setTipoEmpresa={props.setTipoEmpresa}
                    tipoEmpresasoSelected={props.tipoEmpresasoSelected}
                    setTipoEmpresasoSelected={props.setTipoEmpresasoSelected}
                             
                    adj_certificado2={props.adj_certificado2}
                    setAdj_certificado2={props.setAdj_certificado2}
                    adj_certificado_final2={props.adj_certificado_final2}
                    setAdj_certificado_final2={props.setAdj_certificado_final2}

                    adj_certificado3={props.adj_certificado3}
                    setAdj_certificado3={props.setAdj_certificado3}
                    adj_certificado_final3={props.adj_certificado_final3}
                    setAdj_certificado_final3={props.setAdj_certificado_final3}


                    tiposRoles={props.tiposRoles}
                    setTiposRoles={props.setTiposRoles}
                />
              </div>
            )}
          </div>
        </div>
    )
}

const GetStepContentSol = (props) => {
    switch (props.stepIndex) {
        case 0:
            return (
                <ModalSolForm1

                    cargando={props.cargando}
                    setCargando={props.setCargando}

                    tipoDeProductoTec={props.tipoDeProductoTec}
                    setTipoProductoTec={props.setTipoProductoTec}

                    tipoProductoSolSelected={props.tipoProductoSolSelected}
                    setTipoProductoSolSelected={props.setTipoProductoSolSelected}

                    inputs={props.inputs}
                    setInputs={props.setInputs}


                    //fechas para los formularios

                    licencia={props.licencia}
                    setLicencia={props.setLicencia}
                    setlicenciaSelected={props.setlicenciaSelected}
                    licenciaSelected={props.licenciaSelected}

                    fecha={props.fecha}
                    setFecha={props.setFecha}

                    tipoEmpresa={props.tipoEmpresa}
                    setTipoEmpresa={props.setTipoEmpresa}
                    tipoEmpresasoSelected={props.tipoEmpresasoSelected}
                    setTipoEmpresasoSelected={props.setTipoEmpresasoSelected}

                    adj_certificado2={props.adj_certificado2}
                    setAdj_certificado2={props.setAdj_certificado2}

                    adj_certificado_final2={props.adj_certificado_final2}
                    setAdj_certificado_final2={props.setAdj_certificado_final2}

                    adj_certificado3={props.adj_certificado3}
                    setAdj_certificado3={props.setAdj_certificado3}

                    adj_certificado_final3={props.adj_certificado_final3}
                    setAdj_certificado_final3={props.setAdj_certificado_final3}

                    adj_certificado4={props.adj_certificado4}
                    setAdj_certificado4={props.setAdj_certificado4}

                    adj_certificado_final4={props.adj_certificado_final4}
                    setAdj_certificado_final4={props.setAdj_certificado_final4}

                    adj_certificado5={props.adj_certificado5}
                    setAdj_certificado5={props.setAdj_certificado5}

                    adj_certificado_final5={props.adj_certificado_final5}
                    setAdj_certificado_final5={props.setAdj_certificado_final5}
                    //Errores
                     getError={props.getError}
                     errores={props.errores}
                     setErrores={props.setErrores}

                    //rol y modalidad
                    rolActive={props.rolActive}
                    setRolActive={props.setRolActive}

                    fechaRegistroEmpresaCultural={props.fechaRegistroEmpresaCultural}
                    setFechaRegistroEmpresaCultural={props.setFechaRegistroEmpresaCultural}

                    otroTipoEspacioEvento={props.otroTipoEspacioEvento}
                    setOtroTipoEspacioEvento={props.setOtroTipoEspacioEvento}
                />
            )
        case 1:
            return (
                <ModalFormGestionAutores
                    tipoSolicitudActual={props.tipoSolicitudActual}
                    setTipoSolicitudActual={props.setTipoSolicitudActual}
                    //Variables Autores y Particiapntes
                    numeroIdParEvent={props.numeroIdParEvent}
                    setNumeroIdParEvent={props.setNumeroIdParEvent}
                    arrai={props.arrai}
                    setArrai={props.setArrai}

                    //Permisos de la solicitud
                    permisosDeLaSolicitud={props.permisosDeLaSolicitud}
                    setPermisosDeLaSolicitud={props.setPermisosDeLaSolicitud}

                    cargando={props.cargando}
                    setCargando={props.setCargando}

                    //rol y modalidad
                    rolActive={props.rolActive}
                    setRolActive={props.setRolActive}

                    modalidadParticipacionActive={props.modalidadParticipacionActive}
                    setModalidadParticipacionActive={props.setModalidadParticipacionActive}

                    tiposRoles={props.tiposRoles}
                    setTiposRoles={props.setTiposRoles}
                />
            )
    }
}
const ModalSolForm1 = (props) => {
    const classes = useStyles()
    const fileInput = React.createRef();
    React.useEffect(() => {
        if (props.tipoProductoSolSelected && props.tipoProductoSolSelected.codigo) {
            props.setCargando(true);
            obtenerPRODUCTO(props.tipoProductoSolSelected);
            
        }
    }, [props.tipoProductoSolSelected]);
    const handleOnchange = async (e) =>{

        if(e.target.name == "licenciaSelected"){
            props.setlicenciaSelected(e.target.value)
            if(props.errores.length > 0){
                props.setErrores(props.errores.filter(er => er.llave != "licenciaSelected"));
            }
        }else if(e.target.name == "tipoEmpresasoSelected"){
            props.setTipoEmpresasoSelected(e.target.value)
            if(props.errores.length > 0){
                props.setErrores(props.errores.filter(er => er.llave != "tipoEmpresasoSelected"));
            }
        }else if(e.target.name == "tipoDesarrolloSelected"){
            props.setTipoDesarrolloSelected(e.target.value)
            if(props.errores.length > 0){
                props.setErrores(props.errores.filter(er => er.llave != "tipoDesarrolloSelected"));
            }
        }else if(e.target.name == "tipoClaseSelected"){
            props.setTipoClaseSelected(e.target.value)
            if(props.errores.length > 0){
                props.setErrores(props.errores.filter(er => er.llave != "tipoClaseSelected"));
            }
        }else if (e.target.name === "adj_certificado2") {
                const file = e.target.files[0];
                if (file) {
                    props.setAdj_certificado2(file.name);          
                    props.setAdj_certificado_final2(file);         
                }
                if (props.errores.length > 0) {
                    props.setErrores(props.errores.filter(er => er.llave !== "adj_certificado2"));
                }
        }else if (e.target.name === "adj_certificado3") {
                const file = e.target.files[0];
                if (file) {
                    props.setAdj_certificado3(file.name);
                    props.setAdj_certificado_final3(file);
                }
                if (props.errores.length > 0) {
                    props.setErrores(props.errores.filter(er => er.llave !== "adj_certificado3"));
                }
        }else if (e.target.name === "adj_certificado4") {
                const file = e.target.files[0];
                if (file) {
                    props.setAdj_certificado4(file.name);          
                    props.setAdj_certificado_final4(file);         
                }
                if (props.errores.length > 0) {
                    props.setErrores(props.errores.filter(er => er.llave !== "adj_certificado4"));
                }
        }else if (e.target.name === "adj_certificado5") {
                const file = e.target.files[0];
                if (file) {
                    props.setAdj_certificado5(file.name);
                    props.setAdj_certificado_final5(file);
                }
                if (props.errores.length > 0) {
                    props.setErrores(props.errores.filter(er => er.llave !== "adj_certificado5"));
                }
        }else if(e.target.name == "ciudadesSelectedTecTecno"){
            props.setCiudadesSelectedTecTecno(e.target.value)
            if(props.errores.length > 0){
                props.setErrores(props.errores.filter(er => er.llave != "ciudadesSelectedTecTecno"));
            }
        
        }  
                let array = props.inputs.map((item) => {
                if (item.codigo == e.target.name) {
                    if (props.errores.length > 0) {
                        props.setErrores(props.errores.filter(er => er.llave !== e.target.name));
                        }
                    return {
                        ...item,
                        value: e.target.value
                    }
                }
                return item
            })
            props.setInputs(array)

            if (Array.isArray(props.inputsSelects)) {
            let arraySelects = props.inputsSelects.map((item) => {
                if (item.codigo == e.target.name) {
                    if (props.errores.length > 0) {
                    props.setErrores(props.errores.filter(er => er.llave !== e.target.name));
                    }
                    return {
                        ...item,
                        value: e.target.value
                    }
                }
                return item
            })
            props.setInputsSelects(arraySelects)
        }
    }


    const obtenerPRODUCTO = async (producto) =>{
        let permisos = await obtenerPermisosValor(producto.id);
        permisos = permisos.map(({ secundario }) => {
            return {
                id: secundario.id,
                label: secundario.nombre,
                codigo: secundario.codigo,
                error: props.errores,
                value: ''
            }
        });

        if(producto.codigo == "apropiaciacion_social_conocimiento" || producto.codigo== "trabajo_conjunto" || producto.codigo =="fortalecimiento_cadenas_productivas"|| producto.codigo =="generacion_insumos" ){
            await obtenerLicencia()
   
        if(producto.codigo =="fortalecimiento_cadenas_productivas"){
            await obtenerEmpresa()
        }
        if(producto.codigo =="generacion_insumos"){
            await obtenerNivelDocumento()
        }
    }

        props.setInputs(permisos)
        props.setCargando(false)
    }


     const obtenerLicencia = async () =>{
        let permisos = await Funciones.obtenerValores(Helper.LICENCIA)
        props.setLicencia(permisos)
    }
    const obtenerEmpresa = async () =>{
        let permisos = await Funciones.obtenerValores(Helper.EMPRESA)
        props.setTipoEmpresa(permisos)
    }
    const obtenerNivelDocumento = async () =>{
        let permisos = await Funciones.obtenerValores(Helper.AMBITO_INVESTIGACION)
        props.setTipoEmpresa(permisos)
    }
    
    return (
        props.cargando == true ? <div> <TareasTerminadas imagen={emma_w} mensaje={'Cargando..'} widthImg='7%' marginTop='7%' /> <LinearProgress /></div> :
        <div>
            <Grid container spacing={3}>
                 {props.inputs.map((input, index) => (
                    <Grid item xs={12} key={index}>
                    <TextField
                        fullWidth
                        label={input.label}
                        name={input.codigo}
                        value={input.value || ""}
                        onChange={handleOnchange}
                        error={props.getError(input.codigo, props.errores).length > 0}
                        helperText={props.getError(input.codigo, props.errores)}
                    />
                    </Grid>
                ))}
                
                 {(props.tipoProductoSolSelected.codigo === "apropiaciacion_social_conocimiento" ||  props.tipoProductoSolSelected.codigo === "generacion_insumos" ||props.tipoProductoSolSelected.codigo === "trabajo_conjunto" || props.tipoProductoSolSelected.codigo === "fortalecimiento_cadenas_productivas") && (
                    <React.Fragment>                  
                        <Grid item xs={12}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <Fragment>
                                    <DatePicker
                                        views={["year", "month"]}
                                        label="Fecha:"
                                        value={props.fecha}
                                        fullWidth
                                        onChange={props.setFecha}
                                        format="yyyy/MM"
                                    />
                                </Fragment>
                            </MuiPickersUtilsProvider>
                        </Grid>

                        <Grid item xs={12}>
                            <InputLabel htmlFor="age-native-simple">Licencia Creative Commons u Open Data Commons del contenido: </InputLabel>
                            <FormControl 
                                className={classes.formControl} 
                                fullWidth 
                                error={props.getError('licenciaSelected', props.errores).length > 0}
                            >
                                <Select
                                    value={props.licenciaSelected}
                                    displayEmpty
                                    fullWidth
                                    inputProps={{ 'aria-label': 'Without label' }}
                                    onChange={handleOnchange}
                                    name="licenciaSelected"
                                >
                                    <MenuItem value="">
                                        <em style={{color: "rgba(0, 0, 0, 0.54)"}}>
                                            {`${props.licencia.length} Ciudades a Elegir`}
                                        </em>
                                    </MenuItem>
                                    {props.licencia.map((item, index) => (
                                        <MenuItem key={index} value={item}>
                                            {`${item.nombre}`}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <FormHelperText>{props.getError('licenciaSelected', props.errores)}</FormHelperText>
                        </Grid>

                    </React.Fragment>
                )}

                  {props.tipoProductoSolSelected.codigo === "apropiaciacion_social_conocimiento" && (
                    <React.Fragment>                  
                        <Grid item xs={12} className="oculto">
                            <TextField
                                ref={fileInput}
                                required
                                type="file"
                                id="adj_certificado2"
                                name="adj_certificado2"
                                label="Adjuntar Identificación"
                                fullWidth
                                autoComplete="billing address-line1"
                                onChange={handleOnchange}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <InputFile 
                                id="adj_certificado2"
                                label="Certificación emitida por la comunidad y/u organización pública o privada que avala el proyecto"
                                name="adj_certificado2"
                                value={props.adj_certificado2} 
                                required={props.adj_certificado2} 
                                error={props.getError("adj_certificado2", props.errores) > 0}
                                helperText={props.getError("adj_certificado2", props.errores)}
                            />
                        </Grid>
                    </React.Fragment>
                )}

                  {props.tipoProductoSolSelected.codigo === "trabajo_conjunto" && (
                    <React.Fragment>    
                        <Grid item xs={12} className="oculto">
                            <TextField
                                ref={fileInput}
                                required
                                type="file"
                                id="adj_certificado2"
                                name="adj_certificado2"
                                label="Adjuntar Identificación"
                                fullWidth
                                autoComplete="billing address-line1"
                                onChange={handleOnchange}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <InputFile 
                                id="adj_certificado2"
                                label="Certificación del centro de ciencia de su participación en el proyecto de investigación y de la participación del grupo de investigación"
                                name="adj_certificado2"
                                value={props.adj_certificado2} 
                                required={props.adj_certificado2} 
                                error={props.getError("adj_certificado2", props.errores) > 0}
                                helperText={props.getError("adj_certificado2", props.errores)}
                            />
                        </Grid>
                    </React.Fragment>
                )}

                {props.tipoProductoSolSelected.codigo === "fortalecimiento_cadenas_productivas" && (
                    <React.Fragment>
                        <Grid item xs={12}>
                            <InputLabel htmlFor="age-native-simple">Tipo de empresas donde se desarrolla el proceso de apropiación social: </InputLabel>
                            <FormControl 
                                className={classes.formControl} 
                                fullWidth 
                                error={props.getError('tipoEmpresasoSelected', props.errores).length > 0}
                            >
                                <Select
                                    value={props.tipoEmpresasoSelected}
                                    displayEmpty
                                    fullWidth
                                    inputProps={{ 'aria-label': 'Without label' }}
                                    onChange={handleOnchange}
                                    name="tipoEmpresasoSelected"
                                >
                                    <MenuItem value="">
                                        <em style={{color: "rgba(0, 0, 0, 0.54)"}}>
                                            {`${props.tipoEmpresa.length} Ciudades a Elegir`}
                                        </em>
                                    </MenuItem>
                                    {props.tipoEmpresa.map((item, index) => (
                                        <MenuItem key={index} value={item}>
                                            {`${item.nombre}`}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <FormHelperText>{props.getError('tipoEmpresasoSelected', props.errores)}</FormHelperText>
                        </Grid>                 
                        <Grid item xs={12} className="oculto">
                            <TextField
                                ref={fileInput}
                                required
                                type="file"
                                id="adj_certificado2"
                                name="adj_certificado2"
                                label="Adjuntar Identificación"
                                fullWidth
                                autoComplete="billing address-line1"
                                onChange={handleOnchange}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <InputFile 
                                id="adj_certificado2"
                                label="Certificación emitida por la comunidad y/u organización pública o privada que avala el proyecto"
                                name="adj_certificado2"
                                value={props.adj_certificado2} 
                                required={props.adj_certificado2} 
                                error={props.getError("adj_certificado2", props.errores) > 0}
                                helperText={props.getError("adj_certificado2", props.errores)}
                            />
                        </Grid>
                    

                        
                    </React.Fragment>
                )}

                {props.tipoProductoSolSelected.codigo === "generacion_insumos" && (
                    <React.Fragment>
                        <Grid item xs={12}>
                            <InputLabel htmlFor="age-native-simple">Documento o acto normativo que aplica a nivel: </InputLabel>
                            <FormControl 
                                className={classes.formControl} 
                                fullWidth 
                                error={props.getError('tipoEmpresasoSelected', props.errores).length > 0}
                            >
                                <Select
                                    value={props.tipoEmpresasoSelected}
                                    displayEmpty
                                    fullWidth
                                    inputProps={{ 'aria-label': 'Without label' }}
                                    onChange={handleOnchange}
                                    name="tipoEmpresasoSelected"
                                >
                                    <MenuItem value="">
                                        <em style={{color: "rgba(0, 0, 0, 0.54)"}}>
                                            {`${props.tipoEmpresa.length} Ciudades a Elegir`}
                                        </em>
                                    </MenuItem>
                                    {props.tipoEmpresa.map((item, index) => (
                                        <MenuItem key={index} value={item}>
                                            {`${item.nombre}`}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <FormHelperText>{props.getError('tipoEmpresasoSelected', props.errores)}</FormHelperText>
                        </Grid>                 
                        <Grid item xs={12} className="oculto">
                            <TextField
                                ref={fileInput}
                                required
                                type="file"
                                id="adj_certificado2"
                                name="adj_certificado2"
                                label="Adjuntar Identificación"
                                fullWidth
                                autoComplete="billing address-line1"
                                onChange={handleOnchange}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <InputFile 
                                id="adj_certificado2"
                                label="Certificación emitida por la entidad que adopta y/o usa el documento."
                                name="adj_certificado2"
                                value={props.adj_certificado2} 
                                required={props.adj_certificado2} 
                                error={props.getError("adj_certificado2", props.errores) > 0}
                                helperText={props.getError("adj_certificado2", props.errores)}
                            />
                        </Grid>
                    

                        
                    </React.Fragment>
                )}

                </Grid>
        </div>
    )

}


const ModalProduccionDivulgacionForms = (props) =>{

    const classes = useStyles()
    const isInitialMount = React.useRef(true);
    const [tipoDeProductoTec, setTipoProductoTec] = React.useState([]);
    React.useEffect( () => {
        //Obtengo los prceosos activos de la persona activa.
        if(isInitialMount.current){
            isInitialMount.current = false
            const obtenerProcesos = async () => {
                obtenerPRODUCTO()
                obtenerTiposRoles()
                obtenerPaises()
            }
            obtenerProcesos()
        }
    })

    const obtenerTiposRoles = async () =>{
        let permisos = await Funciones.obtenerValores(Helper.TIPO_ROL_INVESTIGACION)

        props.setTiposRoles(permisos)
    }

    const obtenerPaises= async () => {
        try{
            let data = await Funciones.obtenerValores(Helper.PAISES)
            props.setPaisesTecTecno(data)
            props.setCargandoProduTec(false)
        }catch(err){
          console.log(err)
        }
    }
    

    const obtenerPRODUCTO = async () =>{
        let permisos = await obtenerPermisosValor(props.tipoProduccionDivulgacion.id);
        permisos = permisos.map(({ secundario }) => ({
            value: secundario.id,
            label: secundario.nombre,
            codigo: secundario.codigo
        }));
        setTipoProductoTec(permisos)

    }

    return (
        <div className={classes.root}>
          <Stepper activeStep={props.hola} alternativeLabel>
            {props.steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
          <div>
          {/* Aqui es cuando el Stepper llega al final.*/}
            {props.hola === props.steps.length ? (
              <div>
                <Typography className={classes.instructions}>{props.hola}</Typography>
                <Button onClick={props.handleReset}>Reset</Button>
              </div>
            ) : (
              <div>
                <GetStepContentDiv
                    //Control del Stepper
                    stepIndex = {props.hola}
                    activeStepBiblio={props.activeStepBiblio}
                    //Tipo de Solicitud Actual
                    tipoSolicitudActual={props.tipoSolicitudActual}
                    setTipoSolicitudActual={props.setTipoSolicitudActual}

                    cargando={props.cargandoProduTec}
                    setCargando={props.setCargandoProduTec}

                    tipoDeProductoTec={tipoDeProductoTec}
                    setTipoProductoTec={setTipoProductoTec}

                    tipoProductoDivSelected={props.tipoProductoDivSelected}
                    setTipoProductoDivSelected={props.setTipoProductoDivSelected}

                    inputs={props.inputs}
                    setInputs={props.setInputs}

                    //Tipo de Solicitud Actual
                    // tipoSolicitudActual={props.tipoSolicitudActual}
                    // setTipoSolicitudActual={props.setTipoSolicitudActual}
                    //Variables Autores y particiapntes
                    numeroIdParEvent={props.numeroIdParEvent}
                    setNumeroIdParEvent={props.setNumeroIdParEvent}
                    arrai={props.arrai}
                    setArrai={props.setArrai}

                    //Permisos de la solicitud
                    permisosDeLaSolicitud={props.permisosDeLaSolicitud}
                    setPermisosDeLaSolicitud={props.setPermisosDeLaSolicitud}

                     getError={props.getError}
                     errores={props.errores}
                     setErrores={props.setErrores}

                      //rol y modalidad
                    rolActive={props.rolActive}
                    setRolActive={props.setRolActive}

                    modalidadParticipacionActive={props.modalidadParticipacionActive}
                    setModalidadParticipacionActive={props.setModalidadParticipacionActive}

                    fechaRegistroEmpresaCultural={props.fechaRegistroEmpresaCultural}
                    setFechaRegistroEmpresaCultural={props.setFechaRegistroEmpresaCultural}

                    otroTipoEspacioEvento={props.otroTipoEspacioEvento}
                    setOtroTipoEspacioEvento={props.setOtroTipoEspacioEvento}

                    //formularios
                    tipoContenido={props.tipoContenido}
                    setTipoContenido={props.setTipoContenido}
                    tipoContenidoSelected={props.tipoContenidoSelected}
                    setTipoContenidoSelected={props.setTipoContenidoSelected}

                    tipoDesarrollo={props.tipoDesarrollo}
                    setTipoDesarrollo={props.setTipoDesarrollo}
                    tipoDesarrolloSelected={props.tipoDesarrolloSelected}
                    setTipoDesarrolloSelected={props.setTipoDesarrolloSelected}

                    tipoClase={props.tipoClase}
                    setTipoClase={props.setTipoClase}
                    tipoClaseSelected={props.tipoClaseSelected}
                    setTipoClaseSelected={props.setTipoClaseSelected}

                    idiomaArticulo={props.idiomaArticulo}
                    setIdiomaArticulo={props.setIdiomaArticulo}
                    idiomaArticuloSelected={props.idiomaArticuloSelected}
                    setIdiomaArticuloSelected={props.setIdiomaArticuloSelected}

                    medioVerificacion={props.medioVerificacion}
                    setMedioVerificacion={props.setMedioVerificacion}
                    medioVerificacionSelected={props.medioVerificacionSelected}
                    setMedioVerificacionSelected={props.setMedioVerificacionSelected}

                    generoLiterario={props.generoLiterario}
                    setGeneroLiterario={props.setGeneroLiterario}
                    generoLiterarioSelected={props.generoLiterarioSelected}
                    setGeneroLiterarioSelected={props.setGeneroLiterarioSelected}

                    fecha={props.fecha}
                    setFecha={props.setFecha}

                    fechaFinal={props.fechaFinal}
                    setFechaFinal={props.setFechaFinal}

                    ciudadesDivulgacion={props.ciudadesDivulgacion}
                    setCiudadesDivulgacion={props.setCiudadesDivulgacion}
                    ciudadesSelectedDivulgacion={props.ciudadesSelectedDivulgacion}
                    setCiudadesSelectedDivulgacion={props.setCiudadesSelectedDivulgacion}

                    publicoObjetivo={props.publicoObjetivo}
                    setPublicoObjetivo={props.setPublicoObjetivo}
                    publicoObjetivoSelected={props.publicoObjetivoSelected}
                    setPublicoObjetivoSelected={props.setPublicoObjetivoSelected}

                    rutaCirculacion={props.rutaCirculacion}
                    setRutaCirculacion={props.setRutaCirculacion}
                    rutaCirculacionSelected={props.rutaCirculacionSelected}
                    setRutaCirculacionSelected={props.setRutaCirculacionSelected}

                    acuerdoLicencia={props.acuerdoLicencia}
                    setAcuerdoLicencia={props.setAcuerdoLicencia}

                    adj_certificado2={props.adj_certificado2}
                    setAdj_certificado2={props.setAdj_certificado2}
                    adj_certificado_final2={props.adj_certificado_final2}
                    setAdj_certificado_final2={props.setAdj_certificado_final2}

                    adj_certificado3={props.adj_certificado3}
                    setAdj_certificado3={props.setAdj_certificado3}
                    adj_certificado_final3={props.adj_certificado_final3}
                    setAdj_certificado_final3={props.setAdj_certificado_final3}


                    tiposRoles={props.tiposRoles}
                    setTiposRoles={props.setTiposRoles}
                />
              </div>
            )}
          </div>
        </div>
    )
}

const GetStepContentTec = (props) => {
    switch (props.stepIndex) {
        case 0:
            return (
                <ModalProduccionTecForm1

                    cargando={props.cargando}
                    setCargando={props.setCargando}

                    tipoDeProductoTec={props.tipoDeProductoTec}
                    setTipoProductoTec={props.setTipoProductoTec}

                    tipoProductoTecSelected={props.tipoProductoTecSelected}
                    setTipoProductoTecSelected={props.setTipoProductoTecSelected}

                    inputs={props.inputs}
                    setInputs={props.setInputs}


                    //fechas para los formularios
                    fechaCreacionDiseñoIndus={props.fechaCreacionDiseñoIndus}
                    setFechaCreacionDiseñoIndus={props.setFechaCreacionDiseñoIndus}

                    fechaDesarrolloSoftware={props.fechaDesarrolloSoftware}
                    setFechaDesarrolloSoftware={props.setFechaDesarrolloSoftware}

                    fechaObtencionRegistroSoftware={props.fechaObtencionRegistroSoftware}
                    setFechaObtencionRegistroSoftware={props.setFechaObtencionRegistroSoftware}

                    fechaCreacionPrototipo={props.fechaCreacionPrototipo}
                    setFechaCreacionPrototipo={props.setFechaCreacionPrototipo}

                    fechaCreacionSignoDistintivo={props.fechaCreacionSignoDistintivo}
                    setFechaCreacionSignoDistintivo={props.setFechaCreacionSignoDistintivo}

                    fechaRegistroBaseTecno={props.fechaRegistroBaseTecno}
                    setFechaRegistroBaseTecno={props.setFechaRegistroBaseTecno}

                    fechaInnovacionProceServi={props.fechaInnovacionProceServi}
                    setFechaInnovacionProceServi={props.setFechaInnovacionProceServi}

                    fechaInnovacionGestionEmp={props.fechaInnovacionGestionEmp}
                    setFechaInnovacionGestionEmp={props.setFechaInnovacionGestionEmp}

                    fechaPresentacionObraProducto={props.fechaPresentacionObraProducto}
                    setFechaPresentacionObraProducto={props.setFechaPresentacionObraProducto}

                    fechaCreacionObraProducto={props.fechaCreacionObraProducto}
                    setFechaCreacionObraProducto={props.setFechaCreacionObraProducto}

                    fechaInicioEventoArtistico={props.fechaInicioEventoArtistico}
                    setFechaInicioEventoArtistico={props.setFechaInicioEventoArtistico}

                    fechaFinalEventoArtistico={props.fechaFinalEventoArtistico}
                    setFechaFinalEventoArtistico={props.setFechaFinalEventoArtistico}

                    fechaInicioTalleresCreacion={props.fechaInicioTalleresCreacion}
                    setFechaInicioTalleresCreacion={props.setFechaInicioTalleresCreacion}

                    fechaFinalTalleresCreacion={props.fechaFinalTalleresCreacion}
                    setFechaFinalTalleresCreacion={props.setFechaFinalTalleresCreacion}

                    productoTieneSelected={props.productoTieneSelected}
                    setProductoTieneSelected={props.setProductoTieneSelected}

                    inputsSelects={props.inputsSelects}
                    setInputsSelects={props.setInputsSelects}

                    fechaRegistroDiseñoPrototipoTiene={props.fechaRegistroDiseñoPrototipoTiene}
                    setFechaRegistroDiseñoPrototipoTiene={props.setFechaRegistroDiseñoPrototipoTiene}

                    tipoPrototipoSelected={props.tipoPrototipoSelected}
                    setTipoPrototipoSelected={props.setTipoPrototipoSelected}

                    otroTipoPrototipoSelected={props.otroTipoPrototipoSelected}
                    setOtroTipoPrototipoSelected={props.setOtroTipoPrototipoSelected}

                    tipoSoftwareSelected={props.tipoSoftwareSelected}
                    setTipoSoftwareSelected={props.setTipoSoftwareSelected}

                    otroTipoSoftwareSelected={props.otroTipoSoftwareSelected}
                    setOtroTipoSoftwareSelected={props.setOtroTipoSoftwareSelected}

                    tipoSignoDistintivoSelected={props.tipoSignoDistintivoSelected}
                    setTipoSignoDistintivoSelected={props.setTipoSignoDistintivoSelected}

                    tipoEmpresaSelected={props.tipoEmpresaSelected}
                    setTipoEmpresaSelected={props.setTipoEmpresaSelected}
                    
                    tipoProgramaSelected={props.tipoProgramaSelected}
                    setTipoProgramaSelected={props.setTipoProgramaSelected}

                    tipoDepartamentoSelected={props.tipoDepartamentoSelected}
                    setTipoDepartamentoSelected={props.setTipoDepartamentoSelected}

                    tipoInnovacionSelected={props.tipoInnovacionSelected}
                    setTipoInnovacionSelected={props.setTipoInnovacionSelected}

                    tipoEspacioEventoSelected={props.tipoEspacioEventoSelected}
                    setTipoEspacioEventoSelected={props.setTipoEspacioEventoSelected}

                    tipoDisciplinaAmbitoSelected={props.tipoDisciplinaAmbitoSelected}
                    setTipoDisciplinaAmbitoSelected={props.setTipoDisciplinaAmbitoSelected}

                    tipoAmbitoSelected={props.tipoAmbitoSelected}
                    setTipoAmbitoSelected={props.setTipoAmbitoSelected}

                    tipoRolSelected={props.tipoRolSelected}
                    setTipoRolSelected={props.setTipoRolSelected}

                    tipoEventoSelected={props.tipoEventoSelected}
                    setTipoEventoSelected={props.setTipoEventoSelected}

                    productoTiene={props.productoTiene}
                    setProductoTiene={props.setProductoTiene}

                    tiposDePrototipos={props.tiposDePrototipos}
                    setTiposDePrototipos={props.setTiposDePrototipos}

                    tiposDeSoftware={props.tiposDeSoftware}
                    setTiposDeSoftware={props.setTiposDeSoftware}

                    tiposSignoDistintivos={props.tiposSignoDistintivos}
                    setTiposSignoDistintivos={props.setTiposSignoDistintivos}

                    tiposEmpresas={props.tiposEmpresas}
                    setTiposEmpresas={props.setTiposEmpresas}

                    tiposProgramas={props.tiposProgramas}
                    setTiposProgramas={props.setTiposProgramas}

                    tiposDepartamentos={props.tiposDepartamentos}
                    setTiposDepartamentos={props.setTiposDepartamentos}

                    tiposInnovaciones={props.tiposInnovaciones}
                    setTiposInnovaciones={props.setTiposInnovaciones}

                    tiposEspacioEvento={props.tiposEspacioEvento}
                    setTiposEspacioEvento={props.setTiposEspacioEvento}

                    tiposDisciplinaAmbito={props.tiposDisciplinaAmbito}
                    setTiposDisciplinaAmbito={props.setTiposDisciplinaAmbito}

                    tiposAmbitos={props.tiposAmbitos}
                    setTiposAmbitos={props.setTiposAmbitos}

                    tiposRoles={props.tiposRoles}
                    setTiposRoles={props.setTiposRoles}

                    tiposEventos={props.tiposEventos}
                    setTiposEventos={props.setTiposEventos}

                    paisesTecTecno={props.paisesTecTecno}
                    setPaisesTecTecno={props.setPaisesTecTecno}

                    paisSelectedTecTecno={props.paisSelectedTecTecno}
                    setPaisSelectedTecTecno={props.setPaisSelectedTecTecno}
                    ciudadesTecTecno={props.ciudadesTecTecno}
                    setCiudadesTecTecno={props.setCiudadesTecTecno}
                    ciudadesSelectedTecTecno={props.ciudadesSelectedTecTecno}
                    setCiudadesSelectedTecTecno={props.setCiudadesSelectedTecTecno}

                    disponibilidadesTecTecno={props.disponibilidadesTecTecno}
                    setDisponibilidadesTecTecno={props.setDisponibilidadesTecTecno}
                    disponibilidadSelectedTecTecno={props.disponibilidadSelectedTecTecno}
                    setDisponibilidadSelectedTecTecno={props.setDisponibilidadSelectedTecTecno}

                    idiomaTecTecno={props.idiomaTecTecno}
                    setIdiomaTecTecno={props.setIdiomaTecTecno}
                    idiomaSelectedTecTecno={props.idiomaSelectedTecTecno}
                    setIdiomaSelectedTecTecno={props.setIdiomaSelectedTecTecno}

                    acuerdoLicencia={props.acuerdoLicencia}
                    setAcuerdoLicencia={props.setAcuerdoLicencia}

                    adj_certificado2={props.adj_certificado2}
                    setAdj_certificado2={props.setAdj_certificado2}

                    adj_certificado_final2={props.adj_certificado_final2}
                    setAdj_certificado_final2={props.setAdj_certificado_final2}

                    adj_certificado3={props.adj_certificado3}
                    setAdj_certificado3={props.setAdj_certificado3}

                    adj_certificado_final3={props.adj_certificado_final3}
                    setAdj_certificado_final3={props.setAdj_certificado_final3}

                    adj_certificado4={props.adj_certificado4}
                    setAdj_certificado4={props.setAdj_certificado4}

                    adj_certificado_final4={props.adj_certificado_final4}
                    setAdj_certificado_final4={props.setAdj_certificado_final4}

                    adj_certificado5={props.adj_certificado5}
                    setAdj_certificado5={props.setAdj_certificado5}

                    adj_certificado_final5={props.adj_certificado_final5}
                    setAdj_certificado_final5={props.setAdj_certificado_final5}
                    //Errores
                     getError={props.getError}
                     errores={props.errores}
                     setErrores={props.setErrores}

                    //rol y modalidad
                    rolActive={props.rolActive}
                    setRolActive={props.setRolActive}

                    fechaRegistroEmpresaCultural={props.fechaRegistroEmpresaCultural}
                    setFechaRegistroEmpresaCultural={props.setFechaRegistroEmpresaCultural}

                    otroTipoEspacioEvento={props.otroTipoEspacioEvento}
                    setOtroTipoEspacioEvento={props.setOtroTipoEspacioEvento}
                />
            )
        case 1:
            return (
                <ModalFormGestionAutores
                    tipoSolicitudActual={props.tipoSolicitudActual}
                    setTipoSolicitudActual={props.setTipoSolicitudActual}
                    //Variables Autores y Particiapntes
                    numeroIdParEvent={props.numeroIdParEvent}
                    setNumeroIdParEvent={props.setNumeroIdParEvent}
                    arrai={props.arrai}
                    setArrai={props.setArrai}

                    //Permisos de la solicitud
                    permisosDeLaSolicitud={props.permisosDeLaSolicitud}
                    setPermisosDeLaSolicitud={props.setPermisosDeLaSolicitud}

                    cargando={props.cargando}
                    setCargando={props.setCargando}

                    //rol y modalidad
                    rolActive={props.rolActive}
                    setRolActive={props.setRolActive}

                    modalidadParticipacionActive={props.modalidadParticipacionActive}
                    setModalidadParticipacionActive={props.setModalidadParticipacionActive}

                    tiposRoles={props.tiposRoles}
                    setTiposRoles={props.setTiposRoles}
                />
            )
    }
}
const GetStepContentDiv = (props) => {
    switch (props.stepIndex) {
        case 0:
            return (
                <ModalDivulgacionTecForm1

                    cargando={props.cargando}
                    setCargando={props.setCargando}

                    tipoDeProductoTec={props.tipoDeProductoTec}
                    setTipoProductoTec={props.setTipoProductoTec}

                    tipoProductoDivSelected={props.tipoProductoDivSelected}
                    setTipoProductoDivSelected={props.setTipoProductoDivSelected}

                    inputs={props.inputs}
                    setInputs={props.setInputs}

                    inputsSelects={props.inputsSelects}
                    setInputsSelects={props.setInputsSelects}

                    //formularios
                    tipoContenido={props.tipoContenido}
                    setTipoContenido={props.setTipoContenido}
                    tipoContenidoSelected={props.tipoContenidoSelected}
                    setTipoContenidoSelected={props.setTipoContenidoSelected}

                    tipoDesarrollo={props.tipoDesarrollo}
                    setTipoDesarrollo={props.setTipoDesarrollo}
                    tipoDesarrolloSelected={props.tipoDesarrolloSelected}
                    setTipoDesarrolloSelected={props.setTipoDesarrolloSelected}

                    tipoClase={props.tipoClase}
                    setTipoClase={props.setTipoClase}
                    tipoClaseSelected={props.tipoClaseSelected}
                    setTipoClaseSelected={props.setTipoClaseSelected}

                    idiomaArticulo={props.idiomaArticulo}
                    setIdiomaArticulo={props.setIdiomaArticulo}
                    idiomaArticuloSelected={props.idiomaArticuloSelected}
                    setIdiomaArticuloSelected={props.setIdiomaArticuloSelected}

                    medioVerificacion={props.medioVerificacion}
                    setMedioVerificacion={props.setMedioVerificacion}
                    medioVerificacionSelected={props.medioVerificacionSelected}
                    setMedioVerificacionSelected={props.setMedioVerificacionSelected}

                    generoLiterario={props.generoLiterario}
                    setGeneroLiterario={props.setGeneroLiterario}   
                    generoLiterarioSelected={props.generoLiterarioSelected} 
                    setGeneroLiterarioSelected={props.setGeneroLiterarioSelected}

                    fecha={props.fecha}
                    setFecha={props.setFecha}
                    
                    fechaFinal={props.fechaFinal}
                    setFechaFinal={props.setFechaFinal}

                    ciudadesDivulgacion={props.ciudadesDivulgacion}
                    setCiudadesDivulgacion={props.setCiudadesDivulgacion}
                    ciudadesSelectedDivulgacion={props.ciudadesSelectedDivulgacion}
                    setCiudadesSelectedDivulgacion={props.setCiudadesSelectedDivulgacion}

                    publicoObjetivo={props.publicoObjetivo}
                    setPublicoObjetivo={props.setPublicoObjetivo}
                    publicoObjetivoSelected={props.publicoObjetivoSelected}
                    setPublicoObjetivoSelected={props.setPublicoObjetivoSelected}

                    rutaCirculacion={props.rutaCirculacion}
                    setRutaCirculacion={props.setRutaCirculacion}
                    rutaCirculacionSelected={props.rutaCirculacionSelected}
                    setRutaCirculacionSelected={props.setRutaCirculacionSelected}

                    acuerdoLicencia={props.acuerdoLicencia}
                    setAcuerdoLicencia={props.setAcuerdoLicencia}

                    adj_certificado2={props.adj_certificado2}
                    setAdj_certificado2={props.setAdj_certificado2}
                    adj_certificado_final2={props.adj_certificado_final2}
                    setAdj_certificado_final2={props.setAdj_certificado_final2}

                    adj_certificado3={props.adj_certificado3}
                    setAdj_certificado3={props.setAdj_certificado3}
                    adj_certificado_final3={props.adj_certificado_final3}
                    setAdj_certificado_final3={props.setAdj_certificado_final3}

                    tiposRoles={props.tiposRoles}
                    setTiposRoles={props.setTiposRoles}

                    //Errores
                     getError={props.getError}
                     errores={props.errores}
                     setErrores={props.setErrores}

                    //rol y modalidad
                    rolActive={props.rolActive}
                    setRolActive={props.setRolActive}

                    fechaRegistroEmpresaCultural={props.fechaRegistroEmpresaCultural}
                    setFechaRegistroEmpresaCultural={props.setFechaRegistroEmpresaCultural}

                    otroTipoEspacioEvento={props.otroTipoEspacioEvento}
                    setOtroTipoEspacioEvento={props.setOtroTipoEspacioEvento}
                />
            )
        case 1:
            return (
                <ModalFormGestionAutores
                    tipoSolicitudActual={props.tipoSolicitudActual}
                    setTipoSolicitudActual={props.setTipoSolicitudActual}
                    //Variables Autores y Particiapntes
                    numeroIdParEvent={props.numeroIdParEvent}
                    setNumeroIdParEvent={props.setNumeroIdParEvent}
                    arrai={props.arrai}
                    setArrai={props.setArrai}

                    //Permisos de la solicitud
                    permisosDeLaSolicitud={props.permisosDeLaSolicitud}
                    setPermisosDeLaSolicitud={props.setPermisosDeLaSolicitud}

                    cargando={props.cargando}
                    setCargando={props.setCargando}

                    //rol y modalidad
                    rolActive={props.rolActive}
                    setRolActive={props.setRolActive}

                    modalidadParticipacionActive={props.modalidadParticipacionActive}
                    setModalidadParticipacionActive={props.setModalidadParticipacionActive}

                    tiposRoles={props.tiposRoles}
                    setTiposRoles={props.setTiposRoles}
                />
            )
    }
}
const ModalDivulgacionTecForm1 = (props) => {
    const classes = useStyles()
    const fileInput = React.createRef();
    React.useEffect(() => {
        if (props.tipoProductoDivSelected && props.tipoProductoDivSelected.codigo) {
            props.setCargando(true);
            obtenerPRODUCTO(props.tipoProductoDivSelected);
            
        }
    }, [props.tipoProductoDivSelected]);
    const handleOnchange = async (e) =>{

        if(e.target.name == "tipoContenidoSelected"){
            props.setTipoContenidoSelected(e.target.value)
            if(props.errores.length > 0){
                props.setErrores(props.errores.filter(er => er.llave != "tipoContenidoSelected"));
            }
        }else if(e.target.name == "tipoDesarrolloSelected"){
            props.setTipoDesarrolloSelected(e.target.value)
            if(props.errores.length > 0){
                props.setErrores(props.errores.filter(er => er.llave != "tipoDesarrolloSelected"));
            }
        }else if(e.target.name == "tipoClaseSelected"){
            props.setTipoClaseSelected(e.target.value)
            if(props.errores.length > 0){
                props.setErrores(props.errores.filter(er => er.llave != "tipoClaseSelected"));
            }
        }else if(e.target.name == "idiomaArticuloSelected"){
            props.setIdiomaArticuloSelected(e.target.value)
            if(props.errores.length > 0){
                props.setErrores(props.errores.filter(er => er.llave != "idiomaArticuloSelected"));
            }

        }else if(e.target.name == "medioVerificacionSelected"){
            props.setMedioVerificacionSelected(e.target.value)
            if(props.errores.length > 0){
                props.setErrores(props.errores.filter(er => er.llave != "medioVerificacionSelected"));
            }
        }else if(e.target.name == "generoLiterarioSelected"){
            props.setGeneroLiterarioSelected(e.target.value)
            if(props.errores.length > 0){
                props.setErrores(props.errores.filter(er => er.llave != "generoLiterarioSelected"));
            }
        }else if(e.target.name == "fecha"){
            props.setFecha(e.target.value)
            if(props.errores.length > 0){
                props.setErrores(props.errores.filter(er => er.llave != "fecha"));
            }
        }else if(e.target.name == "fechaFinal"){
            props.setFechaFinal(e.target.value)
            if(props.errores.length > 0){
                props.setErrores(props.errores.filter(er => er.llave != "fechaFinal"));
            }
        }else if (e.target.name == "acuerdoLicencia"){
            props.setAcuerdoLicencia(e.target.value)
            if (props.errores.length > 0){
                props.setErrores(props.errores.filter(er => er.llave != "acuerdoLicencia"));
            }
        }else if (e.target.name === "ciudadesSelectedDivulgacion") {
            props.setCiudadesSelectedDivulgacion(e.target.value)
            if (props.errores.length > 0) {
                props.setErrores(props.errores.filter(er => er.llave !== "ciudadesSelectedDivulgacion"));
            }
        }else if (e.target.name === "publicoObjetivoSelected") {
            props.setPublicoObjetivoSelected(e.target.value)
            if (props.errores.length > 0) {
                props.setErrores(props.errores.filter(er => er.llave !== "publicoObjetivoSelected"));
            }
        }else if (e.target.name === "rutaCirculacionSelected") {
            props.setRutaCirculacionSelected(e.target.value)
            if (props.errores.length > 0) {
                props.setErrores(props.errores.filter(er => er.llave !== "rutaCirculacionSelected"));
            }
        
        }else if (e.target.name === "adj_certificado2") {
                const file = e.target.files[0];
                if (file) {
                    props.setAdj_certificado2(file.name);          
                    props.setAdj_certificado_final2(file);         
                }
                if (props.errores.length > 0) {
                    props.setErrores(props.errores.filter(er => er.llave !== "adj_certificado2"));
                }
        }else if (e.target.name === "adj_certificado3") {
                const file = e.target.files[0];
                if (file) {
                    props.setAdj_certificado3(file.name);
                    props.setAdj_certificado_final3(file);
                }
                if (props.errores.length > 0) {
                    props.setErrores(props.errores.filter(er => er.llave !== "adj_certificado3"));
                }
        }else if (e.target.name === "adj_certificado4") {
                const file = e.target.files[0];
                if (file) {
                    props.setAdj_certificado4(file.name);          
                    props.setAdj_certificado_final4(file);         
                }
                if (props.errores.length > 0) {
                    props.setErrores(props.errores.filter(er => er.llave !== "adj_certificado4"));
                }
        }else if (e.target.name === "adj_certificado5") {
                const file = e.target.files[0];
                if (file) {
                    props.setAdj_certificado5(file.name);
                    props.setAdj_certificado_final5(file);
                }
                if (props.errores.length > 0) {
                    props.setErrores(props.errores.filter(er => er.llave !== "adj_certificado5"));
                }
        }else if(e.target.name == "ciudadesSelectedTecTecno"){
            props.setCiudadesSelectedTecTecno(e.target.value)
            if(props.errores.length > 0){
                props.setErrores(props.errores.filter(er => er.llave != "ciudadesSelectedTecTecno"));
            }
        
        }  
                let array = props.inputs.map((item) => {
                if (item.codigo == e.target.name) {
                    if (props.errores.length > 0) {
                        props.setErrores(props.errores.filter(er => er.llave !== e.target.name));
                        }
                    return {
                        ...item,
                        value: e.target.value
                    }
                }
                return item
            })
            props.setInputs(array)

            if (Array.isArray(props.inputsSelects)) {
            let arraySelects = props.inputsSelects.map((item) => {
                if (item.codigo == e.target.name) {
                    if (props.errores.length > 0) {
                    props.setErrores(props.errores.filter(er => er.llave !== e.target.name));
                    }
                    return {
                        ...item,
                        value: e.target.value
                    }
                }
                return item
            })
            props.setInputsSelects(arraySelects)
        }
    }


    const obtenerPRODUCTO = async (producto) =>{
        let permisos = await obtenerPermisosValor(producto.id);
        permisos = permisos.map(({ secundario }) => {
            return {
                id: secundario.id,
                label: secundario.nombre,
                codigo: secundario.codigo,
                error: props.errores,
                value: ''
            }
        });

        if(producto.codigo == "producciones_contenido_digital" || producto. codigo == "desarrollos_web" 
            || producto.codigo == 'produ_estra_contsytrasmedia'){
            await obtenerGenero()
            await obtenerCiudades()
            await obtenerPublico()
            await obtenerRuta()

        if(producto.codigo =="producciones_contenido_digital"){
            await obtenerTipo()
        }
        if (producto.codigo =="desarrollos_web"){
            await obtenerTipoDesarrollo()
            await obtenerComponente()
        }
        }
        if(producto.codigo == 'otro_articulo_publicado'){
                await obtenerIdiomas()
                await obtenerTipoClase()
            }
        if (producto.codigo == 'talleres_creacion'){
                await TipoEvento()
                await obtenerAmbitoTaller()
                await obtenerDistincion()
                await obtenerMecanismo()
            }
        if (producto.codigo == 'eventos_artisticos' ||producto.codigo == 'talleres_creacion'||
            producto.codigo =="evento_cientifico"){
            props.setRolActive(true)
            }else {
            props.setRolActive(false) 
        }

        if (producto.codigo =="evento_cientifico"){
            await TipoEventocientifico()
            await obtenerAmbitoTaller()
            await obtenerCiudades()
            await obtenerprodutoCientifico()
        }
        if (producto.codigo == "consultaria_cientifica_tecnologia"){
            await  obtenerTipoClaseCientifico()
            await  obtenerIdiomas()
            await  obtenerCiudades()
            await  obtenerDisponbilidad()
        }

        if (producto.codigo == "informe_tecnico"){
            await obtenerCiudades()
            await obtenerIdiomas()
            await obtenerDisponbilidad()
        }

        if (producto.codigo == "manuales_guiasespecializadas"){
            await obtenerCiudades()
            await obtenerAmbitoTaller()

        }

        props.setInputs(permisos)
        props.setCargando(false)
    }


    const obtenerCiudades = async () =>{
        let permisos = await Funciones.obtenerValores(Helper.CIUDADES)
        props.setCiudadesDivulgacion(permisos)
    }
    const obtenerIdiomas = async () =>{
        let permisos = await Funciones.obtenerValores(Helper.IDIOMAS)
        props.setIdiomaArticulo(permisos)
    }

    const obtenerTipoClase = async () =>{
        let permisos = await Funciones.obtenerValores(Helper.TIPO_CLASE)
        props.setTipoClase(permisos)
    }

    const obtenerTipoClaseCientifico = async () =>{
        let permisos = await Funciones.obtenerValores(Helper.TIPO_EVENTO_CIENTIFICO_TECNOLOGICA)
        props.setTipoClase(permisos)
    }

    const TipoEvento = async () =>{
        let permisos = await Funciones.obtenerValores(Helper.TIPO_TALLER_CREATIVO)
        props.setTipoClase(permisos)
    }

    const TipoEventocientifico = async () =>{
        let permisos = await Funciones.obtenerValores(Helper.TIPO_EVENTO_CIENTIFICO)
        props.setTipoClase(permisos)
    }

    const obtenerAmbitoTaller = async ()=> {
        let permisos = await Funciones.obtenerValores(Helper.AMBITO_INVESTIGACION)
        props.setIdiomaArticulo(permisos)
    }

    const obtenerTipo = async () =>{
        let permisos = await Funciones.obtenerValores(Helper.TIPO_CONTENIDODIGITAL)
        props.setTipoContenido(permisos)
    }
    const obtenerDisponbilidad = async () =>{
        let permisos = await Funciones.obtenerValores(Helper.TIPO_DISPONIBILIDAD_CIENTIFICA)
        props.setTipoContenido(permisos)
    }
    const obtenerTipoDesarrollo = async () =>{
        let permisos = await Funciones.obtenerValores(Helper.TIPO_DESARROLLO)
        props.setTipoDesarrollo(permisos)
    }

    const obtenerMecanismo = async () =>{
        let permisos = await Funciones.obtenerValores(Helper.MECANISMO)
        props.setTipoContenido(permisos)
    }
    const obtenerprodutoCientifico = async () =>{
        let permisos = await Funciones.obtenerValores(Helper.PRODUCTO_CIENTIFICO)
        props.setTipoContenido(permisos)
    }
    const obtenerDistincion = async () =>{
        let permisos = await Funciones.obtenerValores(Helper.DISTNCION)
        props.setTipoDesarrollo(permisos)
    }

     const obtenerGenero = async () =>{
        let permisos = await Funciones.obtenerValores(Helper.GENERO_LITERARIO)
        props.setGeneroLiterario(permisos)
    }

    const obtenerPublico = async () =>{
        let permisos = await Funciones.obtenerValores(Helper.PUBLICO_OBJETIVO)
        props.setPublicoObjetivo(permisos)
    }

    const obtenerRuta = async () =>{
        let permisos = await Funciones.obtenerValores(Helper.RUTA_CIRCULACION)
        props.setRutaCirculacion(permisos)
    }

    const obtenerComponente =async () =>{
        let permisos = await Funciones.obtenerValores(Helper.COMPONENTE_DIGITAL)
        props.setMedioVerificacion(permisos)
    }
    
    return (
        props.cargando == true ? <div> <TareasTerminadas imagen={emma_w} mensaje={'Cargando..'} widthImg='7%' marginTop='7%' /> <LinearProgress /></div> :
        <div>
            <Grid container spacing={3}>
                 {props.inputs.map((input, index) => (
                    <Grid item xs={12} key={index}>
                    <TextField
                        fullWidth
                        label={input.label}
                        name={input.codigo}
                        value={input.value || ""}
                        onChange={handleOnchange}
                        error={props.getError(input.codigo, props.errores).length > 0}
                        helperText={props.getError(input.codigo, props.errores)}
                    />
                    </Grid>
                ))}
                
                {(props.tipoProductoDivSelected.codigo === "producciones_contenido_digital" || props.tipoProductoDivSelected.codigo === "desarrollos_web" || props.tipoProductoDivSelected.codigo === 'produ_estra_contsytrasmedia' )&& (
                <React.Fragment>                  
                        <Grid item xs={12}>
                        <InputLabel htmlFor="age-native-simple">Genero Literario: </InputLabel>
                        <FormControl className={classes.formControl} fullWidth error = { props.getError('generoLiterarioSelected', props.errores).length > 0}>
                            <Select
                                value={props.generoLiterarioSelected}
                                displayEmpty
                                fullWidth
                                inputProps={{ 'aria-label': 'Without label' }}
                                onChange={handleOnchange}
                                name="generoLiterarioSelected"
                            >
                                <MenuItem value="">
                                    <em style={{color: "rgba(0, 0, 0, 0.54)"}}>{ `${props.generoLiterario.length} Generos a Elegir` }</em>
                                </MenuItem>
                                {props.generoLiterario.map((item, index) => (
                                <MenuItem key= { index } value = { item }>{`${item.nombre}`}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <FormHelperText>{ props.getError('generoLiterarioSelected', props.errores) }</FormHelperText>
                    </Grid>
                    <Grid item xs={12}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <Fragment>
                        <DatePicker
                            views={["year", "month"]}
                            label="Fecha:"
                            value={props.fecha}
                            fullWidth
                            onChange={props.setFecha}
                            format="yyyy/MM"
                        />
                        </Fragment>
                    </MuiPickersUtilsProvider>
                    </Grid>

                    <Grid item xs={12}>
                        <InputLabel htmlFor="age-native-simple">Ciudad: </InputLabel>
                        <FormControl className={classes.formControl} fullWidth error = { props.getError('ciudadesSelectedDivulgacion', props.errores).length > 0}>
                            <Select
                                value={props.ciudadesSelectedDivulgacion}
                                displayEmpty
                                fullWidth
                                inputProps={{ 'aria-label': 'Without label' }}
                                onChange={handleOnchange}
                                name="ciudadesSelectedDivulgacion"
                            >
                                <MenuItem value="">
                                    <em style={{color: "rgba(0, 0, 0, 0.54)"}}>{ `${props.ciudadesDivulgacion.length} Ciudades a Elegir` }</em>
                                </MenuItem>
                                {props.ciudadesDivulgacion.map((item, index) => (
                                <MenuItem key= { index } value = { item }>{`${item.nombre}`}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <FormHelperText>{ props.getError('ciudadesSelectedDivulgacion', props.errores) }</FormHelperText>
                    </Grid>

                    <Grid item xs={12}>
                        <InputLabel htmlFor="age-native-simple">Público Objetivo: </InputLabel>
                        <FormControl className={classes.formControl} fullWidth error = { props.getError('publicoObjetivoSelected', props.errores).length > 0}>
                            <Select
                                value={props.publicoObjetivoSelected}
                                displayEmpty
                                fullWidth
                                inputProps={{ 'aria-label': 'Without label' }}
                                onChange={handleOnchange}
                                name="publicoObjetivoSelected"
                            >
                                <MenuItem value="">
                                    <em style={{color: "rgba(0, 0, 0, 0.54)"}}>{ `${props.publicoObjetivo.length} Publico Objetivo a Elegir` }</em>
                                </MenuItem>
                                {props.publicoObjetivo.map((item, index) => (
                                <MenuItem key= { index } value = { item }>{`${item.nombre}`}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <FormHelperText>{ props.getError('publicoObjetivoSelected', props.errores) }</FormHelperText>
                    </Grid>
                    <Grid item xs={12}>
                        <InputLabel htmlFor="age-native-simple">Ruta Circulación: </InputLabel>
                        <FormControl className={classes.formControl} fullWidth error = { props.getError('rutaCirculacionSelected', props.errores).length > 0}>
                            <Select
                                value={props.rutaCirculacionSelected}
                                displayEmpty
                                fullWidth
                                inputProps={{ 'aria-label': 'Without label' }}
                                onChange={handleOnchange}
                                name="rutaCirculacionSelected"
                            >
                                <MenuItem value="">
                                    <em style={{color: "rgba(0, 0, 0, 0.54)"}}>{ `${props.rutaCirculacion.length} Ruta de circulación a Elegir` }</em>
                                </MenuItem>
                                {props.rutaCirculacion.map((item, index) => (
                                <MenuItem key= { index } value = { item }>{`${item.nombre}`}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <FormHelperText>{ props.getError('rutaCirculacionSelected', props.errores) }</FormHelperText>
                    </Grid>

                     <Grid item xs={12} className="oculto">
                        <TextField
                            ref={fileInput}
                            required
                            type="file"
                            id="adj_certificado2"
                            name="adj_certificado2"
                            label="Adjuntar Identificación"
                            fullWidth
                            autoComplete="billing address-line1"
                            onChange={handleOnchange}
                        />
                        </Grid>

                        <Grid item xs={12}>
                        <InputFile 
                            id="adj_certificado2"
                            label="Certificación de alianza estratégica para la producción y/o circulación del contenido"
                            name="adj_certificado2"
                            value={props.adj_certificado2} 
                            required={props.adj_certificado2} 
                            error={props.getError("adj_certificado2", props.errores) > 0}
                            helperText={props.getError("adj_certificado2", props.errores)}
                        />
                        </Grid>

                </React.Fragment>

                
                )}
                

                {props.tipoProductoDivSelected.codigo == "producciones_contenido_digital" ?
                    <Grid item xs={12}>
                    <InputLabel htmlFor="age-native-simple">Tipo: </InputLabel>
                    <FormControl
                        className={classes.formControl}
                        fullWidth
                        error={props.getError("tipoContenidoSelected", props.errores).length > 0}
                    >
                        <Select
                        value={props.tipoContenidoSelected}
                        displayEmpty
                        fullWidth
                        inputProps={{ "aria-label": "Without label" }}
                        onChange={handleOnchange}
                        name="tipoContenidoSelected"
                        >
                        <MenuItem value="">
                            <em style={{ color: "rgba(0, 0, 0, 0.54)" }}>
                            {`${props.tipoContenido.length} Opciones a Elegir`}
                            </em>
                        </MenuItem>
                        {props.tipoContenido.map((item, index) => (
                            <MenuItem key={index} value={item}>
                            {item.nombre}
                            </MenuItem>
                        ))}
                        </Select>
                    </FormControl>
                    <FormHelperText>
                        {props.getError("tipoContenidoSelected", props.errores)}
                    </FormHelperText>
                    </Grid>

                : ''}

                {props.tipoProductoDivSelected.codigo == "desarrollos_web" ?
                    <>
                    <Grid item xs={12}>
                    <InputLabel htmlFor="age-native-simple">Tipo: </InputLabel>
                    <FormControl
                        className={classes.formControl}
                        fullWidth
                        error={props.getError("tipoDesarrolloSelected", props.errores).length > 0}
                    >
                        <Select
                        value={props.tipoDesarrolloSelected}
                        displayEmpty
                        fullWidth
                        inputProps={{ "aria-label": "Without label" }}
                        onChange={handleOnchange}
                        name="tipoDesarrolloSelected"
                        >
                        <MenuItem value="">
                            <em style={{ color: "rgba(0, 0, 0, 0.54)" }}>
                            {`${props.tipoDesarrollo.length} Tipos desarrollos a Elegir`}
                            </em>
                        </MenuItem>
                        {props.tipoDesarrollo.map((item, index) => (
                            <MenuItem key={index} value={item}>
                            {item.nombre}
                            </MenuItem>
                        ))}
                        </Select>
                    </FormControl>
                    <FormHelperText>
                        {props.getError("tipoDesarrolloSelected", props.errores)}
                    </FormHelperText>
                    </Grid>

                    <Grid item xs={12}>
                    <InputLabel htmlFor="age-native-simple">Componente Digital: </InputLabel>
                    <FormControl
                        className={classes.formControl}
                        fullWidth
                        error={props.getError("medioverificacionSelected", props.errores).length > 0}
                    >
                        <Select
                        value={props.medioVerificacionSelected}
                        displayEmpty
                        fullWidth
                        inputProps={{ "aria-label": "Without label" }}
                        onChange={handleOnchange}
                        name="medioVerificacionSelected"
                        >
                        <MenuItem value="">
                            <em style={{ color: "rgba(0, 0, 0, 0.54)" }}>
                            {`${props.medioVerificacion.length} Componentes Digitales a Elegir`}
                            </em>
                        </MenuItem>
                        {props.medioVerificacion.map((item, index) => (
                            <MenuItem key={index} value={item}>
                            {item.nombre}
                            </MenuItem>
                        ))}
                        </Select>
                    </FormControl>
                    <FormHelperText>
                        {props.getError("medioVerificacionSelected", props.errores)}
                    </FormHelperText>
                    </Grid>

                    <Grid item xs={12} className="oculto">
                        <TextField
                            ref={fileInput}
                            required
                            type="file"
                            id="adj_certificado3"
                            name="adj_certificado3"
                            label="Adjuntar Identificación"
                            fullWidth
                            autoComplete="billing address-line1"
                            onChange={handleOnchange}
                        />
                        </Grid>

                        <Grid item xs={12}>
                        <InputFile 
                            id="adj_certificado3"
                            label="Wireframe o esquema de página o plano de pantalla"
                            name="adj_certificado3"
                            value={props.adj_certificado3} 
                            required={props.adj_certificado3} 
                            error={props.getError("adj_certificado3", props.errores) > 0}
                            helperText={props.getError("adj_certificado3", props.errores)}
                        />
                        </Grid>

                </>
                : ''}

                {props.tipoProductoDivSelected.codigo == "otro_articulo_publicado" ?
                <React.Fragment>                  
                        
                    <Grid item xs={12}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <Fragment>
                        <DatePicker
                            views={["year", "month"]}
                            label="Fecha:"
                            value={props.fecha}
                            fullWidth
                            onChange={props.setFecha}
                            format="yyyy/MM"
                        />
                        </Fragment>
                    </MuiPickersUtilsProvider>
                    </Grid>

                    <Grid item xs={12}>
                    <InputLabel htmlFor="age-native-simple">Tipo/Clase: </InputLabel>
                    <FormControl
                        className={classes.formControl}
                        fullWidth
                        error={props.getError("tipoClaseSelected", props.errores).length > 0}
                    >
                        <Select
                        value={props.tipoClaseSelected}
                        displayEmpty
                        fullWidth
                        inputProps={{ "aria-label": "Without label" }}
                        onChange={handleOnchange}
                        name="tipoClaseSelected"
                        >
                        <MenuItem value="">
                            <em style={{ color: "rgba(0, 0, 0, 0.54)" }}>
                            {`${props.tipoClase.length} Tipo/Clase a Elegir`}
                            </em>
                        </MenuItem>
                        {props.tipoClase.map((item, index) => (
                            <MenuItem key={index} value={item}>
                            {item.nombre}
                            </MenuItem>
                        ))}
                        </Select>
                    </FormControl>
                    <FormHelperText>
                        {props.getError("tipoClaseSelected", props.errores)}
                    </FormHelperText>
                    </Grid>
                    <Grid item xs={12}>
                        <InputLabel htmlFor="age-native-simple">Idioma: </InputLabel>
                        <FormControl className={classes.formControl} fullWidth error = { props.getError('idiomaArticuloSelected', props.errores).length > 0}>
                            <Select
                                value={props.idiomaArticuloSelected}
                                displayEmpty
                                fullWidth
                                inputProps={{ 'aria-label': 'Without label' }}
                                onChange={handleOnchange}
                                name="idiomaArticuloSelected"
                            >
                                <MenuItem value="">
                                    <em style={{color: "rgba(0, 0, 0, 0.54)"}}>{ `${props.idiomaArticulo.length} Idiomas a Elegir` }</em>
                                </MenuItem>
                                {props.idiomaArticulo.map((item, index) => (
                                <MenuItem key= { index } value = { item }>{`${item.nombre}`}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <FormHelperText>{ props.getError('idiomaArticuloSelected', props.errores) }</FormHelperText>
                    </Grid>


                </React.Fragment>
                
                : ''}

                {props.tipoProductoDivSelected.codigo == "talleres_creacion" ?
                <React.Fragment>                  
                        
                    <Grid item xs={12}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <Fragment>
                        <DatePicker
                            views={["year", "month", "day"]}
                            label="Fecha Inicio:"
                            value={props.fecha}
                            fullWidth
                            onChange={props.setFecha}
                            format="yyyy/MM/dd"
                        />
                        </Fragment>
                    </MuiPickersUtilsProvider>
                    </Grid>
                    <Grid item xs={12}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <Fragment>
                        <DatePicker
                            views={["year", "month", "day"]}
                            label="Fecha Final:"
                            value={props.fechaFinal}
                            fullWidth
                            onChange={props.setFechaFinal}
                            format="yyyy/MM/dd"
                        />
                        </Fragment>
                    </MuiPickersUtilsProvider>
                    </Grid>

                    <Grid item xs={12}>
                    <InputLabel htmlFor="age-native-simple">Tipo de Evento: </InputLabel>
                    <FormControl
                        className={classes.formControl}
                        fullWidth
                        error={props.getError("tipoClaseSelected", props.errores).length > 0}
                    >
                        <Select
                        value={props.tipoClaseSelected}
                        displayEmpty
                        fullWidth
                        inputProps={{ "aria-label": "Without label" }}
                        onChange={handleOnchange}
                        name="tipoClaseSelected"
                        >
                        <MenuItem value="">
                            <em style={{ color: "rgba(0, 0, 0, 0.54)" }}>
                            {`${props.tipoClase.length} Tipo evento a Elegir`}
                            </em>
                        </MenuItem>
                        {props.tipoClase.map((item, index) => (
                            <MenuItem key={index} value={item}>
                            {item.nombre}
                            </MenuItem>
                        ))}
                        </Select>
                    </FormControl>
                    <FormHelperText>
                        {props.getError("tipoClaseSelected", props.errores)}
                    </FormHelperText>
                    </Grid>
                    <Grid item xs={12}>
                        <InputLabel htmlFor="age-native-simple">Ámbito: </InputLabel>
                        <FormControl className={classes.formControl} fullWidth error = { props.getError('idiomaArticuloSelected', props.errores).length > 0}>
                            <Select
                                value={props.idiomaArticuloSelected}
                                displayEmpty
                                fullWidth
                                inputProps={{ 'aria-label': 'Without label' }}
                                onChange={handleOnchange}
                                name="idiomaArticuloSelected"
                            >
                                <MenuItem value="">
                                    <em style={{color: "rgba(0, 0, 0, 0.54)"}}>{ `${props.idiomaArticulo.length} Ambitos a Elegir` }</em>
                                </MenuItem>
                                {props.idiomaArticulo.map((item, index) => (
                                <MenuItem key= { index } value = { item }>{`${item.nombre}`}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <FormHelperText>{ props.getError('idiomaArticuloSelected', props.errores) }</FormHelperText>
                    </Grid>

                    <Grid item xs={12}>
                    <InputLabel htmlFor="age-native-simple">Distinción obtenida: </InputLabel>
                    <FormControl
                        className={classes.formControl}
                        fullWidth
                        error={props.getError("tipoContenidoSelected", props.errores).length > 0}
                    >
                        <Select
                        value={props.tipoContenidoSelected}
                        displayEmpty
                        fullWidth
                        inputProps={{ "aria-label": "Without label" }}
                        onChange={handleOnchange}
                        name="tipoContenidoSelected"
                        >
                        <MenuItem value="">
                            <em style={{ color: "rgba(0, 0, 0, 0.54)" }}>
                            {`${props.tipoContenido.length} Distinciones a Elegir`}
                            </em>
                        </MenuItem>
                        {props.tipoContenido.map((item, index) => (
                            <MenuItem key={index} value={item}>
                            {item.nombre}
                            </MenuItem>
                        ))}
                        </Select>
                    </FormControl>
                    <FormHelperText>
                        {props.getError("tipoContenidoSelected", props.errores)}
                    </FormHelperText>
                    </Grid>

                    <Grid item xs={12}>
                    <InputLabel htmlFor="age-native-simple">Mecanismo Selección: </InputLabel>
                    <FormControl
                        className={classes.formControl}
                        fullWidth
                        error={props.getError("tipoDesarrolloSelected", props.errores).length > 0}
                    >
                        <Select
                        value={props.tipoDesarrolloSelected}
                        displayEmpty
                        fullWidth
                        inputProps={{ "aria-label": "Without label" }}
                        onChange={handleOnchange}
                        name="tipoDesarrolloSelected"
                        >
                        <MenuItem value="">
                            <em style={{ color: "rgba(0, 0, 0, 0.54)" }}>
                            {`${props.tipoDesarrollo.length}  Mecanismos a Elegir`}
                            </em>
                        </MenuItem>
                        {props.tipoDesarrollo.map((item, index) => (
                            <MenuItem key={index} value={item}>
                            {item.nombre}
                            </MenuItem>
                        ))}
                        </Select>
                    </FormControl>
                    <FormHelperText>
                        {props.getError("tipoDesarrolloSelected", props.errores)}
                    </FormHelperText>
                    </Grid>

                    <Grid item xs={12} className="oculto">
                        <TextField
                            ref={fileInput}
                            required
                            type="file"
                            id="adj_certificado2"
                            name="adj_certificado2"
                            label="Adjuntar Identificación"
                            fullWidth
                            autoComplete="billing address-line1"
                            onChange={handleOnchange}
                        />
                        </Grid>

                        <Grid item xs={12}>
                        <InputFile 
                            id="adj_certificado2"
                            label="Certificado que haga explicita la participación del investigador en el taller o residencia"
                            name="adj_certificado2"
                            value={props.adj_certificado2} 
                            required={props.adj_certificado2} 
                            error={props.getError("adj_certificado2", props.errores) > 0}
                            helperText={props.getError("adj_certificado2", props.errores)}
                        />
                        </Grid>


                </React.Fragment>
                
                : ''}
                {props.tipoProductoDivSelected.codigo == "eventos_artisticos" ?
                <React.Fragment>                  
                        
                    <Grid item xs={12}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <Fragment>
                        <DatePicker
                            views={["year", "month", "day"]}
                            label="Fecha Inicio:"
                            value={props.fecha}
                            fullWidth
                            onChange={props.setFecha}
                            format="yyyy/MM/dd"
                        />
                        </Fragment>
                    </MuiPickersUtilsProvider>
                    </Grid>
                    <Grid item xs={12}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <Fragment>
                        <DatePicker
                            views={["year", "month", "day"]}
                            label="Fecha Final:"
                            value={props.fechaFinal}
                            fullWidth
                            onChange={props.setFechaFinal}
                            format="yyyy/MM/dd"
                        />
                        </Fragment>
                    </MuiPickersUtilsProvider>
                    </Grid>

                    <Grid item xs={12} className="oculto">
                        <TextField
                            ref={fileInput}
                            required
                            type="file"
                            id="adj_certificado2"
                            name="adj_certificado2"
                            label="Adjuntar Identificación"
                            fullWidth
                            autoComplete="billing address-line1"
                            onChange={handleOnchange}
                        />
                        </Grid>

                        <Grid item xs={12}>
                        <InputFile 
                            id="adj_certificado2"
                            label="Certificado que haga explicita la participación del investigador en el taller o residencia"
                            name="adj_certificado2"
                            value={props.adj_certificado2} 
                            required={props.adj_certificado2} 
                            error={props.getError("adj_certificado2", props.errores) > 0}
                            helperText={props.getError("adj_certificado2", props.errores)}
                        />
                        </Grid>


                </React.Fragment>
                
                : ''}
                {props.tipoProductoDivSelected.codigo == "evento_cientifico" ?
                <React.Fragment>
                    <Grid item xs={12}>
                        <FormControl 
                            fullWidth 
                            error={props.getError('acuerdoLicencia', props.errores).length > 0}>
                            <InputLabel id="acuerdo-licencia-label">¿Es un evento CUC?</InputLabel>
                            <Select
                            labelId="acuerdo-licencia-label"
                            id="acuerdoLicencia"
                            value={props.acuerdoLicencia}
                            onChange={handleOnchange}
                            name="acuerdoLicencia"
                            >
                            <MenuItem value="si">Sí</MenuItem>
                            <MenuItem value="no">No</MenuItem>
                            </Select>
                            <FormHelperText>
                            {props.getError('acuerdoLicencia', props.errores)}
                            </FormHelperText>
                        </FormControl>
                        </Grid>               
                        
                    <Grid item xs={12}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <Fragment>
                        <DatePicker
                            views={["year", "month", "day"]}
                            label="Fecha Inicio:"
                            value={props.fecha}
                            fullWidth
                            onChange={props.setFecha}
                            format="yyyy/MM/dd"
                        />
                        </Fragment>
                    </MuiPickersUtilsProvider>
                    </Grid>
                    <Grid item xs={12}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <Fragment>
                        <DatePicker
                            views={["year", "month", "day"]}
                            label="Fecha Final:"
                            value={props.fechaFinal}
                            fullWidth
                            onChange={props.setFechaFinal}
                            format="yyyy/MM/dd"
                        />
                        </Fragment>
                    </MuiPickersUtilsProvider>
                    </Grid>

                    <Grid item xs={12}>
                    <InputLabel htmlFor="age-native-simple">Tipo de Evento: </InputLabel>
                    <FormControl
                        className={classes.formControl}
                        fullWidth
                        error={props.getError("tipoClaseSelected", props.errores).length > 0}
                    >
                        <Select
                        value={props.tipoClaseSelected}
                        displayEmpty
                        fullWidth
                        inputProps={{ "aria-label": "Without label" }}
                        onChange={handleOnchange}
                        name="tipoClaseSelected"
                        >
                        <MenuItem value="">
                            <em style={{ color: "rgba(0, 0, 0, 0.54)" }}>
                            {`${props.tipoClase.length} Tipo evento a Elegir`}
                            </em>
                        </MenuItem>
                        {props.tipoClase.map((item, index) => (
                            <MenuItem key={index} value={item}>
                            {item.nombre}
                            </MenuItem>
                        ))}
                        </Select>
                    </FormControl>
                    <FormHelperText>
                        {props.getError("tipoClaseSelected", props.errores)}
                    </FormHelperText>
                    </Grid>
                    <Grid item xs={12}>
                        <InputLabel htmlFor="age-native-simple">Ámbito: </InputLabel>
                        <FormControl className={classes.formControl} fullWidth error = { props.getError('idiomaArticuloSelected', props.errores).length > 0}>
                            <Select
                                value={props.idiomaArticuloSelected}
                                displayEmpty
                                fullWidth
                                inputProps={{ 'aria-label': 'Without label' }}
                                onChange={handleOnchange}
                                name="idiomaArticuloSelected"
                            >
                                <MenuItem value="">
                                    <em style={{color: "rgba(0, 0, 0, 0.54)"}}>{ `${props.idiomaArticulo.length} Ambitos a Elegir` }</em>
                                </MenuItem>
                                {props.idiomaArticulo.map((item, index) => (
                                <MenuItem key= { index } value = { item }>{`${item.nombre}`}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <FormHelperText>{ props.getError('idiomaArticuloSelected', props.errores) }</FormHelperText>
                    </Grid>

                    <Grid item xs={12}>
                        <InputLabel htmlFor="age-native-simple">Ciudad: </InputLabel>
                        <FormControl className={classes.formControl} fullWidth error = { props.getError('ciudadesSelectedDivulgacion', props.errores).length > 0}>
                            <Select
                                value={props.ciudadesSelectedDivulgacion}
                                displayEmpty
                                fullWidth
                                inputProps={{ 'aria-label': 'Without label' }}
                                onChange={handleOnchange}
                                name="ciudadesSelectedDivulgacion"
                            >
                                <MenuItem value="">
                                    <em style={{color: "rgba(0, 0, 0, 0.54)"}}>{ `${props.ciudadesDivulgacion.length} Ciudades a Elegir` }</em>
                                </MenuItem>
                                {props.ciudadesDivulgacion.map((item, index) => (
                                <MenuItem key= { index } value = { item }>{`${item.nombre}`}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <FormHelperText>{ props.getError('ciudadesSelectedDivulgacion', props.errores) }</FormHelperText>
                    </Grid>

                    <Grid item xs={12}>
                    <InputLabel htmlFor="age-native-simple">Seleccione los productos realizados en este evento: </InputLabel>
                    <FormControl
                        className={classes.formControl}
                        fullWidth
                        error={props.getError("tipoContenidoSelected", props.errores).length > 0}
                    >
                        <Select
                        value={props.tipoContenidoSelected}
                        displayEmpty
                        fullWidth
                        inputProps={{ "aria-label": "Without label" }}
                        onChange={handleOnchange}
                        name="tipoContenidoSelected"
                        >
                        <MenuItem value="">
                            <em style={{ color: "rgba(0, 0, 0, 0.54)" }}>
                            {`${props.tipoContenido.length} Productos realizados en este evento a Elegir`}
                            </em>
                        </MenuItem>
                        {props.tipoContenido.map((item, index) => (
                            <MenuItem key={index} value={item}>
                            {item.nombre}
                            </MenuItem>
                        ))}
                        </Select>
                    </FormControl>
                    <FormHelperText>
                        {props.getError("tipoContenidoSelected", props.errores)}
                    </FormHelperText>
                    </Grid>

                    <Grid item xs={12} className="oculto">
                        <TextField
                            ref={fileInput}
                            required
                            type="file"
                            id="adj_certificado2"
                            name="adj_certificado2"
                            label="Adjuntar Identificación"
                            fullWidth
                            autoComplete="billing address-line1"
                            onChange={handleOnchange}
                        />
                        </Grid>

                        <Grid item xs={12}>
                        <InputFile 
                            id="adj_certificado2"
                            label="Certificado que haga explicita la participación del investigador en el taller o residencia"
                            name="adj_certificado2"
                            value={props.adj_certificado2} 
                            required={props.adj_certificado2} 
                            error={props.getError("adj_certificado2", props.errores) > 0}
                            helperText={props.getError("adj_certificado2", props.errores)}
                        />
                        </Grid>


                </React.Fragment>
                
                : ''}

                {props.tipoProductoDivSelected.codigo == "consultaria_cientifica_tecnologia" ?
                <React.Fragment>
        
                    <Grid item xs={12}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <Fragment>
                        <DatePicker
                            views={["year", "month"]}
                            label="Fecha Inicio:"
                            value={props.fecha}
                            fullWidth
                            onChange={props.setFecha}
                            format="yyyy/MM"
                        />
                        </Fragment>
                    </MuiPickersUtilsProvider>
                    </Grid>
                    <Grid item xs={12}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <Fragment>
                        <DatePicker
                            views={["year", "month"]}
                            label="Fecha Final:"
                            value={props.fechaFinal}
                            fullWidth
                            onChange={props.setFechaFinal}
                            format="yyyy/MM"
                        />
                        </Fragment>
                    </MuiPickersUtilsProvider>
                    </Grid>

                    <Grid item xs={12}>
                    <InputLabel htmlFor="age-native-simple">Tipo de Evento: </InputLabel>
                    <FormControl
                        className={classes.formControl}
                        fullWidth
                        error={props.getError("tipoClaseSelected", props.errores).length > 0}
                    >
                        <Select
                        value={props.tipoClaseSelected}
                        displayEmpty
                        fullWidth
                        inputProps={{ "aria-label": "Without label" }}
                        onChange={handleOnchange}
                        name="tipoClaseSelected"
                        >
                        <MenuItem value="">
                            <em style={{ color: "rgba(0, 0, 0, 0.54)" }}>
                            {`${props.tipoClase.length} Tipo evento a Elegir`}
                            </em>
                        </MenuItem>
                        {props.tipoClase.map((item, index) => (
                            <MenuItem key={index} value={item}>
                            {item.nombre}
                            </MenuItem>
                        ))}
                        </Select>
                    </FormControl>
                    <FormHelperText>
                        {props.getError("tipoClaseSelected", props.errores)}
                    </FormHelperText>
                    </Grid>
                    <Grid item xs={12}>
                        <InputLabel htmlFor="age-native-simple">Idioma: </InputLabel>
                        <FormControl className={classes.formControl} fullWidth error = { props.getError('idiomaArticuloSelected', props.errores).length > 0}>
                            <Select
                                value={props.idiomaArticuloSelected}
                                displayEmpty
                                fullWidth
                                inputProps={{ 'aria-label': 'Without label' }}
                                onChange={handleOnchange}
                                name="idiomaArticuloSelected"
                            >
                                <MenuItem value="">
                                    <em style={{color: "rgba(0, 0, 0, 0.54)"}}>{ `${props.idiomaArticulo.length} Idiomas a Elegir` }</em>
                                </MenuItem>
                                {props.idiomaArticulo.map((item, index) => (
                                <MenuItem key= { index } value = { item }>{`${item.nombre}`}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <FormHelperText>{ props.getError('idiomaArticuloSelected', props.errores) }</FormHelperText>
                    </Grid>

                    <Grid item xs={12}>
                        <InputLabel htmlFor="age-native-simple">Ciudad: </InputLabel>
                        <FormControl className={classes.formControl} fullWidth error = { props.getError('ciudadesSelectedDivulgacion', props.errores).length > 0}>
                            <Select
                                value={props.ciudadesSelectedDivulgacion}
                                displayEmpty
                                fullWidth
                                inputProps={{ 'aria-label': 'Without label' }}
                                onChange={handleOnchange}
                                name="ciudadesSelectedDivulgacion"
                            >
                                <MenuItem value="">
                                    <em style={{color: "rgba(0, 0, 0, 0.54)"}}>{ `${props.ciudadesDivulgacion.length} Ciudades a Elegir` }</em>
                                </MenuItem>
                                {props.ciudadesDivulgacion.map((item, index) => (
                                <MenuItem key= { index } value = { item }>{`${item.nombre}`}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <FormHelperText>{ props.getError('ciudadesSelectedDivulgacion', props.errores) }</FormHelperText>
                    </Grid>
                    <Grid item xs={12}>
                    <InputLabel htmlFor="age-native-simple">Disponibilidad: </InputLabel>
                    <FormControl
                        className={classes.formControl}
                        fullWidth
                        error={props.getError("tipoContenidoSelected", props.errores).length > 0}
                    >
                        <Select
                        value={props.tipoContenidoSelected}
                        displayEmpty
                        fullWidth
                        inputProps={{ "aria-label": "Without label" }}
                        onChange={handleOnchange}
                        name="tipoContenidoSelected"
                        >
                        <MenuItem value="">
                            <em style={{ color: "rgba(0, 0, 0, 0.54)" }}>
                            {`${props.tipoContenido.length} Disponibilidades a Elegir`}
                            </em>
                        </MenuItem>
                        {props.tipoContenido.map((item, index) => (
                            <MenuItem key={index} value={item}>
                            {item.nombre}
                            </MenuItem>
                        ))}
                        </Select>
                    </FormControl>
                    <FormHelperText>
                        {props.getError("tipoContenidoSelected", props.errores)}
                    </FormHelperText>
                    </Grid>

                    <Grid item xs={12} className="oculto">
                        <TextField
                            ref={fileInput}
                            required
                            type="file"
                            id="adj_certificado2"
                            name="adj_certificado2"
                            label="Adjuntar Identificación"
                            fullWidth
                            autoComplete="billing address-line1"
                            onChange={handleOnchange}
                        />
                        </Grid>

                        <Grid item xs={12}>
                        <InputFile 
                            id="adj_certificado2"
                            label="Contrato o documento que soporta la realización de la consultoría"
                            name="adj_certificado2"
                            value={props.adj_certificado2} 
                            required={props.adj_certificado2} 
                            error={props.getError("adj_certificado2", props.errores) > 0}
                            helperText={props.getError("adj_certificado2", props.errores)}
                        />
                        </Grid>

                        <Grid item xs={12} className="oculto">
                        <TextField
                            ref={fileInput}
                            required
                            type="file"
                            id="adj_certificado3"
                            name="adj_certificado3"
                            label="Adjuntar Identificación"
                            fullWidth
                            autoComplete="billing address-line1"
                            onChange={handleOnchange}
                        />
                        </Grid>

                        <Grid item xs={12}>
                        <InputFile 
                            id="adj_certificado3"
                            label="Certificación sobre el objeto y la calidad de la consultoría prestada"
                            name="adj_certificado3"
                            value={props.adj_certificado3} 
                            required={props.adj_certificado3} 
                            error={props.getError("adj_certificado3", props.errores) > 0}
                            helperText={props.getError("adj_certificado3", props.errores)}
                        />
                        </Grid>

                </React.Fragment>
                
                : ''}

                {props.tipoProductoDivSelected.codigo == "informe_tecnico" ?
                <React.Fragment>
                    <Grid item xs={12}>
                        <InputLabel htmlFor="age-native-simple">Idioma: </InputLabel>
                        <FormControl className={classes.formControl} fullWidth error = { props.getError('idiomaArticuloSelected', props.errores).length > 0}>
                            <Select
                                value={props.idiomaArticuloSelected}
                                displayEmpty
                                fullWidth
                                inputProps={{ 'aria-label': 'Without label' }}
                                onChange={handleOnchange}
                                name="idiomaArticuloSelected"
                            >
                                <MenuItem value="">
                                    <em style={{color: "rgba(0, 0, 0, 0.54)"}}>{ `${props.idiomaArticulo.length} Idiomas a Elegir` }</em>
                                </MenuItem>
                                {props.idiomaArticulo.map((item, index) => (
                                <MenuItem key= { index } value = { item }>{`${item.nombre}`}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <FormHelperText>{ props.getError('idiomaArticuloSelected', props.errores) }</FormHelperText>
                    </Grid>

                    <Grid item xs={12}>
                        <InputLabel htmlFor="age-native-simple">Ciudad: </InputLabel>
                        <FormControl className={classes.formControl} fullWidth error = { props.getError('ciudadesSelectedDivulgacion', props.errores).length > 0}>
                            <Select
                                value={props.ciudadesSelectedDivulgacion}
                                displayEmpty
                                fullWidth
                                inputProps={{ 'aria-label': 'Without label' }}
                                onChange={handleOnchange}
                                name="ciudadesSelectedDivulgacion"
                            >
                                <MenuItem value="">
                                    <em style={{color: "rgba(0, 0, 0, 0.54)"}}>{ `${props.ciudadesDivulgacion.length} Ciudades a Elegir` }</em>
                                </MenuItem>
                                {props.ciudadesDivulgacion.map((item, index) => (
                                <MenuItem key= { index } value = { item }>{`${item.nombre}`}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <FormHelperText>{ props.getError('ciudadesSelectedDivulgacion', props.errores) }</FormHelperText>
                    </Grid>
                    <Grid item xs={12}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <Fragment>
                        <DatePicker
                            views={["year", "month"]}
                            label="Fecha:"
                            value={props.fecha}
                            fullWidth
                            onChange={props.setFecha}
                            format="yyyy/MM"
                        />
                        </Fragment>
                    </MuiPickersUtilsProvider>
                    </Grid>
                    <Grid item xs={12}>
                    <InputLabel htmlFor="age-native-simple">Disponibilidad: </InputLabel>
                    <FormControl
                        className={classes.formControl}
                        fullWidth
                        error={props.getError("tipoContenidoSelected", props.errores).length > 0}
                    >
                        <Select
                        value={props.tipoContenidoSelected}
                        displayEmpty
                        fullWidth
                        inputProps={{ "aria-label": "Without label" }}
                        onChange={handleOnchange}
                        name="tipoContenidoSelected"
                        >
                        <MenuItem value="">
                            <em style={{ color: "rgba(0, 0, 0, 0.54)" }}>
                            {`${props.tipoContenido.length} Disponibilidades a Elegir`}
                            </em>
                        </MenuItem>
                        {props.tipoContenido.map((item, index) => (
                            <MenuItem key={index} value={item}>
                            {item.nombre}
                            </MenuItem>
                        ))}
                        </Select>
                    </FormControl>
                    <FormHelperText>
                        {props.getError("tipoContenidoSelected", props.errores)}
                    </FormHelperText>
                    </Grid>

                    <Grid item xs={12} className="oculto">
                        <TextField
                            ref={fileInput}
                            required
                            type="file"
                            id="adj_certificado2"
                            name="adj_certificado2"
                            label="Adjuntar Identificación"
                            fullWidth
                            autoComplete="billing address-line1"
                            onChange={handleOnchange}
                        />
                        </Grid>

                        <Grid item xs={12}>
                        <InputFile 
                            id="adj_certificado2"
                            label="Certificación de la entidad Estatal que tomó como base el informe para la toma de decisiones"
                            name="adj_certificado2"
                            value={props.adj_certificado2} 
                            required={props.adj_certificado2} 
                            error={props.getError("adj_certificado2", props.errores) > 0}
                            helperText={props.getError("adj_certificado2", props.errores)}
                        />
                        </Grid>
                </React.Fragment>
                
                : ''}

                {props.tipoProductoDivSelected.codigo == "manuales_guiasespecializadas" ?
                <React.Fragment>

                    <Grid item xs={12}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <Fragment>
                        <DatePicker
                            views={["year", "month"]}
                            label="Año/Mes:"
                            value={props.fecha}
                            fullWidth
                            onChange={props.setFecha}
                            format="yyyy/MM"
                        />
                        </Fragment>
                    </MuiPickersUtilsProvider>
                    </Grid>

                    <Grid item xs={12}>
                        <InputLabel htmlFor="age-native-simple">Ciudad: </InputLabel>
                        <FormControl className={classes.formControl} fullWidth error = { props.getError('ciudadesSelectedDivulgacion', props.errores).length > 0}>
                            <Select
                                value={props.ciudadesSelectedDivulgacion}
                                displayEmpty
                                fullWidth
                                inputProps={{ 'aria-label': 'Without label' }}
                                onChange={handleOnchange}
                                name="ciudadesSelectedDivulgacion"
                            >
                                <MenuItem value="">
                                    <em style={{color: "rgba(0, 0, 0, 0.54)"}}>{ `${props.ciudadesDivulgacion.length} Ciudades a Elegir` }</em>
                                </MenuItem>
                                {props.ciudadesDivulgacion.map((item, index) => (
                                <MenuItem key= { index } value = { item }>{`${item.nombre}`}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <FormHelperText>{ props.getError('ciudadesSelectedDivulgacion', props.errores) }</FormHelperText>
                    </Grid>

                     <Grid item xs={12}>
                        <FormControl 
                            fullWidth 
                            error={props.getError('acuerdoLicencia', props.errores).length > 0}>
                            <InputLabel id="acuerdo-licencia-label">Medio divulgación:</InputLabel>
                            <Select
                            labelId="acuerdo-licencia-label"
                            id="acuerdoLicencia"
                            value={props.acuerdoLicencia}
                            onChange={handleOnchange}
                            name="acuerdoLicencia"
                            >
                            <MenuItem value="papel">Papel</MenuItem>
                            <MenuItem value="electrónico">Electrónico</MenuItem>
                            </Select>
                            <FormHelperText>
                            {props.getError('acuerdoLicencia', props.errores)}
                            </FormHelperText>
                        </FormControl>
                        </Grid>

                    <Grid item xs={12}>
                        <InputLabel htmlFor="age-native-simple">¿Cuál fue el medio de publicación del libro de manuales y guías especializadas de la Editorial?  </InputLabel>
                        <FormControl className={classes.formControl} fullWidth error = { props.getError('idiomaArticuloSelected', props.errores).length > 0}>
                            <Select
                                value={props.idiomaArticuloSelected}
                                displayEmpty
                                fullWidth
                                inputProps={{ 'aria-label': 'Without label' }}
                                onChange={handleOnchange}
                                name="idiomaArticuloSelected"
                            >
                                <MenuItem value="">
                                    <em style={{color: "rgba(0, 0, 0, 0.54)"}}>{ `${props.idiomaArticulo.length} medios a Elegir` }</em>
                                </MenuItem>
                                {props.idiomaArticulo.map((item, index) => (
                                <MenuItem key= { index } value = { item }>{`${item.nombre}`}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <FormHelperText>{ props.getError('idiomaArticuloSelected', props.errores) }</FormHelperText>
                    </Grid>
                    
                    <Grid item xs={12} className="oculto">
                        <TextField
                            ref={fileInput}
                            required
                            type="file"
                            id="adj_certificado2"
                            name="adj_certificado2"
                            label="Adjuntar Identificación"
                            fullWidth
                            autoComplete="billing address-line1"
                            onChange={handleOnchange}
                        />
                        </Grid>

                        <Grid item xs={12}>
                        <InputFile 
                            id="adj_certificado2"
                            label="Certificación emitida por el representante legal"
                            name="adj_certificado2"
                            value={props.adj_certificado2} 
                            required={props.adj_certificado2} 
                            error={props.getError("adj_certificado2", props.errores) > 0}
                            helperText={props.getError("adj_certificado2", props.errores)}
                        />
                        </Grid>
                </React.Fragment>
                
                : ''}


                </Grid>
        </div>
    )

}

const ModalProduccionTecForm1 = (props) => {
    const classes = useStyles()
    const fileInput = React.createRef();
    React.useEffect(() => {
        if (props.tipoProductoTecSelected && props.tipoProductoTecSelected.codigo) {
            props.setCargando(true);
            obtenerPRODUCTO(props.tipoProductoTecSelected);
        }
    }, [props.tipoProductoTecSelected]);
    const handleOnchange = async (e) =>{

        if(e.target.name == "productoTiene"){
            props.setCargando(true)
            props.setProductoTieneSelected(e.target.value)
            if(e.target.value != ""){
                let producto = e.target.value
                if(props.errores.length > 0){
                    props.setErrores(props.errores.filter(er => er.llave != "productoTiene"));
                }
                await obtenerPermisosInputExtra(producto)
            }else{
                if(props.errores.length > 0){
                    props.setErrores(props.errores.filter(er => er.llave != "productoTiene"));
                }
                props.setCargando(false)
            }
        }else if(e.target.name == "tipoPrototipoSelected"){
            props.setTipoPrototipoSelected(e.target.value)
            if(props.errores.length > 0){
                props.setErrores(props.errores.filter(er => er.llave != "tipoPrototipoSelected"));
            }
        }else if(e.target.name == "otroTipoEspacioEvento"){
            props.setOtroTipoEspacioEvento(e.target.value)
            if(props.errores.length > 0){
                props.setErrores(props.errores.filter(er => er.llave != "otroTipoEspacioEvento"));
            }
        }
        else if(e.target.name == "nombreOtroPrototipo"){
            props.setOtroTipoPrototipoSelected(e.target.value)
            if(props.errores.length > 0){
                props.setErrores(props.errores.filter(er => er.llave != "nombreOtroPrototipo"));
            }
        }else if(e.target.name == "tipoSoftwareSelected"){
            props.setTipoSoftwareSelected(e.target.value)
            if(props.errores.length > 0){
                props.setErrores(props.errores.filter(er => er.llave != "tipoSoftwareSelected"));
            }
        }else if(e.target.name == "tipoSignoDistintivoSelected"){
            props.setTipoSignoDistintivoSelected(e.target.value)
            if(props.errores.length > 0){
                props.setErrores(props.errores.filter(er => er.llave != "tipoSignoDistintivoSelected"));
            }
        }else if(e.target.name == "tipoEmpresaSelected"){
            props.setTipoEmpresaSelected(e.target.value)
            if(props.errores.length > 0){
                props.setErrores(props.errores.filter(er => er.llave != "tipoEmpresaSelected"));
            }
        }else if(e.target.name == "tipoInnovacionSelected"){
            props.setTipoInnovacionSelected(e.target.value)
            if(props.errores.length > 0){
                props.setErrores(props.errores.filter(er => er.llave != "tipoInnovacionSelected"));
            }
        }else if(e.target.name == "tipoEspacioEventoSelected"){
            props.setTipoEspacioEventoSelected(e.target.value)
            if(props.errores.length > 0){
                props.setErrores(props.errores.filter(er => er.llave != "tipoEspacioEventoSelected"));
            }
        }else if(e.target.name == "tipoDisciplinaAmbitoSelected"){
            props.setTipoDisciplinaAmbitoSelected(e.target.value)
            if(props.errores.length > 0){
                props.setErrores(props.errores.filter(er => er.llave != "tipoDisciplinaAmbitoSelected"));
            }
        }else if(e.target.name == "tipoAmbitoSelected"){
            props.setTipoAmbitoSelected(e.target.value)
            if(props.errores.length > 0){
                props.setErrores(props.errores.filter(er => er.llave != "tipoAmbitoSelected"));
            }
        }else if(e.target.name == "tipoEventoSelected"){
            props.setTipoEventoSelected(e.target.value)
            if(props.errores.length > 0){
                props.setErrores(props.errores.filter(er => er.llave != "tipoEventoSelected"));
            }
        }else if(e.target.name == "nombreOtroSoftware"){
            props.setOtroTipoSoftwareSelected(e.target.value)
            if(props.errores.length > 0){
                props.setErrores(props.errores.filter(er => er.llave != "nombreOtroSoftware"));
            }
        }else if(e.target.name == "paisSelectedTecTecno"){
            props.setPaisSelectedTecTecno(e.target.value)
            if(props.errores.length > 0){
                props.setErrores(props.errores.filter(er => er.llave != "paisSelectedTecTecno"));
            }
        }else if(e.target.name == "disponibilidadSelectedTecTecno"){
            props.setDisponibilidadSelectedTecTecno(e.target.value)
            if(props.errores.length > 0){
                props.setErrores(props.errores.filter(er => er.llave != "disponibilidadSelectedTecTecno"));
            }
        }else if(e.target.name == "idiomaSelectedTecTecno"){
            props.setIdiomaSelectedTecTecno(e.target.value)
            if(props.errores.length > 0){
                props.setErrores(props.errores.filter(er => er.llave != "idiomaSelectedTecTecno"));
            }
        }else if (e.target.name === "acuerdoLicencia") {
                props.setAcuerdoLicencia(e.target.value);
            if(props.errores.length > 0){
                props.setErrores(props.errores.filter(er => er.llave != "acuerdoLicencia"));
            }
        }else if (e.target.name === "adj_certificado2") {
                const file = e.target.files[0];
                if (file) {
                    props.setAdj_certificado2(file.name);          
                    props.setAdj_certificado_final2(file);         
                }
                if (props.errores.length > 0) {
                    props.setErrores(props.errores.filter(er => er.llave !== "adj_certificado2"));
                }
        }else if (e.target.name === "adj_certificado3") {
                const file = e.target.files[0];
                if (file) {
                    props.setAdj_certificado3(file.name);
                    props.setAdj_certificado_final3(file);
                }
                if (props.errores.length > 0) {
                    props.setErrores(props.errores.filter(er => er.llave !== "adj_certificado3"));
                }
        }else if (e.target.name === "adj_certificado4") {
                const file = e.target.files[0];
                if (file) {
                    props.setAdj_certificado4(file.name);          
                    props.setAdj_certificado_final4(file);         
                }
                if (props.errores.length > 0) {
                    props.setErrores(props.errores.filter(er => er.llave !== "adj_certificado4"));
                }
        }else if (e.target.name === "adj_certificado5") {
                const file = e.target.files[0];
                if (file) {
                    props.setAdj_certificado5(file.name);
                    props.setAdj_certificado_final5(file);
                }
                if (props.errores.length > 0) {
                    props.setErrores(props.errores.filter(er => er.llave !== "adj_certificado5"));
                }
        }else if(e.target.name == "ciudadesSelectedTecTecno"){
            props.setCiudadesSelectedTecTecno(e.target.value)
            if(props.errores.length > 0){
                props.setErrores(props.errores.filter(er => er.llave != "ciudadesSelectedTecTecno"));
            }
        
        }  
                let array = props.inputs.map((item)=>{
                        if(item.codigo == e.target.name){
                            item.value = e.target.value
                            if(props.errores.length > 0){
                                props.setErrores(props.errores.filter(er => er.llave != item.codigo));
                                // Elimina error cuando se escribe en el campo
                            }
                        }

                return item
            })

            let arraySelects = props.inputsSelects.map((item)=>{
                if(item.codigo == e.target.name){
                    item.value = e.target.value
                    if(props.errores.length > 0){
                        props.setErrores(props.errores.filter(er => er.llave != item.codigo));
                    }
                }

                return item
            })
            props.setInputs(array)
            props.setInputsSelects(arraySelects)    
    }

    const obtenerPRODUCTO = async (producto) =>{
        let permisos = await obtenerPermisosValor(producto.id);
        permisos = permisos.map(({ secundario }) => {
            return {
                id: secundario.id,
                label: secundario.nombre,
                codigo: secundario.codigo,
                error: props.errores,
                value: ''
            }
        });

        if(producto.codigo == "Inves_tipo_tec_pro_diseñoIndustrial" || producto.codigo == "Inves_tipo_tec_pro_prototipo"
        || producto.codigo == "Inves_tipo_tec_pro_eveArt"||producto.codigo == "Inves_tipo_tec_pro_innGenGesEmp"  || producto.codigo == "Inves_tipo_tec_pro_software" || producto.codigo == "Inves_tipo_tec_pro_innProProSer"){
            await obtenerProductoTiene()
            if(producto.codigo == "Inves_tipo_tec_pro_prototipo"){
                await obtenerTiposPrototipos()
                await obtenerDisponibilida()
            }
        }

        if(producto.codigo == "Inves_tipo_tec_pro_software"){
            await obtenerTiposSoftware()
            await obtenerDisponibilida()
        }else if(producto.codigo == "Inves_tipo_tec_pro_innProProSer"){
            await obtenerDisponibilida() 
        }else if(producto.codigo == "Inves_tipo_tec_pro_signo_distintivo"){
            await obtenerTiposSignoDistintivo()
        }else if(producto.codigo == "Inves_tipo_tec_pro_empBaseTec"){
            await obtenerTiposEmpresas()
        }else if(producto.codigo == "Inves_tipo_tec_pro_empCreaCul"){
            await obtenerTiposDisciplinaAmbito()
        }else if(producto.codigo == "Inves_tipo_tec_pro_innGenGesEmp"){
            await obtenerTiposInnovaciones()
            await obtenerDisponibilida()
            await obtenerIdiomas()
        }else if(producto.codigo == "Inves_tipo_tec_pro_obrPro"){
            await obtenerTiposEspacioEvento()
            await obtenerTiposDisciplinaAmbito()
            await obtenerTiposAmbitos()
            props.setRolActive(false)
        }else if(producto.codigo == "Inves_tipo_tec_pro_eveArt"){
            await obtenerTiposAmbitos()     
        }else if(producto.codigo == "Inves_tipo_tec_pro_talCre"){
            await obtenerTiposAmbitos()
            await obtenerTiposNormas()
        }



        props.setInputs(permisos)
        props.setCargando(false)
    }

    const obtenerProductoTiene = async () =>{
        let permisos = await Funciones.obtenerValores(Helper.DISEÑO_INDUSTRIAL_PROTOTIPO_TIENE)

        props.setProductoTiene(permisos)
    }

    const obtenerDisponibilida = async () =>{
        let permisos = await Funciones.obtenerValores(Helper.DISPONIBILIDAD)
        props.setDisponibilidadesTecTecno(permisos)
    }
    const obtenerIdiomas = async () =>{
        let permisos = await Funciones.obtenerValores(Helper.IDIOMAS)
        props.setIdiomaTecTecno(permisos)
    }

    const obtenerTiposPrototipos = async () =>{
        let permisos = await Funciones.obtenerValores(Helper.TIPOS_DE_PROTOTIPOS_INVESTIGACION)

        props.setTiposDePrototipos(permisos)
    }

    const obtenerTiposSoftware = async () =>{
        let permisos = await Funciones.obtenerValores(Helper.TIPOS_DE_SOFTWARE_INVESTIGACION)

        props.setTiposDeSoftware(permisos)
    }

    const obtenerTiposSignoDistintivo = async () =>{
        let permisos = await Funciones.obtenerValores(Helper.TIPO_SIGNO_DISTINTIVO_INVESTIGACION)

        props.setTiposSignoDistintivos(permisos)
    }

    const obtenerTiposEmpresas = async () =>{
        let permisos = await Funciones.obtenerValores(Helper.TIPO_DE_EMPRESA_INVESTIGACION)

        props.setTiposEmpresas(permisos)
    }

    const obtenerTiposInnovaciones = async () =>{
        let permisos = await Funciones.obtenerValores(Helper.TIPO_INNOVACION_EMP_INVESTIGACION)

        props.setTiposInnovaciones(permisos)
    }

    const obtenerTiposEspacioEvento = async () =>{
        let permisos = await Funciones.obtenerValores(Helper.TIPO_ESPACIO_EVENTO_INVESTIGACION)

        props.setTiposEspacioEvento(permisos)
    }

    const obtenerTiposDisciplinaAmbito = async () =>{
        let permisos = await Funciones.obtenerValores(Helper.TIPO_DISCIPLINA_AMBITO_INVESTIGACION)

        props.setTiposDisciplinaAmbito(permisos)
    }

    const obtenerTiposAmbitos = async () =>{
        let permisos = await Funciones.obtenerValores(Helper.TIPO_AMBITO_INVESTIGACION)

        props.setTiposAmbitos(permisos)
    }

    const obtenerTiposNormas = async () =>{
        let permisos = await Funciones.obtenerValores(Helper.TIPO_NORMA)

        props.setTiposEventos(permisos)
    }

    const obtenerPermisosInputExtra = async (producto) =>{
        let permisos = await obtenerPermisosValor(producto.id);
        permisos = permisos.map(({ secundario }) => {
            return {
                id: secundario.id,
                label: secundario.nombre,
                codigo: secundario.codigo,
                error: props.errores,
                value: ''
            }
        });

        props.setInputsSelects(permisos)
        props.setCargando(false)
    }

    return (
        props.cargando == true ? <div> <TareasTerminadas imagen={emma_w} mensaje={'Cargando..'} widthImg='7%' marginTop='7%' /> <LinearProgress /></div> :
        <div>
            <Grid container spacing={3}>
                
                {props.tipoProductoTecSelected.codigo == "Inves_tipo_tec_pro_obrPro" ?
                    <Grid item xs={12}>
                        <InputLabel htmlFor="age-native-simple">Tipo de espacio o evento: </InputLabel>
                        <FormControl className={classes.formControl} fullWidth error = { props.getError('tipoEspacioEventoSelected', props.errores).length > 0}>
                            <Select
                                value={props.tipoEspacioEventoSelected}
                                displayEmpty
                                fullWidth
                                inputProps={{ 'aria-label': 'Without label' }}
                                onChange={handleOnchange}
                                name="tipoEspacioEventoSelected"
                            >
                                <MenuItem value="">
                                    <em style={{color: "rgba(0, 0, 0, 0.54)"}}>{ `${props.tiposEspacioEvento.length} Opciones a Elegir` }</em>
                                </MenuItem>
                                {props.tiposEspacioEvento.map((item, index) => (
                                <MenuItem key= { index } value = { item }>{`${item.nombre}`}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <FormHelperText>{ props.getError('tipoEspacioEventoSelected', props.errores) }</FormHelperText>
                    </Grid>

                : ''}

                {props.tipoEspacioEventoSelected.codigo == "Inves_tipo_espaEven_otro" ?
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label='Nombre del Otro Espacio o Evento'
                            error = { props.getError('otroTipoEspacioEvento', props.errores).length > 0}
                            helperText = { props.getError('otroTipoEspacioEvento', props.errores) }
                            value={props.otroTipoEspacioEvento}
                            onChange={handleOnchange}
                            name='otroTipoEspacioEvento'
                        />
                    </Grid>
                :''}

                {props.tipoProductoTecSelected.codigo == "Inves_tipo_tec_pro_obrPro" || props.tipoProductoTecSelected.codigo == "Inves_tipo_tec_pro_empCreaCul"?
                    <Grid item xs={12}>
                        <InputLabel htmlFor="age-native-simple">Disciplina o Ambito de Origen: </InputLabel>
                        <FormControl className={classes.formControl} fullWidth error = { props.getError('tipoDisciplinaAmbitoSelected', props.errores).length > 0}>
                            <Select
                                value={props.tipoDisciplinaAmbitoSelected}
                                displayEmpty
                                fullWidth
                                inputProps={{ 'aria-label': 'Without label' }}
                                onChange={handleOnchange}
                                name="tipoDisciplinaAmbitoSelected"
                            >
                                <MenuItem value="">
                                    <em style={{color: "rgba(0, 0, 0, 0.54)"}}>{ `${props.tiposDisciplinaAmbito.length} Opciones a Elegir` }</em>
                                </MenuItem>
                                {props.tiposDisciplinaAmbito.map((item, index) => (
                                <MenuItem key= { index } value = { item }>{`${item.nombre}`}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <FormHelperText>{ props.getError('tipoDisciplinaAmbitoSelected', props.errores) }</FormHelperText>
                    </Grid>

                : ''}

                {props.tipoProductoTecSelected.codigo == "Inves_tipo_tec_pro_talCre"?
                    <Grid item xs={12}>
                        <InputLabel htmlFor="age-native-simple">Tipo: </InputLabel>
                        <FormControl className={classes.formControl} fullWidth error = { props.getError('tipoEventoSelected', props.errores).length > 0}>
                            <Select
                                value={props.tipoEventoSelected}
                                displayEmpty
                                fullWidth
                                inputProps={{ 'aria-label': 'Without label' }}
                                onChange={handleOnchange}
                                name="tipoEventoSelected"
                            >
                                <MenuItem value="">
                                    <em style={{color: "rgba(0, 0, 0, 0.54)"}}>{ `${props.tiposEventos.length} Opciones a Elegir` }</em>
                                </MenuItem>
                                {props.tiposEventos.map((item, index) => (
                                <MenuItem key= { index } value = { item }>{`${item.nombre}`}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <FormHelperText>{ props.getError('tipoEventoSelected', props.errores) }</FormHelperText>
                    </Grid>

                : ''}
                {props.tipoProductoTecSelected.codigo == "Inves_tipo_tec_pro_signo_distintivo"?
                    <Grid item xs={12}>
                        <InputLabel htmlFor="age-native-simple">Tipo signo Distintivo: </InputLabel>
                        <FormControl className={classes.formControl} fullWidth error = { props.getError('tipoSignoDistintivoSelected', props.errores).length > 0}>
                            <Select
                                value={props.tipoSignoDistintivoSelected}
                                displayEmpty
                                fullWidth
                                inputProps={{ 'aria-label': 'Without label' }}
                                onChange={handleOnchange}
                                name="tipoSignoDistintivoSelected"
                            >
                                <MenuItem value="">
                                    <em style={{color: "rgba(0, 0, 0, 0.54)"}}>{ `${props.tiposSignoDistintivos.length} Opciones a Elegir` }</em>
                                </MenuItem>
                                {props.tiposSignoDistintivos.map((item, index) => (
                                <MenuItem key= { index } value = { item }>{`${item.nombre}`}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <FormHelperText>{ props.getError('tipoSignoDistintivoSelected', props.errores) }</FormHelperText>
                    </Grid>

                : ''}

                {props.tipoProductoTecSelected.codigo == "Inves_tipo_tec_pro_obrPro"  || props.tipoProductoTecSelected.codigo == "Inves_tipo_tec_pro_talCre"?
                    <Grid item xs={12}>
                        <InputLabel htmlFor="age-native-simple">Ámbito: </InputLabel>
                        <FormControl className={classes.formControl} fullWidth error = { props.getError('tipoAmbitoSelected', props.errores).length > 0}>
                            <Select
                                value={props.tipoAmbitoSelected}
                                displayEmpty
                                fullWidth
                                inputProps={{ 'aria-label': 'Without label' }}
                                onChange={handleOnchange}
                                name="tipoAmbitoSelected"
                            >
                                <MenuItem value="">
                                    <em style={{color: "rgba(0, 0, 0, 0.54)"}}>{ `${props.tiposAmbitos.length} Opciones a Elegir` }</em>
                                </MenuItem>
                                {props.tiposAmbitos.map((item, index) => (
                                <MenuItem key= { index } value = { item }>{`${item.nombre}`}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <FormHelperText>{ props.getError('tipoAmbitoSelected', props.errores) }</FormHelperText>
                    </Grid>

                : ''}

                {props.tipoProductoTecSelected.codigo == "Inves_tipo_tec_pro_innGenGesEmp" ?
                    <Grid item xs={12}>
                        <InputLabel htmlFor="age-native-simple">Tipo de Innovacion: </InputLabel>
                        <FormControl className={classes.formControl} fullWidth error = { props.getError('tipoInnovacionSelected', props.errores).length > 0}>
                            <Select
                                value={props.tipoInnovacionSelected}
                                displayEmpty
                                fullWidth
                                inputProps={{ 'aria-label': 'Without label' }}
                                onChange={handleOnchange}
                                name="tipoInnovacionSelected"
                            >
                                <MenuItem value="">
                                    <em style={{color: "rgba(0, 0, 0, 0.54)"}}>{ `${props.tiposInnovaciones.length} Opciones a Elegir` }</em>
                                </MenuItem>
                                {props.tiposInnovaciones.map((item, index) => (
                                <MenuItem key= { index } value = { item }>{`${item.nombre}`}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <FormHelperText>{ props.getError('tipoInnovacionSelected', props.errores) }</FormHelperText>
                    </Grid>

                : ''}

                {props.tipoProductoTecSelected.codigo == "Inves_tipo_tec_pro_empBaseTec" ?
                    <Grid item xs={12}>
                        <InputLabel htmlFor="age-native-simple">Tipo de Empresa: </InputLabel>
                        <FormControl className={classes.formControl} fullWidth error = { props.getError('tipoEmpresaSelected', props.errores).length > 0}>
                            <Select
                                value={props.tipoEmpresaSelected}
                                displayEmpty
                                fullWidth
                                inputProps={{ 'aria-label': 'Without label' }}
                                onChange={handleOnchange}
                                name="tipoEmpresaSelected"
                            >
                                <MenuItem value="">
                                    <em style={{color: "rgba(0, 0, 0, 0.54)"}}>{ `${props.tiposEmpresas.length} Opciones a Elegir` }</em>
                                </MenuItem>
                                {props.tiposEmpresas.map((item, index) => (
                                <MenuItem key= { index } value = { item }>{`${item.nombre}`}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <FormHelperText>{ props.getError('tipoEmpresaSelected', props.errores) }</FormHelperText>
                    </Grid>

                : ''}

                {props.tipoSoftwareSelected.codigo == "Inves_tipo_software_otro" ?
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label='Nombre del Otro Software'
                            error = { props.getError('nombreOtroSoftware', props.errores).length > 0}
                            helperText = { props.getError('nombreOtroSoftware', props.errores) }
                            value={props.otroTipoSoftwareSelected}
                            onChange={handleOnchange}
                            name='nombreOtroSoftware'
                        />
                    </Grid>
                :''}

                {/* Tipo de prototipo */}
                {props.tipoProductoTecSelected.codigo == "Inves_tipo_tec_pro_prototipo"?
                    <Grid item xs={12}>
                        <InputLabel htmlFor="age-native-simple">Tipo de Prototipo: </InputLabel>
                        <FormControl className={classes.formControl} fullWidth error = { props.getError('tipoPrototipoSelected', props.errores).length > 0}>
                            <Select
                                value={props.tipoPrototipoSelected}
                                displayEmpty
                                fullWidth
                                inputProps={{ 'aria-label': 'Without label' }}
                                onChange={handleOnchange}
                                name="tipoPrototipoSelected"
                            >
                                <MenuItem value="">
                                    <em style={{color: "rgba(0, 0, 0, 0.54)"}}>{ `${props.tiposDePrototipos.length} Opciones a Elegir` }</em>
                                </MenuItem>
                                {props.tiposDePrototipos.map((item, index) => (
                                <MenuItem key= { index } value = { item }>{`${item.nombre}`}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <FormHelperText>{ props.getError('tipoPrototipoSelected', props.errores) }</FormHelperText>
                    </Grid>
                :''}

                {props.tipoProductoTecSelected.codigo == "Inves_tipo_tec_pro_empBaseTec"?
                        <Grid item xs={12}>
                        <FormControl 
                            fullWidth 
                            error={props.getError('acuerdoLicencia', props.errores).length > 0}>
                            <InputLabel id="acuerdo-licencia-label">¿Tiene productos en el mercado?</InputLabel>
                            <Select
                            labelId="acuerdo-licencia-label"
                            id="acuerdoLicencia"
                            value={props.acuerdoLicencia}
                            onChange={handleOnchange}
                            name="acuerdoLicencia"
                            >
                            <MenuItem value="si">Sí</MenuItem>
                            <MenuItem value="no">No</MenuItem>
                            </Select>
                            <FormHelperText>
                            {props.getError('acuerdoLicencia', props.errores)}
                            </FormHelperText>
                        </FormControl>
                        </Grid>
                    
                :''   }
                 {props.tipoProductoTecSelected.codigo == "Inves_tipo_tec_pro_empBaseTec"?
                   (
                    <>
                        <Grid item xs={12} className="oculto">
                        <TextField
                            ref={fileInput}
                            required
                            type="file"
                            id="adj_certificado2"
                            name="adj_certificado2"
                            label="Adjuntar Identificación"
                            fullWidth
                            autoComplete="billing address-line1"
                            onChange={handleOnchange}
                        />
                        </Grid>

                        <Grid item xs={12}>
                        <InputFile 
                            id="adj_certificado2"
                            label=" (Soporte) Certificación institucional describiendo el campo tecnológico de las empresas creadas"
                            name="adj_certificado2"
                            value={props.adj_certificado2} 
                            required={props.adj_certificado2} 
                            error={props.getError("adj_certificado2", props.errores) > 0}
                            helperText={props.getError("adj_certificado2", props.errores)}
                        />
                        </Grid>

                    </>
                    ) : null}
                 {props.tipoProductoTecSelected.codigo == "Inves_tipo_tec_pro_empCreaCul"?
                        <Grid item xs={12}>
                        <FormControl 
                            fullWidth 
                            error={props.getError('acuerdoLicencia', props.errores).length > 0}>
                            <InputLabel id="acuerdo-licencia-label">¿Tiene productos en el mercado?</InputLabel>
                            <Select
                            labelId="acuerdo-licencia-label"
                            id="acuerdoLicencia"
                            value={props.acuerdoLicencia}
                            onChange={handleOnchange}
                            name="acuerdoLicencia"
                            >
                            <MenuItem value="si">Sí</MenuItem>
                            <MenuItem value="no">No</MenuItem>
                            </Select>
                            <FormHelperText>
                            {props.getError('acuerdoLicencia', props.errores)}
                            </FormHelperText>
                        </FormControl>
                        </Grid>
                    
                :''   }
                {props.tipoProductoTecSelected.codigo == "Inves_tipo_tec_pro_empCreaCul"?
                   (
                    <>
                        <Grid item xs={12} className="oculto">
                        <TextField
                            ref={fileInput}
                            required
                            type="file"
                            id="adj_certificado2"
                            name="adj_certificado2"
                            label="Adjuntar Identificación"
                            fullWidth
                            autoComplete="billing address-line1"
                            onChange={handleOnchange}
                        />
                        </Grid>

                        <Grid item xs={12}>
                        <InputFile 
                            id="adj_certificado2"
                            label="Certificación institucional describiendo el campo creativo de la empresa creada"
                            name="adj_certificado2"
                            value={props.adj_certificado2} 
                            required={props.adj_certificado2} 
                            error={props.getError("adj_certificado2", props.errores) > 0}
                            helperText={props.getError("adj_certificado2", props.errores)}
                        />
                        </Grid>

                        <Grid item xs={12} className="oculto">
                        <TextField
                            ref={fileInput}
                            required
                            type="file"
                            id="adj_certificado3"
                            name="adj_certificado3"
                            label="Adjuntar Identificación"
                            fullWidth
                            autoComplete="billing address-line1"
                            onChange={handleOnchange}
                        />
                        </Grid>

                        <Grid item xs={12}>
                        <InputFile 
                            id="adj_certificado3"
                            label="Certificación de cámara de comercio"
                            name="adj_certificado3"
                            value={props.adj_certificado3} 
                            required={props.adj_certificado3} 
                            error={props.getError("adj_certificado3", props.errores) > 0}
                            helperText={props.getError("adj_certificado3", props.errores)}
                        />
                        </Grid>
                    </>
                    ) : null}

                {props.tipoProductoTecSelected.codigo == "Inves_tipo_tec_pro_diseñoIndustrial" || props.tipoProductoTecSelected.codigo == "Inves_tipo_tec_pro_eveArt"||props.tipoProductoTecSelected.codigo == "Inves_tipo_tec_pro_software"|| props.tipoProductoTecSelected.codigo == "Inves_tipo_tec_pro_prototipo" || props.tipoProductoTecSelected.codigo == "Inves_tipo_tec_pro_innGenGesEmp" || props.tipoProductoTecSelected.codigo == "Inves_tipo_tec_pro_innProProSer"?
                    <Grid item xs={12}>
                        <InputLabel htmlFor="age-native-simple">El Producto tiene: </InputLabel>
                        <FormControl className={classes.formControl} fullWidth error = { props.getError('productoTiene', props.errores).length > 0}>
                            <Select
                                value={props.productoTieneSelected}
                                displayEmpty
                                fullWidth
                                inputProps={{ 'aria-label': 'Without label' }}
                                onChange={handleOnchange}
                                name="productoTiene"
                            >
                                <MenuItem value="">
                                    <em style={{color: "rgba(0, 0, 0, 0.54)"}}>{ `${props.productoTiene.length} Opciones a Elegir` }</em>
                                </MenuItem>
                                {props.productoTiene.map((item, index) => (
                                <MenuItem key= { index } value = { item }>{`${item.nombre}`}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <FormHelperText>{ props.getError('productoTiene', props.errores) }</FormHelperText>
                    </Grid>
                : ''}

                 {props.tipoProductoTecSelected.codigo == "Inves_tipo_tec_pro_signo_distintivo"?
                   (
                    <>
                        <Grid item xs={12} className="oculto">
                        <TextField
                            ref={fileInput}
                            required
                            type="file"
                            id="adj_certificado2"
                            name="adj_certificado2"
                            label="Adjuntar Identificación"
                            fullWidth
                            autoComplete="billing address-line1"
                            onChange={handleOnchange}
                        />
                        </Grid>

                        <Grid item xs={12}>
                        <InputFile 
                            id="adj_certificado2"
                            label="Registro de superintendencia"
                            name="adj_certificado2"
                            value={props.adj_certificado2} 
                            required={props.adj_certificado2} 
                            error={props.getError("adj_certificado2", props.errores) > 0}
                            helperText={props.getError("adj_certificado2", props.errores)}
                        />
                        </Grid>

                    </>
                    ) : null}
                {props.tipoProductoTecSelected.codigo == "Inves_tipo_tec_pro_innProProSer"?
                   (
                    <>
                        <Grid item xs={12} className="oculto">
                        <TextField
                            ref={fileInput}
                            required
                            type="file"
                            id="adj_certificado2"
                            name="adj_certificado2"
                            label="Adjuntar Identificación"
                            fullWidth
                            autoComplete="billing address-line1"
                            onChange={handleOnchange}
                        />
                        </Grid>

                        <Grid item xs={12}>
                        <InputFile 
                            id="adj_certificado2"
                            label="Certificado de implementación en pequeñas, medianas y grandes empresas (expedido por el representante legal de la empresa)"
                            name="adj_certificado2"
                            value={props.adj_certificado2} 
                            required={props.adj_certificado2} 
                            error={props.getError("adj_certificado2", props.errores) > 0}
                            helperText={props.getError("adj_certificado2", props.errores)}
                        />
                        </Grid>

                    </>
                    ) : null}

                {props.tipoProductoTecSelected.codigo == "Inves_tipo_tec_pro_software"?
                   (
                    <>
                        <Grid item xs={12} className="oculto">
                        <TextField
                            ref={fileInput}
                            required
                            type="file"
                            id="adj_certificado2"
                            name="adj_certificado2"
                            label="Adjuntar Identificación"
                            fullWidth
                            autoComplete="billing address-line1"
                            onChange={handleOnchange}
                        />
                        </Grid>

                        <Grid item xs={12}>
                        <InputFile 
                            id="adj_certificado2"
                            label="Soporte entidad financiadora"
                            name="adj_certificado2"
                            value={props.adj_certificado2} 
                            required={props.adj_certificado2} 
                            error={props.getError("adj_certificado2", props.errores) > 0}
                            helperText={props.getError("adj_certificado2", props.errores)}
                        />
                        </Grid>

                        <Grid item xs={12} className="oculto">
                        <TextField
                            ref={fileInput}
                            required
                            type="file"
                            id="adj_certificado3"
                            name="adj_certificado3"
                            label="Adjuntar Identificación"
                            fullWidth
                            autoComplete="billing address-line1"
                            onChange={handleOnchange}
                        />
                        </Grid>

                        <Grid item xs={12}>
                        <InputFile 
                            id="adj_certificado3"
                            label="Soporte Informe Tecnico o avance final"
                            name="adj_certificado3"
                            value={props.adj_certificado3} 
                            required={props.adj_certificado3} 
                            error={props.getError("adj_certificado3", props.errores) > 0}
                            helperText={props.getError("adj_certificado3", props.errores)}
                        />
                        </Grid>
                    </>
                    ) : null}

                {props.tipoProductoTecSelected.codigo == "Inves_tipo_tec_pro_innGenGesEmp"?
                        <Grid item xs={12}>
                        <FormControl 
                            fullWidth 
                            error={props.getError('acuerdoLicencia', props.errores).length > 0}>
                            <InputLabel id="acuerdo-licencia-label">Tamaño de la empresa </InputLabel>
                            <Select
                            labelId="acuerdo-licencia-label"
                            id="acuerdoLicencia"
                            value={props.acuerdoLicencia}
                            onChange={handleOnchange}
                            name="acuerdoLicencia"
                            >
                            <MenuItem value="mediana y pequeña">Mediana Y Pequeña</MenuItem>
                            <MenuItem value="Grande">Grande</MenuItem>
                            </Select>
                            <FormHelperText>
                            {props.getError('acuerdoLicencia', props.errores)}
                            </FormHelperText>
                        </FormControl>
                        </Grid>
                    
                :''   }
                 {props.tipoProductoTecSelected.codigo == "Inves_tipo_tec_pro_innGenGesEmp"?
                   (
                    <>
                        <Grid item xs={12} className="oculto">
                        <TextField
                            ref={fileInput}
                            required
                            type="file"
                            id="adj_certificado2"
                            name="adj_certificado2"
                            label="Adjuntar Identificación"
                            fullWidth
                            autoComplete="billing address-line1"
                            onChange={handleOnchange}
                        />
                        </Grid>

                        <Grid item xs={12}>
                        <InputFile 
                            id="adj_certificado2"
                            label="Certificado de implementación expedido por representante legal"
                            name="adj_certificado2"
                            value={props.adj_certificado2} 
                            required={props.adj_certificado2} 
                            error={props.getError("adj_certificado2", props.errores) > 0}
                            helperText={props.getError("adj_certificado2", props.errores)}
                        />
                        </Grid>

                        <Grid item xs={12} className="oculto">
                        <TextField
                            ref={fileInput}
                            required
                            type="file"
                            id="adj_certificado3"
                            name="adj_certificado3"
                            label="Adjuntar Identificación"
                            fullWidth
                            autoComplete="billing address-line1"
                            onChange={handleOnchange}
                        />
                        </Grid>

                        <Grid item xs={12}>
                        <InputFile 
                            id="adj_certificado3"
                            label="Certificación del producto por parte de la entidad que pertenece al SNCT+I"
                            name="adj_certificado3"
                            value={props.adj_certificado3} 
                            required={props.adj_certificado3} 
                            error={props.getError("adj_certificado3", props.errores) > 0}
                            helperText={props.getError("adj_certificado3", props.errores)}
                        />
                        </Grid>
                        <Grid item xs={12} className="oculto">
                        <TextField
                            ref={fileInput}
                            required
                            type="file"
                            id="adj_certificado4"
                            name="adj_certificado4"
                            label="Adjuntar Identificación"
                            fullWidth
                            autoComplete="billing address-line1"
                            onChange={handleOnchange}
                        />
                        </Grid>

                        <Grid item xs={12}>
                        <InputFile 
                            id="adj_certificado4"
                            label="Documento especificando tamaño según la ley"
                            name="adj_certificado4"
                            value={props.adj_certificado4} 
                            required={props.adj_certificado4} 
                            error={props.getError("adj_certificado4", props.errores) > 0}
                            helperText={props.getError("adj_certificado4", props.errores)}
                        />
                        </Grid>

                        <Grid item xs={12} className="oculto">
                        <TextField
                            ref={fileInput}
                            required
                            type="file"
                            id="adj_certificado5"
                            name="adj_certificado5"
                            label="Adjuntar Identificación"
                            fullWidth
                            autoComplete="billing address-line1"
                            onChange={handleOnchange}
                        />
                        </Grid>

                        <Grid item xs={12}>
                        <InputFile 
                            id="adj_certificado5"
                            label="Certificación Registro tributario"
                            name="adj_certificado5"
                            value={props.adj_certificado5} 
                            required={props.adj_certificado5} 
                            error={props.getError("adj_certificado5", props.errores) > 0}
                            helperText={props.getError("adj_certificado5", props.errores)}
                        />
                        </Grid>
                    </>
                    ) : null}
                {props.tipoProductoTecSelected.codigo == "Inves_tipo_tec_pro_talCre"?
                   (
                    <>
                        <Grid item xs={12} className="oculto">
                        <TextField
                            ref={fileInput}
                            required
                            type="file"
                            id="adj_certificado2"
                            name="adj_certificado2"
                            label="Adjuntar Identificación"
                            fullWidth
                            autoComplete="billing address-line1"
                            onChange={handleOnchange}
                        />
                        </Grid>

                        <Grid item xs={12}>
                        <InputFile 
                            id="adj_certificado2"
                            label="Certificación de la Agencia Nacional del Espectro "
                            name="adj_certificado2"
                            value={props.adj_certificado2} 
                            required={props.adj_certificado2} 
                            error={props.getError("adj_certificado2", props.errores) > 0}
                            helperText={props.getError("adj_certificado2", props.errores)}
                        />
                        </Grid>

                        <Grid item xs={12} className="oculto">
                        <TextField
                            ref={fileInput}
                            required
                            type="file"
                            id="adj_certificado3"
                            name="adj_certificado3"
                            label="Adjuntar Identificación"
                            fullWidth
                            autoComplete="billing address-line1"
                            onChange={handleOnchange}
                        />
                        </Grid>

                        <Grid item xs={12}>
                        <InputFile 
                            id="adj_certificado3"
                            label="Certificado de entidad o institución que emitió el producto"
                            name="adj_certificado3"
                            value={props.adj_certificado3} 
                            required={props.adj_certificado3} 
                            error={props.getError("adj_certificado3", props.errores) > 0}
                            helperText={props.getError("adj_certificado3", props.errores)}
                        />
                        </Grid>
                        <Grid item xs={12} className="oculto">
                        <TextField
                            ref={fileInput}
                            required
                            type="file"
                            id="adj_certificado4"
                            name="adj_certificado4"
                            label="Adjuntar Identificación"
                            fullWidth
                            autoComplete="billing address-line1"
                            onChange={handleOnchange}
                        />
                        </Grid>

                        <Grid item xs={12}>
                        <InputFile 
                            id="adj_certificado4"
                            label="Certificación que soporta/garantiza que el investigador o el grupo participaron en la creación del producto"
                            name="adj_certificado4"
                            value={props.adj_certificado4} 
                            required={props.adj_certificado4} 
                            error={props.getError("adj_certificado4", props.errores) > 0}
                            helperText={props.getError("adj_certificado4", props.errores)}
                        />
                        </Grid>
                    </>
                    ) : null}
                {props.productoTieneSelected.codigo == "patenteDiseñoPrototipoTiene" || props.productoTieneSelected.codigo == "registroDiseñoPrototipoTiene" || props.productoTieneSelected.codigo == "secreEmpDiseñoPrototipoTiene"?
                    props.inputsSelects.map((item, index)=>{
                        if(item.codigo.includes('fecha')){
                            if(item.codigo == "fechaRegistroDiseñoPrototipoTiene"){
                                return(
                                    <Grid item xs={12} key={index}>
                                        <MuiPickersUtilsProvider utils={DateFnsUtils} >
                                            <Fragment>
                                            <KeyboardDatePicker
                                                required={true}                           
                                                style={{ marginTop: 3, width: '100%' }}
                                                format="yyyy/MM"
                                                margin="normal"
                                                label={item.label}
                                                value={props.fechaRegistroDiseñoPrototipoTiene}
                                                onChange={newDate => props.setFechaRegistroDiseñoPrototipoTiene(newDate)}
                                                name={item.codigo}
                                                fullWidth
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change date',
                                                }}
                                                invalidDateMessage='Formato Invalido'

                                            />
                                            </Fragment>
                                        </MuiPickersUtilsProvider>
                                    </Grid>
                                )
                            }
                        }else{
                            return(
                                <Grid item xs={12}>
                                <TextField
                                fullWidth
                                label={item.label}
                                error = { props.getError(item.codigo, props.errores).length > 0}
                                helperText = { props.getError(item.codigo, props.errores) }
                                value={item.value}
                                onChange={handleOnchange}
                                name={item.codigo}
                                />
                                </Grid>
                            )
                        }

                    })
                : ''}

                {props.tipoProductoTecSelected.codigo != "" ?
                    props.inputs.map((item, index)=>{
                        if(item.codigo.includes('fecha')){
                            if(item.codigo == "fechaCreacion"){
                                return(
                                    <Grid item xs={12} key={index}>
                                        <MuiPickersUtilsProvider utils={DateFnsUtils} >
                                            <Fragment>
                                            <KeyboardDatePicker
                                                required={true}                           
                                                style={{ marginTop: 3, width: '100%' }}
                                                format="yyyy/MM"
                                                margin="normal"
                                                label={item.label}
                                                value={props.fechaCreacionDiseñoIndus}
                                                onChange={newDate => props.setFechaCreacionDiseñoIndus(newDate)}
                                                name={item.codigo}
                                                fullWidth
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change date',
                                                }}
                                                invalidDateMessage='Formato Invalido'
                                            />
                                            </Fragment>
                                        </MuiPickersUtilsProvider>
                                    </Grid>
                                )
                            }else if(item.codigo == "fechaDesarrolloSoftware"){
                                return(
                                    <Grid item xs={12} key={index}>
                                        <MuiPickersUtilsProvider utils={DateFnsUtils} >
                                            <Fragment>
                                            <KeyboardDatePicker
                                                required={true}                           
                                                style={{ marginTop: 3, width: '100%' }}
                                                format="yyyy/MM"
                                                margin="normal"
                                                label={item.label}
                                                value={props.fechaDesarrolloSoftware}
                                                onChange={newDate => props.setFechaDesarrolloSoftware(newDate)}
                                                name={item.codigo}
                                                fullWidth
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change date',
                                                }}
                                                invalidDateMessage='Formato Invalido'
                                            />
                                            </Fragment>
                                        </MuiPickersUtilsProvider>
                                    </Grid>
                                )
                            }else if(item.codigo == "fechaInicioTalleresCreacion"){
                                return(
                                    <Grid item xs={12} key={index}>
                                        <MuiPickersUtilsProvider utils={DateFnsUtils} >
                                            <Fragment>
                                            <KeyboardDatePicker
                                                required={true}                           
                                                style={{ marginTop: 3, width: '100%' }}
                                                format="yyyy/MM"
                                                margin="normal"
                                                label={item.label}
                                                value={props.fechaInicioTalleresCreacion}
                                                onChange={newDate => props.setFechaInicioTalleresCreacion(newDate)}
                                                name={item.codigo}
                                                fullWidth
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change date',
                                                }}
                                                invalidDateMessage='Formato Invalido'
                                            />
                                            </Fragment>
                                        </MuiPickersUtilsProvider>
                                    </Grid>
                                )
                            }else if(item.codigo == "fechaInicioEventoArtistico"){
                                return(
                                    <Grid item xs={12} key={index}>
                                        <MuiPickersUtilsProvider utils={DateFnsUtils} >
                                            <Fragment>
                                            <KeyboardDatePicker
                                                required={true}                           
                                                style={{ marginTop: 3, width: '100%' }}
                                                format="yyyy/MM"
                                                margin="normal"
                                                label={item.label}
                                                value={props.fechaInicioEventoArtistico}
                                                onChange={newDate => props.setFechaInicioEventoArtistico(newDate)}
                                                name={item.codigo}
                                                fullWidth
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change date',
                                                }}
                                                invalidDateMessage='Formato Invalido'
                                            />
                                            </Fragment>
                                        </MuiPickersUtilsProvider>
                                    </Grid>
                                )
                            }else if(item.codigo == "fechaObtencionRegistroSoftware"){
                                return(
                                    <Grid item xs={12} key={index}>
                                        <MuiPickersUtilsProvider utils={DateFnsUtils} >
                                            <Fragment>
                                            <KeyboardDatePicker
                                                required={true}                           
                                                style={{ marginTop: 3, width: '100%' }}
                                                format="yyyy/MM"
                                                margin="normal"
                                                label={item.label}
                                                value={props.fechaObtencionRegistroSoftware}
                                                onChange={newDate => props.setFechaObtencionRegistroSoftware(newDate)}
                                                name={item.codigo}
                                                fullWidth
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change date',
                                                }}
                                                invalidDateMessage='Formato Invalido'
                                            />
                                            </Fragment>
                                        </MuiPickersUtilsProvider>
                                    </Grid>
                                )
                            }else if(item.codigo == "fechaCreacionPrototipo"){
                                return(
                                    <Grid item xs={12} key={index}>
                                        <MuiPickersUtilsProvider utils={DateFnsUtils} >
                                            <Fragment>
                                            <KeyboardDatePicker
                                                required={true}                           
                                                style={{ marginTop: 3, width: '100%' }}
                                                format="yyyy/MM"
                                                margin="normal"
                                                label={item.label}
                                                value={props.fechaCreacionPrototipo}
                                                onChange={newDate => props.setFechaCreacionPrototipo(newDate)}
                                                name={item.codigo}
                                                fullWidth
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change date',
                                                }}
                                                invalidDateMessage='Formato Invalido'
                                            />
                                            </Fragment>
                                        </MuiPickersUtilsProvider>
                                    </Grid>
                                )
                            }else if(item.codigo == "fechaCreacionSignoDistintivo"){
                                return(
                                    <Grid item xs={12} key={index}>
                                        <MuiPickersUtilsProvider utils={DateFnsUtils} >
                                            <Fragment>
                                            <KeyboardDatePicker
                                                required={true}                           
                                                style={{ marginTop: 3, width: '100%' }}
                                                format="yyyy/MM"
                                                margin="normal"
                                                label={item.label}
                                                value={props.fechaCreacionSignoDistintivo}
                                                onChange={newDate => props.setFechaCreacionSignoDistintivo(newDate)}
                                                name={item.codigo}
                                                fullWidth
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change date',
                                                }}
                                                invalidDateMessage='Formato Invalido'
                                            />
                                            </Fragment>
                                        </MuiPickersUtilsProvider>
                                    </Grid>
                                )
                            }else if(item.codigo == "fechaRegistroEmpresaCultural"){
                                return(
                                    <Grid item xs={12} key={index}>
                                        <MuiPickersUtilsProvider utils={DateFnsUtils} >
                                            <Fragment>
                                            <KeyboardDatePicker
                                                required={true}                           
                                                style={{ marginTop: 3, width: '100%' }}
                                                format="MM/dd/yyyy"
                                                margin="normal"
                                                label={item.label}
                                                value={props.fechaRegistroEmpresaCultural}
                                                onChange={newDate => props.setFechaRegistroEmpresaCultural(newDate)}
                                                name={item.codigo}
                                                fullWidth
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change date',
                                                }}
                                                invalidDateMessage='Formato Invalido'
                                            />
                                            </Fragment>
                                        </MuiPickersUtilsProvider>
                                    </Grid>
                                )
                            }else if(item.codigo == "fechaRegistroBaseTecno"){
                                return(
                                    <Grid item xs={12} key={index}>
                                        <MuiPickersUtilsProvider utils={DateFnsUtils} >
                                            <Fragment>
                                            <KeyboardDatePicker
                                                required={true}                           
                                                style={{ marginTop: 3, width: '100%' }}
                                                format="MM/dd/yyyy"
                                                margin="normal"
                                                label={item.label}
                                                value={props.fechaRegistroBaseTecno}
                                                onChange={newDate => props.setFechaRegistroBaseTecno(newDate)}
                                                name={item.codigo}
                                                fullWidth
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change date',
                                                }}
                                                invalidDateMessage='Formato Invalido'
                                            />
                                            </Fragment>
                                        </MuiPickersUtilsProvider>
                                    </Grid>
                                )
                            }else if(item.codigo == "fechaInnovacionProceServi"){
                                return(
                                    <Grid item xs={12} key={index}>
                                        <MuiPickersUtilsProvider utils={DateFnsUtils} >
                                            <Fragment>
                                            <KeyboardDatePicker
                                                required={true}                           
                                                style={{ marginTop: 3, width: '100%' }}
                                                format="yyyy/MM"
                                                margin="normal"
                                                label={item.label}
                                                value={props.fechaInnovacionProceServi}
                                                onChange={newDate => props.setFechaInnovacionProceServi(newDate)}
                                                name={item.codigo}
                                                fullWidth
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change date',
                                                }}
                                                invalidDateMessage='Formato Invalido'
                                            />
                                            </Fragment>
                                        </MuiPickersUtilsProvider>
                                    </Grid>
                                )
                            }else if(item.codigo == "fechaInnovacionGestionEmp"){
                                return(
                                    <Grid item xs={12} key={index}>
                                        <MuiPickersUtilsProvider utils={DateFnsUtils} >
                                            <Fragment>
                                            <KeyboardDatePicker
                                                required={true}                           
                                                style={{ marginTop: 3, width: '100%' }}
                                                format="yyyy/MM"
                                                margin="normal"
                                                label={item.label}
                                                value={props.fechaInnovacionGestionEmp}
                                                onChange={newDate => props.setFechaInnovacionGestionEmp(newDate)}
                                                name={item.codigo}
                                                fullWidth
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change date',
                                                }}
                                                invalidDateMessage='Formato Invalido'
                                            />
                                            </Fragment>
                                        </MuiPickersUtilsProvider>
                                    </Grid>
                                )
                            }else if(item.codigo == "fechaPresentacionObraProducto"){
                                return(
                                    <Grid item xs={12} key={index}>
                                        <MuiPickersUtilsProvider utils={DateFnsUtils} >
                                            <Fragment>
                                            <KeyboardDatePicker
                                                required={true}                           
                                                style={{ marginTop: 3, width: '100%' }}
                                                format="MM/dd/yyyy"
                                                margin="normal"
                                                label={item.label}
                                                value={props.fechaPresentacionObraProducto}
                                                onChange={newDate => props.setFechaPresentacionObraProducto(newDate)}
                                                name={item.codigo}
                                                fullWidth
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change date',
                                                }}
                                                invalidDateMessage='Formato Invalido'
                                            />
                                            </Fragment>
                                        </MuiPickersUtilsProvider>
                                    </Grid>
                                )
                            }else if(item.codigo == "fechaCreacionObraProducto"){
                                return(
                                    <Grid item xs={12} key={index}>
                                        <MuiPickersUtilsProvider utils={DateFnsUtils} >
                                            <Fragment>
                                            <KeyboardDatePicker
                                                required={true}                           
                                                style={{ marginTop: 3, width: '100%' }}
                                                format="MM/dd/yyyy"
                                                margin="normal"
                                                label={item.label}
                                                value={props.fechaCreacionObraProducto}
                                                onChange={newDate => props.setFechaCreacionObraProducto(newDate)}
                                                name={item.codigo}
                                                fullWidth
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change date',
                                                }}
                                                invalidDateMessage='Formato Invalido'
                                            />
                                            </Fragment>
                                        </MuiPickersUtilsProvider>
                                    </Grid>
                                )

                            }

                        }if(item.codigo.includes('pais')){
                            return(<Grid item xs={12}>
                                <InputLabel htmlFor="age-native-simple">País</InputLabel>
                                    <FormControl className={classes.formControl} fullWidth error = { props.getError('paisSelectedTecTecno', props.errores).length > 0}>
                                        <Select
                                            value={props.paisSelectedTecTecno}
                                            displayEmpty
                                            fullWidth
                                            inputProps={{ 'aria-label': 'Without label' }}
                                            onChange={handleOnchange}
                                            name="paisSelectedTecTecno"
                                        >
                                            <MenuItem value="">
                                                <em style={{color: "rgba(0, 0, 0, 0.54)"}}>{ `${props.paisesTecTecno.length} Paises para Seleccionar` }</em>
                                            </MenuItem>
                                            {props.paisesTecTecno.map((item, index) => (
                                            <MenuItem key= { index } value = { item }>{`${item.nombre}`}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                <FormHelperText>{ props.getError('paisSelectedTecTecno', props.errores) }</FormHelperText>
                            </Grid> )
                        } else if(item.codigo.includes('disponibilidad')){
                            return(<Grid item xs={12}>
                                <InputLabel htmlFor="age-native-simple">Disponibilidad:</InputLabel>
                                    <FormControl className={classes.formControl} fullWidth error = { props.getError('disponibilidadSelectedTecTecno', props.errores).length > 0}>
                                        <Select
                                            value={props.disponibilidadSelectedTecTecno}
                                            displayEmpty
                                            fullWidth
                                            inputProps={{ 'aria-label': 'Without label' }}
                                            onChange={handleOnchange}
                                            name="disponibilidadSelectedTecTecno"
                                        >
                                            <MenuItem value="">
                                                <em style={{color: "rgba(0, 0, 0, 0.54)"}}>{ `${props.disponibilidadesTecTecno.length} Opciones Disponibles` }</em>
                                            </MenuItem>
                                            {props.disponibilidadesTecTecno.map((item, index) => (
                                            <MenuItem key= { index } value = { item }>{`${item.nombre}`}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                <FormHelperText>{ props.getError('disponibilidadSelectedTecTecno', props.errores) }</FormHelperText>
                            </Grid> )
                        }else if (item.codigo.includes('idioma')){
                            return(<Grid item xs={12}>
                                <InputLabel htmlFor="age-native-simple">Idioma:</InputLabel>
                                <FormControl className={classes.formControl} fullWidth error = { props.getError('idiomaSelectedTecTecno', props.errores).length > 0}>
                                        <Select
                                            value={props.idiomaSelectedTecTecno}
                                            displayEmpty
                                            fullWidth
                                            inputProps={{ 'aria-label': 'Without label' }}
                                            onChange={handleOnchange}
                                            name="idiomaSelectedTecTecno"
                                        >
                                            <MenuItem value="">
                                                <em style={{color: "rgba(0, 0, 0, 0.54)"}}>{ `${props.idiomaTecTecno.length} Opciones Disponibles` }</em>
                                            </MenuItem>
                                            {props.idiomaTecTecno.map((item, index) => (
                                            <MenuItem key= { index } value = { item }>{`${item.nombre}`}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                <FormHelperText>{ props.getError('idiomaSelectedTecTecno', props.errores) }</FormHelperText>
                            </Grid> )
                        }
                        else if(item.codigo.includes('ciudad')){
                            return(<Grid item xs={12}>
                                <InputLabel htmlFor="age-native-simple">Ciudad:</InputLabel>
                                    <FormControl className={classes.formControl} fullWidth error = { props.getError('ciudadesSelectedTecTecno', props.errores).length > 0}>
                                        <Select
                                            value={props.ciudadesSelectedTecTecno}
                                            displayEmpty
                                            fullWidth
                                            inputProps={{ 'aria-label': 'Without label' }}
                                            onChange={handleOnchange}
                                            name="ciudadesSelectedTecTecno"
                                        >
                                            <MenuItem value="">
                                                <em style={{color: "rgba(0, 0, 0, 0.54)"}}>{ `${props.ciudadesTecTecno.length} Ciudades para Seleccionar` }</em>
                                            </MenuItem>
                                            {props.ciudadesTecTecno.map((item, index) => (
                                            <MenuItem key= { index } value = { item }>{`${item.nombre}`}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                <FormHelperText>{ props.getError('ciudadesSelectedTecTecno', props.errores) }</FormHelperText>
                            </Grid> )
                        }
                        else{
                            return(
                                <Grid item xs={12} key={index}>
                                    <TextField
                                    fullWidth
                                    label={item.label}
                                    error = { props.getError(item.codigo, props.errores).length > 0}
                                    helperText = { props.getError(item.codigo, props.errores) }
                                    value={item.value}
                                    onChange={handleOnchange}
                                    name={item.codigo}
                                    />
                                </Grid>
                            )
                        }
                    })
                : ''}
            </Grid>
        </div>
    )

}

const ModalProduccionBibliografica = (props) => {

    const [tiposProductos, setTiposProductos] = React.useState([])
    const classes = useStyles()

    React.useEffect(() => {
        obtenerTiposDeProductos()
    }, [])

    const obtenerTiposDeProductos = async () => {
        try {
            let data = await Funciones.obtenerValores(Helper.TIPOS_DE_PROD_BIBLIO_INVES)
            setTiposProductos(data)
        } catch (err) {
            console.log(err)
        } finally {
            props.setCargandoProduBibliografico(false)
        }
    }

    if (props.cargandoProduBibliografico) {
        return (
            <div>
                <TareasTerminadas
                    imagen={emma_w}
                    mensaje={'Cargando..'}
                    widthImg='7%'
                    marginTop='7%'
                />
                <LinearProgress />
            </div>
        )
    }

    return (
        <Grid container direction={'row'} justify={'center'}>
            {tiposProductos.map((item) => (
                <Grid
                    key={item.codigo}
                    item xs={6} sm={8} md={2}
                    style={{ padding: '2% 2% 0% 2%' }}
                    onClick={() => props.handleClickChangeToFormBibliografia(item)}
                >
                    <Paper className={classes.color} elevation={8} square>
                        <Card
                            className={classes.color}
                            style={{ maxWidth: "100%", minHeight: '100px', cursor: 'pointer' }}
                            elevation={1}
                        >
                            <CardHeader
                                title={
                                    <Typography
                                        variant="body2"
                                        align="center"
                                        style={{
                                            fontWeight: "bold",
                                            minHeight: "60px",
                                            maxHeight: "60px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            textAlign: "center"
                                        }}
                                    >
                                        {item.valorc}
                                    </Typography>
                                }
                            />
                            <CardContent>
                                <Grid container direction={'row'} justify={'center'}>
                                    <Grid item xs={12} style={{ textAlign: 'center', height: "80px" }}>
                                        <img
                                            src={logonuevoconocimiento}
                                            style={{
                                                width: '80px',
                                                maxWidth: '100px',
                                                minWidth: '80px',
                                                height: "80px"
                                            }}
                                            alt='Imagen Tipo'
                                        />
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                    </Paper>
                </Grid>
            ))}
        </Grid>
    )
}

//Aqui estan los formularios de la parte de tipos de produccion bibliografica
const ModalProduccionBibliograficaForms = (props) =>{

    const classes = useStyles()
    const isInitialMount = React.useRef(true);
    //Tipo bibliografico Libro
    const [tiposLibros, setTiposLibros] = React.useState([])
    //Tipo bibliografico Capitulo Libro
    const [tiposLibrosCap, setTiposLibrosCap] = React.useState([])


    React.useEffect( () => {
        //Obtengo los prceosos activos de la persona activa.
        if(isInitialMount.current){
            isInitialMount.current = false
            const obtenerProcesos = async () => {
                await obtenerTiposDeLibros()
                await obtenerTiposDeCapitulosLibros()
                await obtenerTiposDePatentes()
                await obtenerPaises()
                await obtenerIdiomas()
                await obtenerCiudades2()
                await obtenerDisciplinas()
                await obtenerTipos()
                await obtenerDistincion()
                await obtenerAmbitos()
                await obtenermecanismos()
                await obtenerViasolicitud()
            }
            obtenerProcesos()
        }
    })
    const obtenermecanismos = async () =>{
        let permisos = await Funciones.obtenerValores(Helper.MECANISMO)

        props.setMecanismoSeleccion(permisos)
    }

    const obtenerAmbitos = async () =>{
        let permisos = await Funciones.obtenerValores(Helper.TIPO_AMBITO_INVESTIGACION)

        props.setTiposAmbitos(permisos)
    }

    const obtenerPaises= async () => {
        try{
            let data = await Funciones.obtenerValores(Helper.PAISES)
            props.setPaisesTipoArticulo(data)
            
        }catch(err){
          console.log(err)
        }
    }

    const obtenerTiposDeLibros = async () => {
        try{
            let data = await Funciones.obtenerValores(Helper.TIPO_DE_LIBRO_INVESTIGACION)
            setTiposLibros(data)
        }catch(err){
          console.log(err)
        }
    }

    const obtenerTiposDeCapitulosLibros = async () => {
        try{
            let data = await Funciones.obtenerValores(Helper.TIPO_DE_CAPITULO_LIBRO_INVESTIGACION)
            setTiposLibrosCap(data)
        }catch(err){
          console.log(err)
        }
    }

    const obtenerTiposDePatentes = async () => {
        try{
            let data = await Funciones.obtenerValores(Helper.TIPOS_DE_PATENTE_INVESTIGACION)
            props.setTipoPatente(data)

        }catch(err){
          console.log(err)
        }
    }

    const obtenerViasolicitud = async ()=> {
        try{
            let data= await Funciones.obtenerValores(Helper.VIA_SOLICITUDES)
            props.setviaSolicitud(data)
        }catch(err){
            console.log(err);
                    }
    }

    const obtenerCiudades2 = async (value) =>{
        try{
            let data = await Funciones.obtenerValores(Helper.CIUDADES)
            props.setCiudadesTipoArticulo(data)
            props.setCargandoGestionBibliografica(false)
        }catch(err){
          console.log(err)
        }
    }
    const obtenerDisciplinas = async () => {
        try {
            let data = await Funciones.obtenerValores(Helper.DISCIPLINAS);
            props.setDisciplina(data);  
            props.setCargandoGestionBibliografica(false);
        } catch (err) {
           console.log(err)
        }
    };
    const obtenerTipos = async () => {
        try {
            let data = await Funciones.obtenerValores(Helper.TIPO_ESPACIO);
            props.setTipoEspacio(data);  
            props.setCargandoGestionBibliografica(false);
        } catch (err) {
           console.log(err)
        }
    };

    const obtenerDistincion = async() => {
        try {
            let data = await Funciones.obtenerValores(Helper.DISTNCION);
            props.setDistincion(data);
            props.setCargandoGestionBibliografica(false);
        }catch (err){
            console.log(err)
        }
    }
    const obtenerIdiomas = async () => {
        try{
            let data = await Funciones.obtenerValores(Helper.IDIOMAS)
            props.setIdiomasTipoArticulo(data)
            props.setIdiomasLibro(data)
            props.setIdiomasCapituloLibro(data)
            props.setCargandoGestionBibliografica(false)
        }catch(err){
          console.log(err)
        }
    }

    return (
        <div className={classes.root}>
          <Stepper activeStep={props.hola} alternativeLabel>
            {props.steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
          <div>
          {/* Aqui es cuando el Stepper llega al final.*/}
            {props.hola === props.steps.length ? (
              <div>
                <Typography className={classes.instructions}>{props.hola}</Typography>
                <Button onClick={props.handleReset}>Reset</Button>
              </div>
            ) : (
              <div>
                <GetStepContentBiblio
                    //Control del Stepper
                    hola = {props.hola}
                    activeStepBiblio ={props.activeStepBiblio}
                    stepIndex = {props.hola}
                    //Tipo de Solicitud Actual
                    tipoSolicitudActual={props.tipoSolicitudActual}
                    setTipoSolicitudActual={props.setTipoSolicitudActual}
                    //Variables Autores y particiapntes
                    numeroIdParEvent={props.numeroIdParEvent}
                    setNumeroIdParEvent={props.setNumeroIdParEvent}
                    arrai={props.arrai}
                    setArrai={props.setArrai}
                    //Permisos de la solicitud
                    permisosDeLaSolicitud={props.permisosDeLaSolicitud}
                    setPermisosDeLaSolicitud={props.setPermisosDeLaSolicitud}
                    //Tipo de Articulo
                    tipoProduccionBiblio={props.tipoProduccionBiblio}
                    setTipoProduccionBiblio={props.setTipoProduccionBiblio}
        
                    tiposLibros={tiposLibros}
                    setTiposLibros={setTiposLibros}

                    cargando={props.cargandoGestionBibliografica}
                    setCargando={props.setCargandoGestionBibliografica}
                    //campos de tipo Articulo de produccion bibliografica
                    idiomasTipoArticulo={props.idiomasTipoArticulo}
                    setIdiomasTipoArticulo={props.setIdiomasTipoArticulo}

                    idiomaTipoArticuloSelected={props.idiomaTipoArticuloSelected}
                    setIdiomaTipoArticuloSelected={props.setIdiomaTipoArticuloSelected}
                    
                    CiudadesTipoArticulo={props.CiudadesTipoArticulo}
                    setCiudadesTipoArticulo={props.setCiudadesTipoArticulo}

                    CiudadesTipoArticuloSelected={props.CiudadesTipoArticuloSelected}
                    setCiudadesTipoArticuloSelected={props.setCiudadesTipoArticuloSelected}

                    tituloArticulo={props.tituloArticulo}
                    setTituloArticulo={props.setTituloArticulo}
                    
                    PaginaInicial={props.PaginaInicial}
                    setPaginaInicial={props.setPaginaInicial}

                    PaginaFinal={props.PaginaFinal}
                    setPaginaFinal={props.setPaginaFinal}

                    numeropaginas={props.numeropaginas}
                    setNumeropaginas={props.setNumeropaginas}

                    issn={props.issn}
                    setIssn={props.setIssn}

                    nombreRevista={props.nombreRevista}
                    setNombreRevista={props.setNombreRevista}

                    anioPublicacion={props.anioPublicacion}
                    setAnioPublicacion={props.setAnioPublicacion}

                    volumenRevista={props.volumenRevista}
                    setVolumenRevista={props.setVolumenRevista}

                    idioma={props.idioma}
                    setIdioma={props.setIdioma}

                    enlace={props.enlace}
                    setEnlace={props.setEnlace}

                    doi={props.doi}
                    setDoi={props.setDoi}

                    mediodivulgacion={props.mediodivulgacion}
                    setMediodivulgacion={props.setMediodivulgacion}
                    //campos de tipo libro de produccion bibliografica
                    idiomasLibro={props.idiomasLibro}
                    setIdiomasLibro={props.setIdiomasLibro}

                    idiomaLibroSelected={props.idiomaLibroSelected}
                    setIdiomaLibroSelected={props.setIdiomaLibroSelected}

                    tipoLibroSelected={props.tipoLibroSelected}
                    setTipoLibroSelected={props.setTipoLibroSelected}

                    tipoLibroOtro={props.tipoLibroOtro}
                    setTipoLibroOtro={props.setTipoLibroOtro}

                    tituloLibro={props.tituloLibro}
                    setTituloLibro={props.setTituloLibro}

                    isbnLibro={props.isbnLibro}
                    setIsbnLibro={props.setIsbnLibro}

                    mediopublicacionlibro={props.mediopublicacionlibro}
                    setMedioPublicacionLibro={props.setMedioPublicacionLibro}

                    editorialLibro={props.editorialLibro}
                    setEditorialLibro={props.setEditorialLibro}

                    anioPublicacionLibro={props.anioPublicacionLibro}
                    setAnioPublicacionLibro={props.setAnioPublicacionLibro}

                    paisPublicacionLibro={props.paisPublicacionLibro}
                    setPaisPublicacionLibro={props.setPaisPublicacionLibro}

                    idiomaLibro={props.idiomaLibro}
                    setIdiomaLibro={props.setIdiomaLibro}

                    volumenLibro={props.volumenLibro}
                    setVolumenLibro={props.setVolumenLibro}

                    numeroEdicionLibro={props.numeroEdicionLibro}
                    setNumeroEdicionLibro={props.setNumeroEdicionLibro}

                    //Campos de tipo Capitulo de Libro de produccion bibliografica
                    idiomasCapituloLibro={props.idiomasCapituloLibro}
                    setIdiomasCapituloLibro={props.setIdiomasCapituloLibro}

                    idiomaCapituloLibroSelected={props.idiomaCapituloLibroSelected}
                    setIdiomaCapituloLibroSelected={props.setIdiomaCapituloLibroSelected}

                    tiposLibrosCap={tiposLibrosCap}
                    setTiposLibrosCap={setTiposLibrosCap}

                    tipoLibroSelectedCap={props.tipoLibroSelectedCap}
                    setTipoLibroSelectedCap={props.setTipoLibroSelectedCap}

                    tipoLibroOtroCap={props.tipoLibroOtroCap}
                    setTipoLibroOtroCap={props.setTipoLibroOtroCap}

                    tituloCapLibro={props.tituloCapLibro}
                    setTituloCapLibro={props.setTituloCapLibro}

                    tituloLibroCap={props.tituloLibroCap}
                    setTituloLibroCap={props.setTituloLibroCap}

                    isbnLibroCap={props.isbnLibroCap}
                    setIsbnLibroCap={props.setIsbnLibroCap}

                    editorialLibroCap={props.editorialLibroCap}
                    setEditorialLibroCap={props.setEditorialLibroCap}

                    anioPublicacionLibroCap={props.anioPublicacionLibroCap}
                    setAnioPublicacionLibroCap={props.setAnioPublicacionLibroCap}

                    paisPublicacionLibroCap={props.paisPublicacionLibroCap}
                    setPaisPublicacionLibroCap={props.setPaisPublicacionLibroCap}

                    idiomaLibroCap={props.idiomaLibroCap}
                    setIdiomaLibroCap={props.setIdiomaLibroCap}

                    volumenLibroCap={props.volumenLibroCap}
                    setVolumenLibroCap={props.setVolumenLibroCap}

                    numeroEdicionLibroCap={props.numeroEdicionLibroCap}
                    setNumeroEdicionLibroCap={props.setNumeroEdicionLibroCap}

                    //Campos del tipo Obra producciom bibliografica
                    nombreObra={props.nombreObra}
                    setNombreObra={props.setNombreObra}

                    disciplina={props.disciplina}
                    setDisciplina={props.setDisciplina}
                    
                    disciplinaSelected = {props.disciplinaSelected}
                    setDisciplinaSelected = {props.setDisciplinaSelected}

                    tituloObraproducto={props.tituloObraproducto}
                    setTituloObraproducto={props.setTituloObraproducto}

                    tecnica={props.tecnica}
                    setTecnica={props.setTecnica}

                    nombreespacio={props.nombreespacio}
                    setNombreEspacio={props.setNombreEspacio}

                    tipoespacio={props.tipoespacio}
                    setTipoEspacio={props.setTipoEspacio}

                    tipoespacioSelected= {props.tipoespacioSelected}
                    settipoespacioSelected={props.settipoespacioSelected}

                    fechapresentacion={props.fechapresentacion}
                    setFechaPresentacion={props.setFechaPresentacion}

                    aniocreacionespacio={props.aniocreacionespacio}
                    setAniocreacionEspacio={props.setAniocreacionEspacio}

                    distincion={props.distincion}
                    setDistincion={props.setDistincion}

                    distincionSelected={props.distincionSelected}
                    setdistincionSelected={props.setdistincionSelected}

                    entidadconvocante={props.entidadconvocante}
                    setEntidadConvocante={props.setEntidadConvocante}

                    tipoAmbitoSelected={props.tipoAmbitoSelected}
                    setTipoAmbitoSelected={props.setTipoAmbitoSelected}

                    tiposAmbitos={props.tiposAmbitos}
                    setTiposAmbitos={props.setTiposAmbitos}

                    mecanismoseleccion={props.mecanismoseleccion}
                    setMecanismoSeleccion={props.setMecanismoSeleccion}

                    mecanismoSelected={props.mecanismoSelected}
                    setmecanismoSelected={props.setmecanismoSelected}

                    acuerdoLicencia={props.acuerdoLicencia}
                    setAcuerdoLicencia={props.setAcuerdoLicencia}

                    institucionlicencia={props.institucionlicencia}
                    setInstitucionLicencia={props.setInstitucionLicencia}

                    fechaotrogamiento={props.fechaotrogamiento}
                    setFechaOtorgamiento={props.setFechaOtorgamiento}

                    numeroregistro={props.numeroregistro}
                    setNumeroRegistro={props.setNumeroRegistro}

                    contratocomercializacion={props.contratocomercializacion}
                    setContratoComercializacion={props.setContratoComercializacion}

                    //Campos del tipo Patente de producion bibliografica
                    tipoPatente={props.tipoPatente}
                    setTipoPatente={props.setTipoPatente}

                    viaSolicitud={props.viaSolicitud}
                    setviaSolicitud={props.setviaSolicitud}

                    anioObtencionPatente={props.anioObtencionPatente}
                    setAnioObtencionPatente={props.setAnioObtencionPatente}

                    numeroRegistroPatente={props.numeroRegistroPatente}
                    setNumeroRegistroPatente={props.setNumeroRegistroPatente}

                    tituloPatente={props.tituloPatente}
                    setTituloPatente={props.setTituloPatente}

                    numeroPatente={props.numeroPatente}
                    setNumeroPatente={props.setNumeroPatente}

                    nombreSolicitante={props.nombreSolicitante}
                    setnombreSolicitante={props.setnombreSolicitante}

                    paisObtencionPatente={props.paisObtencionPatente}
                    setPaisObtencionPatente={props.setPaisObtencionPatente}

                    gacetaIndustrialPatente={props.gacetaIndustrialPatente}
                    setGaceteIndustrialPatente={props.setGaceteIndustrialPatente}

                    institucionPatente={props.institucionPatente}
                    setInstitucionPatente={props.setInstitucionPatente}

                    tipoPatenteSelected={props.tipoPatenteSelected}
                    setTipoPatenteSelected={props.setTipoPatenteSelected}

                    viaSolicitudSelected={props.viaSolicitudSelected}
                    setviaSolicitudSelected={props.setviaSolicitudSelected}

                    tipoPatenteOtro={props.tipoPatenteOtro}
                    setTipoPatenteOtro={props.setTipoPatenteOtro}

                    paisesTipoArticulo={props.paisesTipoArticulo}
                    setPaisesTipoArticulo={props.setPaisesTipoArticulo}

                    paisTipoLibroSelected={props.paisTipoLibroSelected}
                    setPaisTipoLibroSelected={props.setPaisTipoLibroSelected}

                    paisTipoCapLibroSelected={props.paisTipoCapLibroSelected}
                    setPaisTipoCapLibroSelected={props.setPaisTipoCapLibroSelected}

                    paisPatenteSelected={props.paisPatenteSelected}
                    setPaisPatenteSelected={props.setPaisPatenteSelected}

                    adj_certificado2={props.adj_certificado2}
                    setAdj_certificado2={props.setAdj_certificado2}

                    adj_certificado_final2={props.adj_certificado_final2}
                    setAdj_certificado_final2={props.setAdj_certificado_final2}

                    adj_certificado3={props.adj_certificado3}
                    setAdj_certificado3={props.setAdj_certificado3}

                    adj_certificado_final3={props.adj_certificado_final3}
                    setAdj_certificado_final3={props.setAdj_certificado_final3}

                    adj_certificado4={props.adj_certificado4}
                    setAdj_certificado4={props.setAdj_certificado4}

                    adj_certificado_final4={props.adj_certificado_final4}
                    setAdj_certificado_final4={props.setAdj_certificado_final4}

                    adj_certificado5={props.adj_certificado5}
                    setAdj_certificado5={props.setAdj_certificado5}

                    adj_certificado_final5={props.adj_certificado_final5}
                    setAdj_certificado_final5={props.setAdj_certificado_final5}

                    //Errores
                    getError={props.getError}
                    errores={props.errores}
                    setErrores={props.setErrores}

                    //rol y modalidad
                    rolActive={props.rolActive}
                    setRolActive={props.setRolActive}

                    modalidadParticipacionActive={props.modalidadParticipacionActive}
                    setModalidadParticipacionActive={props.setModalidadParticipacionActive}
                />
              </div>
            )}
          </div>
        </div>
    )
}

const GetStepContentBiblio = (props) => {
    switch (props.stepIndex) {
        case 0:
            return (
                <ModalProduccionBibliograficaForm1
                    //Tipo de produccion
                    tipoProduccionBiblio={props.tipoProduccionBiblio}
                    setTipoProduccionBiblio={props.setTipoProduccionBiblio}
                    //campos de tipo Articulo de produccion bibliografica
                    idiomasTipoArticulo={props.idiomasTipoArticulo}
                    setIdiomasTipoArticulo={props.setIdiomasTipoArticulo}

                    idiomaTipoArticuloSelected={props.idiomaTipoArticuloSelected}
                    setIdiomaTipoArticuloSelected={props.setIdiomaTipoArticuloSelected}

                    CiudadesTipoArticulo={props.CiudadesTipoArticulo}
                    setCiudadesTipoArticulo={props.setCiudadesTipoArticulo}

                    CiudadesTipoArticuloSelected={props.CiudadesTipoArticuloSelected}
                    setCiudadesTipoArticuloSelected={props.setCiudadesTipoArticuloSelected}
                  
                    tituloArticulo={props.tituloArticulo}
                    setTituloArticulo={props.setTituloArticulo}
                    
                    PaginaInicial={props.PaginaInicial}
                    setPaginaInicial={props.setPaginaInicial}

                    PaginaFinal={props.PaginaFinal}
                    setPaginaFinal={props.setPaginaFinal}

                    numeropaginas={props.numeropaginas}
                    setNumeropaginas={props.setNumeropaginas}
                
                    issn={props.issn}
                    setIssn={props.setIssn}

                    nombreRevista={props.nombreRevista}
                    setNombreRevista={props.setNombreRevista}

                    anioPublicacion={props.anioPublicacion}
                    setAnioPublicacion={props.setAnioPublicacion}

                    volumenRevista={props.volumenRevista}
                    setVolumenRevista={props.setVolumenRevista}

                    idioma={props.idioma}
                    setIdioma={props.setIdioma}

                    enlace={props.enlace}
                    setEnlace={props.setEnlace}

                    doi={props.doi}
                    setDoi={props.setDoi}
                    
                    mediodivulgacion={props.mediodivulgacion}
                    setMediodivulgacion={props.setMediodivulgacion}
                    
                    cargando={props.cargando}
                    setCargando={props.setCargando}

                    //campos de tipo libro de produccion bibliografica
                    idiomasLibro={props.idiomasLibro}
                    setIdiomasLibro={props.setIdiomasLibro}

                    idiomaLibroSelected={props.idiomaLibroSelected}
                    setIdiomaLibroSelected={props.setIdiomaLibroSelected}

                    tiposLibros={props.tiposLibros}
                    setTiposLibros={props.setTiposLibros}

                    tipoLibroSelected={props.tipoLibroSelected}
                    setTipoLibroSelected={props.setTipoLibroSelected}

                    tipoLibroOtro={props.tipoLibroOtro}
                    setTipoLibroOtro={props.setTipoLibroOtro}

                    tituloLibro={props.tituloLibro}
                    setTituloLibro={props.setTituloLibro}

                    isbnLibro={props.isbnLibro}
                    setIsbnLibro={props.setIsbnLibro}

                    mediopublicacionlibro={props.mediopublicacionlibro}
                    setMedioPublicacionLibro={props.setMedioPublicacionLibro}

                    adj_certificado2={props.adj_certificado2}
                    setAdj_certificado2={props.setAdj_certificado2}

                    adj_certificado_final2={props.adj_certificado_final2}
                    setAdj_certificado_final2={props.setAdj_certificado_final2}

                    adj_certificado3={props.adj_certificado3}
                    setAdj_certificado3={props.setAdj_certificado3}

                    adj_certificado_final3={props.adj_certificado_final3}
                    setAdj_certificado_final3={props.setAdj_certificado_final3}

                     adj_certificado4={props.adj_certificado4}
                    setAdj_certificado4={props.setAdj_certificado4}

                    adj_certificado_final4={props.adj_certificado_final4}
                    setAdj_certificado_final4={props.setAdj_certificado_final4}

                    adj_certificado5={props.adj_certificado5}
                    setAdj_certificado5={props.setAdj_certificado5}

                    adj_certificado_final5={props.adj_certificado_final5}
                    setAdj_certificado_final5={props.setAdj_certificado_final5}

                    editorialLibro={props.editorialLibro}
                    setEditorialLibro={props.setEditorialLibro}

                    anioPublicacionLibro={props.anioPublicacionLibro}
                    setAnioPublicacionLibro={props.setAnioPublicacionLibro}

                    paisPublicacionLibro={props.paisPublicacionLibro}
                    setPaisPublicacionLibro={props.setPaisPublicacionLibro}

                    idiomaLibro={props.idiomaLibro}
                    setIdiomaLibro={props.setIdiomaLibro}

                    volumenLibro={props.volumenLibro}
                    setVolumenLibro={props.setVolumenLibro}

                    numeroEdicionLibro={props.numeroEdicionLibro}
                    setNumeroEdicionLibro={props.setNumeroEdicionLibro}

                    //Campos de tipo Capitulo de Libro de produccion bibliografica
                    idiomasCapituloLibro={props.idiomasCapituloLibro}
                    setIdiomasCapituloLibro={props.setIdiomasCapituloLibro}

                    idiomaCapituloLibroSelected={props.idiomaCapituloLibroSelected}
                    setIdiomaCapituloLibroSelected={props.setIdiomaCapituloLibroSelected}

                    tiposLibrosCap={props.tiposLibrosCap}
                    setTiposLibrosCap={props.setTiposLibrosCap}

                    tipoLibroSelectedCap={props.tipoLibroSelectedCap}
                    setTipoLibroSelectedCap={props.setTipoLibroSelectedCap}

                    tipoLibroOtroCap={props.tipoLibroOtroCap}
                    setTipoLibroOtroCap={props.setTipoLibroOtroCap}

                    tituloCapLibro={props.tituloCapLibro}
                    setTituloCapLibro={props.setTituloCapLibro}

                    tituloLibroCap={props.tituloLibroCap}
                    setTituloLibroCap={props.setTituloLibroCap}

                    isbnLibroCap={props.isbnLibroCap}
                    setIsbnLibroCap={props.setIsbnLibroCap}

                    editorialLibroCap={props.editorialLibroCap}
                    setEditorialLibroCap={props.setEditorialLibroCap}

                    anioPublicacionLibroCap={props.anioPublicacionLibroCap}
                    setAnioPublicacionLibroCap={props.setAnioPublicacionLibroCap}

                    paisPublicacionLibroCap={props.paisPublicacionLibroCap}
                    setPaisPublicacionLibroCap={props.setPaisPublicacionLibroCap}

                    idiomaLibroCap={props.idiomaLibroCap}
                    setIdiomaLibroCap={props.setIdiomaLibroCap}

                    volumenLibroCap={props.volumenLibroCap}
                    setVolumenLibroCap={props.setVolumenLibroCap}

                    numeroEdicionLibroCap={props.numeroEdicionLibroCap}
                    setNumeroEdicionLibroCap={props.setNumeroEdicionLibroCap}

                    //Campos del tipo Obra producciom bibliografica

                    hola={props.hola}
                    activeStepBiblio={props.activeStepBiblio}
                    setActiveStepBiblio={props.setActiveStepBiblio}

                    nombreObra={props.nombreObra}
                    setNombreObra={props.setNombreObra}

                    disciplina={props.disciplina}
                    setDisciplina={props.setDisciplina}

                    disciplinaSelected = {props.disciplinaSelected}
                    setDisciplinaSelected = {props.setDisciplinaSelected}

                    tituloObraproducto={props.tituloObraproducto}
                    setTituloObraproducto={props.setTituloObraproducto}

                    tecnica={props.tecnica}
                    setTecnica={props.setTecnica}

                    nombreespacio={props.nombreespacio}
                    setNombreEspacio={props.setNombreEspacio}

                    tipoespacio={props.tipoespacio}
                    setTipoEspacio={props.setTipoEspacio}
                    
                    tipoespacioSelected= {props.tipoespacioSelected}
                    settipoespacioSelected={props.settipoespacioSelected}

                    fechapresentacion={props.fechapresentacion}
                    setFechaPresentacion={props.setFechaPresentacion}

                    aniocreacionespacio={props.aniocreacionespacio}
                    setAniocreacionEspacio={props.setAniocreacionEspacio}

                    distincion={props.distincion}
                    setDistincion={props.setDistincion}

                    distincionSelected={props.distincionSelected}
                    setdistincionSelected={props.setdistincionSelected}

                    entidadconvocante={props.entidadconvocante}
                    setEntidadConvocante={props.setEntidadConvocante}

                    tipoAmbitoSelected={props.tipoAmbitoSelected}
                    setTipoAmbitoSelected={props.setTipoAmbitoSelected}

                    tiposAmbitos={props.tiposAmbitos}
                    setTiposAmbitos={props.setTiposAmbito}

                    mecanismoseleccion={props.mecanismoseleccion}
                    setMecanismoSeleccion={props.setMecanismoSeleccion}

                    mecanismoSelected= {props.mecanismoSelected}
                    setmecanismoSelected={props.setmecanismoSelected}

                    acuerdoLicencia={props.acuerdoLicencia}
                    setAcuerdoLicencia={props.setAcuerdoLicencia}

                    institucionlicencia={props.institucionlicencia}
                    setInstitucionLicencia={props.setInstitucionLicencia}

                    fechaotrogamiento={props.fechaotrogamiento}
                    setFechaOtorgamiento={props.setFechaOtorgamiento}

                    numeroregistro={props.numeroregistro}
                    setNumeroRegistro={props.setNumeroRegistro}

                    contratocomercializacion={props.contratocomercializacion}
                    setContratoComercializacion={props.setContratoComercializacion}

                    //Campos del tipo Patente de producion bibliografica
                    tipoPatente={props.tipoPatente}
                    setTipoPatente={props.setTipoPatente}

                    viaSolicitud={props.viaSolicitud}
                    setviaSolicitud={props.setviaSolicitud}

                    anioObtencionPatente={props.anioObtencionPatente}
                    setAnioObtencionPatente={props.setAnioObtencionPatente}

                    numeroRegistroPatente={props.numeroRegistroPatente}
                    setNumeroRegistroPatente={props.setNumeroRegistroPatente}

                    tituloPatente={props.tituloPatente}
                    setTituloPatente={props.setTituloPatente}

                    numeroPatente={props.numeroPatente}
                    setNumeroPatente={props.setNumeroPatente}

                    nombreSolicitante={props.nombreSolicitante}
                    setnombreSolicitante={props.setnombreSolicitante}

                    paisObtencionPatente={props.paisObtencionPatente}
                    setPaisObtencionPatente={props.setPaisObtencionPatente}

                    gacetaIndustrialPatente={props.gacetaIndustrialPatente}
                    setGaceteIndustrialPatente={props.setGaceteIndustrialPatente}

                    institucionPatente={props.institucionPatente}
                    setInstitucionPatente={props.setInstitucionPatente}

                    tipoPatenteSelected={props.tipoPatenteSelected}
                    setTipoPatenteSelected={props.setTipoPatenteSelected}
                    
                    viaSolicitudSelected={props.viaSolicitudSelected}
                    setviaSolicitudSelected={props.setviaSolicitudSelected}

                    tipoPatenteOtro={props.tipoPatenteOtro}
                    setTipoPatenteOtro={props.setTipoPatenteOtro}

                    paisesTipoArticulo={props.paisesTipoArticulo}
                    setPaisesTipoArticulo={props.setPaisesTipoArticulo}

                    paisTipoLibroSelected={props.paisTipoLibroSelected}
                    setPaisTipoLibroSelected={props.setPaisTipoLibroSelected}

                    paisTipoCapLibroSelected={props.paisTipoCapLibroSelected}
                    setPaisTipoCapLibroSelected={props.setPaisTipoCapLibroSelected}

                    paisPatenteSelected={props.paisPatenteSelected}
                    setPaisPatenteSelected={props.setPaisPatenteSelected}
                    //Errores
                    getError={props.getError}
                    errores={props.errores}
                    setErrores={props.setErrores}
                />
            )
        case 1:
            return (
                <ModalFormGestionAutores
                    tipoSolicitudActual={props.tipoSolicitudActual}
                    setTipoSolicitudActual={props.setTipoSolicitudActual}

                    //Variables Autores y Particiapntes
                    numeroIdParEvent={props.numeroIdParEvent}
                    setNumeroIdParEvent={props.setNumeroIdParEvent}
                    arrai={props.arrai}
                    setArrai={props.setArrai}

                    //Permisos de la solicitud
                    permisosDeLaSolicitud={props.permisosDeLaSolicitud}
                    setPermisosDeLaSolicitud={props.setPermisosDeLaSolicitud}

                    cargando={props.cargando}
                    setCargando={props.setCargando}

                    //rol y modalidad
                    rolActive={props.rolActive}
                    setRolActive={props.setRolActive}

                    modalidadParticipacionActive={props.modalidadParticipacionActive}
                    setModalidadParticipacionActive={props.setModalidadParticipacionActive}

                    tiposRoles={[]}
                    setTiposRoles={[]}
                />
            )
    }
}

const ModalProduccionBibliograficaForm1 = (props) =>{
    const classes = useStyles()
    const fileInput = React.createRef();
    const handleOnchange = (e) =>{

        if(props.tipoProduccionBiblio.codigo == "Inves_tipo_biblio_articulo"){
            
            if(e.target.name == "tituloArticulo"){
                props.setTituloArticulo(e.target.value)
                if(props.errores.length > 0){
                    props.setErrores(props.errores.filter(er => er.llave != "tituloArticulo"));
                    // Elimina error cuando se escribe en el campo
                }
            }else if(e.target.name == "PaginaInicial"){
                props.setPaginaInicial(e.target.value)
                if(props.errores.length > 0){
                    props.setErrores(props.errores.filter(er => er.llave != "PaginaInicial"));
                    // Elimina error cuando se escribe en el campo
                }
            }else if(e.target.name == "PaginaFinal"){
                props.setPaginaFinal(e.target.value)
                if(props.errores.length > 0){
                    props.setErrores(props.errores.filter(er => er.llave != "PaginaFinal"));
                    // Elimina error cuando se escribe en el campo
                }
            }else if(e.target.name == "issn"){
                props.setIssn(e.target.value)
                if(props.errores.length > 0){
                    props.setErrores(props.errores.filter(er => er.llave != "issn"));
                    // Elimina error cuando se escribe en el campo
                }
            }else if(e.target.name == "nombreRevista"){
                props.setNombreRevista(e.target.value)
                if(props.errores.length > 0){
                    props.setErrores(props.errores.filter(er => er.llave != "nombreRevista"));
                    // Elimina error cuando se escribe en el campo
                }
            }else if(e.target.name == "volumenRevista"){
                props.setVolumenRevista(e.target.value)
                if(props.errores.length > 0){
                    props.setErrores(props.errores.filter(er => er.llave != "volumenRevista"));
                    // Elimina error cuando se escribe en el campo
                }
            }else if(e.target.name == "idioma"){
                props.setIdioma(e.target.value)
                if(props.errores.length > 0){
                    props.setErrores(props.errores.filter(er => er.llave != "idioma"));
                    // Elimina error cuando se escribe en el campo
                }
            }else if(e.target.name == "enlace"){
                props.setEnlace(e.target.value)
                if(props.errores.length > 0){
                    props.setErrores(props.errores.filter(er => er.llave != "enlace"));
                    // Elimina error cuando se escribe en el campo
                }
            }else if(e.target.name == "doi"){
                props.setDoi(e.target.value)
                if(props.errores.length > 0){
                    props.setErrores(props.errores.filter(er => er.llave != "doi"));
                    // Elimina error cuando se escribe en el campo
                }
            }else if(e.target.name == "mediodivulgacion"){
                props.setMediodivulgacion(e.target.value)
                if(props.errores.length > 0){
                    props.setErrores(props.errores.filter(er => er.llave != "mediodivulgacion"));
                    // Elimina error cuando se escribe en el campo
                }
           
            }else if(e.target.name == "idiomaTipoArticuloSelected"){
                props.setIdiomaTipoArticuloSelected(e.target.value)
                if(props.errores.length > 0){
                    props.setErrores(props.errores.filter(er => er.llave != "idiomaTipoArticuloSelected"));
                    // Elimina error cuando se escribe en el campo
                }
            }else if(e.target.name == "CiudadesTipoArticuloSelected"){
                props.setCiudadesTipoArticuloSelected(e.target.value)
                if(props.errores.length > 0){
                    props.setErrores(props.errores.filter(er => er.llave != "CiudadesTipoArticuloSelected"));
                    // Elimina error cuando se escribe en el campo
                }
            }
        }else if(props.tipoProduccionBiblio.codigo == "Inves_tipo_biblio_libro"){
            if(e.target.name == "tipoDeLibro"){
                props.setTipoLibroSelected(e.target.value)
                props.setTipoLibroOtro('')
                if(props.errores.length > 0){
                    props.setErrores(props.errores.filter(er => er.llave != "tipoLibroSelected"));
                    // Elimina error cuando se escribe en el campo
                }
            }else if(e.target.name == "tipoLibroOtro"){
                props.setTipoLibroOtro(e.target.value)
                if(props.errores.length > 0){
                    props.setErrores(props.errores.filter(er => er.llave != "tipoLibroOtro"));
                    // Elimina error cuando se escribe en el campo
                }
            }else if(e.target.name == "tituloLibro"){
                props.setTituloLibro(e.target.value)
                if(props.errores.length > 0){
                    props.setErrores(props.errores.filter(er => er.llave != "tituloLibro"));
                    // Elimina error cuando se escribe en el campo
                }

            }else if(e.target.name == "mediodivulgacion"){
                props.setMediodivulgacion(e.target.value)
                if(props.errores.length > 0){
                    props.setErrores(props.errores.filter(er => er.llave != "mediodivulgacion"));
                    // Elimina error cuando se escribe en el campo
                }

            }else if (e.target.name== "mediopublicacionlibro"){
                props.setMedioPublicacionLibro(e.target.value)
                if(props.errores.length > 0){   
                    props.setErrores(props.errores.filter(er => er.llave != "mediopublicacionlibro"));

            }
            }else if(e.target.name == "isbnLibro"){
                props.setIsbnLibro(e.target.value)
                if(props.errores.length > 0){
                    props.setErrores(props.errores.filter(er => er.llave != "isbnLibro"));
                    // Elimina error cuando se escribe en el campo
                }
            }else if(e.target.name == "editorialLibro"){
                props.setEditorialLibro(e.target.value)
                if(props.errores.length > 0){
                    props.setErrores(props.errores.filter(er => er.llave != "editorialLibro"));
                    // Elimina error cuando se escribe en el campo
                }
            }else if(e.target.name == "paisTipoCapLibroSelected"){
                props.setPaisTipoCapLibroSelected(e.target.value)
                if(props.errores.length > 0){
                    props.setErrores(props.errores.filter(er => er.llave != "paisTipoCapLibroSelected"));
                    // Elimina error cuando se escribe en el campo
                }
            }else if(e.target.name == "idiomaLibro"){
                props.setIdiomaLibro(e.target.value)
                if(props.errores.length > 0){
                    props.setErrores(props.errores.filter(er => er.llave != "idiomaLibro"));
                    // Elimina error cuando se escribe en el campo
                }
            }else if(e.target.name == "volumenLibro"){
                props.setVolumenLibro(e.target.value)
                if(props.errores.length > 0){
                    props.setErrores(props.errores.filter(er => er.llave != "volumenLibro"));
                    // Elimina error cuando se escribe en el campo
                }
            }else if(e.target.name == "numeroEdicionLibro"){
                props.setNumeroEdicionLibro(e.target.value)
                if(props.errores.length > 0){
                    props.setErrores(props.errores.filter(er => er.llave != "numeroEdicionLibro"));
                    // Elimina error cuando se escribe en el campo
                }
            }else if(e.target.name == "idiomaLibroSelected"){
                props.setIdiomaLibroSelected(e.target.value)
                if(props.errores.length > 0){
                    props.setErrores(props.errores.filter(er => er.llave != "idiomaLibroSelected"));
                    // Elimina error cuando se escribe en el campo
                }
           }else if (e.target.name === "adj_certificado2") {
                const file = e.target.files[0];
                if (file) {
                    props.setAdj_certificado2(file.name);          
                    props.setAdj_certificado_final2(file);         
                }
                if (props.errores.length > 0) {
                    props.setErrores(props.errores.filter(er => er.llave !== "adj_certificado2"));
                }
            }else if (e.target.name === "adj_certificado3") {
                const file = e.target.files[0];
                if (file) {
                    props.setAdj_certificado3(file.name);
                    props.setAdj_certificado_final3(file);
                }
                if (props.errores.length > 0) {
                    props.setErrores(props.errores.filter(er => er.llave !== "adj_certificado3"));
                }
            } 
        
        }else if(props.tipoProduccionBiblio.codigo == "Inves_tipo_biblio_capituloLib"){
            if(e.target.name == "tipoLibroOtroCap"){
                props.setTipoLibroOtroCap(e.target.value)
                if(props.errores.length > 0){
                    props.setErrores(props.errores.filter(er => er.llave != "tipoLibroOtroCap"));
                    // Elimina error cuando se escribe en el campo
                }
            }else if(e.target.name == "tituloCapLibro"){
                props.setTituloCapLibro(e.target.value)
                if(props.errores.length > 0){
                    props.setErrores(props.errores.filter(er => er.llave != "tituloCapLibro"));
                    // Elimina error cuando se escribe en el campo
                }
            }else if(e.target.name == "tituloLibroCap"){
                props.setTituloLibroCap(e.target.value)
                if(props.errores.length > 0){
                    props.setErrores(props.errores.filter(er => er.llave != "tituloLibroCap"));
                    // Elimina error cuando se escribe en el campo
                }
            }else if(e.target.name == "PaginaInicial"){
                props.setPaginaInicial(e.target.value)
                if(props.errores.length > 0){
                    props.setErrores(props.errores.filter(er => er.llave != "PaginaInicial"));
                    // Elimina error cuando se escribe en el campo
                }
            }else if(e.target.name == "PaginaFinal"){
                props.setPaginaFinal(e.target.value)
                if(props.errores.length > 0){
                    props.setErrores(props.errores.filter(er => er.llave != "PaginaFinal"));
                    // Elimina error cuando se escribe en el campo
                }
            }else if(e.target.name == "numeropaginas"){
                props.setNumeropaginas(e.target.value)
                if(props.errores.length > 0){
                    props.setErrores(props.errores.filter(er => er.llave != "numeropaginas"));
                    // Elimina error cuando se escribe en el campo
                }
            }else if(e.target.name == "isbnLibroCap"){
                props.setIsbnLibroCap(e.target.value)
                if(props.errores.length > 0){
                    props.setErrores(props.errores.filter(er => er.llave != "isbnLibroCap"));
                    // Elimina error cuando se escribe en el campo
                }

            }else if(e.target.name == "mediodivulgacion"){
                props.setMediodivulgacion(e.target.value)
                if(props.errores.length > 0){
                    props.setErrores(props.errores.filter(er => er.llave != "mediodivulgacion"));
                    // Elimina error cuando se escribe en el campo
                }
            
            }else if(e.target.name == "paisTipoCapLibroSelected"){
                props.setPaisTipoCapLibroSelected(e.target.value)
                if(props.errores.length > 0){
                    props.setErrores(props.errores.filter(er => er.llave != "paisTipoCapLibroSelected"));
                    // Elimina error cuando se escribe en el campo
                }

                }else if (e.target.name === "adj_certificado2") {
                const file = e.target.files[0];
                if (file) {
                    props.setAdj_certificado2(file.name);          
                    props.setAdj_certificado_final2(file);         
                }
                if (props.errores.length > 0) {
                    props.setErrores(props.errores.filter(er => er.llave !== "adj_certificado2"));
                }
            }else if (e.target.name === "adj_certificado3") {
                const file = e.target.files[0];
                if (file) {
                    props.setAdj_certificado3(file.name);
                    props.setAdj_certificado_final3(file);
                }
                if (props.errores.length > 0) {
                    props.setErrores(props.errores.filter(er => er.llave !== "adj_certificado3"));
                }
            }
        }else if (props.tipoProduccionBiblio.codigo == "Inves_tipo_obra") {
               
                if (e.target.name == "nombreObra") {
                    props.setNombreObra(e.target.value);
                    if (props.errores.length > 0) {
                        props.setErrores(prev => prev.filter(er => er.name !== "nombreObra"));
                    }
                } else if (e.target.name == "disciplinaSelected") {
                    props.setDisciplinaSelected(e.target.value);
                    if (props.errores.length > 0) {
                        props.setErrores(props.errores.filter(er => er.llave != "disciplinaSelected"));
                    }
                } else if (e.target.name == "tituloObraproducto") {
                    props.setTituloObraproducto(e.target.value);
                    if (props.errores.length > 0) {
                        props.setErrores(props.errores.filter(er => er.llave != "tituloObraproducto"));
                    }
                } else if (e.target.name == "tecnica") {
                    props.setTecnica(e.target.value);
                    if (props.errores.length > 0) {
                        props.setErrores(props.errores.filter(er => er.llave != "tecnica"));
                    }
                
                
                } else if (e.target.name == "nombreespacio") {
                    props.setNombreEspacio(e.target.value);
                    if (props.errores.length > 0) {
                        props.setErrores(props.errores.filter(er => er.llave != "nombreespacio"));
                    }
                } else if (e.target.name == "tipoespacioSelected") {
                    props.settipoespacioSelected(e.target.value);
                    if (props.errores.length > 0) {
                        props.setErrores(props.errores.filter(er => er.llave != "tipoespacioSelected"));
                    }
                } else if (e.target.name == "fechapresentacion") {
                    props.setFechaPresentacion(e.target.value);
                    if (props.errores.length > 0) {
                        props.setErrores(props.errores.filter(er => er.llave != "fechapresentacion"));
                    }
                } else if (e.target.name == "aniocreacionespacio") {
                    props.setAniocreacionEspacio(e.target.value);
                    if (props.errores.length > 0) {
                        props.setErrores(props.errores.filter(er => er.llave != "aniocreacionespacio"));
                    }
                } else if (e.target.name == "distincionSelected") {
                    props.setdistincionSelected(e.target.value);
                    if (props.errores.length > 0) {
                        props.setErrores(props.errores.filter(er => er.llave != "distincionSelected"));
                    }
                } else if (e.target.name == "entidadconvocante") {
                    props.setEntidadConvocante(e.target.value);
                    if (props.errores.length > 0) {
                        props.setErrores(props.errores.filter(er => er.llave != "entidadconvocante"));
                    }
                } else if (e.target.name == "tipoAmbitoSelected") {
                    props.setTipoAmbitoSelected(e.target.value);
                    if (props.errores.length > 0) {
                        props.setErrores(props.errores.filter(er => er.llave != "tipoAmbitoSelected"));
                    }
                } else if (e.target.name == "mecanismoSelected") {
                    props.setmecanismoSelected(e.target.value);
                    if (props.errores.length > 0) {
                        props.setErrores(props.errores.filter(er => er.llave != "mecanismoSelected"));
                    }
                } else if (e.target.name == "acuerdoLicencia") {
                    props.setAcuerdoLicencia(e.target.value);
                    if (props.errores.length > 0) {
                        props.setErrores(props.errores.filter(er => er.llave != "acuerdoLicencia"));
                    }
                } else if (e.target.name == "institucionlicencia") {
                    props.setInstitucionLicencia(e.target.value);
                    if (props.errores.length > 0) {
                        props.setErrores(props.errores.filter(er => er.llave != "institucionlicencia"));
                    }
                }else if(e.target.name == "CiudadesTipoArticuloSelected"){
                props.setCiudadesTipoArticuloSelected(e.target.value)
                if(props.errores.length > 0){
                    props.setErrores(props.errores.filter(er => er.llave != "CiudadesTipoArticuloSelected"));
                    // Elimina error cuando se escribe en el campo
                }
                } else if (e.target.name == "fechaotrogamiento") {
                    props.setFechaOtorgamiento(e.target.value);
                    if (props.errores.length > 0) {
                        props.setErrores(props.errores.filter(er => er.llave != "fechaotrogamiento"));
                    }
                } else if (e.target.name == "numeroregistro") {
                    props.setNumeroRegistro(e.target.value);
                    if (props.errores.length > 0) {
                        props.setErrores(props.errores.filter(er => er.llave != "numeroregistro"));
                    }
                } else if (e.target.name == "contratocomercializacion") {
                    props.setContratoComercializacion(e.target.value);
                    if (props.errores.length > 0) {
                        props.setErrores(props.errores.filter(er => er.llave != "contratocomercializacion"));
                    }}
            }else if(props.tipoProduccionBiblio.codigo == "Inves_tipo_biblio_patente"){
            if(e.target.name == "tipoPatente"){
                props.setTipoPatenteSelected(e.target.value)
                if(props.errores.length > 0){
                    props.setErrores(props.errores.filter(er => er.llave != "tipoPatente"));
                    // Elimina error cuando se escribe en el campo
                }
            }else if (e.target.name == "viaSolicitud"){
                props.setviaSolicitudSelected(e.target.value)
                if(props.errores.length > 0){
                    props.setErrores(props.errores.filter(er => er.llave != "viaSolicitud"))
                }
            }else if(e.target.name == "tituloPatente"){
                props.setTituloPatente(e.target.value)
                if(props.errores.length > 0){
                    props.setErrores(props.errores.filter(er => er.llave != "tituloPatente"));
                    // Elimina error cuando se escribe en el campo
                }
            }else if(e.target.name == "numeroPatente"){
                props.setNumeroPatente(e.target.value)
                if(props.errores.length > 0){
                    props.setErrores(props.errores.filter(er => er.llave != "numeroPatente"));
                    // Elimina error cuando se escribe en el campo
                }
            }else if (e.target.name == "nombreSolicitante"){
                props.setnombreSolicitante(e.target.value)
                if(props.errores.length> 0){
                    props.setErrores(props.errores.filter(er => er.llave != "nombreSolicitante"))
                } 
            }else if(e.target.name == "gacetaIndustrialPatente"){
                props.setGaceteIndustrialPatente(e.target.value)
                if(props.errores.length > 0){
                    props.setErrores(props.errores.filter(er => er.llave != "gacetaIndustrialPatente"));
                    // Elimina error cuando se escribe en el campo
                }
            }else if(e.target.name == "institucionPatente"){
                props.setInstitucionPatente(e.target.value)
                if(props.errores.length > 0){
                    props.setErrores(props.errores.filter(er => er.llave != "institucionPatente"));
                    // Elimina error cuando se escribe en el campo
                }
           
            }else if (e.target.name === "adj_certificado2") {
                const file = e.target.files[0];
                if (file) {
                    props.setAdj_certificado2(file.name);          
                    props.setAdj_certificado_final2(file);         
                }
                if (props.errores.length > 0) {
                    props.setErrores(props.errores.filter(er => er.llave !== "adj_certificado2"));
                }
            } else if (e.target.name == "acuerdoLicencia") {
                    props.setAcuerdoLicencia(e.target.value);
                    if (props.errores.length > 0) {
                        props.setErrores(props.errores.filter(er => er.llave != "acuerdoLicencia"));
                    }
            }else if (e.target.name === "adj_certificado3") {
                const file = e.target.files[0];
                if (file) {
                    props.setAdj_certificado3(file.name);
                    props.setAdj_certificado_final3(file);
                }
                if (props.errores.length > 0) {
                    props.setErrores(props.errores.filter(er => er.llave !== "adj_certificado3"));
                }
            }else if (e.target.name === "adj_certificado4") {
                const file = e.target.files[0];
                if (file) {
                    props.setAdj_certificado4(file.name);          
                    props.setAdj_certificado_final4(file);         
                }
                if (props.errores.length > 0) {
                    props.setErrores(props.errores.filter(er => er.llave !== "adj_certificado4"));
                }
            
        
        }
    }

    }

    return(
        props.cargando == true ? <div> <TareasTerminadas imagen={emma_w} mensaje={'Cargando..'} widthImg='7%' marginTop='7%' /> <LinearProgress /></div> :
        <div>

                {/* Seccion de Produccion Bibliografica */}
                { props.tipoProduccionBiblio.codigo == "Inves_tipo_biblio_articulo" ?
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <TextField
                        fullWidth
                        label="Título del artículo"
                        id = 'tituloArticulo'
                        error = { props.getError('tituloArticulo', props.errores).length > 0}
                        helperText = { props.getError('tituloArticulo', props.errores) }
                        value={props.tituloArticulo}
                        onChange={handleOnchange}
                        name="tituloArticulo"/>
                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                        fullWidth
                        label="Página Inicial"
                        id = 'PaginaInicial'
                        type='number'
                        error = { props.getError('PaginaInicial', props.errores).length > 0}
                        helperText = { props.getError('PaginaInicial', props.errores) }
                        value={props.PaginaInicial}
                        onChange={handleOnchange}
                        name="PaginaInicial"/>
                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                        fullWidth
                        label="Página Final"
                        id = 'PaginaFinal'
                        type='Number'
                        error = { props.getError('PaginaFinal', props.errores).length > 0}
                        helperText = { props.getError('PaginaFinal', props.errores) }
                        value={props.PaginaFinal}
                        onChange={handleOnchange}
                        name="PaginaFinal"/>
                    </Grid>

                    <Grid item xs={12}>
                        <InputLabel htmlFor="age-native-simple">Idiomas</InputLabel>
                            <FormControl className={classes.formControl} fullWidth error = { props.getError('idiomaTipoArticuloSelected', props.errores).length > 0}>
                                <Select
                                    value={props.idiomaTipoArticuloSelected}
                                    displayEmpty
                                    fullWidth
                                    inputProps={{ 'aria-label': 'Without label' }}
                                    onChange={handleOnchange}
                                    name="idiomaTipoArticuloSelected"
                                >
                                    <MenuItem value="">
                                        <em style={{color: "rgba(0, 0, 0, 0.54)"}}>{ `${props.idiomasTipoArticulo.length} Idiomas para Seleccionar` }</em>
                                    </MenuItem>
                                    {props.idiomasTipoArticulo.map((item, index) => (
                                    <MenuItem key= { index } value = { item }>{`${item.nombre}`}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        <FormHelperText>{ props.getError('idiomaTipoArticuloSelected', props.errores) }</FormHelperText>
                    </Grid>
                    
                    <Grid item xs={12} sm={6}>
                        <MuiPickersUtilsProvider utils={DateFnsUtils} >
                            <Fragment>
                            <DatePicker
                               views={["year", "month"]}
                                label="Año/Mes de publicación"
                                value={props.anioPublicacion}
                                fullWidth
                                onChange={props.setAnioPublicacion}
                                format="yyyy/MM" 
                            />
                            </Fragment>
                        </MuiPickersUtilsProvider>
                    </Grid>
                    
                    <Grid item xs={12}>
                        <TextField
                        fullWidth
                        label="Nombre de la revista"
                        id = 'nombreRevista'
                        error = { props.getError('nombreRevista', props.errores).length > 0}
                        helperText = { props.getError('nombreRevista', props.errores) }
                        value={props.nombreRevista}
                        onChange={handleOnchange}
                        name="nombreRevista"/>
                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                        fullWidth
                        label="Código ISSN"
                        id = 'issn'
                        error = { props.getError('issn', props.errores).length > 0}
                        helperText = { props.getError('issn', props.errores) }
                        value={props.issn}
                        onChange={handleOnchange}
                        name="issn"/>
                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                        fullWidth
                        label="Volumen de la revista"
                        id = 'volumenRevista'
                        error = { props.getError('volumenRevista', props.errores).length > 0}
                        helperText = { props.getError('volumenRevista', props.errores) }
                        value={props.volumenRevista}
                        onChange={handleOnchange}
                        name="volumenRevista"/>
                    </Grid>

                    <Grid item xs={12}>
                        <InputLabel htmlFor="age-native-simple">Ciudad</InputLabel>
                            <FormControl className={classes.formControl} fullWidth error = { props.getError('CiudadesTipoArticuloSelected', props.errores).length > 0}>
                                <Select
                                    value={props.CiudadesTipoArticuloSelected}
                                    displayEmpty
                                    fullWidth
                                    inputProps={{ 'aria-label': 'Without label' }}
                                    onChange={handleOnchange}
                                    name="CiudadesTipoArticuloSelected"
                                >
                                    <MenuItem value="">
                                        <em style={{color: "rgba(0, 0, 0, 0.54)"}}>{ `${props.CiudadesTipoArticulo.length} Ciudades para Seleccionar` }</em>
                                    </MenuItem>
                                    {props.CiudadesTipoArticulo.map((item, index) => (
                                    <MenuItem key= { index } value = { item }>{`${item.nombre}`}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        <FormHelperText>{ props.getError('CiudadesTipoArticuloSelected', props.errores) }</FormHelperText>
                    </Grid>

                    <Grid item xs={12}>
                    <FormControl 
                        fullWidth 
                        error={props.getError('mediodivulgacion', props.errores).length > 0}
                    >
                        <InputLabel id="medio-divulgacion-libro-labe">Medio de divulgación</InputLabel>
                        <Select
                        labelId="medio-divulgacion-libro-labe"
                        id="mediodivulgacion"
                        value={props.mediodivulgacion}
                        onChange={handleOnchange}
                        name="mediodivulgacion"
                        >
                        <MenuItem value="Papel">Papel</MenuItem>
                        <MenuItem value="Electronico">Electrónico</MenuItem>
                        </Select>
                        <FormHelperText>
                        {props.getError('mediodivulgacion', props.errores)}
                        </FormHelperText>
                    </FormControl>
                    
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                        fullWidth
                        label="Sitio WEB (URL)"
                        type='URL'
                        id = 'enlace'
                        error = { props.getError('enlace', props.errores).length > 0}
                        helperText = { props.getError('enlace', props.errores) }
                        value={props.enlace}
                        onChange={handleOnchange}
                        name="enlace"/>
                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                        fullWidth
                        label="DOI"
                        id = 'doi'
                        error = { props.getError('doi', props.errores).length > 0}
                        helperText = { props.getError('doi', props.errores) }
                        value={props.doi}
                        onChange={handleOnchange}
                        name="doi"/>
                    </Grid>

                </Grid>: ''}

                {/* Seccion de Produccion Bibliografica Libros*/}
                { props.tipoProduccionBiblio.codigo == "Inves_tipo_biblio_libro" ?
                <Grid container spacing={3}>
                    
                    <Grid item xs={12}>
                        <TextField
                        fullWidth
                        label="Título del libro"
                        id = 'tituloLibro'
                        error = { props.getError('tituloLibro', props.errores).length > 0}
                        helperText = { props.getError('tituloLibro', props.errores) }
                        value={props.tituloLibro}
                        onChange={handleOnchange}
                        name="tituloLibro"/>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <MuiPickersUtilsProvider utils={DateFnsUtils} >
                            <Fragment>
                            <DatePicker
                                views={["year", "month"]}
                                label="Año de publicación"
                                value={props.anioPublicacion}
                                fullWidth
                                onChange={props.setAnioPublicacion}
                                animateYearScrolling
                            />
                            </Fragment>
                        </MuiPickersUtilsProvider>
                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                        fullWidth
                        label="ISBN"
                        id = 'isbnLibro'
                        error = { props.getError('isbnLibro', props.errores).length > 0}
                        helperText = { props.getError('isbnLibro', props.errores) }
                        value={props.isbnLibro}
                        onChange={handleOnchange}
                        name="isbnLibro"/>
                    </Grid>

                    <Grid item xs={12}>
                        <InputLabel htmlFor="age-native-simple">País de Publicación</InputLabel>
                            <FormControl className={classes.formControl} fullWidth error = { props.getError('paisTipoCapLibroSelected', props.errores).length > 0}>
                                <Select
                                    value={props.paisTipoCapLibroSelected}
                                    displayEmpty
                                    fullWidth
                                    inputProps={{ 'aria-label': 'Without label' }}
                                    onChange={handleOnchange}
                                    name="paisTipoCapLibroSelected"
                                >
                                    <MenuItem value="">
                                        <em style={{color: "rgba(0, 0, 0, 0.54)"}}>{ `${props.paisesTipoArticulo.length} Paises para Seleccionar` }</em>
                                    </MenuItem>
                                    {props.paisesTipoArticulo.map((item, index) => (
                                    <MenuItem key= { index } value = { item }>{`${item.nombre}`}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        <FormHelperText>{ props.getError('paisTipoCapLibroSelected', props.errores) }</FormHelperText>
                    </Grid>
                    <Grid item xs={12}>
                    <FormControl 
                        fullWidth 
                        error={props.getError('mediodivulgacion', props.errores).length > 0}>
                        <InputLabel id="medio-divulgacion-label">Medio de divulgación</InputLabel>
                        <Select
                        labelId="medio-divulgacion-label"
                        id="mediodivulgacion"
                        value={props.mediodivulgacion}
                        onChange={handleOnchange}
                        name="mediodivulgacion"
                        >
                        <MenuItem value="Papel">Papel</MenuItem>
                        <MenuItem value="Electronico">Electrónico</MenuItem>
                        </Select>
                        <FormHelperText>
                        {props.getError('mediodivulgacion', props.errores)}
                        </FormHelperText>
                    </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                    <FormControl 
                        fullWidth 
                        error={props.getError('mediopublicacionlibro', props.errores).length > 0}
                    >
                        <InputLabel id="medio-publicacion-label">¿Cuál fue el medio de publicación del libro completo resultado de investigación?</InputLabel>
                        <Select
                        labelId="medio-publicacion-label"
                        id="mediopublicacionlibro"
                        value={props.mediopublicacionlibro}
                        onChange={handleOnchange}
                        name="mediopublicacionlibro"
                        >
                        <MenuItem value="Editorial Nacional">Editorial Nacional</MenuItem>
                        <MenuItem value="Libro indexado en el Book Citation Inde">Libro indexado en el Book Citation Index</MenuItem>
                        <MenuItem value="Libro indexado en Scopus">Libro indexado en Scopus</MenuItem>
                        <MenuItem value="Editorial Internacional">Editorial Internacional</MenuItem>
                        </Select>
                        <FormHelperText>
                        {props.getError('mediopublicacionlibro', props.errores)}
                        </FormHelperText>
                    </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                        fullWidth
                        label="Nombre de la Editorial"
                        id = 'editorialLibro'
                        error = { props.getError('editorialLibro', props.errores).length > 0}
                        helperText = { props.getError('editorialLibro', props.errores) }
                        value={props.editorialLibro}
                        onChange={handleOnchange}
                        name="editorialLibro"/>
                    </Grid>
                    <Grid item xs={12} className='oculto'>
                    <TextField
                        ref={fileInput}
                        required
                        type="file"
                        id="adj_certificado2"
                        name="adj_certificado2"
                        label="Adjuntar Identificación"
                        fullWidth
                        autoComplete="billing address-line1"
                        onChange={handleOnchange}
                    />
                    </Grid>

                    <Grid item xs={12}>
                    <InputFile 
                        id="adj_certificado2"
                        label="Certificación de los créditos de la obra"
                        name="adj_certificado2"
                        value={props.adj_certificado2} 
                        required={props.adj_certificado2} 
                        error={props.getError("adj_certificado2", props.errores) > 0}
                        helperText={props.getError("adj_certificado2", props.errores)}
                    />
                    </Grid>

                    <Grid item xs={12} className='oculto'>
                    <TextField
                        ref={fileInput}
                        required
                        type="file"
                        id="adj_certificado3"
                        name="adj_certificado3"
                        label="Adjuntar Identificación"
                        fullWidth
                        autoComplete="billing address-line1"
                        onChange={handleOnchange}
                    />
                    </Grid>

                    <Grid item xs={12}>
                    <InputFile 
                        id="adj_certificado3"
                        label="Certificación de la institución que avala"
                        name="adj_certificado3"
                        value={props.adj_certificado3} 
                        required={props.adj_certificado3} 
                        error={props.getError("adj_certificado3", props.errores) > 0}
                        helperText={props.getError("adj_certificado3", props.errores)}
                    />
                    </Grid>
                </Grid> : ''}
                {/* Seccion de Produccion Bibliografica Libros capitulo*/}
                { props.tipoProduccionBiblio.codigo == "Inves_tipo_biblio_capituloLib" ?
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <TextField
                        fullWidth
                        label="Título del capítulo de libro"
                        id = 'tituloCapLibro'
                        error = { props.getError('tituloCapLibro', props.errores).length > 0}
                        helperText = { props.getError('tituloCapLibro', props.errores) }
                        value={props.tituloCapLibro}
                        onChange={handleOnchange}
                        name="tituloCapLibro"/>
                    </Grid>

                     <Grid item xs={12}>
                        <TextField
                        fullWidth
                        label="Página Inicial"
                        id = 'PaginaInicial'
                        type='number'
                        error = { props.getError('PaginaInicial', props.errores).length > 0}
                        helperText = { props.getError('PaginaInicial', props.errores) }
                        value={props.PaginaInicial}
                        onChange={handleOnchange}
                        name="PaginaInicial"/>
                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                        fullWidth
                        label="Página Final"
                        id = 'PaginaFinal'
                        type='Number'
                        error = { props.getError('PaginaFinal', props.errores).length > 0}
                        helperText = { props.getError('PaginaFinal', props.errores) }
                        value={props.PaginaFinal}
                        onChange={handleOnchange}
                        name="PaginaFinal"/>
                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                        fullWidth
                        label="Número Páginas"
                        id = 'numeropaginas'
                        type='Number'
                        error = { props.getError('numeropaginas', props.errores).length > 0}
                        helperText = { props.getError('numeropaginas', props.errores) }
                        value={props.numeropaginas}
                        onChange={handleOnchange}
                        name="numeropaginas"/>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <MuiPickersUtilsProvider utils={DateFnsUtils} >
                            <Fragment>
                            <DatePicker
                               views={["year", "month"]}
                                label="Año/Mes de publicación"
                                value={props.anioPublicacion}
                                fullWidth
                                onChange={props.setAnioPublicacion}
                                format="yyyy/MM" 
                            />
                            </Fragment>
                        </MuiPickersUtilsProvider>
                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                        fullWidth
                        label="Título del libro"
                        id = 'tituloLibroCap'
                        error = { props.getError('tituloLibroCap', props.errores).length > 0}
                        helperText = { props.getError('tituloLibroCap', props.errores) }
                        value={props.tituloLibroCap}
                        onChange={handleOnchange}
                        name="tituloLibroCap"/>
                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                        fullWidth
                        label="ISBN"
                        id = 'isbnLibroCap'
                        error = { props.getError('isbnLibroCap', props.errores).length > 0}
                        helperText = { props.getError('isbnLibroCap', props.errores) }
                        value={props.isbnLibroCap}
                        onChange={handleOnchange}
                        name="isbnLibroCap"/>
                    </Grid>

                    <Grid item xs={12}>
                    <FormControl 
                        fullWidth 
                        error={props.getError('mediodivulgacion', props.errores).length > 0}>
                        <InputLabel id="medio-divulgacion-label">Medio de divulgación</InputLabel>
                        <Select
                        labelId="medio-divulgacion-label"
                        id="mediodivulgacion"
                        value={props.mediodivulgacion}
                        onChange={handleOnchange}
                        name="mediodivulgacion"
                        >
                        <MenuItem value="Papel">Papel</MenuItem>
                        <MenuItem value="Electronico">Electrónico</MenuItem>
                        </Select>
                        <FormHelperText>
                        {props.getError('mediodivulgacion', props.errores)}
                        </FormHelperText>
                    </FormControl>
                    </Grid>

                     <Grid item xs={12}>
                        <InputLabel htmlFor="age-native-simple">País de Publicación</InputLabel>
                            <FormControl className={classes.formControl} fullWidth error = { props.getError('paisTipoCapLibroSelected', props.errores).length > 0}>
                                <Select
                                    value={props.paisTipoCapLibroSelected}
                                    displayEmpty
                                    fullWidth
                                    inputProps={{ 'aria-label': 'Without label' }}
                                    onChange={handleOnchange}
                                    name="paisTipoCapLibroSelected"
                                >
                                    <MenuItem value="">
                                        <em style={{color: "rgba(0, 0, 0, 0.54)"}}>{ `${props.paisesTipoArticulo.length} Paises para Seleccionar` }</em>
                                    </MenuItem>
                                    {props.paisesTipoArticulo.map((item, index) => (
                                    <MenuItem key= { index } value = { item }>{`${item.nombre}`}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        <FormHelperText>{ props.getError('paisTipoCapLibroSelected', props.errores) }</FormHelperText>
                    </Grid> 
                     <Grid item xs={12} className='oculto'>
                    <TextField
                        ref={fileInput}
                        required
                        type="file"
                        id="adj_certificado2"
                        name="adj_certificado2"
                        label="Adjuntar Identificación"
                        fullWidth
                        autoComplete="billing address-line1"
                        onChange={handleOnchange}
                    />
                    </Grid>

                    <Grid item xs={12}>
                    <InputFile 
                        id="adj_certificado2"
                        label="Certificación de los créditos de la obra"
                        name="adj_certificado2"
                        value={props.adj_certificado2} 
                        required={props.adj_certificado2} 
                        error={props.getError("adj_certificado2", props.errores) > 0}
                        helperText={props.getError("adj_certificado2", props.errores)}
                    />
                    </Grid>

                    <Grid item xs={12} className='oculto'>
                    <TextField
                        ref={fileInput}
                        required
                        type="file"
                        id="adj_certificado3"
                        name="adj_certificado3"
                        label="Adjuntar Identificación"
                        fullWidth
                        autoComplete="billing address-line1"
                        onChange={handleOnchange}
                    />
                    </Grid>
                    <Grid item xs={12}>
                    <InputFile 
                        id="adj_certificado3"
                        label="Certificación de la institución que avala"
                        name="adj_certificado3"
                        value={props.adj_certificado3} 
                        required={props.adj_certificado3} 
                        error={props.getError("adj_certificado3", props.errores) > 0}
                        helperText={props.getError("adj_certificado3", props.errores)}
                    />
                    </Grid>  

                </Grid> : ''}
                {/* Sección de Producción Bibliográfica - Obra */}
                {props.tipoProduccionBiblio.codigo == "Inves_tipo_obra" && (
                <>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label="Nombre de la Obra"
                            id="nombreObra"
                            error={props.getError('nombreObra', props.errores).length > 0}
                            helperText={props.getError('nombreObra', props.errores)}
                            value={props.nombreObra}
                            onChange={handleOnchange}
                            name="nombreObra"
                        />
                        
                        </Grid>

                        <Grid item xs={12}>
                        <InputLabel htmlFor="disciplina">Disciplina</InputLabel>
                        <FormControl
                            className={classes.formControl}
                            fullWidth
                            error={props.getError("disciplina", props.errores).length > 0}
                        >
                            <Select
                            value={props.disciplinaSelected || ''}
                            displayEmpty
                            fullWidth
                            inputProps={{ "aria-label": "Without label" }}
                            onChange={handleOnchange}
                            name="disciplinaSelected"
                            >
                            <MenuItem value="">
                                <em style={{ color: "rgba(31, 30, 30, 0.54)" }}>
                                {`${props.disciplina.length} Disciplinas para Seleccionar`}
                                </em>
                            </MenuItem>
                            {props.disciplina.map((item, index) => (
                                 <MenuItem key= { index } value = { item }>{`${item.nombre}`}</MenuItem>
                            ))}
                            </Select>
                        </FormControl>
                        <FormHelperText>
                            {props.getError("disciplina", props.errores)}
                        </FormHelperText>
                        </Grid>

                        <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label="Título del proyecto  o Investigación"
                            id="tituloObraproducto"
                            error={props.getError('tituloObraproducto', props.errores).length > 0}
                            helperText={props.getError('tituloObraproducto', props.errores)}
                            value={props.tituloObraproducto}
                            onChange={handleOnchange}
                            name="tituloObraproducto"
                        />
                        </Grid>

                        <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label="Técnica o formato"
                            id="tecnica"
                            error={props.getError('tecnica', props.errores).length > 0}
                            helperText={props.getError('tecnica', props.errores)}
                            value={props.tecnica}
                            onChange={handleOnchange}
                            name="tecnica"
                        />
                        </Grid>

                       <Grid item xs={12} sm={6}>
                        <MuiPickersUtilsProvider utils={DateFnsUtils} >
                            <Fragment>
                            <DatePicker
                               views={["year", "month"]}
                                label="Año/Mes de Creación de la Obra"
                                value={props.anioPublicacion}
                                fullWidth
                                onChange={props.setAnioPublicacion}
                                format="yyyy/MM" 
                            />
                            </Fragment>
                        </MuiPickersUtilsProvider>
                    </Grid>
                    
                        <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label="Nombre del Espacio"
                            id="nombreespacio"
                            error={props.getError('nombreespacio', props.errores).length > 0}
                            helperText={props.getError('nombreespacio', props.errores)}
                            value={props.nombreespacio}
                            onChange={handleOnchange}
                            name="nombreespacio"
                        />
                        </Grid>

                        <Grid item xs={12}>
                        <InputLabel htmlFor="tipoespacio">Tipo del espacio o evento</InputLabel>
                        <FormControl
                            className={classes.formControl}
                            fullWidth
                            error={props.getError("tipoespacio", props.errores).length > 0}
                        >
                            <Select
                            value={props.tipoespacioSelected || ''}
                            displayEmpty
                            fullWidth
                            inputProps={{ "aria-label": "Without label" }}
                            onChange={handleOnchange}
                            name="tipoespacioSelected"
                            >
                            <MenuItem value="">
                                <em style={{ color: "rgba(31, 30, 30, 0.54)" }}>
                                {`${props.tipoespacio.length} Tipo del espacio o evento para Seleccionar`}
                                </em>
                            </MenuItem>
                            {props.tipoespacio.map((item, index) => (
                                 <MenuItem key= { index } value = { item }>{`${item.nombre}`}</MenuItem>
                            ))}
                            </Select>
                        </FormControl>
                        <FormHelperText>
                            {props.getError("tipoespacio", props.errores)}
                        </FormHelperText>
                        </Grid>

                         <Grid item xs={12} sm={6}>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDatePicker
                            required
                            style={{ marginTop: 3, width: '100%' }}
                            format="yyyy/MM/dd"
                            margin="normal"
                            label="Fecha de Creación del espacio o evento"
                            value={props.fechapresentacion ? new Date(props.fechapresentacion) : null}
                            onChange={(date) => props.setFechaPresentacion(date)}
                            fullWidth
                            KeyboardButtonProps={{
                                'aria-label': 'change date',
                            }}
                            invalidDateMessage="Formato Inválido"
                            />
                        </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item xs={12}>
                         <MuiPickersUtilsProvider utils={DateFnsUtils} >
                            <Fragment>
                            <DatePicker
                                views={["year"]}
                                label="Año de Creación del espacio"
                                value={props.aniocreacionespacio}
                                fullWidth
                                onChange={props.setAniocreacionEspacio}
                                animateYearScrolling
                            />
                            </Fragment>
                        </MuiPickersUtilsProvider>
                          </Grid>
                      <Grid item xs={12}>
                        <InputLabel htmlFor="distincion">Distinción obtenida</InputLabel>
                        <FormControl
                            className={classes.formControl}
                            fullWidth
                            error={props.getError("distincion", props.errores).length > 0}
                        >
                            <Select
                            value={props.distincionSelected || ''}
                            displayEmpty
                            fullWidth
                            inputProps={{ "aria-label": "Without label" }}
                            onChange={handleOnchange}
                            name="distincionSelected"
                            >
                            <MenuItem value="">
                                <em style={{ color: "rgba(31, 30, 30, 0.54)" }}>
                                {`${props.distincion.length} Distinciones para Seleccionar`}
                                </em>
                            </MenuItem>
                            {props.distincion.map((item, index) => (
                                 <MenuItem key= { index } value = { item }>{`${item.nombre}`}</MenuItem>
                            ))}
                            </Select>
                        </FormControl>
                        <FormHelperText>
                            {props.getError("distincion", props.errores)}
                        </FormHelperText>
                        </Grid>

                        <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label="Entidad Convocante"
                            id="entidadconvocante"
                            error={props.getError('entidadconvocante', props.errores).length > 0}
                            helperText={props.getError('entidadconvocante', props.errores)}
                            value={props.entidadconvocante}
                            onChange={handleOnchange}
                            name="entidadconvocante"
                        />
                        </Grid>

                        <Grid item xs={12}>
                        <InputLabel htmlFor="age-native-simple">Ambito: </InputLabel>
                        <FormControl className={classes.formControl} fullWidth error = { props.getError('tipoAmbitoSelected', props.errores).length > 0}>
                            <Select
                                value={props.tipoAmbitoSelected}
                                displayEmpty
                                fullWidth
                                inputProps={{ 'aria-label': 'Without label' }}
                                onChange={handleOnchange}
                                name="tipoAmbitoSelected"
                            >
                                <MenuItem value="">
                                    <em style={{color: "rgba(0, 0, 0, 0.54)"}}>{ `${props.tiposAmbitos.length} Ambitos a Elegir` }</em>
                                </MenuItem>
                                {props.tiposAmbitos.map((item, index) => (
                                <MenuItem key= { index } value = { item }>{`${item.nombre}`}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <FormHelperText>{ props.getError('tipoAmbitoSelected', props.errores) }</FormHelperText>
                    </Grid>

                        <Grid item xs={12}>
                        <InputLabel htmlFor="mecanismoseleccion">Mecanismo de Selección</InputLabel>
                        <FormControl
                            className={classes.formControl}
                            fullWidth
                            error={props.getError("mecanismoseleccion", props.errores).length > 0}
                        >
                            <Select
                            value={props.mecanismoSelected || ''}
                            displayEmpty
                            fullWidth
                            inputProps={{ "aria-label": "Without label" }}
                            onChange={handleOnchange}
                            name="mecanismoSelected"
                            >
                            <MenuItem value="">
                                <em style={{ color: "rgba(31, 30, 30, 0.54)" }}>
                                {`${props.mecanismoseleccion.length} Mecanismos para Seleccionar`}
                                </em>
                            </MenuItem>
                            {props.mecanismoseleccion.map((item, index) => (
                                 <MenuItem key= { index } value = { item }>{`${item.nombre}`}</MenuItem>
                            ))}
                            </Select>
                        </FormControl>
                        <FormHelperText>
                            {props.getError("mecanismoseleccion", props.errores)}
                        </FormHelperText>
                        </Grid>

                        <Grid item xs={12}>
                        <FormControl 
                            fullWidth 
                            error={props.getError('acuerdoLicencia', props.errores).length > 0}>
                            <InputLabel id="acuerdo-licencia-label">Tiene Registro de Acuerdo de Licencia:</InputLabel>
                            <Select
                            labelId="acuerdo-licencia-label"
                            id="acuerdoLicencia"
                            value={props.acuerdoLicencia}
                            onChange={handleOnchange}
                            name="acuerdoLicencia"
                            >
                            <MenuItem value="si">Sí</MenuItem>
                            <MenuItem value="no">No</MenuItem>
                            </Select>
                            <FormHelperText>
                            {props.getError('acuerdoLicencia', props.errores)}
                            </FormHelperText>
                        </FormControl>
                        </Grid>


                        {props.acuerdoLicencia === "si" && (
                        <>

                        <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label="Institución Licencia"
                            id="institucionlicencia"
                            error={props.getError('institucionlicencia', props.errores).length > 0}
                            helperText={props.getError('institucionlicencia', props.errores)}
                            value={props.institucionlicencia}
                            onChange={handleOnchange}
                            name="institucionlicencia"
                        />
                        </Grid>
                         <Grid item xs={12} sm={6}>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDatePicker
                            required
                            style={{ marginTop: 3, width: '100%' }}
                            format="yyyy/MM/dd"
                            margin="normal"
                            label="Fecha de Otorgamiento de la Licencia"
                            value={props.fechaotrogamiento ? new Date(props.fechaotrogamiento) : null}
                            onChange={(date) => props.setFechaOtorgamiento(date)}
                            fullWidth
                            KeyboardButtonProps={{
                                'aria-label': 'change date',
                            }}
                            invalidDateMessage="Formato Inválido"
                            />
                        </MuiPickersUtilsProvider>
                        </Grid>

                        <Grid item xs={12}>
                        <InputLabel htmlFor="age-native-simple">Ciudad</InputLabel>
                            <FormControl className={classes.formControl} fullWidth error = { props.getError('CiudadesTipoArticuloSelected', props.errores).length > 0}>
                                <Select
                                    value={props.CiudadesTipoArticuloSelected}
                                    displayEmpty
                                    fullWidth
                                    inputProps={{ 'aria-label': 'Without label' }}
                                    onChange={handleOnchange}
                                    name="CiudadesTipoArticuloSelected"
                                >
                                    <MenuItem value="">
                                        <em style={{color: "rgba(0, 0, 0, 0.54)"}}>{ `${props.CiudadesTipoArticulo.length} Ciudades para Seleccionar` }</em>
                                    </MenuItem>
                                    {props.CiudadesTipoArticulo.map((item, index) => (
                                    <MenuItem key= { index } value = { item }>{`${item.nombre}`}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        <FormHelperText>{ props.getError('CiudadesTipoArticuloSelected', props.errores) }</FormHelperText>
                    </Grid>
            
                        <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label="Número de Registro"
                            id="numeroregistro"
                            error={props.getError('numeroregistro', props.errores).length > 0}
                            helperText={props.getError('numeroregistro', props.errores)}
                            value={props.numeroregistro}
                            onChange={handleOnchange}
                            name="numeroregistro"
                        />
                        </Grid>

                        <Grid item xs={12}>
                        <FormControl 
                            fullWidth 
                            error={props.getError('contratocomercializacion', props.errores).length > 0}>
                            <InputLabel id="contrato-comercializacion-label">¿Tiene Contrato de comerzialización?:</InputLabel>
                            <Select
                            labelId="contrato-comercializacion-label"
                            id="contratocomercializacion"
                            value={props.contratocomercializacion}
                            onChange={handleOnchange}
                            name="contratocomercializacion"
                            >
                            <MenuItem value="si">Sí</MenuItem>
                            <MenuItem value="no">No</MenuItem>
                            </Select>
                            <FormHelperText>
                            {props.getError('contratocomercializacion', props.errores)}
                            </FormHelperText>
                        </FormControl>
                        </Grid>
                        </>
                    )}
                    </Grid>
                
                </>
                )}
                {/* Seccion de Produccion Bibliografica Patente*/}
                { props.tipoProduccionBiblio.codigo == "Inves_tipo_biblio_patente" ?
                <Grid container spacing={3}>
                    
                    <Grid item xs={12}>
                        <TextField
                        fullWidth
                        label="Titulo de la Patente"
                        id = 'tituloPatente'
                        error = { props.getError('tituloPatente', props.errores).length > 0}
                        helperText = { props.getError('tituloPatente', props.errores) }
                        value={props.tituloPatente}
                        onChange={handleOnchange}
                        name="tituloPatente"/>
                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                        fullWidth
                        label="Numero Patente"
                        id = 'numeroPatente'
                        error = { props.getError('numeroPatente', props.errores).length > 0}
                        helperText = { props.getError('numeroPatente', props.errores) }
                        value={props.numeroPatente}
                        onChange={handleOnchange}
                        name="numeroPatente"/>
                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                        fullWidth
                        label="Nombre del solicitante de la patente"
                        id = 'nombreSolicitante'
                        error = { props.getError('nombreSolicitante', props.errores).length > 0}
                        helperText = { props.getError('nombreSolicitante', props.errores) }
                        value={props.nombreSolicitante}
                        onChange={handleOnchange}
                        name="nombreSolicitante"/>
                    </Grid>

                    <Grid item xs={12}>
                        <InputLabel htmlFor="age-native-simple">Tipo de patente</InputLabel>
                            <FormControl className={classes.formControl} fullWidth error = { props.getError('tipoPatente', props.errores).length > 0}>
                                <Select
                                    value={props.tipoPatenteSelected}
                                    displayEmpty
                                    fullWidth
                                    inputProps={{ 'aria-label': 'Without label' }}
                                    onChange={handleOnchange}
                                    name="tipoPatente"
                                >
                                    <MenuItem value="">
                                        <em style={{color: "rgba(0, 0, 0, 0.54)"}}>{ `${props.tipoPatente.length} Patentes para Seleccionar` }</em>
                                    </MenuItem>
                                    {props.tipoPatente.map((item, index) => (
                                    <MenuItem key= { index } value = { item }>{`${item.nombre}`}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        <FormHelperText>{ props.getError('tipoPatente', props.errores) }</FormHelperText>
                    </Grid>

                    <Grid item xs={12}>
                        <InputLabel htmlFor="age-native-simple">Via Solicitud</InputLabel>
                            <FormControl className={classes.formControl} fullWidth error = { props.getError('viaSolicitud', props.errores).length > 0}>
                                <Select
                                    value={props.viaSolicitudSelected}
                                    displayEmpty
                                    fullWidth
                                    inputProps={{ 'aria-label': 'Without label' }}
                                    onChange={handleOnchange}
                                    name="viaSolicitud"
                                >
                                    <MenuItem value="">
                                        <em style={{color: "rgba(0, 0, 0, 0.54)"}}>{ `${props.viaSolicitud.length} Opciones para Seleccionar` }</em>
                                    </MenuItem>
                                    {props.viaSolicitud.map((item, index) => (
                                    <MenuItem key= { index } value = { item }>{`${item.nombre}`}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        <FormHelperText>{ props.getError('viaSolicitud', props.errores) }</FormHelperText>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDatePicker
                            required
                            style={{ marginTop: 3, width: '100%' }}
                            format="yyyy/MM/dd"
                            margin="normal"
                            label="Fecha de Presentación"
                            value={props.anioObtencionPatente ? new Date(props.anioObtencionPatente) : null}
                            onChange={(date) => props.setAnioObtencionPatente(date)}
                            fullWidth
                            KeyboardButtonProps={{
                                'aria-label': 'change date',
                            }}
                            invalidDateMessage="Formato Inválido"
                            />
                        </MuiPickersUtilsProvider>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                     <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDatePicker
                            required
                            style={{ marginTop: 3, width: '100%' }}
                            format="yyyy/MM/dd"
                            margin="normal"
                            label="Fecha de Examen"
                            value={props.fechapresentacion ? new Date(props.fechapresentacion) : null}
                            onChange={(date) => props.setFechaPresentacion(date)}
                            fullWidth
                            KeyboardButtonProps={{
                                'aria-label': 'change date',
                            }}
                            invalidDateMessage="Formato Inválido"
                            />
                        </MuiPickersUtilsProvider>
                    </Grid>
                     <Grid item xs={12} sm={6}>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDatePicker
                            required
                            style={{ marginTop: 3, width: '100%' }}
                            format="yyyy/MM/dd"
                            margin="normal"
                            label="Fecha de Obtención"
                            value={props.fechaotrogamiento ? new Date(props.fechaotrogamiento) : null}
                            onChange={(date) => props.setFechaOtorgamiento(date)}
                            fullWidth
                            KeyboardButtonProps={{
                                'aria-label': 'change date',
                            }}
                            invalidDateMessage="Formato Inválido"
                            />
                        </MuiPickersUtilsProvider>
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                        fullWidth
                        label="Institución"
                        id = 'institucionPatente'
                        error = { props.getError('institucionPatente', props.errores).length > 0}
                        helperText = { props.getError('institucionPatente', props.errores) }
                        value={props.institucionPatente}
                        onChange={handleOnchange}
                        name="institucionPatente"/>
                    </Grid>

                    <Grid item xs={12} className='oculto'>
                    <TextField
                        ref={fileInput}
                        required
                        type="file"
                        id="adj_certificado2"
                        name="adj_certificado2"
                        label="Adjuntar Identificación"
                        fullWidth
                        autoComplete="billing address-line1"
                        onChange={handleOnchange}
                    />
                    </Grid>

                    <Grid item xs={12}>
                    <InputFile 
                        id="adj_certificado2"
                        label="Gaceta Industrial de Publicación"
                        name="adj_certificado2"
                        value={props.adj_certificado2} 
                        required={props.adj_certificado2} 
                        error={props.getError("adj_certificado2", props.errores) > 0}
                        helperText={props.getError("adj_certificado2", props.errores)}
                    />
                    </Grid>
                    
                    <Grid item xs={12}>
                        <FormControl 
                            fullWidth 
                            error={props.getError('acuerdoLicencia', props.errores).length > 0}>
                            <InputLabel id="acuerdo-licencia-label">¿La patente tiene contrato de explotación o licenciamiento?</InputLabel>
                            <Select
                            labelId="acuerdo-licencia-label"
                            id="acuerdoLicencia"
                            value={props.acuerdoLicencia}
                            onChange={handleOnchange}
                            name="acuerdoLicencia"
                            >
                            <MenuItem value="si">Sí</MenuItem>
                            <MenuItem value="no">No</MenuItem>
                            </Select>
                            <FormHelperText>
                            {props.getError('acuerdoLicencia', props.errores)}
                            </FormHelperText>
                        </FormControl>
                        </Grid>
                    <Grid item xs={12} className='oculto'>
                    <TextField
                        ref={fileInput}
                        required
                        type="file"
                        id="adj_certificado3"
                        name="adj_certificado3"
                        label="Adjuntar Identificación"
                        fullWidth
                        autoComplete="billing address-line1"
                        onChange={handleOnchange}
                    />
                    </Grid>
                    <Grid item xs={12}>
                    <InputFile 
                        id="adj_certificado3"
                        label="Certificado de patente"
                        name="adj_certificado3"
                        value={props.adj_certificado3} 
                        required={props.adj_certificado3} 
                        error={props.getError("adj_certificado3", props.errores) > 0}
                        helperText={props.getError("adj_certificado3", props.errores)}
                    />
                    </Grid>  
                    
                    <Grid item xs={12} className='oculto'>
                    <TextField
                        ref={fileInput}
                        required
                        type="file"
                        id="adj_certificado4"
                        name="adj_certificado4"
                        label="Adjuntar Identificación"
                        fullWidth
                        autoComplete="billing address-line1"
                        onChange={handleOnchange}
                    />
                    </Grid>
                    <Grid item xs={12}>
                    <InputFile 
                        id="adj_certificado4"
                        label="Examen de fondo"
                        name="adj_certificado4"
                        value={props.adj_certificado4} 
                        required={props.adj_certificado4} 
                        error={props.getError("adj_certificado4", props.errores) > 0}
                        helperText={props.getError("adj_certificado4", props.errores)}
                    />
                    </Grid>
                </Grid> : ''}
        </div>
    )

}
//Este solo se ejecuta cuando setSeleccion es igual a eventos o proyectos
const ModalStepperForm = (props) => {
    const classes = useStyles()

    return (
        <div className={classes.root}>
          <Stepper activeStep={props.hola} alternativeLabel>
            {props.steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
          <div>
          {/* Aqui es cuando el Stepper llega al final.*/}
            {props.hola === props.steps.length ? (
              <div>
                <Typography className={classes.instructions}>{props.hola}</Typography>
                <Button onClick={props.handleReset}>Reset</Button>
              </div>
            ) : (
              <div>
                {getStepContent(props.hola, props)}
              </div>
            )}
          </div>
        </div>
    )
}

function getStepContent(stepIndex, props) {
    switch (stepIndex) {
        case 0:
            return (
                <ModalFormGestion
                    tipoSolicitudActual={props.tipoSolicitudActual}
                    setTipoSolicitudActual={props.setTipoSolicitudActual}

                    //Variables eventos
                    anio={props.anio}
                    setAnio={props.setAnio}

                    fechaInicioEvento={props.fechaInicioEvento}
                    setFechaInicioEvento={props.setFechaInicioEvento}

                    fechaFinEvento={props.fechaFinEvento}
                    setFechaFinEvento={props.setFechaFinEvento}

                    departamentos={props.departamentos}
                    setDepartamentos={props.setDepartamentos}

                    departamento={props.departamento}
                    setDepartamento={props.setDepartamento}

                    ciudades={props.ciudades}
                    setCiudades={props.setCiudades}

                    ciudad={props.ciudad}
                    setCiudad={props.setCiudad}

                    nombreDelEvento={props.nombreDelEvento}
                    setNombreDelEvento={props.setNombreDelEvento}

                    nombreDelAmbito={props.nombreDelAmbito}
                    setNombreDelAmbito={props.setNombreDelAmbito}

                    nombreAmbitos={props.nombreAmbitos}
                    setNombreAmbitos={props.setNombreAmbitos}

                    nombreModalidadPar={props.nombreModalidadPar}
                    setNombreModalidadPar={props.setNombreModalidadPar}

                    nombreModalidadPars={props.nombreModalidadPars}
                    setNombreModalidadPars={props.setNombreModalidadPars}

                    adj_evento={props.adj_evento}
                    setAdj_evento={props.setAdj_evento}

                    //Variables Proyectos
                    fechaInicio={props.fechaInicio}
                    setFechaInicio={props.setFechaInicio}

                    fechaFin={props.fechaFin}
                    setFechaFin={props.setFechaFin}

                    nombreProyecto={props.nombreProyecto}
                    setNombreProyecto={props.setNombreProyecto}

                    descripcionProyecto={props.descripcionProyecto}
                    setDescripcionProyecto={props.setDescripcionProyecto}

                    asignaturaProyecto={props.asignaturaProyecto}
                    setAsignaturaProyecto={props.setAsignaturaProyecto}
                    
                    nombreprofesorProyecto={props.nombreprofesorProyecto}
                    setNombreprofesorProyecto={props.setNombreprofesorProyecto}

                    profesorProyecto={props.profesorProyecto}
                    setProfesorProyecto={props.setProfesorProyecto}

                    obtenerliderSemillero={props.obtenerliderSemillero}
                    //Variables Prod. Bibliografica
                    nombreProductoBiblio={props.nombreProductoBiblio}
                    setNombreProductoBiblio={props.setNombreProductoBiblio}

                    tipoProductoBiblio={props.tipoProductoBiblio}
                    setTipoProductoBiblio={props.setTipoProductoBiblio}

                    anioBiblio={props.anioBiblio}
                    setAnioBiblio={props.setAnioBiblio}

                    revistaEditorialBiblio={props.revistaEditorialBiblio}
                    setRevistaEditorialBiblio={props.setRevistaEditorialBiblio}

                    cuartilBiblio={props.cuartilBiblio}
                    setCuartilBiblio={props.setCuartilBiblio}

                    lugarPublicacionBiblio={props.lugarPublicacionBiblio}
                    setLugarPublicacionBiblio={props.setLugarPublicacionBiblio}

                    medioDivulgacionBiblio={props.medioDivulgacionBiblio}
                    setMedioDivulgacionBiblio={props.setMedioDivulgacionBiblio}

                    //Variables Prod. Tec y Tecno
                    nombreProductoTec={props.nombreProductoTec}
                    setNombreProductoTec={props.setNombreProductoTec}

                    tipoProductoTec={props.tipoProductoTec}
                    setTipoProductoTec={props.setTipoProductoTec}

                    nitTec={props.nitTec}
                    setNitTec={props.setNitTec}

                    numeroRegistroTec={props.numeroRegistroTec}
                    setNumeroRegistroTec={props.setNumeroRegistroTec}

                    nombreTitular={props.nombreTitular}
                    setNombreTitular={props.setNombreTitular}

                    anioTec={props.anioTec}
                    setAnioTec={props.setAnioTec}

                    paisTec={props.paisTec}
                    setPaisTec={props.setPaisTec}
                    //Cargando
                    cargando={props.cargando}
                    setCargando={props.setCargando}

                    //Errores
                    getError={props.getError}
                    errores={props.errores}
                    setErrores={props.setErrores}

                    //rol y modalidad
                    rolActive={props.rolActive}
                    setRolActive={props.setRolActive}
                   
                />
            )
        case 1:
            return (
                <ModalFormGestionAutores
                    tipoSolicitudActual={props.tipoSolicitudActual}
                    setTipoSolicitudActual={props.setTipoSolicitudActual}

                    //Variables Autores y Particiapntes
                    numeroIdParEvent={props.numeroIdParEvent}
                    setNumeroIdParEvent={props.setNumeroIdParEvent}
                    arrai={props.arrai}
                    setArrai={props.setArrai}

                    //Permisos de la solicitud
                    permisosDeLaSolicitud={props.permisosDeLaSolicitud}
                    setPermisosDeLaSolicitud={props.setPermisosDeLaSolicitud}

                    //rol y modalidad
                    rolActive={props.rolActive}
                    setRolActive={props.setRolActive}

                    modalidadParticipacionActive={props.modalidadParticipacionActive}
                    setModalidadParticipacionActive={props.setModalidadParticipacionActive}

                    tiposRoles={props.nombreModalidadPars}
                    setTiposRoles={props.setNombreModalidadPars}

                    //Errores
                    getError={props.getError}
                    errores={props.errores}
                    setErrores={props.setErrores}

                     // Certificado
                     adj_certificado_final={props.adj_certificado_final}
                     setAdj_certificado_final={props.setAdj_certificado_final}
 
                     adj_certificado={props.adj_certificado}
                     setAdj_certificado={props.setAdj_certificado}
                />
            )
    }
}

const ModalFormGestion = (props) => {
    //Variables para proyectos
    const isInitialMount = React.useRef(true);
    const classes = useStyles();
    const fileInput = React.createRef();

    React.useEffect( () => {
        //Obtengo los prceosos activos de la persona activa.
        if(isInitialMount.current){
            isInitialMount.current = false
            const obtenerProcesos = async () => {
                obtenerDepartamentos()
                obtenerAmbitoModalidad()
                obtenerProfesores()
            }
            obtenerProcesos()
        }
    })


    const obtenerDepartamentos = async () =>{
        let departamentos = await obtenerValores(7);
        const transformar = data => {
            return data.map(e => ({
              value: e.id,
              label: e.nombre,
              codigo: e.codigo,
            }));
        }
        props.setDepartamentos(transformar(departamentos))
    }

    const obtenerAmbitoModalidad = async () => {
        try{

          const data = await Funciones.obtenerValores(Helper.AMBITO_INVESTIGACION)
          const dataModalidad = await Funciones.obtenerValores(Helper.MODALIDAD_PAR_INVESTIGACION)
          props.setNombreAmbitos(data)
          props.setNombreModalidadPars(dataModalidad)
          props.setCargando(false)
        }catch(err){
          console.log(err)
        }

      }

    const obtenerCiudades = async (value) =>{

        if(props.ciudad != ''){
            props.setCiudad('')
        }
        let ciudades = await obtenerPermisosValor(value.value);
        ciudades = ciudades.map(({ secundario }) => ({
            value: secundario.id,
            label: secundario.nombre,
          }));
        props.setCiudades(ciudades)
    }
    const obtenerProfesores = async () =>{
        let data = await props.obtenerliderSemillero()
        let profesore= data.lideres.filter(l=>l.rol.codigo != 'Semi_rol1')
        props.setProfesorProyecto(profesore)
    }
    const handleOnchange = (e) =>{
        if(props.tipoSolicitudActual == "Semi_inves_divulgacion" ){
            if(e.target.name == "nombreProyecto"){
                props.setNombreProyecto(e.target.value)
                if(props.errores.length > 0){
                    props.setErrores(props.errores.filter(er => er.llave != "nombreProyecto"));
                    // Elimina error cuando se escribe en el campo
                }
            }else if (e.target.name == "descripcionProyecto") {
                props.setDescripcionProyecto(e.target.value)
                if(props.errores.length > 0){
                    props.setErrores(props.errores.filter(er => er.llave != "descripcionProyecto"));
                    // Elimina error cuando se escribe en el campo
                }
            }else if (e.target.name == "asignaturaProyecto") {
                props.setAsignaturaProyecto(e.target.value)
                if(props.errores.length > 0){
                    props.setErrores(props.errores.filter(er => er.llave != "asignaturaProyecto"));
                    // Elimina error cuando se escribe en el campo
                }
            }else if (e.target.name == "nombreprofesorProyecto") {
                props.setNombreprofesorProyecto(e.target.value)
                if(props.errores.length > 0){
                    props.setErrores(props.errores.filter(er => er.llave != "nombreprofesorProyecto"));
                    // Elimina error cuando se escribe en el campo
                }
            }
        }else if(props.tipoSolicitudActual == "Soli_inves_evento"){
            if(e.target.name == "nombreDelEvento"){
                props.setNombreDelEvento(e.target.value)
                if(props.errores.length > 0){
                    props.setErrores(props.errores.filter(er => er.llave != "nombreDelEvento"));
                    // Elimina error cuando se escribe en el campo
                }
            }else if(e.target.name == "nombreDelAmbito"){
                props.setNombreDelAmbito(e.target.value)
                if(props.errores.length > 0){
                    props.setErrores(props.errores.filter(er => er.llave != "nombreDelAmbito"));
                    // Elimina error cuando se escribe en el campo
                }
            }else if(e.target.name == "nombreModalidadPar"){
                props.setNombreModalidadPar(e.target.value)
                if(props.errores.length > 0){
                    props.setErrores(props.errores.filter(er => er.llave != "nombreModalidadPar"));
                    // Elimina error cuando se escribe en el campo
                }
            }else if(e.target.name == "adj_evento"){
                props.setAdj_evento(e.target.value)
                if(props.errores.length > 0){
                    props.setErrores(props.errores.filter(er => er.llave != "adj_evento"));
                    // Elimina error cuando se escribe en el campo
                }
            }
        }else if(props.tipoSolicitudActual == "Semi_inves_generacion"){
            if(e.target.name == "nombreProductoBiblio"){
                props.setNombreProductoBiblio(e.target.value)
            }else if(e.target.name == "tipoProductoBiblio"){
                props.setTipoProductoBiblio(e.target.value)
            }else if(e.target.name == "revistaEditorialBiblio"){
                props.setRevistaEditorialBiblio(e.target.value)
            }else if(e.target.name == "cuartilBiblio"){
                props.setCuartilBiblio(e.target.value)
            }else if(e.target.name == "lugarPublicacionBiblio"){
                props.setLugarPublicacionBiblio(e.target.value)
            }else if(e.target.name == "medioDivulgacionBiblio"){
                props.setMedioDivulgacionBiblio(e.target.value)
            }
        }else if(props.tipoSolicitudActual == "Semi_inves_tecnologico"){
            if(e.target.name == "nombreProductoTec"){
                props.setNombreProductoTec(e.target.value)
            }else if(e.target.name == "tipoProductoTec"){
                props.setTipoProductoTec(e.target.value)
            }else if(e.target.name == "nitTec"){
                props.setNitTec(e.target.value)
            }else if(e.target.name == "numeroRegistroTec"){
                props.setNumeroRegistroTec(e.target.value)
            }else if(e.target.name == "nombreTitular"){
                props.setNombreTitular(e.target.value)
            }else if(e.target.name == "anioTec"){
                props.setAnioTec(e.target.value)
            }else if(e.target.name == "paisTec"){
                props.setPaisTec(e.target.value)
            }
        }
    }

    return (
        <div>
        {props.cargando == false ?
            <div>
                {/* PROYECTOS */}
                {props.tipoSolicitudActual == "Semi_inves_divulgacion" ?
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <TextField
                        fullWidth
                        label="Nombre del Proyecto"
                        error = { props.getError('nombreProyecto', props.errores).length > 0}
                        helperText = { props.getError('nombreProyecto', props.errores) }
                        value={props.nombreProyecto}
                        onChange={handleOnchange}
                        name="nombreProyecto"/>
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                        fullWidth
                        label="Descripción del proyecto"
                        error = { props.getError('descripcionProyecto', props.errores).length > 0}
                        helperText = { props.getError('descripcionProyecto', props.errores) }
                        value={props.descripcionProyecto}
                        onChange={handleOnchange}
                        name="descripcionProyecto"/>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                        fullWidth
                        label="Nombre de asignatura o área de conocimiento"
                        error = { props.getError('asignaturaProyecto', props.errores).length > 0}
                        helperText = { props.getError('asignaturaProyecto', props.errores) }
                        value={props.asignaturaProyecto}
                        onChange={handleOnchange}
                        name="asignaturaProyecto"/>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <InputLabel htmlFor="age-native-simple">Profesor Asesor</InputLabel>
                        <FormControl className={classes.formControl} fullWidth error = { props.getError('nombreprofesorProyecto', props.errores).length > 0}>
                        <Select
                            value={props.nombreprofesorProyecto}
                            displayEmpty
                            fullWidth
                            inputProps={{ 'aria-label': 'Without label' }}
                            onChange={handleOnchange}
                            name="nombreprofesorProyecto"
                        >
                            <MenuItem value="">
                                <em style={{color: "rgba(0, 0, 0, 0.54)"}}>{ `${props.profesorProyecto.length} Profesores para Seleccionar` }</em>
                            </MenuItem>
                            {props.profesorProyecto.map((item, index) => (
                            <MenuItem key= { index } value = { item.encargado_id }>{`${item.nombre}`}</MenuItem>
                            ))}
                            </Select>
                        </FormControl>
                        <FormHelperText>{ props.getError('nombreprofesorProyecto', props.errores) }</FormHelperText>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <MuiPickersUtilsProvider utils={DateFnsUtils} >
                            <Fragment>
                            <KeyboardDatePicker
                                required={true}                           
                                style={{ marginTop: 3, width: '100%' }}
                                format="MM/dd/yyyy"
                                margin="normal"
                                label="Fecha de Inicio"
                                value={props.fechaInicio}
                                onChange={props.setFechaInicio}
                                fullWidth
                                KeyboardButtonProps={{
                                    'aria-label': 'change date',
                                }}
                                invalidDateMessage='Formato Invalido'
                            />
                            </Fragment>
                        </MuiPickersUtilsProvider>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <MuiPickersUtilsProvider utils={DateFnsUtils} >
                            <Fragment>
                            <KeyboardDatePicker
                                required={true}                           
                                style={{ marginTop: 3, width: '100%' }}
                                format="MM/dd/yyyy"
                                margin="normal"
                                label="Fecha de Fin"
                                value={props.fechaFin}
                                onChange={props.setFechaFin}
                                fullWidth
                                KeyboardButtonProps={{
                                    'aria-label': 'change date',
                                }}
                                invalidDateMessage='Formato Invalido'
                            />
                            </Fragment>
                        </MuiPickersUtilsProvider>
                    </Grid>
                </Grid>: ''}
                {/* FIN PROYECTOS */}

                {/* EVENTOS */}
                {props.tipoSolicitudActual == "Soli_inves_evento" ?
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <TextField
                        fullWidth
                        label="Nombre del Evento"
                        id = 'nombreEvento'
                        error = { props.getError('nombreDelEvento', props.errores).length > 0}
                        helperText = { props.getError('nombreDelEvento', props.errores) }
                        value={props.nombreDelEvento}
                        onChange={handleOnchange}
                        name="nombreDelEvento"/>
                    </Grid>

                    <Grid item xs={12}>
                        <MuiPickersUtilsProvider utils={DateFnsUtils} >
                            <Fragment>
                            <DatePicker
                                views={["year"]}
                                label="Año"
                                value={props.anio}
                                fullWidth
                                onChange={props.setAnio}
                                animateYearScrolling
                            />
                            </Fragment>
                        </MuiPickersUtilsProvider>
                    </Grid>

                    <Grid item xs={12}>
                        <FormControl className={classes.formControl} fullWidth error = { props.getError('departamento', props.errores).length > 0}>
                        <BuscarSelect
                            datos={props.departamentos}
                            cambiarEstado={(value) => {
                                obtenerCiudades(value)

                                props.setDepartamento(value)
                                if(props.errores.length > 0){
                                    props.setErrores(props.errores.filter(er => er.llave != "departamento"));
                                }
                            }} valor={props.departamento}
                            id='select-departamento'
                            nombre='Departamento'
                            name='departamento'
                            placeholder='Seleccione Opción' />
                        </FormControl>
                        <FormHelperText style={{color: "#FF2D00"}}>{ props.getError('departamento', props.errores) }</FormHelperText>
                    </Grid>
                    <Grid item xs={12}>
                        <FormControl className={classes.formControl} fullWidth error = { props.getError('ciudad', props.errores).length > 0}>
                            <BuscarSelect
                            datos={props.ciudades}
                            cambiarEstado={(value) => {
                                props.setCiudad(value)

                                if(props.errores.length > 0){
                                    props.setErrores(props.errores.filter(er => er.llave != "ciudad"));
                                }
                            }}
                            valor={props.ciudad}
                            id='select-ciudad'
                            nombre='Ciudad'
                            name='ciudad'
                            placeholder='Seleccione Opción'/>
                        </FormControl>
                        <FormHelperText style={{color: "#FF2D00"}}>{ props.getError('ciudad', props.errores) }</FormHelperText>
                    </Grid>

                    <Grid item xs={12}>
                        <InputLabel htmlFor="age-native-simple">Ambito</InputLabel>
                        <FormControl className={classes.formControl} fullWidth error = { props.getError('nombreDelAmbito', props.errores).length > 0}>
                        <Select
                            value={props.nombreDelAmbito}
                            displayEmpty
                            fullWidth
                            inputProps={{ 'aria-label': 'Without label' }}
                            onChange={handleOnchange}
                            name="nombreDelAmbito"
                        >
                            <MenuItem value="">
                                <em style={{color: "rgba(0, 0, 0, 0.54)"}}>{ `${props.nombreAmbitos.length} Ambitos para Seleccionar` }</em>
                            </MenuItem>
                            {props.nombreAmbitos.map((item, index) => (
                            <MenuItem key= { index } value = { item.id }>{`${item.nombre}`}</MenuItem>
                            ))}
                            </Select>
                        </FormControl>
                        <FormHelperText>{ props.getError('nombreDelAmbito', props.errores) }</FormHelperText>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <MuiPickersUtilsProvider utils={DateFnsUtils} >
                            <Fragment>
                            <KeyboardDatePicker
                                required={true}                           
                                style={{ marginTop: 3, width: '100%' }}
                                format="MM/dd/yyyy"
                                margin="normal"
                                label="Fecha de Inicio"
                                value={props.fechaInicioEvento}
                                onChange={props.setFechaInicioEvento}
                                fullWidth
                                KeyboardButtonProps={{
                                    'aria-label': 'change date',
                                }}
                                invalidDateMessage='Formato Invalido'
                            />
                            </Fragment>
                        </MuiPickersUtilsProvider>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <MuiPickersUtilsProvider utils={DateFnsUtils} >
                            <Fragment>
                            <KeyboardDatePicker
                                required={true}                           
                                style={{ marginTop: 3, width: '100%' }}
                                format="MM/dd/yyyy"
                                margin="normal"
                                label="Fecha de Fin"
                                value={props.fechaFinEvento}
                                onChange={props.setFechaFinEvento}
                                fullWidth
                                KeyboardButtonProps={{
                                    'aria-label': 'change date',
                                }}
                                invalidDateMessage='Formato Invalido'
                            />
                            </Fragment>
                        </MuiPickersUtilsProvider>
                    </Grid>
                    <Grid item xs={12} className='oculto'>
                        <TextField
                        ref={fileInput}
                        required
                        type="file"
                        id="adj_evento"
                        name="adj_evento"
                        label="Adjuntar Identificación"
                        fullWidth
                        autoComplete="billing address-line1"
                        onChange={handleOnchange}
                        />
                    </Grid>
                    <Grid item xs={12}>
                    <InputFile 
                    label='Adjuntar Soporte de Evento' 
                    id='adj_evento' 
                    value={props.adj_evento} 
                    required={props.adj_evento} 
                    error={props.getError('adj_evento', props.errores) > 0}
                    helperText = { props.getError('adj_evento', props.errores) }/>
                   </Grid>

                </Grid> : ''}
                {/* FIN EVENTOS */}
                {/* PROD. BIBLIOGRÁFICO */}

                {props.tipoSolicitudActual == "Semi_inves_generacion" ?
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <TextField
                        fullWidth
                        label="Nombre del Producto"
                        id = 'nombreProyecto'
                        value={props.nombreProductoBiblio}
                        onChange={handleOnchange}
                        name="nombreProductoBiblio"/>
                    </Grid>

                    <Grid item xs={6}>
                        <TextField
                        fullWidth
                        label="Tipo del Producto"
                        id = 'nombreTipoProducto'
                        value={props.tipoProductoBiblio}
                        onChange={handleOnchange}
                        name="tipoProductoBiblio"/>
                    </Grid>

                    <Grid item xs={6}>
                        <MuiPickersUtilsProvider utils={DateFnsUtils} >
                            <Fragment>
                            <DatePicker
                                views={["year"]}
                                label="Año"
                                value={props.anioBiblio}
                                fullWidth
                                onChange={props.setAnioBiblio}
                                animateYearScrolling
                            />
                            </Fragment>
                        </MuiPickersUtilsProvider>
                    </Grid>

                    <Grid item xs={6}>
                        <TextField
                        fullWidth
                        label="Revista/Editorial"
                        id = 'nombreRevistaEditorial'

                        value={props.revistaEditorialBiblio}
                        onChange={handleOnchange}
                        name="revistaEditorialBiblio"/>
                    </Grid>

                    <Grid item xs={6}>
                        <TextField
                        fullWidth
                        label="Cuartil"
                        id = 'nombreCuartil'
                        value={props.cuartilBiblio}
                        onChange={handleOnchange}
                        name="cuartilBiblio"/>
                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                        fullWidth
                        label="Lugar de Publicacion"
                        id = 'nombreLugarPublicacion'
                        value={props.lugarPublicacionBiblio}
                        onChange={handleOnchange}
                        name="lugarPublicacionBiblio"/>
                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                        fullWidth
                        label="Medio de Divulgacion"
                        id = 'nombreMedioDivulgacion'
                        value={props.medioDivulgacionBiblio}
                        onChange={handleOnchange}
                        name="medioDivulgacionBiblio"/>
                    </Grid>
                </Grid>
                : ''}

                {/* FIN PROD. BIBLIOGRAFICO */}

                {/* PROD. TEC Y TECNO */}
                {props.tipoSolicitudActual == "Semi_inves_tecnologico" ?
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <TextField
                        fullWidth
                        label="Nombre del Producto"
                        id = 'nombreProductoTecTecno'
                        value={props.nombreProductoTec}
                        onChange={handleOnchange}
                        name="nombreProductoTec"/>
                    </Grid>

                    <Grid item xs={6}>
                        <TextField
                        fullWidth
                        label="Tipo de Producto"
                        id = 'nombreTipoProductoTecTecno'
                        value={props.tipoProductoTec}
                        onChange={handleOnchange}
                        name="tipoProductoTec"/>
                    </Grid>

                    <Grid item xs={6}>
                        <TextField
                        fullWidth
                        label="NIT"
                        id = 'nombreNITTecTecno'
                        value={props.nitTec}
                        onChange={handleOnchange}
                        name="nitTec"/>
                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                        fullWidth
                        label="Nombre de Registro"
                        id = 'nombreRegistroTecTecno'
                        value={props.numeroRegistroTec}
                        onChange={handleOnchange}
                        name="numeroRegistroTec"/>
                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                        fullWidth
                        label="Nombre del Titular"
                        id = 'nombreTitularTecTecno'
                        value={props.nombreTitular}
                        onChange={handleOnchange}
                        name="nombreTitular"/>
                    </Grid>

                    <Grid item xs={6}>
                        <MuiPickersUtilsProvider utils={DateFnsUtils} >
                            <Fragment>
                            <DatePicker
                                views={["year"]}
                                label="Año"
                                value={props.anioTec}
                                fullWidth
                                onChange={props.setAnioTec}
                                animateYearScrolling
                            />
                            </Fragment>
                        </MuiPickersUtilsProvider>
                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                        fullWidth
                        label="Pais"
                        id = 'paisTec'
                        value={props.paisTec}
                        onChange={handleOnchange}
                        name="paisTec"/>
                    </Grid>
                </Grid>
                : ''}
            </div> : <TareasTerminadas imagen={emma_s} mensaje={'Cargando..'} widthImg='7%' marginTop='7%' />}
        </div>
    )
}

const ModalFormGestionAutores = (props) => {

    const [openModalAddParti, setopenModalAddParti] = React.useState(false);
    const [openModalCargarArchivo, setOpenModalCargarArchivo] = React.useState(false);
    const [id, setId] = React.useState('');
    const actions = (requisito) => {

      const eventoDetalle = (requisito) => {
        let i = props.numeroIdParEvent.indexOf(requisito)
        let filtredData = ''
        let filtredDataArrai = ''
        if ( i !== -1 ) {
          filtredData = props.numeroIdParEvent.filter(item => item.id != requisito.id);
          filtredDataArrai = props.arrai.filter(item => item.id != requisito.id);
        }

        props.setNumeroIdParEvent(filtredData)
        props.setArrai(filtredDataArrai)
    }  

    const adjuntarCertificado = (requisito) => {
        let data = props.numeroIdParEvent
        let id = data.filter(e => e.id == requisito.id)
        setId(id[0].id)
        setOpenModalCargarArchivo(true)
    }  



      let detalle =(
      <div>
        {props.tipoSolicitudActual =='Soli_inves_evento' && (
            <BtnCargar callback={() => adjuntarCertificado(requisito)} color= {coloresEmma.secondarycolor} texto='Gestionar' />
      )}
        <BtnEliminar callback={() => eventoDetalle(requisito)} /> 
      </div> 
      )

      return detalle

    }

    return(
        props.cargando == true ? <div> <TareasTerminadas imagen={emma_w} mensaje={'Cargando..'} widthImg='7%' marginTop='7%' /> <LinearProgress /></div> :
        <div>
        <ListarDatos
            id="tbl_listar_encargados"
            datos={props.numeroIdParEvent}
            opciones={true}
            agregar={true}
            buscar={true}
            actAgregar={() => setopenModalAddParti(true)}
            css={{
            list: { padding: '0px 0px 20px 0px' },
            appBar: { padding: '0px 0px 0px 0px' },
            }}
            acciones={(row) => actions(row)}
            titulo={"Lista de encargados"}
            fila_principal={({ nombre, id }) => `${nombre}`}
            filas={[
            {
                'mostrar': ({ nombre }) => `${nombre}`,
                'id': 'nombre', 'enLista': false
            },
            {
                'mostrar': ({ correo }) => `${correo}`,
                'id': 'nombre', 'enLista': true
            },
            {
                'mostrar': ({ identificacion }) => `${identificacion}`,
                'id': 'nombre', 'enLista': true
            },
            {
                'mostrar': ({ modalidadParticipacion }) => {
                    if(modalidadParticipacion != null){
                        return `${modalidadParticipacion.nombre}`
                    }else{
                        return ''
                    }
                },
                'id': 'nombre', 'enLista': true
            },
            {
                'mostrar': ({ rolDeParticipante }) => {
                    if(rolDeParticipante != null){
                        return `${rolDeParticipante.nombre}`
                    }else{
                        return ''
                    }
                },
                'id': 'nombre', 'enLista': true
            },
            { 'id': 'descripcion', 'enLista': false },
            ]}
        />

        <SemilleroAddParti
            openModalAddParti={openModalAddParti}
            setopenModalAddParti={setopenModalAddParti}

            participantes={props.numeroIdParEvent}
            setParticipantes={props.setNumeroIdParEvent}

            arrai={props.arrai}
            setArrai={props.setArrai}

            modalidadParticipacion={props.modalidadParticipacionActive}
            rol={props.rolActive}

            tiposModalidadParticipacion={props.tiposRoles}
        />
        {openModalCargarArchivo == true? 
        <ModalAdjuntarArchivo
            openModalCargarArchivo={openModalCargarArchivo}
            setOpenModalCargarArchivo={setOpenModalCargarArchivo}
            adj_certificado_final={props.adj_certificado_final}
            setAdj_certificado_final={props.setAdj_certificado_final}
            adj_certificado={props.adj_certificado}
            setAdj_certificado={props.setAdj_certificado}
            numeroIdParEvent={props.numeroIdParEvent}
            id={id}
            setId={setId}
            //Errores
            getError={props.getError}
            errores={props.errores}
            setErrores={props.setErrores}
        />
            
        :''}
        
    </div>
    )

}
const ModalAdjuntarArchivo = (props) => {
    const [cargando, setCargando] = React.useState(false)
    const fileInput = React.createRef();
    const dispatch = useDispatch();
    const handleClickSendTioApi = async() => {
        setCargando(true)
        let tipo = "success";
        let titulo = "Adjunto Cargado Correctamente";
        dispatch(
        actualizarMensaje({ titulo, tipo, mostrar: true, tiempo: 6000 })
        );
        handleCloseModal()
        setCargando(false)
    }
          
    

    const handleCloseModal = () => {
        if(!props.adj_certificado_final){
            props.setOpenModalCargarArchivo(false)
            props.setAdj_certificado('')
        } else{
            props.setOpenModalCargarArchivo(false)
        }       
    } 
    const handleOnchange = (e) =>{
        if (e.target.name === "adj_certificado") {
            const adj_evento1 = document.getElementById('adj_certificado').files[0];
            if (adj_evento1) {
              const nuevoAdjCertificado = { ...props.adj_certificado };
              props.setAdj_certificado(e.target.value);

              nuevoAdjCertificado[props.id] = e.target.value;
              props.setAdj_certificado(nuevoAdjCertificado);
              
              let adjuntos = [];
              const participanteYaTieneAdjunto = props.adj_certificado_final.find((adjunto) => adjunto.id === props.id);
              if (participanteYaTieneAdjunto) {
                adjuntos = props.adj_certificado_final.filter((adjunto) => adjunto.id !== props.id);
              } else {
                adjuntos = [...props.adj_certificado_final];
              }
              adjuntos.push({ id: props.id, adjunto: adj_evento1 });
              props.setAdj_certificado_final(adjuntos);
            }
        }
        if(props.errores.length > 0){
            props.setErrores(props.errores.filter(er => er.llave != "adj_evento"));
        }
            
    }
    
    
      
      
    return(
        <Dialog open={props.openModalCargarArchivo} onClose={() => { handleCloseModal() }} aria-labelledby="form-dialog-title" maxWidth='sm' fullWidth={true}>
            <AppBarModal titulo='Adjuntar Certificado' mostrarModal={() => { handleCloseModal() }} titulo_accion="" accion="" />
            <DialogContent>
            {cargando == false ?<Grid item xs={12}>
                         <FormControl fullWidth >
                         <Grid item xs={12} className='oculto'>
                                <TextField
                                ref={fileInput}
                                required
                                type="file"
                                id="adj_certificado"
                                name="adj_certificado"
                                label="Adjuntar Identificación"
                                fullWidth
                                autoComplete="billing address-line1"
                                onChange={handleOnchange}
                                />
                            </Grid>
                            <Grid item xs={12}>
                            <InputFile
                             
                            label='Adjuntar Soporte de Evento' 
                            id='adj_certificado' 
                            value={props.adj_certificado[props.id] || ''} 
                            required={props.adj_certificado[props.id] || false}
                            />
                        </Grid>
                         </FormControl>
                         <FormHelperText></FormHelperText>
                     </Grid> : <TareasTerminadas imagen={emma_s} mensaje={'Cargando..'} widthImg='7%' marginTop='7%' />}
                   </DialogContent>
                   <DialogActions>
                <BtnForm texto="Cerrar" callback={() => { handleCloseModal()}}  />
                <Button disabled={cargando == true} variant="contained" color="primary" style={{color: "#fff"}} onClick={() =>handleClickSendTioApi()}>
                            Enviar
                        </Button>
            </DialogActions>
           
        </Dialog>
    )
}
const SemilleroGestionIntegrantes = (props) =>{
    const dispatch = useDispatch();
    const isInitialMount = React.useRef(true);
    const [integrantes, setIntegrantes] = React.useState([])
    const [cargando, setCargando] = React.useState(true)
    const [cargandoAddInt, setCargandoAddInt] = React.useState(false)
    const [cargandoEdit, setCargandoEdit] = React.useState(true)
    const classes = useStyles()
    const [openFiltrar, setOpenFiltrar] = React.useState(false);
    const [dataDelete, setDataDelete] = React.useState("");
    const [openModal, setOpenModal] = React.useState(false);
    const [msg, setMsg] = React.useState("");
    //Edit
    const [cvlac, setCvlac] = React.useState("");
    const [scholar, setScholar] = React.useState("");
    const [researchGate, setResearchGate] = React.useState("");
    const [academiaEdu, setAcademiaEdu] = React.useState("");
    const [openModalEdit, setOpenModalEdit] = React.useState(false);
    const [openModalExp, setOpenModalExp] = React.useState(false);
    const [dataEdit, setDataEdit] = React.useState("");
    const [adj_seminario, setAdj_seminario] = React.useState('');
    const [ nombrecompleto_tutorlegal, setnombrecompleto_tutorlegal]=React.useState("");
    const [ numeroidentificacion_tutorlegal, setnumeroidentificacion_tutorlegal]= React.useState("")
    const [ PermisoTutor, setPermisoTutor]= React.useState("")
    const [adj_tutor, setadj_tutor]=React.useState('')
    const [adj_seminario_final, setAdj_seminario_final] = React.useState('');
    const [openModalMessage, setOpenModalMessage] = React.useState(false);
    const [dataRow, setDataRow] = React.useState("");

    //Add
    const [openModalAddIntegrante, setOpenModalAddIntegrante] = React.useState(false)
    const [programaSelect, setProgramaSelect] = React.useState('')
    const [programa, setPrograma] = React.useState([])
    const [profesor, setProfesor] = React.useState('')
    const [errores, setErrores] = React.useState([]);
    let data = {}
    React.useEffect( () => {
        //Obtengo los prceosos activos de la persona activa.
       
            const obtenerProcesos = async () => {
                setCargando(true)

                if(props.openModalIntegrantes==true&&props.mdlIntegrantes==false){
                    let data = await obtenerIntegrantesActivosSemillero();
                    setIntegrantes(data)
                }else if(props.mdlIntegrantes==true) {
                    props.setOpenModalIntegrantes(true)
                    let data = await filtrarParticipanteSolicitudesenvia();
                    setIntegrantes(data)
                }
            }
            obtenerProcesos()
            setCargando(false)
        
    },[cargandoAddInt])

    const cambiarestado =(estado)=>{
        
        props.setmdlIntegrantes(estado)
        props.setOpenModalIntegrantes(estado)

    }
    
    //Obtener semilleros solicitudes
    const obtenerIntegrantesActivosSemillero = async () => {
        return new Promise(resolve => {
            Funciones.consulta(`api/v1.0/investigacion/listarParticipante2?estado_actual__codigo=Semi_par_acep&semillero=${props.semiActual.id}`, null, null, (error, estado, resp) => {
              resolve(estado === 200 && !error ? resp : null);
            })
        })
    }

    const filtrarParticipanteSolicitudesenvia = async () => {
        return new Promise(resolve => {
            Funciones.consulta(`api/v1.0/investigacion/listarParticipante2?estado_actual__codigo=Semi_par_env&semillero=${props.semiActual.id}`, null, null, (error, estado, resp) => {
            resolve(estado === 200 && !error ? resp : null);
            })
        })
}

    //Sistema de errores

    const getError = (llave, errores) => {
        let existe = errores.find(e => e.llave === llave);
        return existe ? existe.mensaje : '';
    }

    const validateInputs = (campos = []) => {
        return new Promise((resolve) => {
        let errores = [];
        let date_now = new Date()

        function isObjEmpty(obj) {

            if(typeof obj === 'object'){
                for (var prop in obj) {
                    if (obj.hasOwnProperty(prop)) return false;
                  }

                  return true;
            }else if(typeof obj === 'string'){
                return true
            }else{
                return false;
            }

        }

        campos.map(({ value, name, err, value2 }) => {

            if (!err.obj && err.empty && value.replace(/\s+/g, '') == "") errores.push({ llave: name, 'mensaje': `Este campo es obligatorio` });
            if (!err.obj && err.empty == false && value.length == 0) errores.push({ llave: name, 'mensaje': `Este campo es obligatorio` })
            if (err.empty && isObjEmpty(value) && err.obj){
                errores.push({ llave: name, 'mensaje': `Este campo es obligatorio` })
            }
            if (err.numeric && isNaN(value)) errores.push({ llave: name, 'mensaje': `Este campo es obligatorio` });
        });

        resolve(errores);
        });
    }

    const handleClickOpenEdit = (data) =>{
        setDataEdit(data)
        setOpenModalEdit(true)
    }

    const handleClickOpenExperiencias = (data) =>{
        setDataEdit(data)
        setOpenModalExp(true)
    }

    const handleClick = async (data) =>{
        setCargando(true)
        let url = "api/v1.0/investigacion/aceptarParticipante"

        const callback = async (error, estado, resp) => {
          let titulo = "Ha ocurrido un error, contacte con el administrador."
          let tipo = "error"

          if(!error){
              if(estado === 200){
                  tipo = "success"
                  titulo = resp.titulo
              }
          }

          dispatch(
              actualizarMensaje({ titulo, tipo, mostrar: true, tiempo: 6000 })
            );

          let dataSolicitudes = await obtenerIntegrantesActivosSemillero();
          setIntegrantes(dataSolicitudes)
          setCargando(false)
        }

        const msg = await Funciones.consulta(url, data, 'POST', callback)//Fin handle click
    }

    const handleClickDelete = async () =>{
        if(msg == ""){
          alert("Campo vacio")
        }else{
          const hola = {
            mensaje: msg
          }
          const returnedTarget = Object.assign(dataDelete, hola);

          setCargando(true)
          let url = "api/v1.0/investigacion/rechazarParticipante"

          const callback = async (error, estado, resp) => {
            let titulo = "Ha ocurrido un error, contacte con el administrador."
            let tipo = "error"

            if(!error){
                if(estado === 200){
                    tipo = "success"
                    titulo = resp.titulo
                }
            }

            dispatch(
                actualizarMensaje({ titulo, tipo, mostrar: true, tiempo: 6000 })
              );

            let dataSolicitudes = await obtenerIntegrantesActivosSemillero();
            setIntegrantes(dataSolicitudes)
            setCargando(false)
          }
          const mensaje = await Funciones.consulta(url, returnedTarget, 'POST', callback)
          setOpenModal(false)
        }
    }

    const handleClickOpen = (data) =>{
        setDataDelete(data)
        setOpenModal(true)
    }
    const down = (data) =>{
        setDataRow(data)
        setOpenModalMessage(true)
    }
    const closeDownModal = () =>{
        setOpenModalMessage(false)
    }
    const downWithMessageSenToApi = async () => {
        let data = {
            id: dataRow.id,
            msg: msg 
        }; 
        setCargando(true);
        let url = "api/v1.0/investigacion/baja";
        
        const callback = async (error, estado, resp) => {
            let titulo = "Ha ocurrido un error, contacte con el administrador.";
            let tipo = "error";
            if (!error) {
                if (estado === 201) {
                    tipo = "success";
                    titulo = resp.titulo;
                }
            }
            dispatch(
                actualizarMensaje({ titulo, tipo, mostrar: true, tiempo: 6000 })
            );
            let dataSolicitudes = await obtenerIntegrantesActivosSemillero();
            setIntegrantes(dataSolicitudes);
            setCargando(false);
            setMsg(""); 
            setOpenModalMessage(false)
            
        };
    
        await Funciones.consulta(url, data, 'POST', callback);
    };
    
    const botones = (data) =>{
        if(data.estado_actual.codigo == "Semi_par_env"){
            return (
                <div>
                    <IconButton aria-label="done" className={classes.colorCheck} onClick={()=>{handleClick(data)}}>
                    <DoneIcon/>
                    </IconButton>
                    <IconButton aria-label="delete" className={classes.colorDelete} onClick={()=>{handleClickOpen(data)}}>
                    <ClearIcon/>
                    </IconButton>
                    <IconButton aria-label="delete" className={classes.colorEdit} onClick={()=>{handleClickOpenEdit(data)}}>
                    <EditIcon/>
                    </IconButton>
                    <IconButton aria-label="delete" className={classes.colorEdit} onClick={()=>{handleClickOpenExperiencias(data)}}>
                    <MenuBookIcon/>
                    </IconButton>
                </div>
            )
        }else if (data.estado_actual.codigo == "Semi_par_acep"){
            return (
                <div>
                    <IconButton aria-label="delete" className={classes.colorEdit} onClick={()=>{handleClickOpenEdit(data)}}>
                    <EditIcon/>
                    </IconButton>
                    <IconButton aria-label="delete" className={classes.colorDelete} onClick={()=>{down(data)}}>
                    <ArrowDownwardIcon/>
                    </IconButton>
                </div>
            )
        }else{
            return ''
        }
    }

    const acciones = (data) => {
        const detalle = (
            <div>
            {botones(data)}
            </div>
        );

        return (
            detalle
        );
    }

    const handleClickSendTioApi = async() => {
        let array = await validateInputs([
            { value: profesor, name: 'profesor', err: { empty: true, obj: true, numeric: false } },
            { value: programaSelect, name: 'programaSelect', err: { empty: false, obj: false, numeric: true } },
        ])
        setErrores(array)

        if(array.length > 0){

        }else if(!adj_seminario){
            dispatch(
                actualizarMensaje({ titulo: 'Debe adjuntar el soporte', tipo: "info", mostrar: true, tiempo: 6000 })
            );
        }else{

            setCargandoAddInt(true)
            data = await Funciones.crear_form_data({
                idUsuario: profesor.id,
                programa:programaSelect,
                idSemillero:props.semiActual.id,
                link_cvlac:cvlac,
                link_google_scholar:scholar,
                link_research_gate:researchGate,
                link_academia_edu:academiaEdu,
                adj_seminario:adj_seminario_final,
                // nombrecompleto_tutorlegal: nombrecompleto_tutorlegal,
                // numeroidentificacion_tutorlegal:numeroidentificacion_tutorlegal,
                // PermisoTutor:PermisoTutor,
            })


            let url = "api/v1.0/investigacion/crearParticipante"
            const callback = (error, estado, resp) => {
                let titulo = "Ha ocurrido un error, contacte con el administrador."
                let tipo = "info"

                if(!error){
                    if(estado === 201){
                        tipo = "success"
                        titulo = resp.titulo
                        handleCloseModalAddPar()
                    }else{
                        tipo = "info"
                        titulo = resp.titulo
                    }
                }

                dispatch(
                    actualizarMensaje({ titulo, tipo, mostrar: true, tiempo: 6000 })
                  );
                setCargandoAddInt(false)
                if(tipo == "info"){

                }else{
                    setOpenModalAddIntegrante(false)
                }
            }
            const msg = await Funciones.formulario(url, data, 'POST', callback)
        }
    }

    const handleClickSendToApiEdit = async() => {
        setCargandoEdit(true)
        data = {
            idParticipante:dataEdit,
            link_cvlac:cvlac,
            // link_google_scholar:scholar,
            // link_research_gate:researchGate,
            // link_academia_edu:academiaEdu
        }


        let url = "api/v1.0/investigacion/actualizarParticipante"
            const callback = (error, estado, resp) => {
                let titulo = "Ha ocurrido un error, contacte con el administrador."
                let tipo = "info"

                if(!error){
                    if(estado === 200){
                        tipo = "success"
                        titulo = resp.titulo
                    }else{
                        tipo = "info"
                        titulo = resp.titulo
                    }
                }

                dispatch(
                    actualizarMensaje({ titulo, tipo, mostrar: true, tiempo: 6000 })
                  );
                  setCargandoEdit(false)
                if(tipo == "info"){
                }else{
                    setOpenModalEdit(false)
                }
            }
        const msg = await Funciones.consulta(url, data, 'POST', callback)
    }

    const handleCloseModalEdit = () =>{
        setDataEdit('')
        setCvlac('')
        setScholar('')
        setResearchGate('')
        setAcademiaEdu('')

        setOpenModalEdit(false)
    }

    const handleCloseModalExp = () =>{
        setOpenModalExp(false)
    }

    const handleCloseModalAddPar = () =>{
        setProfesor('')
        setProgramaSelect('')
        setDataEdit('')
        setCvlac('')
        setScholar('')
        setResearchGate('')
        setAcademiaEdu('')
        setAdj_seminario('')

        setOpenModalAddIntegrante(false)
    }
    return (
        <div>
            <Dialog PaperProps={{style: {height: '80vh', overflow: 'auto',top: '30px', },}} open={props.openModalIntegrantes} onClose={()=>{cambiarestado(false)}} aria-labelledby="form-dialog-title">

                <AppBarModal titulo='Gestion de Integrantes del Semillero' mostrarModal={()=>{cambiarestado(false)}} titulo_accion="" accion="" />
                {/* Contenido del modal del formulario de */}
                <DialogContent>
                <div>
                    {cargando == true ? <TareasTerminadas imagen={emma_s} mensaje={'Cargando..'} widthImg='7%' marginTop='7%' />
                    : <div>
                            <ListarDatos
                            id="tbl_listar_participantes"
                            avatar={({ participante }) => participante.primer_nombre.charAt(0)}
                            datos={integrantes}
                            opciones={true}
                            agregar={true}
                            buscar={true}
                            filtrar={true}
                            actfiltrar={() => setOpenFiltrar(true)}
                            actAgregar={() => setOpenModalAddIntegrante(true)}
                            css={{
                            list: { padding: '0px 0px 20px 0px' },
                            appBar: { padding: '0px 0px 0px 0px' },
                            }}
                            acciones={(row) => acciones(row)}
                            titulo={"Integrantes del Semillero"}
                            fila_principal={({ participante }) => `${participante.primer_nombre} ${participante.segundo_nombre} ${participante.primer_apellido} ${participante.segundo_apellido}`}
                            filas={[
                            {
                                'mostrar': ({ participante }) => `${participante.correo}`,
                                'id': 'Correo', 'enLista': true
                            },
                            {
                                'mostrar': ({ participante }) => `${participante.celular ? participante.celular : ''}`,
                                'id': 'Celular', 'enLista': true
                            },
                            {   'nombre': 'Fecha de Solicitud: ',
                                'mostrar': ({ fecha_registro }) => moment(fecha_registro).format('YYYY-MM-DD, h:mm a'),
                                'id': 'fecha_registro', 'enLista': true
                            }
                            ]}
                        />
                    </div>
                    }
                </div>
                </DialogContent>

                <DialogActions>

                </DialogActions>

            </Dialog>
            {openModalMessage == true ? 
          <MessageToDown 
          openModal={openModalMessage} 
          setOpenModal={setOpenModalMessage} 
          downWithMessageSenToApi={downWithMessageSenToApi} 
          setMsg={setMsg} 
          msg={msg} 
          closeDownModal={closeDownModal}
        />
         : null}

            {openModalEdit == true ?
                <SemilleroRowEdit
                    openModalEdit={openModalEdit}
                    setOpenModalEdit={setOpenModalEdit}

                    cvlac={cvlac}
                    setCvlac={setCvlac}
                    scholar={scholar}
                    setScholar={setScholar}
                    researchGate={researchGate}
                    setResearchGate={setResearchGate}
                    academiaEdu={academiaEdu}
                    setAcademiaEdu={setAcademiaEdu}

                    dataEdit={dataEdit}
                    setDataEdit={setDataEdit}

                    handleClickSendToApiEdit={handleClickSendToApiEdit}

                    cargandoEdit={cargandoEdit}
                    setCargandoEdit={setCargandoEdit}

                    handleCloseModalEdit={handleCloseModalEdit}
            />: null}

            {openModalAddIntegrante == true ?
                <SemilleroModalAddIntegrante
                    openModalAddIntegrante={openModalAddIntegrante}
                    setOpenModalAddIntegrante={setOpenModalAddIntegrante}

                    cvlac={cvlac}
                    setCvlac={setCvlac}
                    scholar={scholar}
                    setScholar={setScholar}
                    researchGate={researchGate}
                    setResearchGate={setResearchGate}
                    academiaEdu={academiaEdu}
                    setAcademiaEdu={setAcademiaEdu}
                    adj_seminario={adj_seminario}
                    setAdj_seminario={setAdj_seminario}
                    adj_seminario_final={adj_seminario_final}
                    setAdj_seminario_final={setAdj_seminario_final}
                    programaSelect={programaSelect}
                    setProgramaSelect={setProgramaSelect}
                    nombrecompleto_tutorlegal= {setnombrecompleto_tutorlegal}
                    numeroidentificacion_tutorlegal={setnumeroidentificacion_tutorlegal}
                    PermisoTutor={setPermisoTutor}
                    adj_tutor={setadj_tutor}
                    programa={programa}
                    setPrograma={setPrograma}

                    handleClickSendTioApi={handleClickSendTioApi}

                    profesor={profesor}
                    setProfesor={setProfesor}

                    //Errores
                    getError={getError}
                    errores={errores}
                    setErrores={setErrores}

                    cargandoAddInt={cargandoAddInt}
                    setCargandoAddInt={setCargandoAddInt}

                    handleCloseModalAddPar={handleCloseModalAddPar}
            /> : ''}

            {openFiltrar == true ?
            <ModalFiltrar
                openFiltrar = {openFiltrar}
                setOpenFiltrar = {setOpenFiltrar}

                semiActual = {props.semiActual}

                infoSoli = {integrantes}
                setInfoSoli = {setIntegrantes}

                cargando = {cargando}
                setCargando = {setCargando}
          /> : null}

            {openModal == true ?
            <SemilleroMessage
                openModal={openModal}
                setOpenModal={setOpenModal}

                msg={msg}
                setMsg={setMsg}

                handleClickDelete={handleClickDelete}
            />: null}

            {openModalExp == true &&
            <ModalExperiencias
                openModalExp={openModalExp}
                setOpenModalExp={setOpenModalExp}
                handleCloseModalExp={handleCloseModalExp}

                dataEdit={dataEdit}
                setDataEdit={setDataEdit}
            />
            }
        </div>
    )
}

const useStylesTables = makeStyles((theme) => ({
    columna: {
      display: 'flex',
    },
}));

const ModalExperiencias = (props) => {
    const btnVer = archivo =>
        <Link href={`${Funciones.api}${archivo}`} target="_blank">
            <IconButton style={{ color: '#01579b' }} aria-label="delete">
                <VisibilityIcon fontSize="small" />
            </IconButton>
        </Link>

    const classes = useStylesTables();
    return(
        <Dialog open={props.openModalExp} onClose={() => { props.handleCloseModalExp() }} aria-labelledby="form-dialog-title" maxWidth='sm' fullWidth={true}>
            <AppBarModal titulo='Detalle Participante' mostrarModal={() => { props.handleCloseModalExp() }} titulo_accion="" accion="" />
            <DialogContent>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <Table>
                            <TableBody>
                                <TableRow key={1}>
                                    <TableCell component="th" scope="row">Experiencias</TableCell>
                                    <TableCell align="left">{props.dataEdit.experiencia}</TableCell>
                                </TableRow>
                                {props.dataEdit.adj_seminario &&
                                    <TableRow key={2}>
                                        <TableCell component="th" scope="row">Soporte Seminario Adjunto</TableCell>
                                        <TableCell align="left">{btnVer(props.dataEdit.adj_seminario)}</TableCell>
                                    </TableRow>
                                }
                                {props.dataEdit.adj_metodologia &&
                                    <TableRow key={3}>
                                        <TableCell component="th" scope="row">Soporte Metodologia de Investigación</TableCell>
                                        <TableCell align="left">{btnVer(props.dataEdit.adj_metodologia)}</TableCell>
                                    </TableRow>
                                } 
                                {props.dataEdit.nombrecompleto_tutorlegal &&
                                <TableRow key={1}>
                                    <TableCell component="th" scope="row">Nombre del tutor legal</TableCell>
                                    <TableCell align="left">{props.dataEdit.nombrecompleto_tutorlegal}</TableCell>
                                </TableRow>  
                                }
                                {props.dataEdit.numeroidentificacion_tutorlegal &&
                                <TableRow key={1}>
                                    <TableCell component="th" scope="row">Número de identificación del tutor legal</TableCell>
                                    <TableCell align="left">{props.dataEdit.numeroidentificacion_tutorlegal}</TableCell>
                                </TableRow> }
                                {props.dataEdit && props.dataEdit.PermisoTutor && (
                                    <TableRow key={1}>
                                    <TableCell component="th" scope="row">Autorización del tutor legal</TableCell>
                                    <TableCell align="left">{props.dataEdit.PermisoTutor}</TableCell>
                                    </TableRow>
                                    )}
                            </TableBody>
                        </Table>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <BtnForm texto="Cerrar" callback={() => { props.handleCloseModalExp()}} />
            </DialogActions>
        </Dialog>
    )
}
const MessageToDown = (props) => {
    
    const handleOnchange2 = (e) =>{
        props.setMsg(e.target.value);
    }
  
    return (
      <div>
        <Dialog fullWidth={true} maxWidth="sm" fullScreen={window.innerWidth < 600} open={props.openModal} onClose={() => props.closeDownModal()}>
          <AppBarModal titulo={'¡ Digite su Mensaje !'} mostrarModal={() => props.closeDownModal()} titulo_accion="" accion="" />
          <DialogContent>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <TextField 
                        fullWidth 
                        multiline
                        label="Escriba un mensaje indicándole la razón  por qué se desvinculó del grupo." 
                        id = 'msg'
                        value={props.msg} 
                        onChange={handleOnchange2}
                        name="msg" 
                        
                    />
                </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button variant="contained" color="primary" style={{color: "#fff"}} onClick={props.downWithMessageSenToApi}>
                Enviar
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    )
  
  }

const SemilleroRowEdit = (props) => {

    const isInitialMount = React.useRef(true);

    const handleOnchange = (e) =>{
      if(e.target.name == "cvlac"){
        props.setCvlac(e.target.value)
      }else if(e.target.name == "scholar"){
        props.setScholar(e.target.value)
      }
    }

    React.useEffect( () => {
      //Obtengo los prceosos activos de la persona activa.
      if(isInitialMount.current){
          isInitialMount.current = false
          const obtenerProcesos = async () => {
              let data = await obtenerLinks();

              if(data[0].link_academia_edu != null){
                props.setAcademiaEdu(data[0].link_academia_edu)
              }
              if(data[0].link_cvlac != null){
                props.setCvlac(data[0].link_cvlac)
              }
              if(data[0].link_google_scholar != null){
                props.setScholar(data[0].link_google_scholar)
              }
              if(data[0].link_research_gate != null){
                props.setResearchGate(data[0].link_google_scholar)
              }
              props.setCargandoEdit(false)
          }
          obtenerProcesos()
      }
    })

    //Obtener semilleros solicitudes
    const obtenerLinks = async () => {
      return new Promise(resolve => {
          Funciones.consulta(`api/v1.0/investigacion/listarParticipante2?id=${props.dataEdit.id}`, null, null, (error, estado, resp) => {
            resolve(estado === 200 && !error ? resp : null);
          })
      })
    }

    return(
      <div>
              <Dialog open={props.openModalEdit} onClose={()=>{props.handleCloseModalEdit()}} aria-labelledby="form-dialog-title">

                  <AppBarModal titulo='Actualizar Links' mostrarModal={()=>{props.handleCloseModalEdit()}} titulo_accion="" accion="" />
                  {/* Contenido del modal del formulario de */}
                  <DialogContent>
                  {props.cargandoEdit == true ? <TareasTerminadas imagen={emma_w} mensaje={'Cargando..'} widthImg='7%' marginTop='7%' /> :
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <TextField
                        label="Link de Cvlac (en caso de tenerlo) O linkedin"
                        fullWidth
                        value={props.cvlac}
                        onChange={handleOnchange}
                        name="cvlac"
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        label="Link Google Scholar (en caso de tenerlo)"
                        fullWidth
                        value={props.scholar}
                        onChange={handleOnchange}
                        name="scholar"
                      />
                    </Grid>
                    </Grid>}
                  </DialogContent>

                  <DialogActions>
                    <BtnForm texto="Enviar" callback={props.handleClickSendToApiEdit} />
                  </DialogActions>

              </Dialog>
          </div>
    )

}

const SemilleroModalAddIntegrante = (props) =>{

    const [openModal, setOpenModal] = React.useState(false)
    const classes = useStyles();
    const fileInput = React.createRef();
    const handleOnchange = (e) =>{
        if(e.target.name == "cvlac"){
          props.setCvlac(e.target.value)
          if(props.errores.length > 0){
            props.setErrores(props.errores.filter(er => er.llave != "cvlac"));
            // Elimina error cuando se escribe en el campo
          }
        }else if(e.target.name == "scholar"){
          props.setScholar(e.target.value)
        }else if(e.target.name == "adj_seminario"){
            props.setAdj_seminario(e.target.value)
            let adj_semi = document.getElementById('adj_seminario').files[0];
            if (adj_semi) props.setAdj_seminario_final(adj_semi);
            if(props.errores.length > 0){
              props.setErrores(props.errores.filter(er => er.llave != "adj_seminario"));
              // Elimina error cuando se escribe en el campo
            }
          }
    }

    const obtenerInfoUser = async (id) => {
        const data = await Funciones.obtenerMisDatos(id)
        props.setPrograma(data.programas)

    }

    //Funcion para asginar Departamentos y Programas al select.
    const handleChangeDepaPro = (event) => {
        props.setProgramaSelect(event.target.value);
        if(props.errores.length > 0){
            props.setErrores(props.errores.filter(er => er.llave != "programaSelect"));
            // Elimina error cuando se escribe en el campo
        }
    };

    return (
        <div>
              <Dialog open={props.openModalAddIntegrante} onClose={()=>{props.handleCloseModalAddPar()}} aria-labelledby="form-dialog-title">

                  <AppBarModal titulo='Agregar Integrante al Semillero' mostrarModal={()=>{props.handleCloseModalAddPar()}} titulo_accion="" accion="" />
                  {/* Contenido del modal del formulario de */}
                  <DialogContent>
                    <Box p={2}>
                        {props.cargandoAddInt == false ? <Grid container spacing={3}>
                            <Grid item xs={12}>
                            <FormControl className={classes.formControl} fullWidth error = { props.getError('profesor', props.errores).length > 0}>
                                <InputBuscar
                                    id='profesor'
                                    label='Estudiante'
                                    name="profesor"
                                    fullWidth
                                    placeholder='Clic aquí para buscar'
                                    value={props.profesor.nombre == undefined ? '' : props.profesor.nombre}
                                    callback={() => {
                                        setOpenModal(true)
                                        if(props.errores.length > 0){
                                            props.setErrores(props.errores.filter(er => er.llave != "profesor"));
                                        }
                                    }} />
                                </FormControl>
                            <FormHelperText style={{color: "#FF2D00"}}>{ props.getError('profesor', props.errores) }</FormHelperText>
                            </Grid>
                            <Grid item xs={12}>
                                <InputLabel htmlFor="age-native-simple">Programa</InputLabel>
                                <FormControl className={classes.formControl} fullWidth error = { props.getError('programaSelect', props.errores).length > 0}>
                                    <Select
                                        value={props.programaSelect}
                                        displayEmpty
                                        fullWidth
                                        className={classes.selectEmpty}
                                        inputProps={{ 'aria-label': 'Without label' }}
                                        onChange={handleChangeDepaPro}
                                        name="programaSelect"
                                    >
                                        <MenuItem value="">
                                            <em style={{color: "rgba(0, 0, 0, 0.54)"}}>{ `${props.programa.length} Progra. Seleccionados` }</em>
                                        </MenuItem>
                                        {props.programa.map((item, index) => (
                                        <MenuItem key= { index } value = { item.relacion.id }>{`${item.relacion.nombre}`}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                <FormHelperText style={{color: "#FF2D00"}}>{ props.getError('programaSelect', props.errores) }</FormHelperText>
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    id="cvlac"
                                    label="Link de ORCID o CVLAC (en caso de tenerlo)"
                                    // error = { props.getError('cvlac', props.errores).length > 0}
                                    // helperText = { props.getError('cvlac', props.errores) }
                                    fullWidth
                                    value={props.cvlac}
                                    onChange={handleOnchange}
                                    name="cvlac"
                                />
                             <FormHelperText style={{color: "#FF2D00"}}>{ props.getError('cvlac', props.errores) }</FormHelperText>
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    //id="standard-multiline-flexible"
                                    label=" Link de Google Scholar o LinkedIn (en caso de tenerlo)"
                                    //error = { props.getError('correo', props.errores).length > 0}
                                    //helperText = { props.getError('correo', props.errores) }
                                    fullWidth
                                    value={props.scholar}
                                    onChange={handleOnchange}
                                    name="scholar"
                                />
                            </Grid>
                            {/* <Grid item xs={12}>
                                <TextField
                                    //id="standard-multiline-flexible"
                                    label="Link ResearchGate (en caso de tenerlo)"
                                    //error = { props.getError('correo', props.errores).length > 0}
                                    //helperText = { props.getError('correo', props.errores) }
                                    fullWidth
                                    value={props.researchGate}
                                    onChange={handleOnchange}
                                    name="researchGate"
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    //id="standard-multiline-flexible"
                                    label="Link academia.edu (en caso de tenerlo)"
                                    //error = { props.getError('correo', props.errores).length > 0}
                                    //helperText = { props.getError('correo', props.errores) }
                                    fullWidth
                                    value={props.academiaEdu}
                                    onChange={handleOnchange}
                                    name="academiaEdu"
                                />
                            </Grid> */}
                            <Grid item xs={12} className='oculto'>
                                <TextField
                                ref={fileInput}
                                required
                                type="file"
                                id="adj_seminario"
                                name="adj_seminario"
                                label="Adjuntar"
                                fullWidth
                                autoComplete="billing address-line1"
                                onChange={handleOnchange}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                 <InputFile 
                                 label='Adjuntar Certificado de Seminario de Investigación Adjunto' 
                                 id='adj_seminario' 
                                 value={props.adj_seminario} 
                                 required={props.adj_seminario} 
                                 fullWidth
                                 error={props.getError('adj_seminario', props.errores) > 0} 
                                 helperText = { props.getError('adj_seminario', props.errores) }/>
                            </Grid>
                        </Grid> : <TareasTerminadas imagen={emma_s} mensaje={'Cargando..'} widthImg='7%' marginTop='7%' />}
                    </Box>
                  </DialogContent>

                  <DialogActions>
                        <Button disabled={props.cargandoAddInt == true} variant="contained" color="primary" style={{color: "#fff"}} onClick={() => props.handleClickSendTioApi()}>
                            Enviar
                        </Button>
                  </DialogActions>

              </Dialog>

              {openModal == true ?
                <Dialog fullWidth={true} maxWidth="sm" fullScreen={window.innerWidth < 600} open={openModal} onClose={() => setOpenModal(false)}>
                    <AppBarModal titulo={'¡ Buscar Estudiante !'} mostrarModal={() => setOpenModal(false)} titulo_accion="CERRAR" accion={() => setOpenModal(false)} />
                    <DialogContent style={{ padding: '0' }} className='scroll'>
                        <BuscarPersona callback={(data) => {
                            props.setProfesor({id: data.id, nombre:  `${data.primer_nombre} ${data.segundo_nombre} ${data.primer_apellido} ${data.segundo_apellido}`})
                            props.setProgramaSelect('')
                            obtenerInfoUser(data.id)
                            setOpenModal(false)
                        }} />
                    </DialogContent>
                    <DialogActions>
                            <Button variant="contained" color="primary" style={{color: "#fff"}} onClick={() => setOpenModal(false)}>
                                Cancelar
                            </Button>
                    </DialogActions>
                </Dialog>
                : ''}
          </div>
    )

}

const ModalFiltrar = (props) =>{

    const [lineaSeleccion, setLineaSeleccion] = React.useState('');
    const [estadosPar, setEstadosPar] =  React.useState([]);
    const isInitialMount = React.useRef(true);
    const [cargandoPar, setCargadoPar] = React.useState(true);
    const classes = useStyles();
    React.useEffect( () => {
      //Obtengo los prceosos activos de la persona activa.
      if(isInitialMount.current){
          isInitialMount.current = false
          obtenerEstados()
      }
    })
    //Obtengo los estados
    const obtenerEstados = async () => {
      try{
        const data = await Funciones.obtenerValores(Helper.SOLICITUDES_PAR_INVES)

        setEstadosPar(data)
        setCargadoPar(false)
      }catch(err){
        console.log(err)
      }
    }

    const filtrarParticipanteSolicitudes = async () => {
      return new Promise(resolve => {
          Funciones.consulta(`api/v1.0/investigacion/listarParticipante2?estado_actual__codigo=${lineaSeleccion.codigo}&semillero=${props.semiActual.id}`, null, null, (error, estado, resp) => {
            resolve(estado === 200 && !error ? resp : null);
          })
      })
    }

    //Funcipan para cambiar el seleccionado
    const handleChangeLinea = (event) => {
      setLineaSeleccion(event.target.value);
    };

    const filtrar = async() =>{
      if(lineaSeleccion == ""){
        alert("elija una opcion")
      }else{
        props.setCargando(true)
        let data = await filtrarParticipanteSolicitudes()
        props.setInfoSoli(data)
        props.setOpenFiltrar(false)
        props.setCargando(false)
      }
    }

    return(
      <div>
        <Dialog fullWidth={true} maxWidth="sm" fullScreen={window.innerWidth < 600} open={props.openFiltrar} onClose={() => props.setOpenFiltrar(false)}>
          <AppBarModal titulo={'¡ Más Información !'} mostrarModal={() => props.setOpenFiltrar(false)} titulo_accion="" accion="" />
          <DialogContent>
            {cargandoPar == true ? <TareasTerminadas mensaje='Cargando..' marginTop='7%' imagen={emma_w} widthImg="7%" /> : <Grid container spacing={3}>
              <Grid item xs={12}>
                <InputLabel htmlFor="age-native-simple">Estados</InputLabel>
                <FormControl className={classes.formControl} fullWidth /*error = { props.getError('lineaSubInves', props.errores).length > 0}*/>
                  <Select
                    value={lineaSeleccion}
                    displayEmpty
                    fullWidth
                    //className={classes.selectEmpty}
                    inputProps={{ 'aria-label': 'Without label' }}
                    onChange={handleChangeLinea}
                  >
                    <MenuItem value="">
                        <em style={{color: "rgba(0, 0, 0, 0.54)"}}>{ `${estadosPar.length} Estados Disponibles` }</em>
                    </MenuItem>
                    {estadosPar.map((item, index) => (
                      <MenuItem key= { index } value = { item }>{`${item.nombre}`}</MenuItem>
                    ))}
                    </Select>
                </FormControl>
                {/*<FormHelperText>{ props.getError('lineaSubInves', props.errores) }</FormHelperText>*/}
              </Grid>
            </Grid>}
          </DialogContent>
          <DialogActions>
                <BtnForm texto="Filtrar" callback={filtrar} />
          </DialogActions>
        </Dialog>
      </div>
    )
}
export { SemilleroModalAddIntegrante, SemilleroGestionIntegrantes }
export default Semilleros